{
  "news.2026-11-04-zzzzzzzzzzsignals.title": "Signals you can hear",
  "news.2026-11-04-zzzzzzzzzzsignals.intro": "Each group signal now has its own sound.",
  "news.2026-11-04-zzzzzzzzzzsignals.signals": "Signals with their own sound",
  "news.2026-11-04-zzzzzzzzzzsignals.signals.desc": "\"Attack here\", \"Defend here\", \"Watch out!\", \"On my way\" and \"Help!\" each sound different, so you know them without looking: a steel strike, a deep shield hum, a pulsing alarm, a rising whoosh and falling pulses.",
  "news.2026-11-04-zzzzzzzzzwalls.title": "Walls that hold",
  "news.2026-11-04-zzzzzzzzzwalls.intro": "What the group built now grows stronger with its level too.",
  "news.2026-11-04-zzzzzzzzzwalls.walls": "What you build keeps up",
  "news.2026-11-04-zzzzzzzzzwalls.walls.desc": "When the group is above its Marea's level the nightmares come stronger; now walls, gates and towers do too: they take more blows, and towers and traps hit harder. They grow half as much as the nightmares, so raising a wall a level or cladding it in iron is still worth it. Before, a group ahead of its level saw every wall fall to the rams within seconds.",
  "news.2026-11-04-zzzzzzzzaura.title": "A clearer bastion",
  "news.2026-11-04-zzzzzzzzaura.intro": "Paladins' auras no longer cover the bastion.",
  "news.2026-11-04-zzzzzzzzaura.aura": "Aura on guard",
  "news.2026-11-04-zzzzzzzzaura.aura.desc": "Between waves, no paladin draws its aura on the bastion floor, neither one being played nor a spectre: it covered the keep and the works. In the wave it shows as always.",
  "news.2026-11-04-zzzzzzzzaura.timers": "Build timers with room",
  "news.2026-11-04-zzzzzzzzaura.timers.desc": "With many works under way, the bastion shows only a few timers at a time (the work you're helping on and the ones finishing soonest), spaced apart, instead of covering everything. The rest show on each work's sheet and in the golems panel.",
  "news.2026-11-04-zzzzzzzring.title": "The ring, on the floor",
  "news.2026-11-04-zzzzzzzring.intro": "The ring that marks your hero is back under its feet.",
  "news.2026-11-04-zzzzzzzring.ring": "Rings underfoot",
  "news.2026-11-04-zzzzzzzring.ring.desc": "Your hero's red ring and the one marking the nightmare you aim at were drawn over the miniature. Now they sit on the floor, underfoot, in the bastion, the crypts and the raids.",
  "news.2026-11-04-zzzzzzbagforge.title": "Forge from the bag",
  "news.2026-11-04-zzzzzzbagforge.intro": "A piece in the bag can be forged too.",
  "news.2026-11-04-zzzzzzbagforge.bagforge": "Forge before you wear it",
  "news.2026-11-04-zzzzzzbagforge.bagforge.desc": "On the Gear sheet, a piece in your bag now also shows «Forge +n», like the ones you wear. You can get it ready before you put it on.",
  "news.2026-11-04-zzzzzfrost.title": "Frost reaches the bastion",
  "news.2026-11-04-zzzzzfrost.intro": "From November 8, a day of frost also changes the waves.",
  "news.2026-11-04-zzzzzfrost.frost": "Frozen towers and burning oil",
  "news.2026-11-04-zzzzzfrost.frost.desc": "Under frost, towers reload 25 % slower and grow a crust of rime. A charged burning-oil trap two cells away or closer lights as the wave starts, burns one charge and keeps the towers near it warm to the end; a fire-enchanted tower doesn't freeze either. An empty oil gives no warmth: repair it first. When building on a frost day, the oil's circle shows how far its warmth reaches and each tower's card says whether it stays warm. It applies to both kinds of bastion, and the report counts how many towers fought warm.",
  "news.2026-11-04-zzzzzfrost.mended": "Repairs that aren't lost",
  "news.2026-11-04-zzzzzfrost.mended.desc": "A repair that finished while someone was fighting the wave live or alone was lost when the fight ended. Now the wave only takes off what it spent, and the repair stays.",
  "news.2026-11-04-zzzzprep.title": "A preparation for every nightmare",
  "news.2026-11-04-zzzzprep.intro": "Preparations now keep your gear too.",
  "news.2026-11-04-zzzzprep.prep": "Each preparation keeps its pieces",
  "news.2026-11-04-zzzzprep.prep.desc": "In “What to carry”, the Gear section keeps what you are wearing in that preparation. Set up a fire one for the troll, a frost one and a damage one, and pick which to go down with in the waiting room, without changing piece by piece. If a piece is gone, that slot goes with whatever you wear. Your spectre fights with the waves preparation, gear included.",
  "news.2026-11-04-zzzzprep.lobby": "What you put on in the waiting room goes down with you",
  "news.2026-11-04-zzzzprep.lobby.desc": "A piece put on, forged or socketed while you waited for the others went down unworn, even though your sheet showed it. Now the fight is built with it.",
  "news.2026-11-04-zzzzprep.fire": "Every fire stops the troll, and only fire",
  "news.2026-11-04-zzzzprep.fire.desc": "Fire zones (Embers, Rain of fire, the Incendiary mortar, the towers) hurt it without stopping its mending, while a bleed or a poison did stop it. Now any fire stops it, and nothing else.",
  "news.2026-11-04-zzzskies.title": "The sky reaches the bastion",
  "news.2026-11-04-zzzskies.intro": "From November 7, some of the day's omens also change the waves.",
  "news.2026-11-04-zzzskies.skies": "Fog and storm over the walls",
  "news.2026-11-04-zzzskies.skies.desc": "In fog, towers reach 20 % less, except those with a vigil beacon nearby: their circle shows it while you build. In a storm, in «From scratch» campaigns from era IV, lightning falls on the towers, marked a moment before, and each bolt takes some of their health; a lightning rod near a tower draws it away. The clock names each wave's sky and the report counts the bolts. A wave under an omen makes the next one neither easier nor harder. The other omens still apply only to incursions and crypts, and the bastion no longer dresses for them.",
  "news.2026-11-04-zzsoftgl.title": "A notice when the graphics card is missing",
  "news.2026-11-04-zzsoftgl.intro": "If the browser draws without the GPU, the game says so.",
  "news.2026-11-04-zzsoftgl.softgl": "We tell you when the browser isn’t using the graphics card",
  "news.2026-11-04-zzsoftgl.softgl.desc": "Some browsers draw the game without the graphics card, with hardware acceleration off, and everything runs much slower. Now the game says so once and how to turn it on.",
  "news.2026-11-04-zcompanions.title": "No stutter when companions arrive",
  "news.2026-11-04-zcompanions.intro": "Spotted in the first trips down the Chasm.",
  "news.2026-11-04-zcompanions.companions": "The colossus and the other companions, ready before setting out",
  "news.2026-11-04-zcompanions.companions.desc": "The first time an artificer called the colossus, or the hawk, decoy, drone, hound or treant showed up, the screen froze for up to half a second for the whole party. Now they are made ready with everything else before the fight starts, in the Chasm and everywhere else.",
  "news.2026-11-04-troll.title": "Embers for the troll",
  "news.2026-11-04-troll.intro": "The captain that would not die.",
  "news.2026-11-04-troll.embers": "Ember pits in the Chasm",
  "news.2026-11-04-troll.embers.desc": "The peat troll mends from any wound unless it burns, and down in the Chasm, with no towers, many groups had nothing to burn it with. Now, when it is the floor's captain, its hall holds ember pits: drag it into the fire and it stops mending. Fire on the floor burns nightmares too, and the captain's bar says whether it is mending or burning.",
  "news.2026-11-03-zzzzzstats.title": "Campaign stats",
  "news.2026-11-03-zzzzzstats.intro": "Everything the group did, in numbers.",
  "news.2026-11-03-zzzzzstats.stats": "Statistics",
  "news.2026-11-03-zzzzzstats.stats.desc": "From the bastion (under «More» on phones) you can open the campaign's statistics page: the group and each hero, side-by-side comparisons, the storehouse, outings, waves, when each of you plays and the records. Filter by hero, kind of fight and days. What the game has kept since November 2: play time, each hero's daily progress, every wave and the storehouse's spending.",
  "news.2026-11-03-zzzzreload.title": "No more sudden reloads",
  "news.2026-11-03-zzzzreload.intro": "The page stays where you are.",
  "news.2026-11-03-zzzzreload.reload": "New versions wait",
  "news.2026-11-03-zzzzreload.reload.desc": "When a new version came out, the page could reload by itself in the middle of whatever you were doing, for instance when the connection dropped for a moment during a fight. Now it only reloads if your fight has already moved to the new version (and it takes you straight back in); otherwise you keep playing and the new-version notice lets you reload whenever you like.",
  "news.2026-11-03-zzzskills.title": "Clearer skills",
  "news.2026-11-03-zzzskills.intro": "Look before you spend.",
  "news.2026-11-03-zzzskills.skills": "Variants in sight",
  "news.2026-11-03-zzzskills.skills.desc": "Tapping a skill you haven't learned yet now shows its two variants on its card, with what each one changes, so you can choose before spending the point. And a skill already within your level now says \"No points\" when you have none left, instead of looking locked.",
  "news.2026-11-03-zzfold.title": "Panels that fold",
  "news.2026-11-03-zzfold.intro": "More screen to play in the cellars and the Furrows.",
  "news.2026-11-03-zzfold.fold": "Fold the goal panel",
  "news.2026-11-03-zzfold.fold.desc": "In the garrison cellars and the Furrows, the button in the corner of the top panel folds it: the title, the bar of what you are doing and the clocks that press stay, and the room shows. If a new order comes while it is folded, the panel flashes. It remembers how you left it.",
  "news.2026-11-03-zspectres.title": "Crypts alone or with spectres",
  "news.2026-11-03-zspectres.intro": "No need to be online together to go down.",
  "news.2026-11-03-zspectres.crypts": "Go down the crypts alone or with spectres",
  "news.2026-11-03-zspectres.crypts.desc": "All three crypts can be played alone, as incursions can. On each crypt’s sheet you pick which absent friends come down with you as spectres: they fight, raise you when you fall, do their part in the puzzles and follow you from room to room. The crypt fills as if they were live, so it is no easier. The chest is yours; each friend who came as a spectre gets 10 % of the XP. If a picked friend shows up while the party gathers, they join live instead of their spectre.",
  "news.2026-11-03-zgifts.title": "Gifts you notice",
  "news.2026-11-03-zgifts.intro": "Now you know what you were sent, and by whom.",
  "news.2026-11-03-zgifts.notice": "A notice when you're sent something",
  "news.2026-11-03-zgifts.notice.desc": "When someone in the group sends you a piece, a card shows the piece and who sent it. Several pieces from the same friend come together on one card. If they were sent while you were away, the notice shows when you come back. Tap the card to see it in your bag.",
  "news.2026-11-03-zgifts.fresh": "New pieces glow in the bag",
  "news.2026-11-03-zgifts.fresh.desc": "Gifts, and loot you haven't looked at yet, glow in their rarity's color, are marked «New» and come first. The hero button and the Gear tab say how many there are. A piece stops glowing once you look at it, and «Mark as seen» clears them all at once. Every gifted piece says who sent it, so you know whom to thank.",
  "news.2026-11-03-triangle.title": "Big buildings in place",
  "news.2026-11-03-triangle.intro": "Three-cell buildings show where they stand.",
  "news.2026-11-03-triangle.square": "Big buildings no longer stand askew",
  "news.2026-11-03-triangle.square.desc": "The forge, the barracks, the temple and the other three-cell buildings turned to face the keep and stood crooked, half over the cells next to them. Now they line up with their own three cells, as plans and while they rise too.",
  "news.2026-11-03-triangle.place": "Big buildings back on their cells",
  "news.2026-11-03-triangle.place.desc": "Some three-cell buildings showed up shifted beside the spot they were planned on once finished. Each now stands on the cells chosen for its blueprint, in waves too, and those already built move back on their own.",
  "news.2026-11-03-sides.title": "Other stories, with friends",
  "news.2026-11-03-sides.intro": "The other stories' fights no longer have to be played alone.",
  "news.2026-11-03-sides.together": "«Play with friends» in the other stories",
  "news.2026-11-03-sides.together.desc": "Every fight in The Horn, The well, The rails and the rest can be opened live: whoever is online comes in to help, and the fight adjusts to how many you are. Winning it moves the story on for the whole group, as alone. Medium and harder are made for two or more.",
  "news.2026-11-02-zzzzzzsheet.title": "Cards you can read",
  "news.2026-11-02-zzzzzzsheet.intro": "On a phone, every building's name shows whole.",
  "news.2026-11-02-zzzzzzsheet.sheet": "Building names no longer covered",
  "news.2026-11-02-zzzzzzsheet.sheet.desc": "Tapping a building on a phone, the erase and «Go here» buttons covered its name and split it word by word. Now they sit on their own row, on top.",
  "news.2026-11-02-zzzzzchat.title": "The chat from its last line",
  "news.2026-11-02-zzzzzchat.intro": "Joining a room, you read the latest first.",
  "news.2026-11-02-zzzzzchat.chat": "The room's chat opens at the end",
  "news.2026-11-02-zzzzzchat.chat.desc": "In the waiting room before going down together, the chat showed its oldest lines and you had to scroll down to see what was just said. Now it opens on the latest line.",
  "news.2026-11-02-zzzzroads.title": "Roads that don't lie",
  "news.2026-11-02-zzzzroads.intro": "In group incursions, the roads on the ground are the real ones again.",
  "news.2026-11-02-zzzzroads.roads": "Nightmares follow the roads you see",
  "news.2026-11-02-zzzzroads.roads.desc": "If someone in the group finished another incursion while you waited in the room, the place was laid out again with other roads when a friend joined, but those already inside kept seeing the old ones: nightmares walked where nothing was drawn. Now the room keeps the place it opened with.",
  "news.2026-11-02-zzzupdates.title": "Improvements without the wait",
  "news.2026-11-02-zzzupdates.intro": "New things arrive sooner, and nobody gets cut off.",
  "news.2026-11-02-zzzupdates.updates": "Updates without interruptions",
  "news.2026-11-02-zzzupdates.updates.desc": "An improvement used to wait until nobody was playing live, sometimes for hours. Now it goes out at once, and each bastion picks it up when its group is not in the middle of a fight. If one ever lands during a fight, the game reloads by itself and takes you back into the room within seconds.",
  "news.2026-11-02-zzwarden.title": "Clearer Warden blows",
  "news.2026-11-02-zzwarden.intro": "Where to stand now reads at a glance.",
  "news.2026-11-02-zzwarden.marks": "Red hits, blue saves",
  "news.2026-11-02-zzwarden.marks.desc": "The Warden's two big blows were marked in the same violet and were hard to tell apart. Now red is always where it hits: if the red circle spreads from the Warden, get away; if the red is outside and a pale blue circle lights up around it, get in there, close to the Warden. The ripples also show which way to go. And it no longer seems to hit outside the circle: the blast stops at the line, and in live play your hero is shown exactly where it stands when the blow lands. The same goes for every blow marked on the floor: eruptions, bolts, the Colossus, the Chasm, the Unsleeping, the dragon and the barrels.",
  "news.2026-11-02-zzblanks.title": "Complete texts",
  "news.2026-11-02-zzblanks.intro": "Two messages that showed a brace instead of a number.",
  "news.2026-11-02-zzblanks.blanks": "No stray braces",
  "news.2026-11-02-zzblanks.blanks.desc": "The button to awaken a relic showed a brace instead of a stage: now it just says «Awaken». And the notice that you need a higher level to rebuild in stone or clad in iron now says which level.",
  "news.2026-11-02-zautomaton.title": "The automaton in the crypts",
  "news.2026-11-02-zautomaton.intro": "The artificer's automaton now draws nightmares underground too.",
  "news.2026-11-02-zautomaton.automaton": "The automaton draws in the crypts",
  "news.2026-11-02-zautomaton.automaton.desc": "In the crypts and in boss fights, nightmares walked right past the automaton and on to the heroes. Now they go to break it, as on the bastion. A boss heeds it only for a moment when it lands, like a warrior's challenge (a little longer if it is the Colossus), and then comes back for the heroes.",
  "news.2026-11-02-zautomaton.crypts": "Slightly harder crypts",
  "news.2026-11-02-zautomaton.crypts.desc": "In all three crypts the nightmares have a little more life and hit a little harder, and more so for each artificer who goes down with the party, now that its automaton draws them.",
  "news.2026-11-02-patio.title": "The patio of deeds",
  "news.2026-11-02-patio.intro": "The sagas' trophies, set in order round the keep.",
  "news.2026-11-02-patio.patio": "A plinth for each saga",
  "news.2026-11-02-patio.patio.desc": "Each saga has its stone plinth with its lamp, two cells from the keep, and its trophies stand on it. Build on that cell and the plinth moves in towards the keep, never under a building. A saga you have begun shows its bare plinth until its first trophy. Brann and Hilde's bets and the weapons of the Unsleeping have one too.",
  "news.2026-11-02-gates.title": "Opens with the group level",
  "news.2026-11-02-gates.intro": "The hardest outings no longer wait for a Tide.",
  "news.2026-11-02-gates.gates": "By group level, not by Tide",
  "news.2026-11-02-gates.gates.desc": "The titan's far ring, ember incursions, the crypt in embers, plunder and the Furrows open with the group at level 5. Obsidian incursions, the deep crypt, the cellars and the Chasm, at level 8. Like the saga and the eras: the pace is set by what the group played, not the calendar.",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzznight.title": "The night of the bell",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzznight.intro": "The last saga reaches its end.",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzznight.night": "The Eyelid, chapter 4",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzznight.night.desc": "From group 50. A big one is coming, like few before it, and the bell has to ring all night.",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzaura.title": "A calmer aura",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzaura.intro": "The paladin's aura no longer throbs.",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzaura.aura": "A calmer paladin's aura",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzaura.aura.desc": "The ring of the paladin's aura stays on the ground but breathes slowly and only brightens now and then, instead of flashing every second while it heals or protects.",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzzzzzzzzzzground.title": "Detailed land",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzzzzzzzzzzground.intro": "The ground of from-scratch bastions looks finer.",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzzzzzzzzzzground.ground": "Finer ground on the land",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzzzzzzzzzzground.ground.desc": "In from-scratch bastions the grass has patches and grain, cliff rock runs in bands and every cell has a fine line round its edge. It looks better up close, on phones too, without asking more of your device.",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzzzzzzzzzzzleave.title": "Leaving without extra questions",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzzzzzzzzzzzleave.intro": "A fix when leaving the bastion.",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzzzzzzzzzzzleave.leave": "Leaving no longer asks where your ghost waits",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzzzzzzzzzzzleave.leave.desc": "On terraced land there are no roads to keep: your ghost always goes where it's needed most. So «Leave» no longer opens a question with a single answer: it just leaves.",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzzzzzzzzzfaces.title": "Familiar faces",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzzzzzzzzzfaces.intro": "The last saga goes on up on the head.",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzzzzzzzzzfaces.faces": "The Eyelid, chapter 3",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzzzzzzzzzfaces.faces.desc": "From group 48. Someone is walking along the edge of the eyelid, and you know that face.",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzzzzzzzzname.title": "The campaign’s name",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzzzzzzzzname.intro": "Whoever founded a campaign can now rename it.",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzzzzzzzzname.rename": "Rename the campaign",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzzzzzzzzname.rename.desc": "In the menu, tap “⋯” next to the campaign: if you founded it, you can give it a new name there. Everyone sees it.",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzzzzzzzbell.title": "The bell",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzzzzzzzbell.intro": "The last saga goes on.",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzzzzzzzbell.bell": "The Eyelid, chapter 2",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzzzzzzzbell.bell.desc": "From group 45. It weighs as much as ten carts, and it lies down the slope.",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzzzzzzgate.title": "Smoother group play",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzzzzzzgate.intro": "Fewer hitches in live crypts, incursions and waves.",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzzzzzzgate.ticks": "No more freezes every few seconds",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzzzzzzgate.ticks.desc": "In group play, the game stood still for half a second and then jumped, for everyone at once. It was the server saving the fight: now it saves without holding back what it sends you.",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzzzzhelp.title": "Helping at works, on the new land",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzzzzhelp.intro": "Your hero's hands count again in «From scratch» campaigns.",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzzzzhelp.help": "Helping at a work counts again",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzzzzhelp.help.desc": "In «From scratch» campaigns, helping at a work did nothing: the hero swung but the clock didn't move. Now it counts as on the ring.",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzzzzzearth.title": "Earthworks in sight",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzzzzzearth.intro": "Clearing and quarrying no longer surprise you with a hole in the wall.",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzzzzzearth.earth": "Time left, and where a way opens",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzzzzzearth.earth.desc": "Every cell being cleared or quarried shows its clock above it, like other works, and its card says what it is and who planned it. If it touches a wall or gate, the tag turns red and warns that a way opens when it's done; planning it warns too. Gathering with golems never uses up the woods or the rock: only Clear and Quarry remove them.",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzzzhours.title": "Wave hours that make sense",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzzzhours.intro": "When creating a campaign, the hours no longer overlap.",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzzzhours.hours": "The three wave hours, different and apart",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzzzhours.hours.desc": "When creating a campaign you can no longer pick three equal hours: they must be at least two hours apart. They can be picked in any order.",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzzlid.title": "The head",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzzlid.intro": "The last saga begins.",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzzlid.lid": "The Eyelid, chapter 1",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzzlid.lid.desc": "From group 42. The plumb won't keep still, and the Order knew something.",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzgate.title": "Both on your side, this time",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzgate.intro": "Brann and Hilde's last bet.",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzgate.gate": "Bet 9: \"The open gate\"",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzgate.gate.desc": "From group 40. It isn't paid in barrels: Hilde has another idea.",
  "news.2026-11-01-zzzzzzzzzzzzzzzzrelics.title": "Relics for everyone",
  "news.2026-11-01-zzzzzzzzzzzzzzzzrelics.intro": "The Unsleeping's relics no longer go only to whoever hits hardest.",
  "news.2026-11-01-zzzzzzzzzzzzzzzzrelics.relics": "The Unsleeping's relics, shared out",
  "news.2026-11-01-zzzzzzzzzzzzzzzzrelics.relics.desc": "The relic of an Unsleeping who falls for good goes to whoever fought him and has the fewest of those relics, not to whoever struck the last blow. Those who were playing come first; in a tie, the one who struck the last blow.",
  "news.2026-11-01-zzzzzzzzzzzzzzzrace.title": "Against the clock",
  "news.2026-11-01-zzzzzzzzzzzzzzzrace.intro": "Brann and Hilde disagree again.",
  "news.2026-11-01-zzzzzzzzzzzzzzzrace.race": "Bet 8: \"The race\"",
  "news.2026-11-01-zzzzzzzzzzzzzzzrace.race.desc": "From group 32. Hilde says you can; Brann says he did it in half the time.",
  "news.2026-11-01-zzzzzzzzzzzzzzsunken.title": "The bones rise",
  "news.2026-11-01-zzzzzzzzzzzzzzsunken.intro": "The Shore comes to an end.",
  "news.2026-11-01-zzzzzzzzzzzzzzsunken.sunken": "The Shore, chapter 5",
  "news.2026-11-01-zzzzzzzzzzzzzzsunken.sunken.desc": "From group 40. The end of the saga, with a new seal for awakening uniques.",
  "news.2026-11-01-zzzzzzzzzzzzzbones.title": "When the sea goes out",
  "news.2026-11-01-zzzzzzzzzzzzzbones.intro": "The Shore goes on.",
  "news.2026-11-01-zzzzzzzzzzzzzbones.bones": "The Shore, chapter 4",
  "news.2026-11-01-zzzzzzzzzzzzzbones.bones.desc": "From group 37. Once every seventy years the sea goes out far, and what lay on the bottom comes to light.",
  "news.2026-11-01-zzzzzzzzzzzzmaw.title": "A light at sea",
  "news.2026-11-01-zzzzzzzzzzzzmaw.intro": "The Shore goes on.",
  "news.2026-11-01-zzzzzzzzzzzzmaw.maw": "The Shore, chapter 3",
  "news.2026-11-01-zzzzzzzzzzzzmaw.maw.desc": "From group 34. Two boats broke on the rocks the same night. They saw a light and thought it was the lighthouse.",
  "news.2026-11-01-zzzzzzzzzfin.title": "The fin",
  "news.2026-11-01-zzzzzzzzzfin.intro": "The Shore goes on.",
  "news.2026-11-01-zzzzzzzzzfin.fin": "The Shore, chapter 2",
  "news.2026-11-01-zzzzzzzzzfin.fin.desc": "From group 31. Sometimes the titan moves its fin in its sleep, and every time it sends a wave over the stilt-houses.",
  "news.2026-11-01-zzzzzzzzzzzbond.title": "Bond",
  "news.2026-11-01-zzzzzzzzzzzbond.intro": "The last glyph, to share what you give yourself.",
  "news.2026-11-01-zzzzzzzzzzzbond.bond": "Bond",
  "news.2026-11-01-zzzzzzzzzzzbond.bond.desc": "What a skill does on you or on an ally (a Frenzy, a Last Stand, a heal) reaches the nearest ally too, at half.",
  "news.2026-11-01-zzzzzzzzzzzbond.expeditions": "Fragments from expeditions",
  "news.2026-11-01-zzzzzzzzzzzbond.expeditions.desc": "Expeditions and the Furrows give Bond fragments; with Bond complete, of any glyph. Bosses give it too, once the four conversions are complete.",
  "news.2026-11-01-zzzzzzzzashore.title": "The Shore",
  "news.2026-11-01-zzzzzzzzashore.intro": "A new saga, on the coast.",
  "news.2026-11-01-zzzzzzzzashore.shore": "The Shore, chapter 1",
  "news.2026-11-01-zzzzzzzzashore.shore.desc": "From group 28. At the stilt-houses on the fin, the nets bring up black scales. And at night something comes out of the water.",
  "news.2026-11-01-zzzzzzzzconversion.looks": "It looks its type",
  "news.2026-11-01-zzzzzzzzconversion.looks.desc": "A storm turned to fire looks like fire on the ground, and a plague turned to frost, like frost. Turrets, summons and shots with a type glyph glow and shed sparks of that colour.",
  "news.2026-11-01-zzzzzzzbeside.title": "Another bet",
  "news.2026-11-01-zzzzzzzbeside.intro": "Brann and Hilde are arguing again.",
  "news.2026-11-01-zzzzzzzbeside.beside": "Bet 7: \"Beside\"",
  "news.2026-11-01-zzzzzzzbeside.beside.desc": "From group 25. Hilde says her towers think. Brann says they don't.",
  "news.2026-11-01-zzzzzsima.title": "The Chasm",
  "news.2026-11-01-zzzzzsima.intro": "Under the deep crypt there is a crack with no bottom.",
  "news.2026-11-01-zzzzzsima.sima": "The Chasm: how deep you get",
  "news.2026-11-01-zzzzzsima.sima.desc": "Opens once the group wins the deep crypt to its bottom. You go down floor by floor, each harder and somewhere else in the titan, and every fifth floor a guardian waits with its own rule. What counts is the group's mark: the deepest floor anyone finished. Walking out keeps everything; falling, half. Play alone or 1 to 8 together; every week the order of the floors and their signs change. It is in Outings.",
  "news.2026-11-01-zzzzzfair.title": "Fair day",
  "news.2026-11-01-zzzzzfair.intro": "The well comes to an end.",
  "news.2026-11-01-zzzzzfair.fair": "The well, chapter 3",
  "news.2026-11-01-zzzzzfair.fair.desc": "From group 4. Musgoviejo holds its first fair in forty years. Something wants to make off with the wares.",
  "news.2026-11-01-zzrising.title": "What comes up",
  "news.2026-11-01-zzrising.intro": "The rails, the last part.",
  "news.2026-11-01-zzrising.rising": "The rails, chapter 4",
  "news.2026-11-01-zzrising.rising.desc": "From group 28. Something is coming up the rails, straight for the bastion. Before it gets there, the group decides what to do with the rails.",
  "news.2026-11-01-sheet.title": "Each outing's sheet closes on a phone",
  "news.2026-11-01-sheet.intro": "A small fix in Outings.",
  "news.2026-11-01-sheet.chat": "The chat no longer covers the close button",
  "news.2026-11-01-sheet.chat.desc": "On a phone, the chat button sat right on top of the cross that closes an outing's sheet. While the sheet is open, the chat steps aside; closing it brings the chat back.",
  "news.2026-11-01-crowd.title": "Smoother big waves",
  "news.2026-11-01-crowd.intro": "Crowds of nightmares ask less of the phone.",
  "news.2026-11-01-crowd.far": "Lighter nightmares and buildings at a distance",
  "news.2026-11-01-crowd.far.desc": "With the camera at its usual distance, nightmares and buildings are drawn with less detail, which doesn't show at that size. In a big wave, a phone's graphics chip works almost a third less. Zoom in and the full detail is back.",
  "news.2026-10-31-zzzzzzzzzzzzzzzzzzzzzzzzzzzzanvil.title": "The bottom of it all",
  "news.2026-10-31-zzzzzzzzzzzzzzzzzzzzzzzzzzzzanvil.intro": "The rails reach the very bottom.",
  "news.2026-10-31-zzzzzzzzzzzzzzzzzzzzzzzzzzzzanvil.anvil": "The rails, chapter 3",
  "news.2026-10-31-zzzzzzzzzzzzzzzzzzzzzzzzzzzzanvil.anvil.desc": "From group 25. Something down there beats, and you have to keep time with it.",
  "news.2026-10-31-zzzzzzzzzzzzzzzzzzzzzzzzzzzlight.title": "Lighter on the phone",
  "news.2026-10-31-zzzzzzzzzzzzzzzzzzzzzzzzzzzlight.intro": "The bastion and the waves ask less of the phone.",
  "news.2026-10-31-zzzzzzzzzzzzzzzzzzzzzzzzzzzlight.light": "A lighter bastion and woods",
  "news.2026-10-31-zzzzzzzzzzzzzzzzzzzzzzzzzzzlight.light.desc": "The bastion's trophies are drawn in one go instead of piece by piece, the marks over the works no longer move every frame, and the woods outside the walls are drawn only where the camera looks. Slower phones feel it in the bastion and in big waves.",
  "news.2026-10-31-zzzzzzzzzzzzzzzzzzzzzzzzzreread.title": "Read it again",
  "news.2026-10-31-zzzzzzzzzzzzzzzzzzzzzzzzzreread.intro": "The stories, at your pace.",
  "news.2026-10-31-zzzzzzzzzzzzzzzzzzzzzzzzzreread.back": "A step back in the stories",
  "news.2026-10-31-zzzzzzzzzzzzzzzzzzzzzzzzzreread.back.desc": "In the saga, the other stories, the cellars and the Furrows, the «Back» button shows the previous line again. It works before choosing too.",
  "news.2026-10-31-zzzzzzzzzzzzzzzzzzzzzzzzzreread.ring": "By the pit, how long is left shows",
  "news.2026-10-31-zzzzzzzzzzzzzzzzzzzzzzzzzreread.ring.desc": "The ring that fills while you wait by the pit now runs round its edge, thicker, and marks how far out you can stand.",
  "news.2026-10-31-zzzzzzzzzzzzzzzzzzzzzzzzwinder.title": "Further down still",
  "news.2026-10-31-zzzzzzzzzzzzzzzzzzzzzzzzwinder.intro": "The rails keep going down.",
  "news.2026-10-31-zzzzzzzzzzzzzzzzzzzzzzzzwinder.winder": "The rails, chapter 2",
  "news.2026-10-31-zzzzzzzzzzzzzzzzzzzzzzzzwinder.winder.desc": "From group 23: at the foot of the fast way there are dwarven halls with their lamps lit. Someone has kept them all this time.",
  "news.2026-10-31-zzzzzzzzzzzzzzzzzzzzzzzpit.title": "The pit can be reached",
  "news.2026-10-31-zzzzzzzzzzzzzzzzzzzzzzzpit.intro": "The way through the woods, open.",
  "news.2026-10-31-zzzzzzzzzzzzzzzzzzzzzzzpit.pit": "The pit in the woods, within reach",
  "news.2026-10-31-zzzzzzzzzzzzzzzzzzzzzzzpit.pit.desc": "In Borrowed faces, chapter 3, the pit sometimes lay among the trees with no way to stand beside it: nobody came out. Now a trail leads from the clearing to the pit; stay by it and they come out one at a time.",
  "news.2026-10-31-zzzzzzzzzzzzzzzzzzzzzzrails.title": "Deeper than anything",
  "news.2026-10-31-zzzzzzzzzzzzzzzzzzzzzzrails.intro": "Hilde hears something from far below.",
  "news.2026-10-31-zzzzzzzzzzzzzzzzzzzzzzrails.rails": "The rails",
  "news.2026-10-31-zzzzzzzzzzzzzzzzzzzzzzrails.rails.desc": "A new saga, from group 21: the fast way of Hilde's clan goes deeper than the crypt. Hold on.",
  "news.2026-10-31-zzzzzzzzzzzzzzzzzzzzzend.title": "No freeze at the end of a wave",
  "news.2026-10-31-zzzzzzzzzzzzzzzzzzzzzend.intro": "The last nightmare no longer freezes the screen.",
  "news.2026-10-31-zzzzzzzzzzzzzzzzzzzzzend.end": "The end of a wave, without the wait",
  "news.2026-10-31-zzzzzzzzzzzzzzzzzzzzzend.end.desc": "When the last nightmare fell, the screen stood still for a few seconds before showing the result. Now the end comes right away.",
  "news.2026-10-31-zzzzzzzzzzzzzzzzzzbell.title": "The bell weighs more",
  "news.2026-10-31-zzzzzzzzzzzzzzzzzzbell.intro": "Raising the gate bell is a fight again.",
  "news.2026-10-31-zzzzzzzzzzzzzzzzzzbell.winch": "Holding the winch",
  "news.2026-10-31-zzzzzzzzzzzzzzzzzzbell.winch.desc": "While the cellars winch turns, nightmares come more often and grow as the bell rises, some of them inked, and the old garrison’s sergeants come down every second press. A higher-level party meets them tougher and in greater numbers.",
  "news.2026-10-31-zzzzzzzzzzzzzzzzzzzsalidas.title": "Outings",
  "news.2026-10-31-zzzzzzzzzzzzzzzzzzzsalidas.intro": "Everything you can go out to play, in one place.",
  "news.2026-10-31-zzzzzzzzzzzzzzzzzzzsalidas.screen": "One screen to choose what to play",
  "news.2026-10-31-zzzzzzzzzzzzzzzzzzzsalidas.screen.desc": "Incursions, crypts, the cellars, the Furrows, the saga, the other stories and the bets are now together under “Outings”. At the top, what still pays today and who is gathering; then one card per outing with its level, whether you already claimed it and what it gives.",
  "news.2026-10-31-zzzzzzzzzzzzzzzzzzzsalidas.history": "Who went, when and with whom",
  "news.2026-10-31-zzzzzzzzzzzzzzzzzzzsalidas.history.desc": "Each outing keeps how many times you went, how many you won, the last time and with whom. Tap it to see the history, yours or the whole group’s. It starts counting today.",
  "news.2026-10-31-zzzzzzzzzzzzzzzzzalone.title": "A new bet",
  "news.2026-10-31-zzzzzzzzzzzzzzzzzalone.intro": "Brann and Hilde never learn.",
  "news.2026-10-31-zzzzzzzzzzzzzzzzzalone.alone": "One alone",
  "news.2026-10-31-zzzzzzzzzzzzzzzzzalone.alone.desc": "From group 20, Brann bets one hero can hold a whole road with no help. Hilde isn't so sure.",
  "party.wayfarer": "wayfarer",
  "party.ally": "ally",
  "news.2026-10-31-zzzzzzzzzzzzzzzzdragon.title": "What the Burn is worth",
  "news.2026-10-31-zzzzzzzzzzzzzzzzdragon.intro": "The wayfarers' saga doesn't end up in a drawer.",
  "news.2026-10-31-zzzzzzzzzzzzzzzzdragon.dragon": "Against the dragon",
  "news.2026-10-31-zzzzzzzzzzzzzzzzdragon.dragon.desc": "What the group found in the Burn helps in the Turtle's last fight. Each chapter done brings something; the whole saga, someone more.",
  "side.burn.edge.ballista": "fourth harpoon",
  "side.burn.edges": "The Burn: {list}.",
  "side.burn.edge.map": "fire marked earlier",
  "side.burn.edge.scale": "cracked scale",
  "side.burn.edge.beacon": "beacon light",
  "side.burn.edge.orla": "Orla",
  "side.burn.tower.title": "The watchtower",
  "side.burn.tower.smoke.l1": "From the harpoon you can see a tower of black stone in the middle of the glass. Smoke rises from its top: someone lit a fire inside.",
  "side.burn.tower.smoke.l2": "It's Tobin. He makes fire like his father did: lots of smoke, little flame.",
  "side.burn.tower.smoke.l3": "All around it the glass is full of cracks, and that's where the nightmares come from. Cracks close if you blow them shut: take powder.",
  "side.burn.tower.smoke.l4": "And the tower has a beacon. Light it, and it'll be seen from the bastion.",
  "side.burn.tower.cracks.title": "The cracks",
  "side.burn.tower.cracks.goal": "Tobin is shut in the tower, and the nightmares come out of the cracks in the glass. He hands down powder barrels: take each one to a crack and get away before it blows. Every crack takes two. Take too many blows with a barrel on you and it goes off in your hands. Don't let the tower fall.",
  "side.burn.tower.map.l1": "With the last crack shut, the beacon flares over the Burn. Tobin comes down, his face black with soot.",
  "side.burn.tower.map.l2": "Late. But whole.",
  "side.burn.tower.map.l3": "That night, at the bastion's table, Orla finishes the map. Then she reads the diary's last page aloud.",
  "side.burn.tower.map.l4": "\"Those of us left are not going back to the town. We are climbing to the summit, to watch that the titan stays asleep.\"",
  "side.burn.tower.map.l5": "\"We call ourselves the Vigil. If anyone reads this, let them not forget us.\"",
  "side.burn.tower.map.l6": "The Order. It started here.",
  "side.burn.tower.map.l7": "We wayfarers owe you one. When you need us, we'll be there.",
  "side.burn.beaconNew": "The watchtower's beacon burns over the Burn: you can see it from the bastion.",
  "side.blastRule": "Take Tobin's barrels to the cracks (two each) and get away. Don't let the tower fall.",
  "side.blastTower": "Watchtower",
  "side.blastOf": "cracks shut · of {n}",
  "side.blastReady": "A barrel is waiting on the stack by the tower.",
  "side.blastNext": "Tobin hands down another barrel in {s} s",
  "side.blast.ready": "Tobin handed a barrel down to the stack.",
  "side.blast.crack": "The crack narrows. One more barrel shuts it.",
  "side.blast.seal": "Crack shut!",
  "side.blast.burst": "The barrel went off too soon!",
  "side.blast.beacon": "The beacon is lit!",
  "side.wayCrack": "A crack",
  "side.wayBarrel": "A barrel",
  "news.2026-10-31-zzzzzzzzzzzzzzztower.title": "The Burn, the end",
  "news.2026-10-31-zzzzzzzzzzzzzzztower.intro": "The wayfarers' saga comes to its end.",
  "news.2026-10-31-zzzzzzzzzzzzzzztower.tower": "The last chapter",
  "news.2026-10-31-zzzzzzzzzzzzzzztower.tower.desc": "The day after the third chapter, Orla knows where Tobin is.",
  "news.2026-10-31-zzzzzzzzzzzzcamera.title": "The camera, with a mouse",
  "news.2026-10-31-zzzzzzzzzzzzcamera.intro": "A fix for those who play on a computer.",
  "news.2026-10-31-zzzzzzzzzzzzcamera.drag": "Dragging moves the camera",
  "news.2026-10-31-zzzzzzzzzzzzcamera.drag.desc": "With a mouse or trackpad, holding and dragging in a battle moves the camera, as in the bastion, instead of walking the hero. To move it, click where you want it to go or drag from the hero itself.",
  "news.2026-10-31-zzzzzzzzzzzpaladin.title": "A holier paladin",
  "news.2026-10-31-zzzzzzzzzzzpaladin.intro": "Two requests from those who play it.",
  "news.2026-10-31-zzzzzzzzzzzpaladin.smite": "Smite from afar",
  "news.2026-10-31-zzzzzzzzzzzpaladin.smite.desc": "The hammer of light falls from the sky: you no longer need to stand next to the nightmare to cast it.",
  "news.2026-10-31-zzzzzzzzzzzpaladin.hallow": "Hallow heals",
  "news.2026-10-31-zzzzzzzzzzzpaladin.hallow.desc": "Besides weakening the nightmares and burning the ink, the hallowed ground heals the heroes on it every second.",
  "side.burn.trap.title": "The first Vigil's trap",
  "side.burn.trap.engine.l1": "Tobin's marks end at the foot of a huge engine, half sunk in the glass: a harpoon three men long, mounted on a frame of black beams.",
  "side.burn.trap.engine.l2": "Tobin came through here. Beyond it lies the way further in, and something big blocks it.",
  "side.burn.trap.engine.l3": "That's no ballista. It's a trap. They built it for something that flies.",
  "side.burn.trap.engine.l4": "It's broken, but whole. Two winches to wind it and a lever on a rope. It only has to work once.",
  "side.burn.trap.engine.l5": "Then we make it work.",
  "side.burn.trap.harpoon.title": "The harpoon",
  "side.burn.trap.harpoon.goal": "A glass colossus blocks the way, and almost nothing hurts it. Wind the trap at its two winches, bring the colossus into the harpoon's line and stand on the lever. Every shot needs winding again.",
  "side.burn.trap.diary.l1": "Among the trap's beams lay a small chest, sealed with pitch. Inside, a diary.",
  "side.burn.trap.diary.l2": "It is the trap captain's. \"Fire did nothing to it: the hot glass closed over. The harpoon went in under the left wing.\"",
  "side.burn.trap.diary.l3": "\"It did not fall. It roared, tore the harpoon out and flew off over the sea, bleeding.\"",
  "side.burn.trap.diary.l4": "\"That night it froze. Cold, its glass cracked where the harpoon went in, under the left wing. If it comes back, let someone remember.\"",
  "side.burn.trap.diary.l5": "They're talking about the dragon. The real one.",
  "side.burn.trap.diary.l6": "And Tobin read the same as we did. He went on toward the tower you can see from here.",
  "side.burn.harpoonNew": "The trap's harpoon, in the bastion: the one that wounded the dragon centuries ago.",
  "side.trapRule": "Wind both winches, bring the colossus into the line and stand on the lever.",
  "side.trapHits": "harpoons",
  "side.trapWinding": "Wound: {n} %",
  "side.trapReady": "Ready! With the colossus in the line, to the lever.",
  "side.trapFlying": "The harpoon flies!",
  "side.trap.armed": "The trap is wound. Bring the colossus into the line and stand on the lever.",
  "side.trap.hit": "The harpoon runs the colossus through!",
  "side.trap.miss": "The harpoon missed. It needs winding again.",
  "side.wayWinch": "A winch",
  "side.wayLever": "The lever",
  "news.2026-10-31-zzzzzzzzzzzzztrap.title": "The Burn, third chapter",
  "news.2026-10-31-zzzzzzzzzzzzztrap.intro": "Something old waits in the glass.",
  "news.2026-10-31-zzzzzzzzzzzzztrap.trap": "What the first Vigil left",
  "news.2026-10-31-zzzzzzzzzzzzztrap.trap.desc": "The day after the second chapter, Tobin's marks lead further in.",
  "news.2026-10-31-zzzzzzzzzfear.title": "Nerve after a fright",
  "news.2026-10-31-zzzzzzzzzfear.intro": "Against packs of ogres.",
  "news.2026-10-31-zzzzzzzzzfear.fear": "Fear no longer chains",
  "news.2026-10-31-zzzzzzzzzfear.fear.desc": "When an ogre's or a giant's roar frightens you, once it wears off no other roar can frighten you for 4 seconds. With many ogres around you no longer spend half the fight without your skills.",
  "side.wait": "The next chapter opens tomorrow (in {h} h).",
  "side.burn.camp.title": "The camp in the glass",
  "side.burn.camp.marks.l1": "Orla spreads the half-drawn map across the table.",
  "side.burn.camp.marks.l2": "Tobin leaves marks: three stones in a row, the middle one smaller. They go further in, as far as the smoke we saw.",
  "side.burn.camp.marks.l3": "That's no wayfarers' camp. We don't light fires on the glass.",
  "side.burn.camp.marks.l4": "Then whose is it?",
  "side.burn.camp.marks.l5": "Let's go and see. I'm bringing the cart: whatever's there, we bring back.",
  "side.burn.camp.camp.title": "The sunken camp",
  "side.burn.camp.camp.goal": "An old camp, half sunk in the glass. Take the chests to Orla's cart; the nightmares drag off whatever is left on the ground. With eight loaded you can go home: everyone by the cart.",
  "side.burn.camp.forge.l1": "At the forge, Hilde turns a melted spearhead against the light.",
  "side.burn.camp.forge.l2": "My clan didn't forge this. It's older. Much older.",
  "side.burn.camp.forge.l3": "And these ballistas… nobody has built like this in centuries. Look where they melted: the fire came from above.",
  "side.burn.camp.forge.l4": "There was a banner, with an open eye stitched on it. We'll hang it in the bastion until we know whose it is.",
  "side.burn.camp.forge.l5": "Tobin's marks lead further in, toward something huge rising out of the glass.",
  "side.burn.bannerNew": "The sunken camp's banner, in the bastion: an open eye, stitched centuries ago.",
  "side.campRule": "Take the chests to Orla's cart. With eight, everyone by the cart and home.",
  "side.campIntro": "Pick up a chest (C) and take it to Orla's cart. With {n} loaded you can go home: everyone by the cart, then Leave (V).",
  "side.campLoaded": "in the cart · {n} needed",
  "side.campCart": "Orla's cart",
  "side.campGolem": "Orla leaves on her own in",
  "news.2026-10-31-zzzzzzzzzzcamp.title": "The Burn, second chapter",
  "news.2026-10-31-zzzzzzzzzzcamp.intro": "The wayfarers' saga goes on.",
  "news.2026-10-31-zzzzzzzzzzcamp.camp": "Tobin's marks",
  "news.2026-10-31-zzzzzzzzzzcamp.camp.desc": "The day after the first chapter, Orla follows her son's trail. From now on the Burn opens a chapter a day.",
  "news.2026-10-31-zzzzzzzzwaves.title": "Giant waves, smoother",
  "news.2026-10-31-zzzzzzzzwaves.intro": "For the phones that stuttered in the biggest waves.",
  "news.2026-10-31-zzzzzzzzwaves.waves": "More frames with hundreds of nightmares",
  "news.2026-10-31-zzzzzzzzwaves.waves.desc": "With hundreds of nightmares on the field, the game asks much less of the phone: in a real wave of over 3000 nightmares, 50 to 60 % more frames per second. It looks the same.",
  "npc.orla": "Orla",
  "npc.orla.role": "Wayfarer, mapmaker",
  "side.well.fair.odna.l1": "Odna allows a fair in Musgoviejo's square. The first in forty years.",
  "side.well.fair.odna.b1": "Odna, the mayor of Musgoviejo. She doesn't like us. She has her reasons.",
  "side.well.fair.odna.l2": "Pell says he owes you the water.",
  "side.well.fair.odna.f1": "Come and see the fair. From a distance.",
  "side.well.fair.odna.c1": "The caravan came in whole. Come up close.",
  "side.well.fair.odna.l3": "Tonight there are lanterns in the square. If anything comes up, let it be people.",
  "side.well.fair.stalls.title": "The fair",
  "side.well.fair.stalls.goal": "The draggers haul the wares from the stalls to their holes. Kill them so they drop them, pick them up and take them back to their stall. The ink thieves only show near a lantern. What you save decides how big the fair is.",
  "side.well.fair.fenn.g1": "The fair fills the whole square. The lanterns light up on the flank, and from the bastion they look like a river of light.",
  "side.well.fair.fenn.m1": "The fair's lanterns light up on the flank. A few stalls are missing, but from the bastion you can see them.",
  "side.well.fair.fenn.s1": "A few lanterns light up on the flank. It's a small fair, but it's a fair, and you can see it from the bastion.",
  "side.well.fair.fenn.l1": "Fenn, the pedlar. If anyone knows what's going on across the titan, it's him.",
  "side.well.fair.fenn.l2": "Fenn. I sell everything but advice. That I give away.",
  "side.well.fair.fenn.l3": "Thanks for the cart. One for free: the Horn clan, out on the tail, keeps losing their herd.",
  "side.well.fair.fenn.l4": "And another: Cal, Mada's boy, went off to the tail with them for the whole season.",
  "side.well.fair.fenn.l5": "I'll leave you the fair's banner. Let it be seen from the square.",
  "side.result.fair": "Wares saved: {n} of {of}",
  "side.fairRule": "Kill the draggers so they drop what they stole, pick it up and take it back to its stall. The ink thieves only show near a lantern.",
  "side.fairOf": "wares at their stalls · of {n}",
  "side.fairLeft": "The fair closes in {s} s",
  "side.fair.cart": "They're taking Fenn's cart!",
  "side.fair.drop": "It dropped the wares! Stay by them to pick them up.",
  "side.fair.back": "Back at its stall.",
  "side.fair.lost": "Wares lost down a hole.",
  "side.fair.end": "The fair closes.",
  "side.well.bannerNew": "The banner of Musgoviejo's fair, in the bastion.",
  "side.shore.title": "The Shore",
  "side.shore.question": "What is breaking the fishers' boats?",
  "side.shore.over": "At the stilt-houses the boats come back whole.",
  "side.shore.nets.title": "What the nets bring up",
  "side.shore.fin.title": "The fin",
  "side.shore.maw.title": "The Maw",
  "side.shore.bones.title": "The bones",
  "side.shore.drowned.title": "The Drowned Dragon",
  "side.shore.nets.scale.l1": "Fenn comes up to the bastion with a thin woman, hard-handed, her boots wet.",
  "side.shore.nets.scale.l2": "Yorra, from the stilt-houses on the fin. If she came all the way up here, it's serious.",
  "side.shore.nets.scale.l3": "Yorra sets a scale on Hilde's table. It's black and hard as glass.",
  "side.shore.nets.scale.l4": "The nets bring up scales. No fish has scales like that.",
  "side.shore.nets.scale.l5": "And at night people who aren't people come out of the water.",
  "side.shore.nets.scale.l6": "And the net?",
  "side.shore.nets.scale.l7": "The big one got caught on the reef. Tomorrow the sea goes out low: there's a while to go and get it.",
  "side.shore.nets.lowwater.title": "The low water",
  "side.shore.nets.lowwater.goal": "With the sea out, one of the roads reaches the reef. Work the net loose (two do it quicker) and bring it to the stilt-house before the water comes back: in the water you wade slowly and drown. That night the Drowned come up for it: hold till dawn. If a Drowned grabs you, it drags you out to sea: hit it to get free.",
  "side.shore.nets.burnt.l1": "The water comes back like a wall of foam. When the sun comes up the net is safe at the stilt-house, and the reef is gone.",
  "side.shore.nets.burnt.l2": "This isn't from a nightmare. It's a real scale. And it's burnt.",
  "side.shore.nets.burnt.b1": "The first Vigil's diary said the dragon flew off wounded over the sea. It doesn't say it ever got anywhere.",
  "side.shore.nets.burnt.l3": "Whatever it is, it's still down there. And we go out fishing every day.",
  "side.tideRule": "Bring the net from the reef before the water comes back and hold the night at the stilt-house. If a Drowned grabs you, hit it to get free.",
  "side.tideNode": "Stilt-houses",
  "side.tideNet.reef": "The net, caught on the reef",
  "side.tideNet.ground": "The net, lying loose",
  "side.tideNet.carried": "The net, on its way",
  "side.tideNet.home": "The net, at the stilt-house",
  "side.tideLow": "The water comes back in {s} s",
  "side.tideDawn": "Dawn in {s} s",
  "side.tide.back": "The water's coming back! And the Drowned with it.",
  "side.tide.loose": "The net is loose! Take it to the stilt-house.",
  "side.tide.home": "The net is at the stilt-house! Hold till dawn.",
  "side.tide.dawn": "Dawn!",
  "side.tide.lost": "The sea took the net.",
  "side.tide.grab": "A Drowned is dragging someone out to sea!",
  "side.tide.grabMe": "A Drowned is dragging you out to sea! Hit it to get free.",
  "side.tide.freeMe": "Free!",
  "enemy.drowned": "Drowned",
  "enemy.drowned.desc": "A nightmare shaped like a bloated fisherman, with nets and stones tied on. Slow and tough. It grabs a hero and drags them out to sea unless someone cuts it loose.",
  "npc.yorra": "Yorra",
  "npc.yorra.role": "Fisher from the stilt-houses on the fin",
  "side.shore.netNew": "The stilt-houses' great net, with a black scale caught in it.",
  "side.shore.fin.wave.l1": "Yorra comes up to the bastion again, soaked to the knees.",
  "side.shore.fin.wave.l2": "Sometimes the titan moves its fin in its sleep, as if swimming. Every time, a wave.",
  "side.shore.fin.wave.l3": "What's new is that they come up with the wave.",
  "side.shore.fin.wave.l4": "A wave that sweeps everything. That doesn't pick a side.",
  "side.shore.fin.lanes.title": "The lanes",
  "side.shore.fin.lanes.goal": "Every so often the fin comes down and a wave sweeps a lane: it's marked 5 s ahead. Whatever is left in the lane the water takes, nightmares included. Hold on to a post or get out of the lane. At night the Drowned come up: leave them in the lane when the wave comes. Hold till dawn.",
  "side.shore.fin.father.l1": "The fin rises out of the sea, the size of a mountain, streaming water. Its shadow covers the whole of the stilt-houses.",
  "side.shore.fin.father.l2": "And it comes down. The last wave takes what was left of the Drowned.",
  "side.shore.fin.father.l3": "My father used to say the titan doesn't know we're here. I think it does.",
  "side.shore.fin.father.l4": "Whatever stays in the lane, the fin crushes. Worth remembering.",
  "side.finRule": "When a lane is marked, hold on to a post or get out: the wave takes whatever's left. Leave the Drowned in it.",
  "side.finNext": "The fin comes down in {s} s",
  "side.finMarked": "Lane marked! The wave comes in {s} s",
  "side.finDay": "Day · dawn in {s} s",
  "side.finNight": "Night · dawn in {s} s",
  "side.fin.warn": "The fin is rising! Hold on to a post or get out of the lane.",
  "side.fin.sweep": "The wave sweeps the lane!",
  "side.fin.dawn": "Dawn!",
  "side.fin.warnFire": "The dragon surfaces! Get out of the marked lane.",
  "side.fin.sweepFire": "Fire down the lane!",
  "side.fin.warnBig": "The fin rises! Keep the dragon still in the lane.",
  "side.breathRule": "The dragon sweeps the marked lane with fire: get out. A post won't stop fire. Hold until dawn.",
  "side.breathNext": "Fire in {s} s",
  "side.breathMarked": "Lane marked! Fire in {s} s",
  "side.sunkenRule": "Lead the dragon into the marked lane and keep it from moving (stunned, taunted, rooted, drawing breath or harpooned): the fin takes a third of its life. Hold on to a post yourself.",
  "side.sunkenLife": "Drowned Dragon · {n} %",
  "side.sunken.heartFire": "Whoever carries the heart draws the fire: don't leave them alone.",
  "side.sunken.heartBait": "The dragon goes after its heart: take it into the marked lane.",
  "side.sunken.rise": "The Drowned Dragon comes out of the sea!",
  "side.sunken.harpoon": "A harpoon from the boats! It's held still a moment.",
  "side.sunken.crush": "The fin crushed it!",
  "side.sunken.shrug": "It moved: the wave went past it.",
  "side.sunken.felled": "The Drowned Dragon has fallen!",
  "side.sunken.drop": "The heart is on the ground! Pick it up.",
  "side.sunken.lift": "Someone picked up the heart.",
  "side.shore.fangNew": "A fang of the Drowned Dragon, over the gate.",
  "side.shore.oarNew": "An oar from the stilt-houses, leant against the great net's frame.",
  "side.shore.maw.light.l1": "Yorra comes up at night. Her face is cut by a rope.",
  "side.shore.maw.light.l2": "Two boats broke on the rocks the same night. They saw a light.",
  "side.shore.maw.light.l3": "They thought it was the lighthouse.",
  "side.shore.maw.light.l4": "Then we light the real lighthouse. And put out the other light.",
  "side.shore.maw.maw.title": "The Maw",
  "side.shore.maw.maw.goal": "At the tip of the fin, at night. The Maw has a light hanging over its mouth: while it shines, it drags you towards it. Break the light's stalk and it's blind and still for a while: hit it then. Keep the lighthouse's braziers lit: with more fire, the false light drags less. Don't let the lighthouse fall.",
  "side.shore.maw.boat.l1": "The Maw's light goes out and the sea goes black. The lighthouse turns, and its beam shows the open mouth right under the pier. Then, nothing.",
  "side.shore.maw.boat.l2": "The boat the Maw nearly took ends up on dry land, by the bastion wall.",
  "side.shore.maw.boat.l3": "So you remember who saved it.",
  "side.mawRule": "Break the light's stalk to leave it dark and hit it then. Lit braziers slow the drag. Don't let the lighthouse fall.",
  "side.mawNode": "Lighthouse",
  "side.mawOf": "braziers lit · of {n}",
  "side.mawLit": "The light drags: break the stalk",
  "side.mawDark": "Dark! Hit it: {s} s",
  "side.maw.dark": "The light is out! The Maw is blind and still.",
  "side.maw.light": "The light comes back on.",
  "side.maw.out": "A Drowned put out a brazier!",
  "side.maw.lit": "Brazier lit.",
  "side.maw.bite": "The Maw bites you!",
  "side.maw.felled": "The Maw has fallen!",
  "enemy.maw": "The Maw",
  "enemy.maw.desc": "A fish of ink the size of a ship, with a light hanging over its mouth. While it shines, whatever sees it walks towards the mouth.",
  "enemy.lure": "The Maw's light",
  "enemy.lure.desc": "The stalk that holds the light. Broken, the light goes out for a few seconds.",
  "side.shore.boatNew": "The boat saved from the Maw, on dry land beside the great net.",
  "side.shore.bones.far.l1": "The fin stayed raised. Yorra comes up to the bastion before dawn.",
  "side.shore.bones.far.l2": "My grandmother used to say that's how it starts. Tomorrow the sea goes out far.",
  "side.shore.bones.far.l3": "It happens once every seventy years.",
  "side.shore.bones.far.l4": "The next day, the sea goes out further than the eye can see. A league from the fin, on the bottom, black bones appear, burnt and covered in coral.",
  "side.shore.bones.far.l5": "They're a dragon's bones. The real one: the one that burned the titan centuries ago. It fell here and never rose again.",
  "side.shore.bones.far.l6": "Ink runs through them. Something is getting in. We go down before the water comes back.",
  "side.shore.bones.ribs.title": "Between the ribs",
  "side.shore.bones.ribs.goal": "Go down room by room between the dragon's ribs, to the chest. Ink runs through the bones, and what comes up from below fights.",
  "side.shore.bones.heart.l1": "In the skeleton's chest its heart glows: a red stone the size of a barrel, with an ember inside. It's still warm.",
  "side.shore.bones.heart.b1": "Beside it, a huge scale, split from side to side. The first Vigil's trap split it.",
  "side.shore.bones.heart.b2": "The diary was right. They hit it, and it came here to die.",
  "side.shore.bones.heart.l2": "Far off, you hear the water starting to come back.",
  "side.shore.bones.heart.l3": "With an ember of that, at the forge, I could wake anything.",
  "side.shore.bones.heart.l4": "And if you take it, whatever is in these bones will come looking for it.",
  "side.shore.bones.heart.vote": "What do you do with the dragon's heart?",
  "side.shore.bones.heart.c.take": "Take it: to the forge, and the dragon will come looking for it",
  "side.shore.bones.heart.c.leave": "Leave it: let the sea keep it",
  "side.shore.bones.back.title": "The way back",
  "side.shore.bones.back.goal": "The sea comes back the way you came down. Run room by room to the rock, in the last room: in the water you wade slowly and drown.",
  "side.shore.bones.back.goalHeart": "The sea comes back the way you came down. Run to the rock, in the last room, with the heart: whoever carries it is slower, and if they fall someone else has to pick it up before the water takes it. The Drowned go for it.",
  "side.shore.bones.claw.l1": "The last hero climbs onto the rock. Behind, the sea covers the bones.",
  "side.shore.bones.claw.l2": "A claw of bone comes out of the water and digs into the shore. And stays there.",
  "side.shore.bones.claw.t1": "The heart is in the forge. It warms on its own, like the Anvil. Now it knows where we are.",
  "side.shore.bones.claw.m1": "Let it keep its heart. Hopefully that's enough.",
  "side.shore.bones.claw.l3": "It isn't. That claw didn't dig in by itself.",
  "side.shore.drowned.wall.l1": "Brann has been on the wall since before dawn, watching the sea. He doesn't move when the group comes up.",
  "side.shore.drowned.wall.b1": "The one at the Burn, the nightmares made of smoke and glass. This is the real one: its own bones, with something inside.",
  "side.shore.drowned.wall.n1": "Centuries ago it burned the titan. Now it comes back in its own bones.",
  "side.shore.drowned.wall.t1": "That night, the heart at the forge beats. Once, and again, harder each time.",
  "side.shore.drowned.wall.t2": "It's coming for it. One of us carries it, and runs.",
  "side.shore.drowned.wall.m1": "It kept its heart, and that's not enough for it. Now it wants the fin.",
  "side.shore.drowned.breath.title": "In the water",
  "side.shore.drowned.breath.goal": "The dragon swims round the fin and surfaces to sweep fire down one lane of the stilt-houses: it is marked 3 s ahead. A post won't stop fire: get out of the lane. The Drowned come up in batches. Hold until dawn.",
  "side.shore.drowned.breath.goalHeart": "The dragon came for its heart. One hero carries it, slower, and the dragon's fire goes for their lane: it is marked 3 s ahead, and a post won't stop fire. If the carrier falls, someone else picks it up. The Drowned come up in batches. Hold until dawn.",
  "side.shore.drowned.boats.l1": "Dawn. The dragon sinks, and the water boils where it was.",
  "side.shore.drowned.boats.l2": "The boats we have left will be out on the water. They carry whale harpoons.",
  "side.shore.drowned.boats.l3": "A harpoon won't kill it. But it holds it still a while.",
  "side.shore.drowned.sunken.title": "The Drowned Dragon",
  "side.shore.drowned.sunken.goal": "The dragon comes out of the sea. Blows barely touch it: what breaks its bones is the fin. Every so often it comes down on a lane, 6 s ahead. If the dragon is in that lane and can't move just then (stunned, taunted, rooted, drawing breath for its fire, or with a harpoon from the boats in it), the fin takes a third of its life. Hold on to a post yourself. Don't let the stilt-houses fall.",
  "side.shore.drowned.sunken.goalHeart": "The dragon comes out of the sea after whoever carries its heart. Blows barely touch it: what breaks its bones is the fin. Every so often it comes down on a lane, 6 s ahead. Lead it into the lane with the heart: while it follows, if the fin catches it there, it takes a third of its life. With its chest empty it has more life, and strikes with steam. Hold on to a post. Don't let the stilt-houses fall.",
  "side.shore.drowned.still.l1": "The fin, the size of a mountain, comes down on the dragon of bone. The sea splits open and the bones burst.",
  "side.shore.drowned.still.l2": "For an instant the whole titan moves under everyone's feet. Then it lies still.",
  "side.shore.drowned.still.t1": "The heart at the forge has gone dark. Only the ember is left. It doesn't beat any more.",
  "side.shore.drowned.still.l3": "My father was half right. The titan knows we're here. And this time it helped us.",
  "side.shore.drowned.still.l4": "A fang, over the gate. So whatever comes from the sea knows who it's dealing with.",
  "side.lid.title": "The Eyelid",
  "side.lid.question": "Can the titan be kept asleep?",
  "side.lid.over": "The titan sleeps. As it used to.",
  "side.lid.neck.title": "The neck",
  "side.lid.bell.title": "The bell",
  "side.lid.faces.title": "The ones with your face",
  "side.lid.night.title": "The night of the bell",
  "side.lid.neck.plumb.l1": "Brann stands by the plumb's shaft. Down below, the plumb knocks against the walls of the shaft, again and again, as if it wanted out.",
  "side.lid.neck.plumb.l2": "This isn't a Marea. It's about to wake.",
  "side.lid.neck.plumb.l3": "And what do we do?",
  "side.lid.neck.plumb.l4": "The Order had a bell up on the head. In the great Mareas they rang it all night, and the titan stayed asleep.",
  "side.lid.neck.plumb.l5": "Nobody knew why. But it worked.",
  "side.lid.neck.plumb.o1": "We wanderers never mapped the head. The Order went up by the neck. I know where it starts.",
  "side.lid.neck.plumb.f1": "I went once, up the neck. Sold nothing. I know the way up.",
  "side.lid.neck.neck.title": "The neck",
  "side.lid.neck.neck.goal": "Climb the titan's neck, room by room. The folds of its skin breathe: they open as it breathes out and shut as it breathes in, and whoever is caught in one is squeezed and pushed back. Now and then the titan shakes: when the dust jumps, stand still, or you'll fall.",
  "side.lid.neck.ruins.l1": "Up by the eye stand the ruins of the Order's post. Low walls, a cold hearth and a huge wooden frame, empty.",
  "side.lid.neck.ruins.l2": "That's where it hung. Pitch the camp. Whatever came up the neck will want us off it.",
  "side.lid.neck.post.title": "The post",
  "side.lid.neck.post.goal": "Hold the ruins of the Order's post while the camp goes up. When the dust jumps off the skin, the titan shakes: whoever is walking falls. Don't let the post fall.",
  "side.lid.neck.eye.l1": "Dawn over the head. The eye is right there, a stone's throw away: a closed eyelid the size of a valley.",
  "side.lid.neck.eye.l2": "The eyelid trembles. A slit of light opens, and every nightmare on the slope turns to look at it. Then it closes.",
  "side.lid.neck.eye.l3": "Down the slope of the head lies the fallen bell, on its side, half buried in the skin.",
  "side.lid.neck.eye.l4": "It's cracked. But it rings.",
  "side.lid.bell.clapper.l1": "The post's camp smells of charcoal. Hilde came up with the group, built a small forge among the stones and didn't stop all night.",
  "side.lid.bell.clapper.l2": "I made it a new clapper. The old one is down there with it, and I don't know if it's any good.",
  "side.lid.bell.clapper.l3": "It weighs as much as ten carts. We drag it up on ropes, or we don't get it up at all.",
  "side.lid.bell.clapper.u1": "At dawn two stone boars come up the slope in harness. Ulla sent them, with a knot of horn tied to the traces.",
  "side.lid.bell.clapper.u2": "Ulla doesn't forget a thing. Hitch them up in front.",
  "side.lid.bell.clapper.n1": "It's us and the ropes. Nobody else is coming all the way up here to pull.",
  "side.lid.bell.climb.title": "The Climb",
  "side.lid.bell.climb.goal": "Drag the bell up the slope. It only moves with heroes beside it pulling the ropes: the more, the quicker. The nightmares cut the ropes, and with each one cut the bell slides back; if they all go, it rolls down the slope. When the dust jumps, stand still beside it: you hold it and it doesn't slip.",
  "side.lid.bell.frame.l1": "The bell reaches the top dragging skin and earth. Up close it is bigger than the frame waiting for it, and the crack runs through the bronze from top to bottom.",
  "side.lid.bell.frame.l2": "The Order's winches still turn. Greased with whatever there was, but they turn. Three, one for each leg of the frame.",
  "side.lid.bell.frame.l3": "As long as someone turns, it goes up. Let go, and it comes down. And what was on the slope followed us.",
  "side.lid.bell.hang.title": "Hanging It",
  "side.lid.bell.hang.goal": "Turn the winches to raise the bell into the frame: stand beside one. Every winch with someone at it adds; if none turns, the bell sinks. The nightmares go for the frame: don't let it fall.",
  "side.lid.bell.ring.l1": "The bell hangs. Hilde fits the new clapper, wipes her hands on her apron and strikes the first blow.",
  "side.lid.bell.ring.l2": "It rings deep and cracked, and the sound runs down the skin of the head, down the neck, through the whole titan.",
  "side.lid.bell.ring.l3": "Far off, in the bastion, the plumb goes still in its shaft. For the first time in weeks.",
  "side.lid.bell.ring.l4": "The next day the plumb starts moving again.",
  "side.lid.bell.ring.l5": "One day. For the great Marea it will have to ring all night.",
  "side.lid.faces.edge.l1": "That night, from the post, someone is walking along the edge of the eyelid. Slowly, like someone who knows the way.",
  "side.lid.faces.edge.l2": "When the firelight reaches it, its face shows. It is the face of one of you, in black glass, with a cloak of smoke that doesn't move with the wind.",
  "side.lid.faces.edge.l3": "It's you. On their side. Like the Unsleeping of the old garrison.",
  "side.lid.faces.edge.l4": "They fight the way you do. So nobody knows them better than you. Go find yourselves.",
  "side.lid.faces.copies.title": "The Ones With Your Face",
  "side.lid.faces.copies.goal": "The group's copies come out one at a time, in black glass, each fighting the way its player fights. Every hero hits their own copy twice as hard: find yours. The ones that fall stay down for the next outing. Don't let the post fall.",
  "side.lid.faces.glass.l1": "The last copy kneels. For an instant it has a real face, without cracks. Then it is glass, and then not even that.",
  "side.lid.faces.glass.l2": "At dawn, black shards lie along the edge of the eyelid, reflecting nothing.",
  "side.lid.faces.glass.l3": "If these come out up on the head, in the great Marea they'll come out everywhere. Better it was here.",
  "side.lid.night.plumb.l1": "The plumb won't stop. It knocks against the walls of its well all afternoon, and by nightfall nothing else can be heard in the bastion.",
  "side.lid.night.plumb.l2": "A big one is coming. Like few I've seen.",
  "side.lid.night.plumb.l3": "And the bell? Up there nobody is ringing it.",
  "side.lid.night.plumb.l4": "Then we do both. Some stay on the walls; the others go up and ring it until the sun comes out.",
  "side.lid.night.dusk.title": "Dusk",
  "side.lid.night.dusk.goal": "The Marea reaches the bastion, bigger than ever, and the Hollow Shell comes with it. Hold the walls beside the group's spectres. Don't let the keep fall.",
  "side.lid.night.midnight.l1": "At midnight they reach the post. The bell hangs in its frame, still, and the skin of the head trembles underfoot.",
  "side.lid.night.midnight.l2": "It has to be rung with the pulse. Like the Anvil down below: when the light closes, strike.",
  "side.lid.night.midnight.l3": "And don't let them cut its rope.",
  "side.lid.night.toll.title": "Midnight",
  "side.lid.night.toll.goal": "Ring the bell with the titan's pulse: strike when the ring of light closes. Every blow on time pushes the nightmares back and adds calm; off the beat, the eyelid trembles and whoever is walking falls. Fill the calm before they cut the rope.",
  "side.lid.night.dawn.l1": "The bell keeps ringing on its own a while. Down below, at the bastion, the Marea hasn't gone yet.",
  "side.lid.night.dawn.l2": "What's left comes with everything. Hold on until the sun comes out.",
  "side.lid.night.dawn.title": "Dawn",
  "side.lid.night.dawn.goal": "What's left of the Marea comes back at the bastion, with everything. Hold on until dawn. Don't let the keep fall.",
  "side.lid.night.sleep.l1": "The last nightmare falls. The bell strikes one last time, and then there is silence.",
  "side.lid.night.sleep.l2": "Up on the head, the eyelid stops trembling. Down in its well, the plumb goes still.",
  "side.lid.night.sleep.hilde": "With the bronze left over I'll make a small one, for the top of the keep. Let it do the warning.",
  "side.lid.night.sleep.odna": "In the village they slept all night. Nobody knows what happened, and that's as it should be.",
  "side.lid.night.sleep.gaspar": "This time I wasn't alone at the gate.",
  "side.lid.night.sleep.maelis": "No ash fell tonight. It's been a long time since I saw the sky like this.",
  "side.lid.night.sleep.mada": "Cal slept at home. The real one. He told me it's quiet out there.",
  "side.lid.night.sleep.ulla": "The boars came down to the walls and didn't shy once. The clan will talk about this all winter.",
  "side.lid.night.sleep.orla": "I measured it. From the head to the bastion is eleven thousand paces, and the bell is heard on every one.",
  "side.lid.night.sleep.dorn": "The machines knew who was who. For the first time in forty years.",
  "side.lid.night.sleep.pell": "Every lantern came back. And the well's water tastes of stone.",
  "side.lid.night.sleep.yorra": "From the boats we saw the bastion's light all night. Not one of them broke.",
  "side.lid.night.sleep.fenn": "I'll tell this all over the titan. Free, just this once.",
  "side.lid.night.sleep.brann": "It sleeps. Like before. The Mareas will keep coming, but those we know.",
  "side.night.ally.gaspar": "Ser Gaspar appears on guard at the gate, as always. This time he isn't alone.",
  "side.night.ally.pell": "A line of lanterns climbs the road: Pell and Musgoviejo's militia.",
  "side.night.ally.maelis": "Maelis arrives, and the ash stops falling on the walls.",
  "side.night.ally.ulla": "A horn sounds and the stone boars come down in a stampede. Ulla leads them.",
  "side.night.ally.dorn": "The carts come up the mouth of the rails, full of automatons. Dorn rides with them.",
  "side.night.ally.yorra": "On the shore, Yorra's boats light their lanterns and the sea glows.",
  "side.night.ally.orla": "Wayfarers' horns sound from the hills: Orla and her people.",
  "side.night.finale.l1": "The bell strikes one last time.",
  "side.night.finale.l2": "Silence.",
  "side.night.finale.l3": "Far off, in the head, the eyelid stops trembling.",
  "side.tollOf": "calm · {n} needed",
  "side.tollNow": "Now!",
  "side.toll.rule": "Strike the bell as the ring closes",
  "side.toll.node": "The rope",
  "side.toll.calm": "Calm",
  "side.toll.hit": "On time: the nightmares fall back",
  "side.toll.miss": "Off the beat: the eyelid trembles",
  "side.toll.lapse": "The bell fell silent",
  "side.toll.calmFull": "The titan calms",
  "side.toll.far": "Get closer to the bell",
  "side.toll.strike": "Ring",
  "side.toll.strikeTip": "Strike the bell when the ring of light closes.",
  "hero.bellTitle": "of the bell",
  "side.neck.dust": "Dust! The titan is about to shake: stand still.",
  "side.neck.dustNow": "Dust! Stand still",
  "side.neck.next": "Shake in {s} s",
  "side.neck.open": "Folds open · shutting in {s} s",
  "side.neck.shut": "Folds shut · opening in {s} s",
  "side.neck.fallMe": "You fell: you were walking when it shook.",
  "side.neck.squeezeMe": "The fold squeezed you and pushed you back.",
  "side.lid.signNew": "The sign from the Order's post, by the keep.",
  "side.copies.rule": "Every hero hits their own copy twice as hard: find yours.",
  "side.copies.of": "{name}'s copy",
  "side.copies.yours": "Your copy · you hit it twice as hard",
  "side.copies.none": "Another copy is coming",
  "side.copies.allDown": "All of them are down",
  "side.copies.you": "you",
  "side.copies.out": "{name}'s copy comes out.",
  "side.copies.outMine": "Your copy comes out. You hit it twice as hard.",
  "side.copies.fell": "{name}'s copy is down.",
  "side.copies.fellMine": "Your copy is down.",
  "side.lid.shardNew": "A shard of black glass, by the Order's sign.",
  "side.lid.bellNew": "A small bell at the very top of the keep, cast from the great one's leftover bronze.",
  "side.climb.bell": "The bell",
  "side.climb.way": "Climb",
  "side.climb.ropes": "Ropes {n} / {of}",
  "side.climb.pulling": "{n} pulling",
  "side.climb.pullingBoars": "{n} pulling, and the boars",
  "side.climb.up": "{p}% up",
  "side.climb.dust": "Dust! Stand still beside the bell: hold it.",
  "side.climb.dustNow": "Dust! Stand still beside it: hold it",
  "side.hoist.cut": "A rope is cut! The bell slides back.",
  "side.hoist.slip": "The shake made it slip: no one was holding it.",
  "side.hoist.brace": "Held: it didn't slip.",
  "side.hoist.roll": "Every rope is cut: the bell rolls down the slope.",
  "side.hoist.up": "The bell is hung!",
  "side.hang.rule": "Stand by a winch to turn it",
  "side.hang.label": "Bell",
  "side.hang.frame": "The frame",
  "side.hang.turning": "Winches turning: {n} of {of}",
  "side.hang.none": "No one turning: the bell sinks",
  "side.hang.up": "Hung",
  "side.lid.clapperNew": "The bell's old clapper, hung beside the Order's sign.",
  "side.flight.runTitle": "To the rock!",
  "side.flight.runSub": "The sea is coming back the way you came: run to the last room.",
  "side.flight.outTitle": "On the rock",
  "side.flight.heartSub": "{name} carries the heart: don't leave them alone.",
  "side.flight.heartDown": "The heart is on the ground! Pick it up before the water takes it.",
  "side.flight.heartWay": "Heart",
  "side.flight.wayOut": "The rock",
  "side.flight.burst": "The sea is coming back!",
  "side.flight.wave": "The water's coming! Run to the rock.",
  "side.flight.out": "Everyone on the rock!",
  "side.flight.lost": "The sea took the heart.",
  "side.shore.ember": "A dragon's ember",
  "uawaken.ember": "Dragon's ember: pays the dust and the rares (you have {n})",
  "uawaken.emberUses": "Uses a dragon's ember.",
  "side.shore.heartNew": "The dragon's heart, at the forge: a red stone with an ember inside.",
  "side.rails.title": "The rails",
  "side.rails.question": "Who keeps the machines below running?",
  "side.rails.over": "The rails went quiet.",
  "side.rails.descent.title": "The fast way",
  "side.rails.winder.title": "The one who winds",
  "side.rails.anvil.title": "The anvil",
  "side.rails.rising.title": "What comes up",
  "side.rails.descent.mouth.l1": "At the foot of the keep, behind a heap of rubble, there is a mouth of stone. Two rails run down into the dark.",
  "side.rails.descent.mouth.l2": "My clan's fast way. It goes deeper than the crypt. Deeper than anything.",
  "side.rails.descent.mouth.l3": "And why was it walled up?",
  "side.rails.descent.mouth.l4": "Because it has no brake. But listen: down there, someone is still winding the machines.",
  "side.rails.descent.mouth.l5": "I've fixed the carts. You clear the rails. Whatever is on them when we come through, we won't be going around it.",
  "side.rails.descent.run.title": "The way down",
  "side.rails.descent.run.goal": "The carts don't brake, and they go faster and faster. Run ahead and break the bone barricades before the train gets there. On the last lap the bridge goes up: break its counterweight, at the end of the rails.",
  "side.rails.descent.cavern.l1": "The train comes out of the tunnel into a cavern with no bottom. Far below glows the red of the Marrow.",
  "side.rails.descent.cavern.l2": "Hold on!",
  "side.rails.descent.cavern.l3": "The bridge comes down just in time. The carts screech across, and the last plank falls away behind them.",
  "side.rails.descent.cavern.l4": "Forty years with nobody coming down, and it had to be today.",
  "side.rails.descent.cavern.l5": "Hush. Listen. Gears. Someone is winding, down there.",
  "side.rails.cartNew": "A cart of Hilde's clan, in the bastion, by the mouth of the fast way.",
  "side.railsTrain": "Train",
  "side.railsWay": "Rails",
  "side.railsRule": "The train doesn't brake. Break the barricades before it gets there; on the last lap, the bridge's counterweight.",
  "side.rails.wall": "A barricade on the rails!",
  "side.rails.derail": "A cart went off the rails! {n} left.",
  "side.rails.up": "The bridge went up! Break the counterweight at the end of the rails.",
  "side.rails.down": "The bridge is coming down!",
  "side.rails.fall": "The train went over the edge.",
  "npc.dorn": "Dorn",
  "npc.dorn.role": "Hilde's cousin, keeper of the Anvil",
  "side.rails.winder.halls.l1": "At the foot of the rails, clean dwarven halls. The lamps are lit and the floors are swept.",
  "side.rails.winder.halls.l2": "Someone kept this. For forty years.",
  "side.rails.winder.halls.l3": "And the machines too?",
  "side.rails.winder.halls.l4": "An alarm of bells rings out. In every room the guard automatons rise, bone and stone, their eyes alight.",
  "side.rails.winder.bells.title": "The bells",
  "side.rails.winder.bells.goal": "The automatons strike whatever is nearest, hero or nightmare, and heroes can't break them. Stay by each room's lever until it's down. Lead the nightmares to the machines so they keep them busy. Don't let the node fall.",
  "side.rails.winder.dorn.l1": "With the last lever the bells go quiet. Down a passage comes a dwarf with a winding key as long as an arm.",
  "side.rails.winder.dorn.l2": "Dorn. My cousin. We gave him up for dead.",
  "side.rails.winder.dorn.l3": "Sorry about the machines. They don't know who's who.",
  "side.rails.winder.dorn.l4": "Hilde and Dorn look at each other, forty years on. Neither knows what to say.",
  "side.rails.winder.dorn.l5": "You cut your hair short.",
  "side.rails.winder.dorn.l6": "It was my week on the Anvil watch. Nobody came to relieve me. If I left, the Anvil would cool and what is below would come up.",
  "side.rails.winder.dorn.l7": "And what did you eat for forty years?",
  "side.rails.winder.dorn.l8": "Mushrooms. Don't ask about the mushrooms.",
  "side.rails.guardNew": "One of Dorn's automatons, switched off, stands guard by the mouth of the fast way.",
  "side.bellsRule": "Stay by each lever until it is down. The automatons strike everyone: lead the nightmares to them. Don't let the node fall.",
  "side.bellsOf": "levers down · of {n}",
  "side.bellsGuard": "Guard automaton",
  "side.bells.pull": "Pulling the lever…",
  "side.bells.down": "Lever down! That room's automatons go still.",
  "side.bells.all": "The bells go quiet!",
  "side.rails.anvil.cold.l1": "At the very bottom, the Anvil: a block of black iron the size of a house, barely warm. The air around it is already cold.",
  "side.rails.anvil.cold.l2": "Forty years I kept it hot with a hammer. My arm can't do it any more.",
  "side.rails.anvil.cold.l3": "Its heat stops up the way for what comes from further down. If it cools, the way opens.",
  "side.rails.anvil.cold.l4": "Then we nail it to the titan's vein. Let it keep hot by itself.",
  "side.rails.anvil.cold.l5": "Five strikes, when it beats. Not before, not after. And hurry: what is below has heard it cooling.",
  "side.rails.anvil.strikes.title": "The five strikes",
  "side.rails.anvil.strikes.goal": "The Anvil beats: a ring of light closes on it. Stand by it and strike with the hammer just as the ring closes. On the beat, the heat burns the nightmares in the hall; off it, the blow is lost. After each strike the Anvil rests a while. Five strikes on the beat, and don't let the Anvil fall.",
  "side.rails.anvil.key.l1": "The fifth strike. The vein catches, the whole hall turns red, and every nightmare left goes to ash at once.",
  "side.rails.anvil.key.l2": "There. Nobody needs to stay any more.",
  "side.rails.anvil.key.l3": "Take the key, it's no use to me now. Oh: the big machine in the crypt, I used to wind it. Sorry.",
  "side.rails.anvil.key.l4": "The Custodian? That was you?",
  "side.rails.anvil.key.l5": "Dorn comes up to the bastion for the first time in forty years and stays by the forge, looking up.",
  "side.rails.anvil.key.l6": "There's a lot of light up here.",
  "side.rails.anvil.key.l7": "I came down in the last cart, don't look at me like that. And one more thing: at the stilt houses, the nets come up full of black scales.",
  "side.rails.keyNew": "Dorn's winding key, hung up in the bastion.",
  "side.rails.rising.dawn.l1": "At dawn the rails of the fast way shake. Dorn comes running up from the mouth, his winding key still in his hand.",
  "side.rails.rising.dawn.l2": "The Anvil shuts its way, but the rails are another way. And we opened them. Something is coming up them.",
  "side.rails.rising.dawn.l3": "Listen to it. Hammer on iron: one long blow and two short. That's Bruni. He taught me to temper.",
  "side.rails.rising.dawn.l4": "Bruni died that night, at the forge.",
  "side.rails.rising.dawn.l5": "And to the forge he goes. He always went to the forge.",
  "side.rails.rising.dawn.m1": "We've seen him. He came with the nightmares, shot at our towers and went up in smoke. This time he has nowhere to go.",
  "side.rails.rising.dawn.f1": "But Bruni already fell. What's coming up doesn't sound like footsteps: it sounds like gears.",
  "side.rails.rising.dawn.f2": "Those are the machines Bruni touched. They still do what he told them. He built them, and he left them the same gap he had: under the right arm.",
  "side.rails.rising.dawn.l6": "Hit him under the right arm. He always left that uncovered.",
  "side.rails.rising.dawn.l7": "I can bring down a stretch of rail as soon as he's past. Whatever comes behind him stays below. But then nothing else comes up that way: no ore, and none of my machines.",
  "side.rails.rising.dawn.vote": "What do you do with the rails?",
  "side.rails.rising.dawn.c.close": "Bring them down behind him: Bruni comes alone, and the Anvil is cut off",
  "side.rails.rising.dawn.c.open": "Leave them open: the Anvil stays linked to the bastion, and Bruni comes up with whatever he finds",
  "side.rails.rising.forge.title": "Bruni, the Hollow Forger",
  "side.rails.rising.forge.goal": "At the bastion's forge. Every so often Bruni marks a tower: stand by it before he turns it. Hit him from his right, under the arm: every blow there is a critical. This time he doesn't flee.",
  "side.rails.rising.forge.goalOpen": "At the bastion's forge. With the rails open, Bruni comes up with more nightmares; at half his life Dorn's automatons arrive. Stand by the tower he marks before he turns it, and hit him from his right: every blow there is a critical.",
  "side.rails.rising.forge.goalFelled": "Bruni already fell. The biggest of the automatons he turned comes up, with his same trick: it marks towers to turn them. Its weak spot is Bruni's: under the right arm.",
  "side.rails.rising.ash.b1": "Bruni falls beside the forge where he died. The black glass cracks across his face, and for a moment there is a dwarf's face, soot in his beard.",
  "side.rails.rising.ash.b2": "Hilde kneels and closes his eyes.",
  "side.rails.rising.ash.b3": "Nobody tempered better. Keep the hammer. Hang it at the forge, where it belongs.",
  "side.rails.rising.ash.f1": "The automaton comes down beside the forge. Among its gears there is a dwarf's hammer, its handle worn smooth.",
  "side.rails.rising.ash.f2": "It's his. He gave it to the machine. That's it, master: you can stop working now.",
  "side.rails.rising.ash.c1": "The stretch is down. Whatever came behind him stayed below. The Anvil is alone and hot, and that's enough.",
  "side.rails.rising.ash.o1": "The rails stay open. Every week I'll send ore up. And if anything else comes up, my machines come up behind it.",
  "side.rails.rising.ash.l1": "Forty years below, and the first thing he did was go back to his forge.",
  "side.rails.rising.ash.l2": "Tomorrow I light the fire. Someone has to keep tempering.",
  "side.risingNode": "Forge",
  "side.risingRule": "Stand by the marked tower before it turns. Hit him from his right: critical.",
  "side.rising.mark": "A tower is marked! Stand by it before it turns.",
  "side.rising.saved": "Tower kept.",
  "side.rising.turned": "A tower turned! It's shooting the heroes.",
  "side.rising.dorn": "Dorn's automatons are coming up!",
  "side.rails.hammerNew": "Bruni's hammer, hung on the forge wall.",
  "side.rails.oreNew": "A cart of ore comes up the fast way every week.",
  "enemy.hulk": "The big automaton",
  "enemy.hulk.desc": "The biggest of the automatons Bruni turned. It still does what he told it.",
  "log.shoreEmber": "{who} received a dragon's ember",
  "log.railsOre": "Ore came up the fast way: +{stone} stone, +{crystal} crystal",
  "side.anvilRule": "By the Anvil, strike as the ring closes. Five strikes on the beat. Don't let the Anvil fall.",
  "side.anvilOf": "strikes on the beat · of {n}",
  "side.anvilNode": "Anvil",
  "side.anvilRest": "The Anvil rests: it beats again in {s} s",
  "side.anvilNow": "It beats! Strike as the ring closes",
  "side.anvil.hit": "On the beat! The heat sweeps the hall.",
  "side.anvil.miss": "Off the beat. The blow is lost.",
  "side.anvil.fifth": "The vein catches!",
  "side.anvil.strike": "Hammer",
  "side.anvil.strikeTip": "By the Anvil: strike it just as the ring of light closes on it.",
  "side.anvil.far": "Get closer to the Anvil to strike it.",
  "side.burn.title": "The Burn",
  "side.burn.question": "Where did Tobin's patrol go?",
  "side.burn.over": "The wayfarers finished their map.",
  "side.burn.patrol.title": "The patrol that never came back",
  "side.burn.patrol.orla.l1": "An old woman waits at the bastion's gate, a rolled map under her arm, her boots grey with ash.",
  "side.burn.patrol.orla.l2": "Orla. Wayfarer. If she can't find something, it isn't there.",
  "side.burn.patrol.orla.l3": "My son, Tobin, led a patrol to the edge of the Burn. They've been gone four days.",
  "side.burn.patrol.orla.l4": "The glass at the edge is breaking. It's four hundred paces to firm rock. I counted them myself, twenty years ago.",
  "side.burn.patrol.orla.l5": "Then let's not lose one.",
  "side.burn.patrol.glass.title": "The breaking glass",
  "side.burn.patrol.glass.goal": "The glass is breaking from one side of the clearing. Stay by each wounded wayfarer to lift them, and take them to the firm rock on the other side. Three are needed.",
  "side.burn.patrol.rock.l1": "The wayfarers drop onto the rock. Behind them, the whole edge sinks into the Burn.",
  "side.burn.patrol.rock.l2": "I count four. There were five. Tobin is missing.",
  "side.burn.patrol.rock.l3": "One of the wayfarers, his leg bound to a plank: \"He saw smoke further in. Said it was a camp, and went on alone.\"",
  "side.burn.patrol.rock.l4": "Then he's alive. And still walking.",
  "side.burn.patrol.rock.l5": "I'll draw what we saw. Leave me a table in the bastion.",
  "side.burn.tableNew": "Orla's map table, in the bastion: the Burn, half drawn.",
  "side.collapseRule": "Stay by a wayfarer to lift them; they follow you to the firm rock.",
  "side.collapseOf": "on the rock · {n} needed",
  "side.collapseOut": "On the glass: {n}",
  "side.collapseLost": "Lost: {n}",
  "side.collapse.lost": "We lost a wayfarer.",
  "side.wayRock": "The firm rock",
  "side.wayScout": "A wayfarer",
  "news.2026-10-31-zzzzzzzzzburn.title": "The Burn",
  "news.2026-10-31-zzzzzzzzzburn.intro": "A new, light saga of short chapters.",
  "news.2026-10-31-zzzzzzzzzburn.burn": "Someone never came back from the Burn",
  "news.2026-10-31-zzzzzzzzzburn.burn.desc": "From group 16, a wayfarer climbs to the bastion to ask for help. First chapter.",
  "news.2026-10-31-zzzzzzcrypts.title": "Deadlier crypts",
  "news.2026-10-31-zzzzzzcrypts.intro": "For high-level groups, the crypts put up a real fight.",
  "news.2026-10-31-zzzzzzcrypts.rooms": "Fewer nightmares, tougher ones",
  "news.2026-10-31-zzzzzzcrypts.rooms.desc": "From level 8, the rooms of all three crypts bring fewer nightmares, but each one lasts longer and hits harder. Rooms take longer and the group has to look after itself.",
  "news.2026-10-31-zzzzzzcrypts.guardians": "Deep crypt: sharper guardians",
  "news.2026-10-31-zzzzzzcrypts.guardians.desc": "The three guardians have less health but hit harder: shorter, more dangerous fights. The Colossus is still the hardest.",
  "news.2026-10-31-zzzzzzzbet.title": "One more bet",
  "news.2026-10-31-zzzzzzzbet.intro": "Hilde has something to prove.",
  "news.2026-10-31-zzzzzzzbet.bet": "Not a scratch",
  "news.2026-10-31-zzzzzzzbet.bet.desc": "A new bet from Brann and Hilde, from group 16. This time Hilde bets on you.",
  "news.2026-10-31-zzzcrypts.title": "Lighter crypts and incursions",
  "news.2026-10-31-zzzcrypts.intro": "Tried on a real phone: same look, a good deal less work.",
  "news.2026-10-31-zzzcrypts.fights": "Fights ask less of your phone",
  "news.2026-10-31-zzzcrypts.fights.desc": "The bars, names and arrows that follow the board no longer make the whole screen redraw every frame: in our tests the deep crypt went from 32 to 39 frames a second.",
  "news.2026-10-31-zzzcrypts.gear": "No stutter 12 seconds into every fight",
  "news.2026-10-31-zzzcrypts.gear.desc": "The guard's shield and the war banner were only made ready the first time they showed; now they are ready before setting out.",
  "news.2026-10-31-zzzcrypts.crypt": "Portcullises, runes and torches in one go",
  "news.2026-10-31-zzzcrypts.crypt.desc": "Each crypt portcullis was drawn bar by bar: now it is one piece, and a room mid-fight costs a third less.",
  "news.2026-10-31-zzzzalone.title": "The one who came back alone",
  "news.2026-10-31-zzzzalone.intro": "The last chapter of El Cuerno.",
  "news.2026-10-31-zzzzalone.alone": "Ulla climbs to the bastion alone",
  "news.2026-10-31-zzzzalone.alone.desc": "From group 14, once the Old Uro is hunted down. She has something she never told, and this time the group decides.",
  "news.2026-10-31-zzzcrypts.start": "No freeze on the way in",
  "news.2026-10-31-zzzcrypts.start.desc": "Opening a crypt or a fight froze the screen for a second while it got ready: now it gets ready without stalling, and the waiting room answers meanwhile.",
  "news.2026-10-31-zzzcrypts.colossus": "No stutter when the colossus shines",
  "news.2026-10-31-zzzcrypts.colossus.desc": "During the holidays, the obsidian colossus's first shine rebuilt its figure on the spot and froze everyone's screen; the same with an Unsleeping's first skill. The cleric's totem and the artificer's turret and grenade are also made ready ahead.",
  "news.2026-10-31-zzzcrypts.blur": "A lighter miniature look",
  "news.2026-10-31-zzzcrypts.blur.desc": "The blur at the top and bottom of the screen is worked out at half resolution, with the same look: on older graphics cards the bastion and fights cost a good deal less per frame.",
  "news.2026-10-31-zzzcrypts.corner": "No stray numbers in the corner",
  "news.2026-10-31-zzzcrypts.corner.desc": "In live fights a damage number (or a group signal) could flash for an instant at the top left before going to its place.",
  "news.2026-10-31-zlighter.title": "Smoother on phones",
  "news.2026-10-31-zlighter.intro": "Same look, less work for the phone.",
  "news.2026-10-31-zlighter.bastion": "The bastion asks less of your phone",
  "news.2026-10-31-zlighter.bastion.desc": "The trophies by the keep are drawn in one go instead of piece by piece: a big bastion costs a quarter less per frame.",
  "news.2026-10-31-zlighter.waves": "Fewer stutters mid-wave",
  "news.2026-10-31-zlighter.waves.desc": "A wall wearing down in a fight no longer remakes every district's dressing, and the skills' and gear's effects are made ready before the fight.",
  "news.2026-10-31-zlighter.panel": "The hero sheet opens faster",
  "news.2026-10-31-zlighter.panel.desc": "The group's portraits are drawn ahead, while the bastion stands still.",
  "news.2026-10-31-heroes.title": "Switching heroes",
  "news.2026-10-31-heroes.intro": "A fix for anyone playing more than one hero.",
  "news.2026-10-31-heroes.swap": "Switching heroes no longer gets stuck halfway",
  "news.2026-10-31-heroes.swap.desc": "Leave an incursion or a saga act before it ends and you can switch heroes right away. And when a switch can't be made, the sheet goes back to the hero actually in play and tells you why.",
  "news.2026-10-31-zzhunt.title": "The hunt",
  "news.2026-10-31-zzhunt.intro": "El Cuerno, chapter 3.",
  "news.2026-10-31-zzhunt.hunt": "Ulla is looking for hunters",
  "news.2026-10-31-zzhunt.hunt.desc": "From group 11, once the lash is done. This quarry won't fall in a day: whatever you do to it stays for whoever goes out next, even if you never play together.",
  "news.2026-10-30-zzzzzzzzzzzzzzzzzzcrypt.title": "Smoother crypts",
  "news.2026-10-30-zzzzzzzzzzzzzzzzzzcrypt.intro": "Fewer stutters on phones.",
  "news.2026-10-30-zzzzzzzzzzzzzzzzzzcrypt.guardians": "Guardians no longer stutter when they appear",
  "news.2026-10-30-zzzzzzzzzzzzzzzzzzcrypt.guardians.desc": "The Warden, the Magma Lord and the Colossus (shining too) are made ready when the crypt opens, along with the puzzles' reinforcements: they no longer freeze the screen for a moment when they arrive.",
  "news.2026-10-30-zzzzzzzzzzzzzzzzzzcrypt.deep": "The deep crypt asks less of your phone",
  "news.2026-10-30-zzzzzzzzzzzzzzzzzzcrypt.deep.desc": "Only the floor you are fighting on is drawn. It looks exactly the same.",
  "news.2026-10-30-zzzzzzzzzzzzzzzzzlash.title": "The Horn goes on",
  "news.2026-10-30-zzzzzzzzzzzzzzzzzlash.intro": "Chapter 2.",
  "news.2026-10-30-zzzzzzzzzzzzzzzzzlash.lash": "Ulla invites you to the summer camp",
  "news.2026-10-30-zzzzzzzzzzzzzzzzzlash.lash.desc": "From group 9, once the first chapter is done. Bring good boots.",
  "news.2026-10-30-zzzzzzzzzzzzzzzzzlash.toasts": "Notices no longer cover the top card on phones",
  "news.2026-10-30-zzzzzzzzzzzzzzzzzlash.toasts.desc": "In a fight, notices now sit below the wave card, however many rules it shows.",
  "news.2026-10-30-zzzzzzzzzzzzzzzzclasses.title": "Class balance",
  "news.2026-10-30-zzzzzzzzzzzzzzzzclasses.intro": "We measured the eight classes over thousands of fights, from level 1 to 50, so each one shines at its own thing.",
  "news.2026-10-30-zzzzzzzzzzzzzzzzclasses.skills": "Skills grow with your level",
  "news.2026-10-30-zzzzzzzzzzzzzzzzclasses.skills.desc": "Until now, leveling up grew your attack and health but barely your skills. Now damage, heals, shields and summons grow with level just like the attack: twice as much at level 11, almost four times at level 30. Building repairs don't change. Since high-level heroes get stronger, the nightmares in crypts, cellars, Furrows, saga and incursions get tougher too, in proportion.",
  "news.2026-10-30-zzzzzzzzzzzzzzzzclasses.paladin": "Paladin: the aura shows and ranks up",
  "news.2026-10-30-zzzzzzzzzzzzzzzzclasses.paladin.desc": "The aura shows on the ground around the paladin and ranks up at levels 7 and 16, like skills. Devotion: 15%, 20% and 25% less damage for allies nearby. Retribution hits harder and Life heals more at each rank. Smite and Aegis grow with level.",
  "news.2026-10-30-zzzzzzzzzzzzzzzzclasses.ranger": "Ranger: sharper aim, and it shows",
  "news.2026-10-30-zzzzzzzzzzzzzzzzclasses.ranger.desc": "Attack +25% and Multishot +50% per arrow: the best at hitting a single target. Its skills have new effects.",
  "news.2026-10-30-zzzzzzzzzzzzzzzzclasses.warrior": "Warrior: Challenge saves the walls",
  "news.2026-10-30-zzzzzzzzzzzzzzzzclasses.warrior.desc": "Challenge reaches 50% farther, and nightmares striking a wall, gate or tower near the warrior leave it and come for him. His blow also lands at half strength on the two nightmares nearest the one he strikes.",
  "news.2026-10-30-zzzzzzzzzzzzzzzzclasses.barbarian": "Barbarian: holds out longer",
  "news.2026-10-30-zzzzzzzzzzzzzzzzclasses.barbarian.desc": "Its armor stops 25% of damage (was 10%). Fury now heals too: the more hurt, the more life it drinks from its blows.",
  "news.2026-10-30-zzzzzzzzzzzzzzzzclasses.artificer": "Artificer: slightly softer turrets",
  "news.2026-10-30-zzzzzzzzzzzzzzzzclasses.artificer.desc": "Turret −33% and Automaton −20% damage: it was the strongest class in crypts and waves. With level growth it still hits harder than before at high level.",
  "news.2026-10-30-zzzzzzzzzzzzzzzzclasses.cleric": "Cleric: slightly smaller heals",
  "news.2026-10-30-zzzzzzzzzzzzzzzzclasses.cleric.desc": "Mend −17% and Sanctuary −20% per pulse. Still the best healer, and with level growth it heals far more than before at high level.",
  "news.2026-10-30-zzzzzzzzzzzzzzzzclasses.ghosts": "New spectres are sharper",
  "news.2026-10-30-zzzzzzzzzzzzzzzzclasses.ghosts.desc": "Spectres that haven't learned their player yet play more like people: they hit the nearest nightmare and fall back at 40% health.",
  "news.2026-10-30-zzzzzzzzzzzzzzzzclasses.guardians": "Deep crypt: each guardian tougher",
  "news.2026-10-30-zzzzzzzzzzzzzzzzclasses.guardians.desc": "The Magma Lord and the Colossus hit harder and last longer: each guardian is harder than the one before, and the Colossus the hardest of the three.",
  "news.2026-10-30-zzzzzzzzzzzzzzzhorn.title": "A new story: The Horn",
  "news.2026-10-30-zzzzzzzzzzzzzzzhorn.intro": "Up on the titan's tail.",
  "news.2026-10-30-zzzzzzzzzzzzzzzhorn.horn": "Someone climbs to the bastion asking for help",
  "news.2026-10-30-zzzzzzzzzzzzzzzhorn.horn.desc": "From group 7, under Other stories in the chronicle. A clan of herders is short of hands. Bring patience: not everything is solved by hitting it.",
  "news.2026-10-30-zzzzzzzzzzzzzzsignals.title": "Signals for the group",
  "news.2026-10-30-zzzzzzzzzzzzzzsignals.intro": "Tell the others where to go, in the thick of a fight.",
  "news.2026-10-30-zzzzzzzzzzzzzzsignals.signals": "Attack here, Defend here, Watch out! and On my way",
  "news.2026-10-30-zzzzzzzzzzzzzzsignals.signals.desc": "On a phone, the signals button above your card: tap it, pick one and tap where. On a computer, hold G, point and let go, or Alt + click on what you want to mark. Put on a creature or a hero, the signal follows it. When it is off someone's screen, an arrow shows at the edge, and tapping it walks their hero there. It works in waves, incursions, crypts, cellars and the Furrows, when you play together live.",
  "news.2026-10-30-zzzzzzzzzzzzzzsignals.help": "Help!",
  "news.2026-10-30-zzzzzzzzzzzzzzsignals.help.desc": "Hold the signals button (or pick the middle of the wheel) and everyone sees where you are: a horn sounds, the edge of the screen turns red and your name beats in the party list.",
  "news.2026-10-30-zzzzzzzzzzzzzmada.title": "Borrowed faces, the end",
  "news.2026-10-30-zzzzzzzzzzzzzmada.intro": "Chapter 4.",
  "news.2026-10-30-zzzzzzzzzzzzzmada.mada": "Mada wants to talk to you",
  "news.2026-10-30-zzzzzzzzzzzzzmada.mada.desc": "From group level 17, with chapter 3 done. Better if everyone comes.",
  "news.2026-10-30-zzzzzzzzzzzzbar.title": "Fixes",
  "news.2026-10-30-zzzzzzzzzzzzbar.intro": "The bastion's bottom bar.",
  "news.2026-10-30-zzzzzzzzzzzzbar.bar": "The bottom bar always fits in one row",
  "news.2026-10-30-zzzzzzzzzzzzbar.bar.desc": "On some screens the bottom buttons wrapped their text over several lines and «Leave» ended up off screen. Now, if they don't fit, they show only their icon, and if they still don't fit, the less used ones fold into «more».",
  "news.2026-10-30-zzzzzzzzzzzzbar.phone": "Bigger buttons on the phone",
  "news.2026-10-30-zzzzzzzzzzzzbar.phone.desc": "The bottom bar takes the whole width of the screen, with taller buttons and larger icons: easy to hit with a thumb.",
  "news.2026-10-30-zzzzzzzzzzzchat.title": "The chat tells when",
  "news.2026-10-30-zzzzzzzzzzzchat.intro": "Every message with its time.",
  "news.2026-10-30-zzzzzzzzzzzchat.when": "Each chat line says when it was written",
  "news.2026-10-30-zzzzzzzzzzzchat.when.desc": "“just now”, “5 min ago”, “yesterday 21:40”: so you know whether the group is still around or already gone. Hover over it to see the exact date and time.",
  "news.2026-10-30-zzzzzzzzzzdamage.title": "Gear damage, clearer",
  "news.2026-10-30-zzzzzzzzzzdamage.intro": "What each piece adds, in numbers.",
  "news.2026-10-30-zzzzzzzzzzdamage.damage": "The sheet says how much attack each piece gives",
  "news.2026-10-30-zzzzzzzzzzdamage.damage.desc": "Every piece's «+% damage» adds up and applies once to the base attack, so a +18 % doesn't raise the attack you already have by 18 %. Now each piece says how much attack it adds (for example «+18 % damage · +6 attack») and the hero sheet shows the total damage next to Attack. The math didn't change: what the sheet says is what you hit for.",
  "news.2026-10-30-zzzzzzzzzaccuse.title": "Borrowed faces goes on",
  "news.2026-10-30-zzzzzzzzzaccuse.intro": "Chapter 3.",
  "news.2026-10-30-zzzzzzzzzaccuse.accuse": "Someone arrives with news from the forest",
  "news.2026-10-30-zzzzzzzzzaccuse.accuse.desc": "From group level 15, with chapter 2 done. At the end, the group votes.",
  "news.2026-10-30-zzzzzzzzshadow.title": "Borrowed faces goes on",
  "news.2026-10-30-zzzzzzzzshadow.intro": "Chapter 2.",
  "news.2026-10-30-zzzzzzzzshadow.shadow": "A night of lanterns in Musgoviejo",
  "news.2026-10-30-zzzzzzzzshadow.shadow.desc": "From group level 12, with chapter 1 done. Bring lanterns.",
  "news.2026-10-30-zzzzzzzflee.title": "The Unsleeping who flee",
  "news.2026-10-30-zzzzzzzflee.intro": "Now you can tell when one is getting away.",
  "news.2026-10-30-zzzzzzzflee.flee": "When one of the Unsleeping tries to flee, you notice",
  "news.2026-10-30-zzzzzzzflee.flee.desc": "Low on life, they fade into smoke for two seconds: now it says so in large letters, with a bar for the time left to strike and stop the escape, and the smoke shows from afar. If they get away, the victory waits until you see them go and warns they will be back.",
  "news.2026-10-30-zzzzzzchat.title": "Fixes",
  "news.2026-10-30-zzzzzzchat.intro": "The chat on a computer.",
  "news.2026-10-30-zzzzzzchat.chat": "The chat no longer shrinks while you type",
  "news.2026-10-30-zzzzzzchat.chat.desc": "On a computer, clicking to type hid the quick lines and shortened the log. That's only meant for phones, when the keyboard covers half the screen.",
  "news.2026-10-30-zzzzzfaces.title": "Something is wrong in Musgoviejo",
  "news.2026-10-30-zzzzzfaces.intro": "A new story, beside the saga.",
  "news.2026-10-30-zzzzzfaces.faces": "Borrowed faces",
  "news.2026-10-30-zzzzzfaces.faces.desc": "From group level 10, Odna has something to tell you. It's in the chronicle, under \"Other stories\". Losing a fight costs nothing, and what you find stays for the rest of the group.",
  "news.2026-10-30-zzzzbets.title": "Brann and Hilde are betting",
  "news.2026-10-30-zzzzbets.intro": "They agree on nothing. Now they bet, and you are the ones who play.",
  "news.2026-10-30-zzzzbets.bets": "Brann and Hilde's bets",
  "news.2026-10-30-zzzzbets.bets.desc": "Short challenges in the chronicle, with one rule that changes everything. Every bet won leaves something in the bastion. More open as the group levels up.",
  "news.2026-10-30-zzzheal.title": "Fixes",
  "news.2026-10-30-zzzheal.intro": "Healing on each fight's board.",
  "news.2026-10-30-zzzheal.heal": "Healing and the Healing hand now count the same",
  "news.2026-10-30-zzzheal.heal.desc": "The Healing bar added what each hero healed on themselves, while the Healing hand title only counted what they healed on others, so the two could disagree. Now the bar also counts only what you healed on others, and what you healed on yourself shows below it, in small print.",
  "news.2026-10-30-zzicons.title": "Fixes",
  "news.2026-10-30-zzicons.intro": "Gear icons.",
  "news.2026-10-30-zzicons.icons": "Every piece of gear with its own icon",
  "news.2026-10-30-zzicons.icons.desc": "Hoods, helms, boots, shields, rings and off-hand pieces showed an amulet. Now each piece shows what it is: helm, boot, shield, grimoire, quiver, axe, bow…",
  "news.2026-10-30-zhands.title": "Fixes",
  "news.2026-10-30-zhands.intro": "Two-handed unique weapons.",
  "news.2026-10-30-zhands.hands": "Two-handed weapons take both hands",
  "news.2026-10-30-zhands.hands.desc": "Some unique and older weapons said they were two-handed but still let you hold something in the off hand. Now they really take both hands: if you had something beside one, it went back to your bag.",
  "news.2026-10-30-zforge.title": "Fixes",
  "news.2026-10-30-zforge.intro": "The forge in ruins.",
  "news.2026-10-30-zforge.ruined": "With the forge in ruins, the gear tab says so",
  "news.2026-10-30-zforge.ruined.desc": "If the forge falls in a wave, the Melt button no longer disappears: it shows greyed out and a note says it must be repaired to melt, forge, cut gems or awaken.",
  "news.2026-10-30-works.title": "Bastion deeds",
  "news.2026-10-30-works.intro": "Who brings the most home and who builds the most.",
  "news.2026-10-30-works.works": "Gathering and building in the Deeds",
  "news.2026-10-30-works.works.desc": "Below the fights, the Deeds now have a bastion ranking: how much wood, stone, crystal and iron each of you brought back from incursions (shared among those who went live), how much you gave to blueprints and tasks, how many minutes you worked on site and how many of the works you planned were finished. It starts counting today.",
  "news.2026-10-29-zzzzzzzzzzzzzzzzzzzzzbear.title": "Fixes",
  "news.2026-10-29-zzzzzzzzzzzzzzzzzzzzzbear.intro": "The druid's bear.",
  "news.2026-10-29-zzzzzzzzzzzzzzzzzzzzzbear.bear": "The druid's bear goes in to fight",
  "news.2026-10-29-zzzzzzzzzzzzzzzzzzzzzbear.bear.desc": "Once shifted, the bear goes after the nightmare the druid had in range on its own, even past 3 tiles, and doesn't wait even if you just moved it. Before, it stood still for the whole form when nothing was close.",
  "news.2026-10-29-zzzzzzzzzzzzzzzzzzzzpanel.title": "Improvements",
  "news.2026-10-29-zzzzzzzzzzzzzzzzzzzzpanel.intro": "The puzzle panel on phones.",
  "news.2026-10-29-zzzzzzzzzzzzzzzzzzzzpanel.puzzle": "The puzzle panel no longer covers the room on phones",
  "news.2026-10-29-zzzzzzzzzzzzzzzzzzzzpanel.puzzle.desc": "In the deep crypt, with the phone upright or on its side, each puzzle's panel shows in full for a few seconds and then shrinks to its name and its bar. The corner button opens it again. On its side, it is also smaller.",
  "news.2026-10-29-zzzzzzzzzzzzzzzzzzzfoes.title": "Fixes",
  "news.2026-10-29-zzzzzzzzzzzzzzzzzzzfoes.intro": "The count of the last nightmares.",
  "news.2026-10-29-zzzzzzzzzzzzzzzzzzzfoes.count": "The last-nightmares marker says how many are left",
  "news.2026-10-29-zzzzzzzzzzzzzzzzzzzfoes.count.desc": "When the golem waits for the field to be cleared, the nearest arrow says how many nightmares are still standing. Before, every arrow said \"one left\" even when there were several.",
  "news.2026-10-29-zzzzzzzzzzzzzzzzzchat.title": "Chat with the keyboard up",
  "news.2026-10-29-zzzzzzzzzzzzzzzzzchat.intro": "A fix for typing on a phone.",
  "news.2026-10-29-zzzzzzzzzzzzzzzzzchat.keyboard": "You can see what you type in the chat",
  "news.2026-10-29-zzzzzzzzzzzzzzzzzchat.keyboard.desc": "On some phones the keyboard covered the chat box, in the bastion and in the waiting room, so you couldn't see what you were writing. Now the chat moves above the keyboard while you type, and Send keeps it open so you can keep talking.",
  "news.2026-10-29-zzzzzzzzzzzzzzzstart.title": "Smoother first fights",
  "news.2026-10-29-zzzzzzzzzzzzzzzstart.intro": "Phones and computers stall less as a fight or a crypt opens.",
  "news.2026-10-29-zzzzzzzzzzzzzzzstart.start": "Solo fights wait for the board to be ready",
  "news.2026-10-29-zzzzzzzzzzzzzzzstart.start.desc": "On slower phones, a fight on your own now finishes preparing its nightmares and their shading before the clock starts, instead of stuttering as the first packs come in. The first fight after the game updates may take a moment longer to open.",
  "news.2026-10-29-zzzzzzzzzzzzzzzstart.apart": "Models are prepared on the side",
  "news.2026-10-29-zzzzzzzzzzzzzzzstart.apart.desc": "A fight's nightmares and heroes are put together in the background, without holding up the screen: on phones, an incursion or a crypt starts sooner and without the stutter of its first seconds.",
  "news.2026-10-29-zzzzzzzzzzzzzzmilitary.title": "Fixes",
  "news.2026-10-29-zzzzzzzzzzzzzzmilitary.intro": "The military district makes everything cheaper.",
  "news.2026-10-29-zzzzzzzzzzzzzzmilitary.iron": "The military district discounts iron too",
  "news.2026-10-29-zzzzzzzzzzzzzzmilitary.iron.desc": "Raising a tower's level or cladding it in iron inside the military district now costs 25% less across the board, iron included. Before, only wood and stone went down.",
  "app.title": "Somnhold",
  "app.tagline": "A fortress on the back of a sleeping titan",
  "menu.practice": "Practice field",
  "menu.practiceHint": "One wave against shadow goblins, no campaign.",
  "menu.campaigns": "My campaigns",
  "menu.language": "Español",
  "menu.continue": "Continue",
  "menu.settings": "Settings",
  "menu.back": "Back",
  "menu.howTo": "How to play",
  "hud.keep": "Keep",
  "hud.wave": "Wave {n}",
  "hud.marea": "Tide {n}",
  "hud.enemies": "{n} nightmares",
  "hud.time": "{m}:{s}",
  "hud.start": "Let them come",
  "hud.startHint": "Build your defenses. The wave starts when you are ready.",
  "hud.pause": "Pause",
  "news.2026-10-29-zzzzzzzzzzzzzzzzeight.title": "Groups of up to 8",
  "news.2026-10-29-zzzzzzzzzzzzzzzzeight.intro": "Nobody has to stay behind any more.",
  "news.2026-10-29-zzzzzzzzzzzzzzzzeight.eight": "Up to 8 everywhere",
  "news.2026-10-29-zzzzzzzzzzzzzzzzeight.eight.desc": "All three crypts, the saga, the garrison cellars, the Furrows and incursions now take up to 8 live heroes; an incursion, up to 7 companions between friends and spectres. The cellars go down with 3 to 8.",
  "news.2026-10-29-zzzzzzzzzzzzzzzzeight.scale": "Difficulty grows with the group",
  "news.2026-10-29-zzzzzzzzzzzzzzzzeight.scale.desc": "Past 4 there are more nightmares, but mostly tougher ones, and bosses have more life: that way the screen doesn’t fill with twice the creatures. In the cellars, past 4 the wings are walked in pairs.",
  "news.2026-10-29-zzzzzzzzzzzzzcall.title": "Improvements",
  "news.2026-10-29-zzzzzzzzzzzzzcall.intro": "You no longer miss the group gathering.",
  "news.2026-10-29-zzzzzzzzzzzzzcall.call": "The group call finds you on any panel",
  "news.2026-10-29-zzzzzzzzzzzzzcall.call.desc": "If someone gathers a group while you read your hero sheet, gear, skills, the news or a scene of the chronicle, a small call lights up at the top saying who is setting out and where. You can join right from it or wave it off; once you close the panel, the full call is still in the bastion.",
  "news.2026-10-29-zzzzzzzzzzzzchat.title": "Improvements",
  "news.2026-10-29-zzzzzzzzzzzzchat.intro": "The group chat now follows you wherever you go.",
  "news.2026-10-29-zzzzzzzzzzzzchat.chat": "The chat follows you into the fight",
  "news.2026-10-29-zzzzzzzzzzzzchat.chat.desc": "When you join a wave, a crypt, an incursion or an expedition you stay in the same group chat: what those in the bastion say reaches the waiting room and the fight, and what you write there everyone reads. In the waiting room the chat sits at the top, in sight.",
  "news.2026-10-29-zzzzzzzzzzzstay.title": "Fixes",
  "news.2026-10-29-zzzzzzzzzzzstay.intro": "A fix in the bastion.",
  "news.2026-10-29-zzzzzzzzzzzstay.stay": "No more snapping back to the keep",
  "news.2026-10-29-zzzzzzzzzzzstay.stay.desc": "While building, every hero walking the bastion would sometimes jump back beside the keep: it happened when someone switched or started a hero, or when a sector opened or a district rose. Now everyone stays where they were.",
  "news.2026-10-29-zzzzzzzzzznames.title": "Named heroes",
  "news.2026-10-29-zzzzzzzzzznames.intro": "Each hero can carry a name of its own.",
  "news.2026-10-29-zzzzzzzzzznames.names": "Name your hero",
  "news.2026-10-29-zzzzzzzzzznames.names.desc": "On the hero sheet, tap the quill next to the name and write theirs. That name is the one shown over the miniature in the bastion and in fights, in the party list and among allies. Each hero you keep holds its own, and you can name a new one as you start it. Leave it empty and your own name shows again.",
  "news.2026-10-29-zzsmooth.title": "Steadier waves",
  "news.2026-10-29-zzsmooth.intro": "Fewer stutters on phones.",
  "news.2026-10-29-zzsmooth.waves": "Skills no longer stall the wave",
  "news.2026-10-29-zzsmooth.waves.desc": "On some phones, every arrow rain, net or storm cloud froze the screen for a moment while its effect was prepared, again and again during a wave. Now each effect is prepared only once.",
  "news.2026-10-29-zzsmooth.sheet": "The hero sheet opens without a stall",
  "news.2026-10-29-zzsmooth.sheet.desc": "The first time the hero sheet opened, drawing the group's heroes could freeze the screen for almost a second. Now the bastion prepares them ahead.",
  "news.2026-10-29-zsheet.title": "The sheet, in tabs",
  "news.2026-10-29-zsheet.intro": "The hero sheet is tidied up so there is less scrolling.",
  "news.2026-10-29-zsheet.tabs": "Tabs on the hero sheet",
  "news.2026-10-29-zsheet.tabs.desc": "Under the portrait, four tabs: Hero (your numbers, how far armor and cooldown go, your heroes and your allies), Skills (the tree and what to carry), Gear (what you wear, the bag and the crypt chests) and Relics. The bar stays on top as you scroll, and the sheet opens again on the last tab you looked at. With points to spend, Skills says so from any tab. In the tree, the tab for fighting skills is now called “Combat”.",
  "news.2026-10-29-zsheet.forge": "Forge text on Relics",
  "news.2026-10-29-zsheet.forge.desc": "Without a standing forge, relics showed a half-built line. Now they say a forge is needed to awaken them.",
  "news.2026-10-29-zheroes.title": "Up to three heroes",
  "news.2026-10-29-zheroes.intro": "You can now keep more than one hero in the campaign.",
  "news.2026-10-29-zheroes.roster": "Several heroes per player",
  "news.2026-10-29-zheroes.roster.desc": "On the hero sheet, “Your heroes” keeps up to three. Start a new one at level 1 without losing the one you had, pick which one to play, and retire one to try another class. Only the one in play fights and earns experience; the others wait just as they are, with their gear and relics. The day's incursions and chests are still per player, and the group's level counts your best hero, so raising a new one holds nobody back.",
  "news.2026-10-29-slingers.title": "Incursions that end",
  "news.2026-10-29-slingers.intro": "A fix for the end of incursions.",
  "news.2026-10-29-slingers.stuck": "No slinger leaves an incursion hanging",
  "news.2026-10-29-slingers.stuck.desc": "Once the golems were loaded, a slinger could stay far off in the dark, slinging from beyond the heroes' reach, and the incursion never ended. Now, as soon as the golems are loaded, whoever was shooting from afar stops and comes in to fight, and a red arrow shows where each nightmare left is, even off screen. In the bastion, slingers left alone at the end of a wave come in too.",
  "news.2026-10-29-rooms.title": "Waiting rooms that don't freeze",
  "news.2026-10-29-rooms.intro": "An improvement for playing together below ground.",
  "news.2026-10-29-rooms.together": "Fewer stalls when gathering in the crypt",
  "news.2026-10-29-rooms.together.desc": "When a friend joined the waiting room of a crypt, the Furrows or the cellars, on some computers the screen froze for several seconds. The start of a crypt together no longer stalls on some phones either. Now the game prepares everything little by little, without cutting into the run.",
  "news.2026-10-29-bastion.title": "The bastion appears all at once",
  "news.2026-10-29-bastion.intro": "A fix when coming back from a fight.",
  "news.2026-10-29-bastion.whole": "No empty bastion on the way back",
  "news.2026-10-29-bastion.whole.desc": "Coming back from a crypt or an incursion, the bastion showed empty for a moment and then everything built popped in at once, with a stutter. Now it appears whole from the start.",
  "hud.preparing": "Preparing the fight…",
  "hud.resume": "Resume",
  "hud.quit": "Leave",
  "hud.speed": "Speed ×{n}",
  "hud.build": "Build",
  "hud.sell": "Dismantle",
  "hud.upgrade": "Upgrade",
  "hud.close": "Close",
  "hud.notEnough": "Not enough resources",
  "hud.blocked": "You can't build there",
  "hud.dragToPlace": "Drag onto a free bastion cell",
  "hud.tapToPlace": "Tap a free bastion cell",
  "hud.cursed": "Cursed: stand next to it to purify it",
  "end.won": "The keep holds",
  "end.lost": "The keep has fallen",
  "end.wonSub": "The nightmares crumble into ash. The titan sleeps on.",
  "end.lostSub": "The titan stirs in its sleep.",
  "end.victory": "Victory",
  "end.defeat": "Defeat",
  "end.settling": "The chronicler records the battle",
  "end.kills": "Nightmares slain",
  "end.damage": "Damage dealt",
  "end.keep": "Keep health",
  "end.time": "Duration",
  "end.retry": "Again",
  "end.menu": "Back to the menu",
  "end.dust": "Dream dust",
  "res.wood": "Wood",
  "res.stone": "Stone",
  "res.crystal": "Crystal",
  "res.dust": "Dream dust",
  "class.warrior": "Warrior",
  "class.artificer": "Artificer",
  "class.mage": "Mage",
  "class.ranger": "Ranger",
  "class.warrior.desc": "Plate and shield. Holds the gate and taunts the nightmares. His blow also catches those around his target.",
  "class.artificer.desc": "Turrets you can blow up, grenades that pull nightmares together and a battle automaton. Buildings near it mend on their own during a fight. Builds level 3 towers.",
  "class.mage.desc": "Fire, frost and storm. Enchants towers.",
  "class.ranger.desc": "Longbow and nets. Reveals what the Tide brings.",
  "skill.shieldBash": "Shield bash",
  "skill.shieldBash.desc": "40 damage and stuns the closest enemy.",
  "skill.challenge": "Challenge",
  "skill.challenge.desc": "Taunts every nearby nightmare for 4 s, flyers too: they come down to fight you. Those striking a wall, gate or tower near you leave it and come for you. Siege engines can't be taunted.",
  "skill.oath": "Oath",
  "skill.oath.desc": "Invulnerable and taunts in a wide radius for 5 s.",
  "skill.turret": "Portable turret",
  "skill.turret.desc": "Places a turret that fires for {s} s. Up to {n} at a time.",
  "skill.overload": "Overload",
  "skill.overload.desc": "Blows up one of your turrets, hurting and stunning everything around it. With a single turret out it goes at once; with more, tap which. It has its own {s} s wait, apart from placing turrets.",
  "skill.overloadNone": "You have no turrets to overload",
  "skill.overloadAim": "Tap one of your turrets",
  "skill.fireball": "Fireball",
  "skill.fireball.desc": "60 area damage.",
  "skill.frostWall": "Frost wall",
  "skill.frostWall.desc": "A line of ice that slows by 60 % for 5 s.",
  "skill.storm": "Storm",
  "skill.storm.desc": "Lightning over an area for 4 s.",
  "skill.multishot": "Multishot",
  "skill.multishot.desc": "Five arrows at the nightmares in an area.",
  "skill.net": "Net",
  "skill.net.desc": "Roots a nightmare for 2 s.",
  "skill.arrowRain": "Arrow rain",
  "skill.arrowRain.desc": "Arrows over an area for 4 s.",
  "skill.ready": "Ready",
  "skill.aim": "Pick a spot",
  "skill.no.ground": "Not there: pick open ground closer by",
  "skill.no.stun": "Stunned: no skills for now",
  "skill.no.fear": "Afraid: no skills for now",
  "skill.no.sleep": "Asleep: no skills for now",
  "skill.no.bear": "In bear form you only claw",
  "structure.ballista": "Ballista",
  "structure.ballista.desc": "Fast bolts against ground and air.",
  "structure.catapult": "Catapult",
  "structure.catapult.desc": "Area boulders. Slow, ground only.",
  "structure.arcane": "Arcane tower",
  "structure.arcane.desc": "Pulses that ignore armor. Hits flyers.",
  "structure.belfry": "War belfry",
  "structure.belfry.desc": "Its toll stuns nearby nightmares.",
  "structure.beacon": "Vigil beacon",
  "structure.beacon.desc": "Nearby towers fire faster. Reveals the invisible.",
  "structure.wall": "Wall",
  "structure.wall.desc": "Blocks the way. Nightmares attack it when there is no other path.",
  "structure.gate": "Gate",
  "structure.gate.desc": "A path's entrance. If it falls, the way stays open.",
  "structure.spikes": "Spike pit",
  "structure.spikes.desc": "Wounds and slows. Wears out.",
  "structure.oil": "Burning oil",
  "structure.oil.desc": "Burns whoever steps in. Wears out.",
  "structure.forge": "Dwarven forge",
  "structure.forge.desc": "Upgrades gear with dream dust: each + adds 4 points to the main attribute. Level 1 goes up to +3, level 2 to +4 and level 3 to +5.",
  "structure.barracks": "Barracks",
  "structure.barracks.desc": "Hires mercenaries who fight beside you in the waves. Higher level: more of them at once, and stronger.",
  "structure.temple": "Temple",
  "structure.grove": "Grove",
  "structure.grove.desc": "The druid's. Wood after every wave (twice with a druid in the group); its roots slow the nightmares passing by, more so with a druid in the fight. One per bastion.",
  "structure.hall": "Clan hall",
  "structure.hall.desc": "The barbarian's. Every warlord or boss felled this Tide hangs a trophy: +2 % damage for every hero (up to 5). With a barbarian in the fight the drums sound: everyone runs faster as the wave begins. One per bastion.",
  "structure.watchtower": "Watchtower",
  "structure.watchtower.desc": "The ranger's. Towers nearby reach 15 % farther (25 % with a ranger in the fight). It reveals the invisible around it and marks what moves under the ground: it can be seen and hit before it surfaces. One per bastion.",
  "structure.sanctum": "Sanctum",
  "structure.sanctum.desc": "The cleric's. After every wave, what stands nearby recovers 15 % of its health (25 % with a cleric in the group). In a fight, heroes beside it heal little by little, twice as fast with a cleric in the fight. One per bastion.",
  "structure.trebuchet": "Trebuchet",
  "structure.trebuchet.desc": "Huge stones from very far away, in an area. Very slow, ground only. Hits giants, colossi, siege engines, warlords and bosses 50 % harder, and aims at them first.",
  "structure.temple.desc": "The paladin's. Towers nearby hit the inked and the undead 15 % harder; with a paladin in the fight, what stands nearby takes 20 % less. One per bastion.",
  "structure.keep": "Keep",
  "enemy.goblin": "Goblin",
  "enemy.wolf": "Shadow wolf",
  "enemy.skeleton": "Ash skeleton",
  "enemy.wraith": "Wraith",
  "enemy.gargoyle": "Gargoyle",
  "enemy.slime": "Ink slime",
  "enemy.stalker": "Stalker",
  "enemy.witch": "The Ash Witch",
  "enemy.shell": "The Hollow Shell",
  "enemy.boneWall": "Bone wall",
  "tier.3": "Ash",
  "enemy.elite": "Warlord",
  "controls.title": "Controls",
  "controls.pc": "Click (left or right) to move and attack · Q W E skills · R turret · drag to move the camera · right-drag to turn · wheel to zoom",
  "controls.mobile": "Tap to move and attack · skill buttons bottom right · hold and drag a card to build · two fingers to rotate and zoom",
  "settings.tiltShift": "Miniature blur",
  "settings.sound": "Sound",
  "settings.music": "Music",
  "settings.quality": "Quality",
  "settings.quality.high": "High",
  "settings.quality.low": "Low",
  "tutorial.move": "Tap or click the ground to move your warrior.",
  "tutorial.build": "Drag a ballista near the gate.",
  "tutorial.start": "When you're ready, call the wave.",
  "err.webgl": "The browser won't let the game use the graphics card right now, so the table can't be shown. It usually clears a few seconds after a dropout: we'll keep trying.",
  "err.webgl.gaveUp": "Still not starting. Try closing and reopening the browser, or check that hardware acceleration is on.",
  "menu.localCampaign": "Trial campaign",
  "menu.localCampaignHint": "A bastion in this browser, with two ghost companions. To try the whole loop.",
  "menu.continueCampaign": "Continue: {name}",
  "menu.newLocal": "New trial campaign",
  "menu.fastPace": "Fast pace: a day lasts 10 minutes",
  "menu.pickClass": "Choose your class",
  "menu.yourName": "Your name",
  "menu.start": "Start",
  "menu.delete": "Delete",
  "bastion.title": "The bastion",
  "bastion.storage": "Storage",
  "bastion.over.won": "The titan sleeps in peace. Campaign won.",
  "bastion.over.lost": "The titan woke up. Campaign lost.",
  "bastion.defend": "Fight live",
  "bastion.log": "Log",
  "bastion.leave": "Leave",
  "bastion.more": "More",
  "bastion.leaveTitle": "Where does your ghost wait?",
  "bastion.leaveHint": "While you're away, your ghost fights with 70 % of your strength. It waits at that post while things are calm and, when they attack, goes on its own wherever it's needed most: a gate under pressure, a breach in the wall or the keep.",
  "bastion.anywhere": "No fixed post",
  "bastion.sector": "Path {n}",
  "bastion.emptyCell": "Free cell",
  "bastion.gateway": "Path {n} gateway",
  "bastion.gatewayHint": "Without a gate, nightmares walk right in.",
  "bastion.blueprint": "Blueprint: {s}",
  "bastion.placedBy": "Planned by {name}",
  "bastion.building": "Under construction: {s}",
  "bastion.waitingGolem": "Waiting for a free golem",
  "bastion.golemOn": "A golem is building it",
  "bastion.contribute": "Put in what we have",
  "bastion.cancel": "Remove blueprint",
  "bastion.work": "Help with your hero",
  "bastion.working": "You help while your hero stays inside the blue circle. You can close this sheet.",
  "bastion.stopWork": "Stop helping",
  "bastion.level": "Level {n}",
  "bastion.material.1": "Wood and adobe",
  "bastion.material.2": "Stone",
  "bastion.repair": "Repair",
  "bastion.upgrade": "Upgrade to level {n}",
  "bastion.toStone": "Rebuild in stone",
  "bastion.demolish": "Demolish",
  "bastion.demolishTitle": "Demolish {s}",
  "bastion.demolishHint": "Leave a note for the group. It can be undone for 24 hours.",
  "bastion.notePlaceholder": "Why you're demolishing it",
  "bastion.undo": "Undo",
  "bastion.enchant": "Enchant",
  "bastion.enchant.fire": "Fire",
  "bastion.enchant.frost": "Frost",
  "bastion.enchant.lightning": "Lightning",
  "bastion.fortify": "Fortify (+25 % health, 24 h)",
  "bastion.enchanted": "Enchanted: {e}",
  "bastion.fortified": "Fortified",
  "bastion.ruined": "In ruins",
  "bastion.charges": "Charges: {n}/{m}",
  "bastion.frost.warm": "Warm in the frost",
  "bastion.frost.cold": "Slowed by the frost",
  "bastion.frost.oil": "Lights in the frost",
  "bastion.frost.oilEmpty": "Empty: gives no warmth",
  "bastion.cost": "Cost",
  "bastion.time": "Build time: {t}",
  "bastion.keep": "Keep",
  "bastion.lastWave": "Last wave",
  "bastion.report": "Damage report",
  "bastion.reportWon": "Wave {w} of Tide {m}: the keep held",
  "bastion.reportLost": "Wave {w} of Tide {m}: the keep fell",
  "bastion.reportSector": "Path {n}: {k} nightmares slain, {l} reached the keep, {s} structures lost",
  "bastion.gateFell": "the gate fell",
  "bastion.byGhost": "held by ghosts",
  "bastion.byLive": "defended live",
  "bastion.walkHere": "Go here",
  "bastion.holdToWalk": "Hold your finger on the ground to walk, or use “Go here”.",
  "bastion.close": "Close",
  "time.d": "{n} d",
  "time.h": "{n} h",
  "time.m": "{n} min",
  "time.s": "{n} s",
  "time.now": "now",
  "time.justNow": "just now",
  "time.yesterday": "yesterday {time}",
  "reason.occupied": "That cell is taken.",
  "reason.notBuildable": "You can't build there.",
  "reason.notEnough": "Not enough in storage.",
  "reason.needsArtificer": "Only an artificer builds level 3.",
  "reason.locked": "Your hero isn't high enough level for this yet.",
  "reason.busy": "There's already work on that cell.",
  "reason.noteRequired": "Write a note.",
  "reason.tooLate": "More than 24 hours have passed.",
  "reason.intact": "It's intact.",
  "reason.generic": "That didn't work.",
  "log.blueprint": "{who} drew the blueprint for {s}",
  "log.contribute": "{who} put in {what}",
  "log.built": "Finished: {s}",
  "log.repaired": "{who} repaired {s}",
  "log.golemRepaired": "The golems repaired {s}",
  "log.demolished": "{who} demolished {s}: “{note}”",
  "log.undoDemolish": "{who} undid a demolition",
  "log.work": "{who} helped {n} min on site",
  "log.wave": "Wave {w} of Tide {m}: {r}",
  "log.waveWon": "we held",
  "log.waveLost": "the keep fell",
  "log.mareaWon": "Tide {m} survived!",
  "log.mareaLost": "Tide {m} lost: storage loses 30 %",
  "log.levelUp": "{who} reached level {n}",
  "log.enchant": "{who} enchanted a tower",
  "log.fortify": "{who} fortified a wall",
  "log.ghostPost": "{who} left their ghost on guard",
  "log.joined": "A new path opened",
  "log.campaignWon": "First season won! The tide goes on.",
  "log.campaignLost": "The campaign is over",
  "log.mareaLostLate": "Marea {m} was lost: it starts over",
  "structure.foundry": "Foundry",
  "structure.foundry.desc": "Golems dig iron out of the rock it touches and bring it here. Adds an «Iron» row to the golem table. Takes 3 cells. One per bastion.",
  "structure.arsenal": "Arsenal",
  "structure.arsenal.desc": "Ballistas and catapults touching it fire faster. Takes 3 cells.",
  "structure.rod": "Lightning rod",
  "structure.rod.desc": "When the herald's lightning leaps near it, the chain ends in it, harmlessly.",
  "structure.gatetower": "Gate tower",
  "structure.gatetower.desc": "Stands beside a gate and shoots like a light ballista, at the ground and the air. Two at its sides make a fortified gate.",
  "structure.titanEye": "Titan's Eye",
  "structure.titanEye.desc": "Charges while nightmares are near and, full, fires by itself at the biggest one in reach. No plate or scale turns it. Takes 7 cells on one level.",
  "earth.title": "Earthworks",
  "earth.placed": "{n} earthworks planned: {e}",
  "earth.count": "{n} cells",
  "earth.clear": "Clear",
  "earth.clear.hint": "The wood becomes open ground and leaves some timber. It opens a way, no longer slows, and the golems lose that source.",
  "earth.quarry": "Quarry",
  "earth.quarry.hint": "The rock becomes open ground and leaves some stone. It opens a way and the golems lose that source.",
  "earth.opensDraft": "Careful: some cells are next to a wall or gate. When the golems finish, a way opens there.",
  "earth.opensWall": "It touches a wall: when it's done, nightmares walk through here. If you don't want it, cancel it.",
  "earth.raise": "Raise",
  "earth.raise.hint": "The cell rises a level, to level the ground for big pieces or change where the way climbs.",
  "earth.lower": "Lower",
  "earth.lower.hint": "The cell drops a level.",
  "earth.ditch": "Ditch",
  "earth.ditch.hint": "Nightmares on foot cross it slowly, like a ford. Nothing is built on it.",
  "earth.ford": "Ford",
  "earth.ford.hint": "Deep water by the bank becomes a ford: a slow crossing, opened on purpose.",
  "branch.pick": "Pick a branch for this tower:",
  "branch.change": "Change branch (the new one is paid in full):",
  "branch.current": "Current branch",
  "branch.vs": "Against: {x}",
  "branch.eraHint": "In {era} this tower picks a branch.",
  "branch.levelHint": "At level 4 this tower picks a branch.",
  "branch.repeater": "Repeater",
  "branch.repeater.desc": "Fires two bolts, each a little lighter.",
  "branch.repeater.vs": "swarms and small flyers",
  "branch.harpoon": "Harpoon",
  "branch.harpoon.desc": "The shot runs through the line and hits big and flying ones harder.",
  "branch.harpoon.vs": "columns of rams and mammoths",
  "branch.pitch": "Pitch",
  "branch.pitch.desc": "Where it lands the ground burns a while (not in water).",
  "branch.pitch.vs": "trolls and whatever fears fire",
  "branch.counterweight": "Counterweight",
  "branch.counterweight.desc": "Reaches much farther, but fires slower.",
  "branch.counterweight.vs": "the giant and what shoots from afar",
  "branch.focus": "Focus",
  "branch.focus.desc": "More damage and reach on a single target.",
  "branch.focus.vs": "elites and the big ones",
  "branch.sky": "Sky",
  "branch.sky.desc": "Shoots only what flies, with holy light: double damage and more reach.",
  "branch.sky.vs": "wyrmlings, wyverns, the herald and the drake",
  "branch.steam": "Steam cannon",
  "branch.steam.desc": "Every shot bursts in an area.",
  "branch.steam.vs": "tight packs",
  "branch.sealed": "Sealed",
  "branch.sealed.desc": "Nothing puts it to sleep, cocoons, curses or turns it.",
  "branch.sealed.vs": "the dreamer, the weaver and Bruni",
  "branch.split": "Split stones",
  "branch.split.desc": "Each stone breaks and two more fall round it.",
  "branch.split.vs": "spread-out waves",
  "branch.embers": "Embers",
  "branch.embers.desc": "Where it lands it leaves a field of live embers.",
  "branch.embers.vs": "whatever comes in a mass",
  "mount.needsStone": "In era III a stone or iron wall run can carry a tower on top.",
  "mount.hint": "Mount a level {n} tower on this run: it shoots from the wall and falls with it.",
  "mount.do": "Mount {s}",
  "mount.on": "Carries a level {n} {s} on top.",
  "reason.badBranch": "That branch isn't this tower's.",
  "reason.sameBranch": "It already has that branch.",
  "reason.branchLevel": "The tower has to be level 4.",
  "reason.needsWall": "Only on a wall run.",
  "reason.needsStoneWall": "The run has to be stone or iron.",
  "reason.needsGate": "A gate tower goes beside a gate.",
  "reason.badEarth": "There's no such earthwork.",
  "reason.crest": "The keep's plateau stays as it is.",
  "reason.wrongGround": "That earthwork can't be done on this ground.",
  "reason.tooFar": "A cell moves at most one level from its own height.",
  "reason.foundryRock": "That rock is the foundry's.",
  "reason.earthCap": "The bastion has already changed all the land this era allows.",
  "reason.ditchCap": "No room for more ditches.",
  "reason.steep": "It would leave a step nobody can climb.",
  "reason.shutsKeep": "It would cut the keep off from some edge.",
  "reason.notLand": "Only on a bastion on terraced land.",
  "log.blueprintEarth": "planned an earthwork: {e}",
  "log.blueprintBranch": "picked the {b} branch for a {s}",
  "log.blueprintMount": "planned to mount a tower on the wall",
  "log.earthDone": "An earthwork was finished: {e}",
  "log.earthFailed": "An earthwork couldn't be finished ({e}) and what was paid came back",
  "bastion.noArtificer": "Without an artificer of level {n} or more playing in the group, it costs {p} % more.",
  "reset.title": "New ground",
  "reset.lead": "The group starts again on firm ground: the keep alone on the crest, new heroes and Marea I ahead.",
  "reset.p1": "Build anywhere on the map: drag to draw walls and put the gates wherever you like.",
  "reset.p2": "The golems belong to the group: a table says how many gather wood, stone or crystal, and the rest build.",
  "reset.p3": "Nightmares open rifts without warning and come in where the bastion is weakest.",
  "reset.p4": "Every era brings new pieces, an upgrade step and earthworks to reshape the land.",
  "reset.go": "Start building",
  "log.titanStirs": "The titan stirred in its sleep: everything was shaken to half its life and the storage lost 25 %",
  "__won": "First season won! The tide goes on.",
  "log.empty": "Nothing has happened yet.",
  "bastion.you": "you",
  "email.magic.subject": "Your Somnhold sign-in link",
  "email.magic.body": "Someone (most likely you) asked to sign in to Somnhold with this email.\nTap the button to get in. The link expires in 15 minutes and works only once.",
  "email.magic.button": "Sign in to Somnhold",
  "email.magic.ignore": "If you didn't ask for it, ignore this email: nobody can get in without it.",
  "email.open": "Open the bastion",
  "auth.title": "Sign in",
  "auth.hint": "We'll email you a magic link. No passwords.",
  "auth.email": "Your email",
  "auth.send": "Send me the link",
  "auth.sent": "Done. Check your email and tap the link.",
  "auth.devLink": "Dev mode: sign in with this link",
  "auth.logout": "Sign out",
  "auth.invalid": "That link expired or was already used. Ask for another.",
  "auth.rate": "Too many links in an hour. Wait a while.",
  "campaigns.title": "Your campaigns",
  "campaigns.none": "You're not in any campaign yet.",
  "campaigns.new": "Found a campaign",
  "campaigns.name": "Campaign name",
  "campaigns.timezone": "Group time zone",
  "campaigns.hours": "Wave hours",
  "campaigns.hoursHint": "Three times a day during each Tide. Whoever wants to play live knows when to come in.",
  "campaigns.hoursBad": "The three hours must be different, at least {n} hours apart.",
  "campaigns.depth": "Depth of sleep",
  "campaigns.depth.light": "Light sleep",
  "campaigns.depth.deep": "Deep sleep",
  "campaigns.create": "Found",
  "campaigns.players": "{n} wardens",
  "campaigns.invite": "Invite",
  "campaigns.inviteHint": "Send this link to your friends. Valid for 7 days, up to 8 people.",
  "campaigns.copy": "Copy link",
  "campaigns.copied": "Link copied",
  "campaigns.share": "Share",
  "invite.title": "You've been invited to “{name}”",
  "invite.hint": "Choose your class and name. Play whenever you like: your ghost defends while you're away.",
  "invite.join": "Join",
  "invite.invalid": "This invite expired or is full.",
  "invite.taken": "Already in the group",
  "net.offline": "Offline: your actions are kept and sent when you're back.",
  "net.rebased": "The bastion changed while you played. {n} actions were no longer possible and were dropped.",
  "gl.software": "Your browser is drawing the game without the graphics card, which is why it runs slowly. Turn on hardware acceleration (in Chrome: Settings → System → “Use graphics acceleration when available”) and restart the browser.",
  "gl.software.ok": "Got it",
  "net.glLost": "The game's screen dropped out. Waiting for it to come back…",
  "net.glLost.reload": "The screen didn't come back on its own. Reload to carry on: if you were in a fight, the bastion offers the way back.",
  "net.error": "We couldn't reach the server.",
  "menu.account": "Account",
  "menu.signIn": "Sign in with your email",
  "menu.signInHint": "To play with friends without having to be online together.",
  "bastion.watch": "Watch the replay",
  "bastion.replayTitle": "Replay: wave {w} of Tide {m}",
  "bastion.lastReport": "Last report",
  "live.stopped.cancelled": "The fight was cut short",
  "live.stopped.cancelledSub": "The server had a problem with this fight and called it off. Go back to the bastion; we already got word of it.",
  "live.stopped.full": "The room is full",
  "live.stopped.fullSub": "The group set out without you, or there is no room left. Go back to the bastion.",
  "live.stopped.replaced": "You opened this fight somewhere else",
  "live.stopped.replacedSub": "You are still playing in the other tab or device. This one closed so you don't fight twice.",
  "live.stopped.gone": "The fight is over",
  "live.stopped.goneSub": "While you were away the fight ended or was lost. Whatever was won is in the bastion.",
  "live.stopped.refused": "Couldn't get in",
  "live.stopped.refusedSub": "The room didn't answer. Go back to the bastion and try again.",
  "live.reconnecting": "Connection lost. Your ghost fights while you reconnect…",
  "live.full": "The room already has 8 live heroes.",
  "live.waiting": "The wave starts in {t}. Whoever comes in joins with their hero.",
  "live.together": "Together: {names}",
  "bastion.lobby": "Wait for the wave live",
  "merc.title": "Mercenaries",
  "merc.hint": "They fight in the waves with {p} % of their class's strength. They don't go on incursions or into the crypt.",
  "merc.hire": "Hire",
  "merc.serving": "Hired {cls} · hired by {who}",
  "reason.needsBarracks": "You need a standing barracks.",
  "log.mercenary": "{who} hired a mercenary",
  "moment.eliteSlain": "{who} slew a warlord",
  "moment.bossSlain": "{who} brought down {what}",
  "moment.gateFell": "the gate of path {n} fell",
  "moment.oath": "{who} swore the Oath",
  "moment.bossPhase": "the boss changed its shape",
  "moment.someone": "a tower",
  "hero.title": "Your hero",
  "hero.level": "Level {n}",
  "hero.maxLevel": "Campaign level cap",
  "hero.points": "{n} points",
  "hero.tree": "Skill tree",
  "hero.gear": "Gear",
  "hero.bag": "Bag",
  "hero.relics": "Relics",
  "hero.tabs": "Hero sheet",
  "hero.tab.hero": "Hero",
  "hero.tab.skills": "Skills",
  "hero.tab.gear": "Gear",
  "hero.tab.relics": "Relics",
  "hero.equip": "Equip",
  "hero.forge": "Forge +{n} ({gain})",
  "hero.forgeHint": "The forge adds 4 points to the item's main attribute for each +. It needs a standing dwarven forge.",
  "branch.bastion": "Bastion",
  "stat.damage": "+{v} % damage",
  "stat.hp": "+{v} % health",
  "stat.attackSpeed": "+{v} % attack speed",
  "stat.cooldown": "−{v} % cooldown",
  "stat.armor": "+{v} % armor",
  "stat.range": "+{v} % range",
  "aura.title": "Aura you carry into battle",
  "aura.devotion": "Devotion",
  "aura.retribution": "Retribution",
  "aura.life": "Life",
  "aura.devotion.desc": "Allies near you take less damage: 15%, 20% from level 7 and 25% from level 16.",
  "aura.retribution.desc": "Every nightmare that strikes an ally near you is struck back with light, harder at levels 7 and 16.",
  "aura.life.desc": "Allies near you recover a little life every second, more at levels 7 and 16.",
  "stat.healing": "+{v} % healing",
  "perk.repairDiscount": "−{v} % repair cost",
  "perk.workBonus": "+{v} % when working on site",
  "perk.ghostPower": "+{v} % ghost strength",
  "perk.incursionLoot": "+{v} % incursion loot",
  "node.rank": "{skill}: rank {n}",
  "slot.weapon": "Weapon",
  "slot.armor": "Armor",
  "slot.amulet": "Amulet",
  "rarity.common": "Common",
  "rarity.uncommon": "Uncommon",
  "rarity.rare": "Rare",
  "attr.damage": "+{v} % damage",
  "attr.damageAttack": "+{n} attack",
  "attr.damageAttackHint": "Every piece's % damage adds up and applies once to the base attack. This is what this piece adds to your Attack.",
  "attr.hp": "+{v} % health",
  "attr.attackSpeed": "+{v} % attack speed",
  "attr.cooldown": "−{v} % cooldown",
  "attr.armor": "+{v} % armor",
  "attr.crit": "+{v} % certainty (critical chance)",
  "attr.resFire": "+{v} % against fire (half that less against frost)",
  "attr.resFrost": "+{v} % against frost (half that less against fire)",
  "attr.resLightning": "+{v} % against lightning (half that less against acid)",
  "attr.resAcid": "+{v} % against acid (half that less against lightning)",
  "attr.resPoison": "+{v} % against poison (half that less against shadow)",
  "attr.resShadow": "+{v} % against shadow (half that less against poison)",
  "effect.burn": "Burns on hit",
  "effect.lifesteal": "Lifesteal",
  "effect.thorns": "Thorns",
  "effect.swift": "Swift step",
  "relic.fateDie": "Fate die",
  "relic.fateDie.desc": "Every basic attack rolls the die: on a 6, it hits twice as hard.",
  "relic.vigilGrimoire": "Vigil grimoire",
  "relic.vigilGrimoire.desc": "Your ghost uses your ultimate once per wave.",
  "relic.vigilLantern": "Vigil lantern",
  "relic.vigilLantern.desc": "Reveals stalkers around you.",
  "relic.dreamerRing": "Dreamer's ring",
  "relic.dreamerRing.desc": "When you fall you return in 10 s instead of 20.",
  "relic.warHorn": "War horn",
  "relic.warHorn.desc": "Nearby towers fire 15 % faster.",
  "relic.ashAmulet": "Ash amulet",
  "relic.ashAmulet.desc": "Slaying a nightmare heals you a little.",
  "relic.corvinGate": "Corvin's gate",
  "relic.corvinGate.desc": "Blows that reach you from the front hurt you 25 % less.",
  "relic.velaString": "Vela's string",
  "relic.velaString.desc": "What you strike is smoked for 4 s: it takes 12 % more from everyone.",
  "relic.anselPage": "Ansel's page",
  "relic.anselPage.desc": "Every 6th basic attack bursts in fire around its target.",
  "relic.lucanCenser": "Lucan's censer",
  "relic.lucanCenser.desc": "Every nightmare that dies near you heals the allies at your side 1 % of their health.",
  "relic.bruniHammer": "Bruni's hammer",
  "relic.bruniHammer.desc": "Structures near you take 30 % less damage.",
  "relic.ragnaHorn": "Ragna's horn",
  "relic.ragnaHorn.desc": "You hit 3 % harder for every 10 % of health you have lost.",
  "relic.eddaShield": "Edda's shield",
  "relic.eddaShield.desc": "Once a fight, as you are about to fall you turn untouchable for 2 s and heal 20 %.",
  "relic.kaelaSeed": "Kaela's seed",
  "relic.kaelaSeed.desc": "A nightmare that stays near you for 2 s is pinned for 1 s (not bosses).",
  "inc.title": "Incursions",
  "inc.hint": "Climb down the titan's body to gather resources. The first 3 each day give full reward; the rest, 25 %.",
  "inc.today": "Today: {n} of 3 at full reward",
  "inc.quarry": "Quarry",
  "inc.forest": "Forest",
  "inc.crystal": "Crystal mine",
  "inc.altar": "Altar",
  "inc.rescue": "Lost golem",
  "inc.quarry.desc": "Stone for walls, gates and repairs.",
  "inc.forest.desc": "Wood for towers, traps and mercenaries.",
  "inc.crystal.desc": "Arcane crystal for arcane towers and upgrades.",
  "inc.altar.desc": "Dream dust for the forge and gear. Sometimes, a relic.",
  "inc.rescue.desc": "A lost golem: bring it home and it works for the bastion until the Tide ends. It also brings wood and stone.",
  "inc.double": "Double reward",
  "inc.companion": "Bring the ghost of",
  "inc.alone": "Go alone",
  "inc.go": "Set out",
  "inc.extract": "Extraction",
  "inc.node": "Node",
  "inc.turret": "Field turret",
  "inc.titan": "The titan's body",
  "board.title": "Request board",
  "board.hint": "Ask for materials for something concrete. What others put in goes to the storage, and whoever fulfills the request gains experience and shows up in the chronicle.",
  "board.new": "New request",
  "board.text": "E.g. stone for the south wall",
  "board.fulfill": "Fulfill",
  "board.done": "Done",
  "board.empty": "No open requests.",
  "board.by": "Asked by {name}",
  "bastion.hero": "Hero",
  "reason.noPoints": "You have no points left.",
  "reason.needsPrevious": "First the previous node in that branch.",
  "reason.maxRank": "Already maxed.",
  "reason.needsForge": "You need a standing dwarven forge.",
  "reason.maxPlus": "Already at +5.",
  "reason.noTask": "That request is gone.",
  "reason.nothingToGive": "Nothing to contribute.",
  "log.incursion": "{who} returned from an incursion",
  "log.loot": "{who} found something",
  "log.task": "{who} used the board",
  "bastion.scouted": "The rangers spotted {n} foes: {list}",
  "bastion.scoutedMore": "The rangers spotted {n} foes: {list} and {more} more kinds",
  "bastion.scoutedFull": "The rangers spotted: {list}",
  "coach.title": "Guide",
  "coach.next": "Next",
  "coach.begin": "Show me",
  "coach.skip": "Skip guide",
  "coach.welcome": "This is the practice field. In a minute I'll show you how to defend the bastion. You can skip the guide at any time.",
  "coach.keep": "The keep is the heart of the bastion. Every nightmare that reaches it takes away health; if it hits zero, you lose.",
  "coach.gate": "Nightmares come in through the gate (the marker) and follow the path to the keep. That's where you want to defend.",
  "coach.res": "These three materials pay for defenses. Each card shows its cost with the same icons; if you can't afford it, the card turns grey. Tap a resource at the top to see what it is for.",
  "coach.build.touch": "Tap the ballista card, then tap a free tile next to the path, near the gate. You can also drag it.",
  "coach.build.pc": "Drag the ballista card onto a free tile next to the path, near the gate. The circle shows its range.",
  "coach.more": "Nice! The ballista fires bolts at a single target. Try another defense:",
  "coach.hero.touch": "This is your warrior. Tap the ground to move and tap a nightmare to attack it. Left alone, they fight whatever is close. Try moving.",
  "coach.hero.pc": "This is your warrior. Click the ground to move it and click a nightmare to attack it. Left alone, it fights whatever is near. Try moving it.",
  "coach.skills": "Bottom right are their skills. After use they take a while to recharge:",
  "coach.camera.touch": "Drag with one finger to move the table. Use two fingers to zoom and turn.",
  "coach.camera.pc": "Drag to move the table, scroll to zoom and right-drag to turn. Q, W and E cast the skills.",
  "coach.start": "When you're ready, tap “Let them come”. You can keep building during the wave.",
  "coach.tip.spawn": "Here they come! Take the warrior to the path to stop them before the keep.",
  "coach.tip.keep": "A nightmare reached the keep. Cut them off or add defenses along the path.",
  "coach.tip.down": "Your warrior fell. They get back up in a few seconds.",
  "coach.tip.ult": "{name} is ready. Save it for when many nightmares bunch up.",
  "coach.res.wood": "ballistas, catapults and timber works.",
  "coach.res.stone": "almost every defense needs it.",
  "coach.res.crystal": "arcane towers and magic.",
  "advice.title": "Advice",
  "advice.show": "Show me",
  "advice.open": "Open",
  "advice.dismiss": "Hide advice",
  "advice.defend": "The wave is coming. Tap “Defend live” to fight yourself; otherwise your ghost holds your post alone.",
  "advice.gate": "Path {n} has no gate: without one, the nightmares walk straight in. Plan a gate where it enters.",
  "advice.fund": "The {s} plan is waiting for materials. Contribute from the store so the golems can start.",
  "advice.work": "The golems are building {s}. If you work on the site, it finishes sooner.",
  "advice.repair": "{s} is badly damaged. Repair it before the next wave.",
  "advice.tower": "Path {n} has very few towers. Place a ballista near the gate: you have materials to spare.",
  "advice.skills": "You have {n} unspent skill points. Open your hero and spend them on the tree.",
  "advice.incursion": "You have {n} full-reward incursions left today. Go down the titan's body to gather materials.",
  "advice.board": "A companion asked for materials on the board. Fulfilling it earns you experience.",
  "advice.upgrade": "You can afford to upgrade {s}. Tap it and choose “Upgrade”.",
  "advice.preview": "The wave is almost here: step into the room and defend live with the group.",
  "advice.wait": "The bastion is in order. The next wave arrives in {t}: come back to defend or let your ghost do it.",
  "bastion.blueprintHint": "This is still a blueprint: nothing is built yet. Once the storage covers every material, a golem raises it in {t}.",
  "bastion.materials": "Materials in",
  "bastion.paidOf": "{n} of {m}",
  "bastion.contributeAll": "Put in the materials",
  "bastion.contributeSome": "The storage can't cover it all: the rest can go in later, or another player can add it.",
  "bastion.storeEmpty": "The storage lacks what's missing. It fills from incursions (Incursions button).",
  "bastion.buildingHint": "The materials are in. A golem is building it on its own; you don't need to do anything.",
  "bastion.workHint": "If you help, the work goes ×{n} while your hero stays next to it.",
  "log.blueprint.you": "You drew the blueprint for {s}",
  "log.contribute.you": "You put in {what}",
  "log.repaired.you": "You repaired {s}",
  "log.demolished.you": "You demolished {s}: “{note}”",
  "log.undoDemolish.you": "You undid a demolition",
  "log.work.you": "You helped {n} min on site",
  "log.levelUp.you": "You reached level {n}",
  "log.enchant.you": "You enchanted a tower",
  "log.fortify.you": "You fortified a wall",
  "log.ghostPost.you": "You left your ghost on guard",
  "log.mercenary.you": "You hired a mercenary",
  "log.incursion.you": "You returned from an incursion",
  "log.loot.you": "You found something",
  "log.task.you": "You used the board",
  "log.ago": "{t} ago",
  "board.post": "Pin it to the board",
  "board.textLabel": "What it's for",
  "board.wantLabel": "What's needed",
  "board.byYou": "Your request",
  "board.noText": "No description",
  "inc.how1": "Pick a place on the titan's body.",
  "inc.how2": "The golems extract while you defend them through 3 waves. With the field clear they work faster.",
  "inc.how3": "What you bring back goes to the shared storage; if you fall early, you bring a part.",
  "inc.todayLeft": "{n} left at full reward today",
  "inc.todayReduced": "Today's now give 25 %; they renew tomorrow",
  "inc.youGet": "If you hold to the end:",
  "restip.wood.use": "For ballistas, catapults, traps and mercenaries.",
  "restip.stone.use": "For walls, gates, repairs and most towers.",
  "restip.crystal.use": "For arcane towers, belfries, beacons and level upgrades.",
  "restip.dust.use": "For the forge: upgrading your gear. Nightmares drop it.",
  "restip.wood.from": "Found in forests (Incursions).",
  "restip.stone.from": "Found in quarries (Incursions) and from demolishing.",
  "restip.crystal.from": "Found in crystal mines (Incursions).",
  "restip.dust.from": "Won from nightmares, altars and defended waves.",
  "restip.battle": "It's what you have left to build in this practice.",
  "campaigns.depth.hint": "This is the difficulty: how deeply the titan sleeps decides what its nightmares are made of.",
  "campaigns.depth.light.desc": "Shadow nightmares. Recommended for a first campaign.",
  "campaigns.depth.deep.desc": "Some nightmares are made of ink: more health, and they heal if you stop hitting them. Bosses too. For experienced groups.",
  "history.title": "Waves",
  "history.empty": "No waves yet. The first one comes with the first Tide.",
  "history.wave": "Tide {m} · wave {w}",
  "history.won": "We held",
  "history.lost": "The keep fell",
  "history.sector": "Sector",
  "history.defenders": "Who defended",
  "history.kills": "Slain",
  "history.leaks": "To the keep",
  "history.gate": "Gate",
  "history.gateHeld": "Standing",
  "history.gateFell": "Fell",
  "history.live": "live",
  "history.ghost": "ghost",
  "history.skipped": "Not fought: the keep had already fallen this Tide.",
  "history.gatesHeld": "Gates standing",
  "history.gateFellOne": "A gate fell",
  "history.gatesFell": "{n} gates fell",
  "history.killsLbl": "slain",
  "history.xp": "+{n} experience",
  "history.xpGhost": "+{n} experience (your ghost)",
  "history.grove": "Grove: +{n} wood",
  "history.sanctum": "Sanctum: +{n} health to the buildings",
  "history.quarry": "Quarries: +{wood} wood, +{stone} stone",
  "history.leaksLbl": "reached the keep",
  "history.asGhosts": "as ghosts",
  "hud.leftOne": "nightmare left",
  "hud.leftMany": "nightmares left",
  "hud.onField": "{n} on the field",
  "hud.incoming": "{n} still coming",
  "hud.waveBrings": "nightmares in this wave",
  "hud.cleared": "Wave cleared",
  "hud.downTitle": "Your hero fell",
  "hud.downIn": "back in {n} s",
  "hud.downSub": "Respawns at the keep. Meanwhile, the towers keep defending.",
  "hud.downShort": "Down",
  "update.updating": "A new version is out: reloading to stay in the fight…",
  "update.available": "A new version of the game is out.",
  "update.reload": "Reload",
  "update.later": "Later",
  "bastion.tagWaiting": "Waiting",
  "clock.calm": "Tide {n} arrives in",
  "clock.omen": "Omen · Tide {n} arrives in",
  "clock.marea": "Tide {n} · wave {w} of 6 in",
  "clock.omenHost": "Omen · Tide {n} ({host}) arrives in",
  "clock.mareaHost": "Tide {n} · wave {w} of 6 · {host} in",
  "clock.hostType": "{host}, mostly {type}",
  "plan.move.assault": "A horn sounds: the enemy bulk charges the wall.",
  "plan.move.wings": "The flyers that were waiting swoop on the bastion.",
  "plan.move.shift": "A distant horn: the enemy bulk circles the bastion towards another gate.",
  "plan.feint.strike": "It was a feint: the bulk charges elsewhere.",
  "plan.rush.strike": "A horn sounds: everything waiting outside charges at once.",
  "plan.pincer.strike": "A horn sounds: the bulk storms both sides of the gate.",
  "plan.escortedSiege.strike": "A horn sounds: the bulk charges the wall.",
  "clock.due": "Tide {n} · wave {w} is arriving!",
  "clock.rebuild": "The fallen keep is rebuilt in",
  "hero.xpLeft": "{n} experience to level {l}",
  "hero.stat.hp": "Health",
  "hero.stat.attack": "Attack",
  "hero.stat.damage": "Damage",
  "hero.stat.armor": "Armor",
  "hero.stat.speed": "Hits per second",
  "hero.pointsHint": "Each skill has two variants: tap \"+\" to learn one (1 point). Then pick which to carry in \"What to carry\", below. Ranks come with the level.",
  "hero.empty.weapon": "No weapon.",
  "hero.empty.armor": "No armor.",
  "hero.empty.amulet": "No amulet.",
  "inc.aloneSub": "The whole reward is yours",
  "inc.ghostOf": "Ghost · {cls} · level {n}",
  "inc.companionHint": "The ghost fights beside you the way its owner plays and takes 10 % of the reward.",
  "hero.point": "{n} point",
  "inc.extracting": "of {n} · {res}",
  "inc.extractedAll": "Extraction complete!",
  "inc.done": "Back to the bastion with the haul",
  "inc.quiet": "Field clear: the golems work ×{n} and the next wave comes sooner",
  "inc.waveOf": "Wave {w} of {n}",
  "inc.turretDesc": "{n} left. Tap the button (or R), then the spot, or drag the button onto the spot: it shoots nearby nightmares by itself for {s} s, and they can break it. Save it for when they press in.",
  "inc.turretHint": "You have {n} field turrets of {s} s each: drop them when a big pack closes in, near the golems.",
  "bastion.helpFast": "Your hero is helping: ×{n} while you stay here",
  "bastion.previewDone": "You already fought this wave: it counts when it resolves.",
  "due.title": "Wave {w} of Tide {n} is here!",
  "due.sub": "The nightmares are already marching on the bastion.",
  "due.hintLocal": "Fight it in person with your hero, or let the ghosts defend the whole bastion with what has been built.",
  "due.hintServer": "Join the live fight with whoever is here. Otherwise your ghost defends for you.",
  "due.ghosts": "Let the ghosts defend",
  "due.later": "Not now",
  "incEnd.won": "Extraction complete!",
  "incEnd.lost": "The extraction fell",
  "incEnd.wonSub": "The golems come back with the haul.",
  "incEnd.lostSub": "The nightmares broke the node, but the golems saved part of it.",
  "incEnd.nothing": "Nothing was extracted this time.",
  "incEnd.toStore": "It is already in the shared store, for the whole group.",
  "incEnd.xp": "+{n} experience",
  "incEnd.level": "You reached level {n}!",
  "incEnd.item": "You found gear: it is in your bag.",
  "incEnd.relic": "You found a relic: {name}",
  "incEnd.back": "Back to the bastion",
  "inc.turretsOut": "None left",
  "inc.turretsNone": "You already placed your {n} turrets",
  "inc.turretAim": "Tap or drag to the spot, inside the circle",
  "inc.turretFar": "Too far: the turret goes near your hero, inside the circle",
  "inc.turretBlocked": "Not there: pick open ground",
  "bastion.keepFallen": "The keep fell this Tide: the remaining waves are not fought. It is rebuilt whole for Tide {n}; use the time to build.",
  "hero.relicFree": "Free slot",
  "hero.relicsFrom": "There are {n} relics; each hero carries two, and ones won with both slots full wait in reserve to swap in. Where they come from: the Ash Witch (Tide 3) and the Hollow Shell (Tide 6) give every defender one for sure; beating the crypt's Warden gives each hero 15 % (25 % in embers) and its daily chest 40 % (60 % in embers); a den's warlord, 30 %; the Magma Lord, 20 %; a won altar, the Grimoire (15 %, 30 % far out); a rescued golem, the Horn (same); an ink warlord in a wave, the Ring (15 %). Besides, each of the Unsleeping who falls for good leaves a relic, only once, to whoever fought him and has the fewest of those relics (in a tie, the one who struck the last blow).",
  "hero.gearFrom": "Pieces come from warlords and bosses, incursions, crypts, cellars and the Furrows. The deeper the place, the more power the piece brings; what your class can't use may suit someone else in the group.",
  "end.wonTitle": "Campaign won!",
  "end.lostTitle": "Campaign over",
  "end.wonHint": "The group held the bastion to the end. You can go over every wave in the history.",
  "end.lostHint": "{n} Tides were lost in a row and the titan woke. You can go over every wave in the history and start a new campaign from the menu.",
  "end.history": "See the waves",
  "hero.over": "The campaign is over: points and gear can no longer change.",
  "reason.campaignOver": "The campaign is over.",
  "reason.notAPlayer": "You are not part of this campaign.",
  "reason.badAmount": "Invalid amount.",
  "reason.badClass": "That class does not exist.",
  "reason.badElement": "That element doesn't work here.",
  "reason.badNode": "That skill is not from your class.",
  "reason.badSector": "That path does not exist.",
  "reason.badStructure": "That cannot be built.",
  "reason.cannotDemolishGate": "The gate cannot be demolished.",
  "reason.maxLevel": "Already at the top level.",
  "reason.maxMaterial": "Already the best material.",
  "reason.needsMage": "It needs a mage.",
  "reason.needsWarrior": "It needs a warrior.",
  "reason.noItem": "That item is gone.",
  "reason.bound": "It's a unique piece: bound to your hero.",
  "reason.staleAct": "Someone in the group already moved the story on.",
  "reason.sagaClosed": "This chapter can't be played right now.",
  "reason.notAScene": "It's time to fight, not to choose.",
  "reason.noChoice": "That choice is gone.",
  "reason.noLevels": "This has no levels.",
  "reason.noMaterial": "This cannot be remade in another material.",
  "reason.noNote": "Nothing to undo.",
  "reason.notAGateway": "The gate goes at the mouth of the path.",
  "reason.notATower": "That is not a tower.",
  "reason.notAWall": "That is not a wall.",
  "reason.notBuilding": "That site is no longer under construction.",
  "reason.nothingThere": "There is nothing there.",
  "reason.ruined": "It is in ruins: repair it first.",
  "reason.unsupported": "That can't be done yet.",
  "menu.tag.lost": "Lost",
  "menu.tag.won": "Won",
  "menu.ended.lost": "The titan woke",
  "menu.ended.won": "The titan sleeps in peace",
  "num.decimal": ".",
  "inc.howPlays": "How it plays here",
  "inc.twist.quarry": "Plain assault: they come down all three paths.",
  "inc.twist.forest": "Ambush: part of every wave comes out of the woods at the edge of the clearing, not down the paths.",
  "inc.twist.crystal": "The crystals call: nightmares run straight for the node and can't be held back. Kill them before they get there, or taunt them.",
  "inc.twist.altar": "Corrupted altar: an elite rises at the end of the last wave.",
  "inc.twist.rescue": "The caged golem's cries: each wave comes in three tight packs, with a breather between them.",
  "inc.titleDanger": "{place} · dangerous",
  "omen.title": "Today's omen",
  "omen.line": "Omen: {omen}.",
  "omen.fog": "Fog",
  "omen.fog.desc": "Poor sight: bows and spells reach 20 % less. Applies to every incursion today, and to the crypt.",
  "omen.fog.bastion": "In the bastion: towers reach 20 % less, except those with a vigil beacon nearby.",
  "omen.frenzy": "Frenzy",
  "omen.frenzy.desc": "Nightmares run 25 % faster. Applies to every incursion today, and to the crypt.",
  "omen.ink": "Ink",
  "omen.ink.desc": "One in three nightmares comes inked: tougher, and it heals. Applies to every incursion today, and to the crypt.",
  "omen.swarm": "Swarm",
  "omen.swarm.desc": "Half again as many nightmares, but frailer. Applies to every incursion today, and to the crypt.",
  "omen.storm": "Storm",
  "omen.storm.desc": "Lightning falls on the field. Each bolt is marked on the ground a moment before and strikes everything under it, heroes and nightmares alike: step out in time, or lead them in. Applies to every incursion today, and to the crypt.",
  "omen.storm.bastion": "In the bastion: lightning falls on the towers, marked a moment before, and each bolt takes a little of their health. A lightning rod near a tower draws it away.",
  "omen.storm.bastionLater": "In the bastion, the storm falls on the towers only where a lightning rod can be raised: in «From scratch» campaigns, from era IV.",
  "omen.bastionNone": "It doesn't change the bastion's waves.",
  "omen.frost": "Hard frost",
  "omen.frost.desc": "The cold numbs the nightmares: they walk 20 % slower, but last 15 % longer. Applies to every incursion today, and to the crypt.",
  "omen.frost.bastion": "In the bastion: towers reload 25 % slower, except those with a charged burning-oil trap two cells away or closer. As the wave starts that oil lights, burns one charge and keeps them warm all wave long; a fire-enchanted tower doesn't freeze either. The blessed oil offered at the keep doesn't warm them.",
  "omen.bloodMoon": "Blood moon",
  "omen.bloodMoon.desc": "Nightmares hit 30 % harder, but every hero's blow gives some life back. Applies to every incursion today, and to the crypt.",
  "omen.starfall": "Starfall",
  "omen.starfall.desc": "Now and then a star falls near the heroes. The first to reach it is healed and hits 40 % harder for 8 s. A few more nightmares come. Applies to every incursion today, and to the crypt.",
  "omen.starPick": "{who} took up the star: +40 % damage",
  "omen.starPickMe": "You took up the star: +40 % damage for 8 s",
  "omen.boltHint": "Lightning! Step out of the circle, or lead the nightmares in.",
  "omen.starHint": "A star fell: go and get it.",
  "log.in": "on the {s}",
  "log.goThere": "See",
  "log.incursionWon": "{who} came back from the {place} with {what}",
  "log.incursionLost": "{who} pulled out of the {place} with {what}",
  "log.incursionWon.you": "You came back from the {place} with {what}",
  "log.incursionLost.you": "You pulled out of the {place} with {what}",
  "log.lootRelic": "{who} found a relic: {relic}",
  "log.lootRelic.you": "You found a relic: {relic}",
  "log.lootItem": "{who} found {rarity} gear: {slot}",
  "log.lootItem.you": "You found {rarity} gear: {slot}",
  "hero.allies": "Your allies",
  "hero.allyNow": "playing now",
  "hero.allySeen": "{t} ago",
  "site.0": "Shell Crest",
  "site.1": "Eastern Scute",
  "site.2": "Moss Hollow",
  "site.3": "Southern Rift",
  "site.4": "Western Scute",
  "site.5": "Neck Base",
  "site.6": "Right Shoulder",
  "site.7": "Right Flank",
  "site.8": "Right Haunch",
  "site.9": "Left Haunch",
  "site.10": "Left Flank",
  "site.11": "Left Shoulder",
  "site.12": "The Sleeping Head",
  "site.13": "Right Forefoot",
  "site.14": "Right Hindfoot",
  "site.15": "The Tail's Tip",
  "site.16": "Left Hindfoot",
  "site.17": "Left Forefoot",
  "inc.lair": "Warlord's Den",
  "inc.lair.desc": "Dream dust, and always a rare piece of gear.",
  "inc.twist.lair": "Warlord's den: two more elites come out at the end of the last wave.",
  "inc.lairLoot": "And if you win: a sure rare piece of gear.",
  "inc.ring.1": "Near · the shell",
  "inc.ring.1.desc": "The usual: normal waves.",
  "inc.ring.2": "Middle · flanks and legs",
  "inc.ring.2.desc": "More nightmares, some ink and an elite at the end. Loot ×{mult} and {item} % item chance.",
  "inc.ring.3": "Far · head, feet and tail",
  "inc.ring.3.desc": "Many more nightmares, lots of ink and an elite every wave. Loot ×{mult}, a sure item and better relic odds.",
  "inc.lockedRing": "Out of reach for now: the titan's extremities open when the group reaches level {n}.",
  "inc.openedBy": "Path opened by {name}",
  "inc.unknown": "Unexplored: win an incursion next to it to open the way",
  "inc.how3map": "Every win opens the neighboring places for the whole group. Farther out is harder, with better loot.",
  "inc.explored": "{n} of {total} places of the titan explored",
  "log.explore": "{who} opened the way to {places}",
  "log.explore.you": "You opened the way to {places}",
  "inc.openedByYou": "You opened this way",
  "dungeon.title": "The Crypt under the Shell",
  "dungeon.sub": "Three halls that lock behind you, and the Marrow Warden at the end.",
  "dungeon.elite": "Elite incursion",
  "dungeon.pitch": "Under the shell lies a crypt. Each hall stays locked until no nightmare is left standing, and the Marrow Warden waits at the bottom. It is very hard: dodge, look after each other and pick up the fallen.",
  "dungeon.locked": "Opens once the group reaches a warlord's den: the titan's head or the tip of its tail.",
  "dungeon.factParty": "{min} to {max} heroes connected at once. If someone drops, their hero stands still: nobody plays it.",
  "dungeon.factSolo": "In a local campaign you go down alone. Online it is for {min} to {max} connected heroes.",
  "dungeon.factRevive": "The fallen don't get up on their own: an ally has to stand by them.",
  "dungeon.factReward": "If you win: a rare piece of gear each, dream dust, lots of XP and a shot at a relic. Once a day per hero: if you already took it, you only earn XP.",
  "dungeon.factOmen": "Today's omen: {omen}. It holds down here too.",
  "dungeon.factClaimed": "You already took today's crypt chest: going down again gives XP only.",
  "dungeon.gather": "Gather the party",
  "dungeon.goSolo": "Go down into the crypt",
  "dungeon.busy": "The crypt is already under way: wait until they finish.",
  "dungeon.lobby": "The crypt's entrance",
  "dungeon.need": "{n} more needed to go down. Tell them: Incursions → The Crypt under the Shell.",
  "crypt.spectres.title": "Spectres coming down",
  "crypt.spectres.count": "{n} of {of}",
  "crypt.spectres.hint": "Friends who aren’t here come down with you as spectres: they fight, raise the fallen and follow you. The crypt fills as if they were live. The chest is only for who plays; each owner gets {n} % of the XP.",
  "dungeon.ready": "{n} of {max}. Go down when you're ready.",
  "dungeon.enter": "Go down",
  "dungeon.lobbyHint": "Inside, a dropped player's hero stands still. The fallen get up when an ally stands beside them.",
  "dungeon.descend": "Going down: {names}",
  "dungeon.warden": "The Marrow Warden",
  "dungeon.phase1": "",
  "dungeon.phase2": "· enraged",
  "dungeon.phase3": "· last fury",
  "dungeon.exit": "The way out",
  "dungeon.toExit": "On to the way out",
  "dungeon.wayExit": "To the way out",
  "dungeon.hall": "The Warden's hall",
  "dungeon.bones": "{n} more nightmares",
  "dungeon.room": "Hall {n} of {total}",
  "dungeon.nextWave": "Breathe: another wave is coming",
  "dungeon.left": "{n} left · wave {w} of {waves}",
  "dungeon.gathering": "The entrance",
  "dungeon.gatherSub": "Waiting for the party",
  "dungeon.toHall": "On to the Warden's hall",
  "dungeon.toRoom": "On to hall {n} of {total}",
  "dungeon.walkOn": "Heal up before the door: it locks behind you",
  "dungeon.wayNext": "Next room",
  "dungeon.wayHall": "To the guardian",
  "dungeon.dodgeSlam": "Get out of the red circle!",
  "dungeon.dodgeNova": "Out of the red: get away from the Warden!",
  "dungeon.dodgeRing": "Into the blue: get close to the Warden!",
  "dungeon.fallen": "{name} is down: stand beside them to pick them up",
  "dungeon.down": "Down",
  "dungeon.reviving": "Getting up…",
  "dungeon.waitHelp": "You're down: wait for an ally to pick you up. Drag to look around.",
  "dungeon.reviveHint": "Stand here to pick up {name}",
  "log.dungeonWon": "The party beat the Marrow Warden ({names})",
  "log.dungeonLost": "The crypt threw the party out in hall {n} ({names})",
  "cryptEnd.won": "The Warden has fallen!",
  "cryptEnd.wonSub": "The crypt is the party's for today.",
  "cryptEnd.lost": "The crypt threw you out",
  "cryptEnd.lostSub": "Nobody was left standing. What you learned counts for the next time.",
  "dungeon.bone": "1 more nightmare",
  "hud.cooldown": "Cooldown: {n} s.",
  "hud.holdSkill": "Hold a power to see what it does.",
  "campaigns.player": "1 warden",
  "menu.online": "online",
  "menu.localShort": "Test run, in this browser",
  "menu.noCampaigns": "No campaigns yet. Found one and invite your friends, or try a test run on your own.",
  "menu.endedList": "Finished ({n})",
  "menu.found": "Found a campaign with friends",
  "menu.signInWhy": "With your email you can found campaigns and invite friends. No password needed.",
  "menu.solo": "Try it alone",
  "menu.localShortHint": "A bastion with two ghosts, on a fast clock.",
  "menu.practiceShort": "A single wave, no campaign.",
  "menu.manage": "Options for “{name}”",
  "rename.label": "Campaign name",
  "rename.save": "Save",
  "rename.done": "The campaign is now called “{name}”.",
  "leave.title.local": "Delete “{name}”",
  "leave.body.local": "A test campaign stored in this browser. It is deleted for good.",
  "leave.go.local": "Delete",
  "leave.done.local": "“{name}” was deleted.",
  "leave.title.alone": "Delete “{name}”",
  "leave.body.alone": "You are the last warden left. If you leave, the campaign is deleted for good, with its bastion and history, and its invites stop working.",
  "leave.go.alone": "Delete the campaign",
  "leave.done.alone": "“{name}” was deleted.",
  "leave.title.others": "Leave “{name}”",
  "leave.body.others": "The others keep playing. Your hero stays on the wall as a ghost at 40 %, so the group isn't left with a hole in the defence. If you ever want to come back, ask for an invite and you get your hero back as it was.",
  "leave.go.others": "Leave the campaign",
  "leave.done.others": "You left “{name}”. Your hero stays on guard.",
  "leave.title.ended": "Remove “{name}” from your list",
  "leave.body.ended": "The campaign is over. It goes off your list; the others still see it.",
  "leave.go.ended": "Remove from my list",
  "leave.done.ended": "“{name}” is off your list.",
  "log.left": "{who} left the campaign: their hero stays on guard",
  "log.left.you": "You left the campaign",
  "email.magic.title": "Your key to get in",
  "email.magic.preheader": "Your link to the bastion. It expires in 15 minutes.",
  "email.fallback": "Button not working? Paste this link into your browser:",
  "inc.companions": "Companions",
  "inc.companionCount": "{n} of {max}",
  "inc.companionsHint": "You take your friends' ghosts: they fight the way they play, at 70 %. Each one brings more nightmares and takes 10 % of the XP.",
  "inc.online": "Online now",
  "inc.together": "Go together, live",
  "inc.togetherHint": "Opens a room: friends who are online see it and join with their hero. Each one brings their whole share of what the place gives and spends one of their runs of the day: going together pays as much as going apart, with the same experience for everyone. If someone drops, their ghost carries on.",
  "party.incursionShare": "you bring your share and use one of your runs of the day",
  "party.incursion": "{name} is heading to {place} and wants company",
  "party.crypt": "Gathering at the crypt's entrance: {names}",
  "party.count": "{n} of {max} · live",
  "party.rejoin": "Your run is still under way: the group is waiting for you.",
  "party.rejoinBtn": "Go back",
  "party.join": "Join",
  "party.full": "They already set out, or the room is full.",
  "party.lobby": "Waiting for companions",
  "party.need": "At least {n} more friend needed. Friends who are online see a card in their bastion.",
  "party.lobbyHint": "Leaving before setting out takes you out of the room (if you opened it, it's called off for everyone). Once under way, a disconnected player's ghost keeps fighting. Loot goes to the common storage and everyone earns their own experience.",
  "party.go": "Set out together",
  "party.ghost": "ghost",
  "party.backIn": "back in {n} s",
  "log.carried": "{who} earned {n} XP: their ghost went along with {name}",
  "log.carried.you": "You earned {n} XP: your ghost went along with {name}",
  "log.withFriends": "(together with {names}, live)",
  "log.carriedMe": "earned {n} XP: their ghost went along with you",
  "incEnd.newItem": "New gear, {r}!",
  "incEnd.newRelic": "A relic!",
  "incEnd.worn": "Already worn: it filled an empty slot.",
  "incEnd.inBag": "It's in your bag: equip it from Your hero.",
  "inc.ambushNow": "Ambush! They come out of the woods, not just down the paths. Watch the red circles.",
  "inc.finishThem": "The golems are loaded: finish off the rest ({n})",
  "inc.wayFoe": "One left",
  "inc.wayFoes": "{n} left",
  "bastion.forecast": "With the golems as they are, it would take {t}: done by {at}.",
  "bastion.forecastLate": "It would take {t} and the next wave comes in {w}: it would still be a building site in the fight.",
  "hero.salvage": "Melt",
  "hero.salvageHint": "It melts in the forge and the dust goes to the common storage.",
  "hero.giftTo": "Give to:",
  "gift.toast": "{who} sent you",
  "gift.toastMany": "{who} sent you {n} pieces",
  "gift.best": "The best: {what}",
  "gift.see": "See in your bag",
  "gift.more": "and {n} more from others",
  "gift.from": "Sent by {who}",
  "gift.sent": "You sent {what} to {who}",
  "bag.fresh": "New",
  "bag.freshN": "{n} new pieces in your bag",
  "bag.seenAll": "Mark as seen ({n})",
  "hero.bagHint": "What you don't use: melt it into dust for the whole group, or give it to a friend (it reaches them even offline).",
  "hero.bagHintNoForge": "Give what you don't use to a friend. With a forge built, you can also melt it into dust for the group.",
  "hero.bagHintForgeRuined": "Give what you don't use to a friend. The forge lies in ruins: once it is repaired, you can also melt it into dust for the group.",
  "forge.ruined": "The forge lies in ruins: until it is repaired, nothing can be melted, forged, cut or awakened.",
  "log.salvage": "{who} melted {rarity} {what}: +{n} dust for the storage",
  "log.salvage.you": "You melted {rarity} {what}: +{n} dust for the storage",
  "log.forged": "{who} forged +{n} into their {what} ({a}): −{d} common dust",
  "log.forged.you": "You forged +{n} into your {what} ({a}): −{d} common dust",
  "log.reforge": "{who} reforged their {what}: {from} → {to}, −{d} common dust",
  "log.reforge.you": "You reforged your {what}: {from} → {to}, −{d} common dust",
  "log.carve": "{who} carved their {what}: {from} → {to}, −{d} common dust",
  "log.attune": "{who} carved the affinity of their {what}: {from} → {to}, −{d} common dust",
  "log.attune.you": "You carved the affinity of your {what}: {from} → {to}, −{d} common dust",
  "log.carve.you": "You carved your {what}: {from} → {to}, −{d} common dust",
  "log.temper": "{who} tempered their {what} to {rarity}: −{d} common dust",
  "log.temper.you": "You tempered your {what} to {rarity}: −{d} common dust",
  "log.socket": "{who} opened a setting in their {what}: −{d} common dust",
  "log.socket.you": "You opened a setting in your {what}: −{d} common dust",
  "log.gem": "{who} set {gem} in their {what}: −{c} crystal and −{d} common dust",
  "log.gem.you": "You set {gem} in your {what}: −{c} crystal and −{d} common dust",
  "log.reforgeNext": " (next one, {next})",
  "log.piece": "piece",
  "attrName.damage": "damage",
  "attrName.hp": "health",
  "attrName.attackSpeed": "attack speed",
  "attrName.cooldown": "cooldown",
  "attrName.armor": "armor",
  "attrName.crit": "certainty",
  "attrName.resFire": "affinity: fire",
  "attrName.resFrost": "affinity: frost",
  "attrName.resLightning": "affinity: lightning",
  "attrName.resAcid": "affinity: acid",
  "attrName.resPoison": "affinity: poison",
  "attrName.resShadow": "affinity: shadow",
  "log.gift": "{who} gave {name} {rarity} {what}",
  "log.gift.you": "You gave {name} {rarity} {what}",
  "log.giftYou": "you",
  "reason.noPlayer": "That player is no longer in the campaign.",
  "reason.bagFull": "Their bag is full (12).",
  "bastion.finishing": "Finishing…",
  "hero.forged": "(+{v} forge)",
  "hero.forgeCap": "To forge +{n}, raise the forge to level {l}.",
  "reason.forgeLevel": "Your forge can't go further: raise its level.",
  "reason.stoneLocked": "To rebuild in stone, your hero needs level {n}.",
  "bastion.stoneLocked": "Your hero needs level {n} to rebuild in stone (now level {m}).",
  "hero.bagAll": "All",
  "slot.weapons": "Weapons",
  "slot.armors": "Armor",
  "slot.amulets": "Amulets",
  "compare.vs": "Against what you wear: {what}",
  "compare.better": "Better",
  "compare.worse": "Worse",
  "compare.mixed": "Mixed",
  "compare.same": "Same",
  "compare.empty": "Free",
  "compare.betterHint": "Improves on everything you wear in that slot.",
  "compare.worseHint": "Improves on nothing you wear in that slot.",
  "compare.mixedHint": "Gains in one thing and loses in another: check the details.",
  "compare.sameHint": "Gives the same as what you wear.",
  "compare.emptyHint": "Nothing in that slot: any piece adds.",
  "compare.gain": "Adds {what}",
  "compare.lose": "You lose {what}",
  "party.leave": "Leave",
  "party.cancelled": "The run was called off",
  "party.cancelledSub": "Whoever opened the room left before setting out. You can open another one from the incursions panel.",
  "party.back": "Back to the bastion",
  "party.more": "and {n} more",
  "party.decline": "Not now",
  "party.joining": "Joining…",
  "party.wave": "Gathering to hold the wave live",
  "party.waveOn": "Fighting the wave live",
  "live.lobbyTitle": "Waiting for the wave",
  "live.lobbyHint": "The fight starts on its own on the hour for everyone here. If you leave, your ghost defends as usual.",
  "structure.rampart": "Bastion wall",
  "structure.rampart.desc": "The stone ring around the bastion. Nightmares can break it to get in wherever they like; repair it before the next wave.",
  "bastion.lobbyHint": "At the wave's hour, whoever is in the room fights live; everyone else as a ghost.",
  "advice.damage": "The last wave left {n} structures damaged. Tap one and order the repair: the golems do it (start with {s}).",
  "advice.cure": "{who} carries {a}. Today's cure is ready: cure them from your hero sheet, even if they're away.",
  "advice.damageDown": "The last wave left {n} structures damaged and {d} destroyed. Order the repairs before the next one: the golems do them (start with {s}).",
  "bastion.repairing": "Under repair: {s}",
  "bastion.golemRepairing": "A golem is repairing it",
  "bastion.repairHint": "Already paid for. A golem repairs it on its own; help with your hero and it goes faster.",
  "inc.rule.forest": "Ambush: part of each wave comes out of the woods, not down the paths.",
  "inc.rule.crystal": "The crystals call them: they run for the node and nobody holds them. Kill them on the way or use Challenge.",
  "inc.rule.altar": "Corrupted altar: an elite rises at the end.",
  "inc.rule.rescue": "The golem cries: each wave comes in three tight packs.",
  "inc.rule.lair": "Den: two more elites come out at the end.",
  "party.merc": "Mercenary",
  "party.title": "Party ({n})",
  "bastion.helpStopped": "You stopped helping: you walked away from the site.",
  "reason.noAttr": "That item doesn't have that attribute.",
  "hero.forgeNext": "Forge +{n}: what goes up?",
  "bastion.planTitle": "Plan: {s}",
  "bastion.planHint": "This is how it would sit. Tap another free cell to try a different spot, or lay it here.",
  "bastion.planHintRange": "The circle is how far it reaches. Tap another free cell to try a different spot, or lay it here.",
  "bastion.planHere": "Lay the plan here",
  "bastion.planCancel": "Pick another",
  "golems.title": "Golems",
  "golems.short": "Golems",
  "golems.count": "{busy} of {total} golems at work.",
  "golems.where": "You have {base}: 3 plus 1 for every 2 players. Rescuing the lost golem in an incursion adds one more for this Tide (now: {extra}). Each golem works one site at a time; extra sites wait in line. Your hero can help on any of them.",
  "golems.working": "At work",
  "golems.queue": "Waiting for a golem",
  "golems.plans": "Plans waiting for materials",
  "golems.building": "Building: {s}",
  "golems.repairing": "Repairing: {s}",
  "golems.left": "{t} left",
  "golems.waits": "in line",
  "golems.needs": "needs materials",
  "golems.idle": "No work now: the golems rest.",
  "golems.plan": "Plan: {s}",
  "live.outside": "Not in the room",
  "live.startsIn": "The wave starts in",
  "fork.bashCharge": "Charge",
  "fork.bashCharge.desc": "The bash reaches from afar: the warrior leaps to the target and strikes it.",
  "fork.bashCleave": "Cleave",
  "fork.bashCleave.desc": "The blow carries on: it also hits and stuns the 2 nightmares nearest the target (60 % damage).",
  "fork.ironWall": "Iron wall",
  "fork.ironWall.desc": "While the challenge lasts, the warrior takes 35 % less damage.",
  "fork.warCry": "War cry",
  "fork.warCry.desc": "Challenged nightmares come on slowly: 40 % slower while it lasts.",
  "fork.sharedOath": "Shared oath",
  "fork.sharedOath.desc": "Allies nearby are untouchable too, for half the time.",
  "fork.secondWind": "Second wind",
  "fork.secondWind.desc": "Swearing the oath heals the warrior for 35 % of its life.",
  "fork.frostTurret": "Frost turret",
  "fork.frostTurret.desc": "Turret bullets freeze: they slow what they hit. An overload freezes too.",
  "fork.fireTurret": "Fire turret",
  "fork.fireTurret.desc": "Turret bullets set things on fire: what they hit keeps burning. An overload leaves the ground burning.",
  "fork.meteor": "Meteor",
  "fork.meteor.desc": "A huge fireball: more damage and area, but it takes longer to come back.",
  "fork.embers": "Embers",
  "fork.embers.desc": "Where it lands the ground burns for 3 seconds, scorching whatever steps on it.",
  "fork.longWall": "Ice rampart",
  "fork.longWall.desc": "The frost wall is 3 hexes longer: it cuts a whole path.",
  "fork.bitingFrost": "Biting frost",
  "fork.bitingFrost.desc": "The wall also hurts whatever crosses it, armor or not.",
  "fork.stillStorm": "Heavy storm",
  "fork.stillStorm.desc": "Under the storm, nightmares move 40 % slower.",
  "fork.thunderclap": "Thunderclap",
  "fork.thunderclap.desc": "The whole storm strikes at once, and harder.",
  "fork.volley": "Volley",
  "fork.volley.desc": "Three more arrows, each a little weaker.",
  "fork.frostArrows": "Frost arrows",
  "fork.frostArrows.desc": "Multishot arrows freeze: whatever they hit slows down.",
  "fork.wideNet": "Wide net",
  "fork.wideNet.desc": "The net catches every nightmare around the target (up to 6).",
  "fork.steelNet": "Steel net",
  "fork.steelNet.desc": "The net lasts longer and holds warlords too, for half the time.",
  "fork.pinningRain": "Pinning rain",
  "fork.pinningRain.desc": "Under the rain, nightmares move 40 % slower.",
  "fork.wideRain": "Deluge",
  "fork.wideRain.desc": "The rain covers an area 50 % wider.",
  "tree.f.attacks": "Attacks per second",
  "tree.f.range": "Range",
  "tree.f.damage": "Damage",
  "tree.f.duration": "Duration",
  "tree.f.stun": "Stun",
  "tree.f.radius": "Area",
  "tree.f.reach": "Reach",
  "tree.f.cooldown": "Cooldown",
  "tree.amount.shieldBash": "Amount",
  "tree.amount.challenge": "Amount",
  "tree.amount.oath": "Amount",
  "tree.amount.turret": "Turrets at once",
  "tree.amount.fireball": "Amount",
  "tree.amount.frostWall": "Hexes",
  "tree.amount.storm": "Amount",
  "tree.amount.multishot": "Arrows",
  "tree.amount.net": "Amount",
  "tree.amount.arrowRain": "Amount",
  "unit.sec": "{n} s",
  "unit.hexes": "{n} hexes",
  "perk.repairDiscount.name": "Cheaper repairs",
  "perk.workBonus.name": "Extra work on sites",
  "perk.ghostPower.name": "Your ghost's strength",
  "perk.incursionLoot.name": "Incursion loot",
  "tree.perkNext": "At rank {n}: {what}",
  "tree.why.max": "Already maxed.",
  "tree.why.fork": "In this branch you chose “{other}”. To change it, start over.",
  "tree.why.locked": "First: “{prev}”.",
  "tree.why.noPoints": "No points left: level up for more.",
  "tree.kind.fork": "Choice: taking one closes the other",
  "tree.kind.rank": "Skill upgrade",
  "tree.rank": "Rank {n} of {m}",
  "tree.rankDesc": "The skill ranks up: 30 % stronger.",
  "tree.now": "Now",
  "tree.then": "After",
  "tree.without": "Without it",
  "tree.with": "With it",
  "tree.learn": "Learn (1 point)",
  "tree.respec": "Start over",
  "tree.free": "free",
  "tree.respecAsk": "The whole tree is cleared and you get your {n} points back.",
  "tree.respecYes": "Yes, start over",
  "reason.forkTaken": "You already chose the other path in that branch.",
  "reason.nothingSpent": "There are no points to give back.",
  "tree.respecNo": "No, keep it",
  "tree.kind.skill": "Skill · rank {n}",
  "tree.withFork": "With “{f}”:",
  "tree.seeSkill": "See what the skill does",
  "tree.amount.mend": "Heals",
  "tree.amount.sanctuary": "Heals per pulse",
  "tree.amount.dawn": "Heals (of life)",
  "skill.aimAlly": "Tap who to heal (or the button again: the most hurt)",
  "skill.allyWait": "Mend is back in {n} s",
  "skill.allyDown": "They're down: Dawn raises them.",
  "class.cleric": "Cleric",
  "class.cleric.desc": "Healing light: mends one, hallows the ground and raises the fallen.",
  "skill.mend": "Mend",
  "skill.mend.desc": "Heals a hero at once and inspires them: for a few seconds they attack faster, hurt or not. Touch their name in the party or their miniature; without a choice it goes to the most hurt (you count too).",
  "skill.sanctuary": "Sanctuary",
  "skill.sanctuary.desc": "Hallows the ground for 6 s: every second it heals the heroes standing on it.",
  "skill.dawn": "Dawn",
  "skill.dawn.desc": "The sun rises around you: the fallen get up, everyone is healed and untouchable for a moment.",
  "fork.mendChain": "Chain mend",
  "fork.mendChain.desc": "The light jumps from the healed hero to the 2 most hurt nearby (55 % of the heal).",
  "fork.mendWard": "Aegis",
  "fork.mendWard.desc": "The healed hero is warded for 4 s: takes 35 % less damage.",
  "fork.consecrate": "Hallowed ground",
  "fork.consecrate.desc": "The sanctuary also burns nightmares that step on it, armor or not.",
  "fork.bulwark": "Bulwark",
  "fork.bulwark.desc": "Heroes standing on the sanctuary take 30 % less damage.",
  "fork.dawnRebirth": "Rebirth",
  "fork.dawnRebirth.desc": "The fallen come back at full life, and everyone stays untouchable twice as long.",
  "fork.dawnSmite": "Judgement",
  "fork.dawnSmite.desc": "The sun also strikes every nightmare around with lances of light.",
  "class.barbarian": "Barbarian",
  "class.barbarian.desc": "Goes out after them: a whirling cut, a leap that stuns and a frenzy nothing stops. Fury: the more hurt, the harder it hits and the more life it drinks from its blows. Its help on a building site counts double.",
  "class.paladin": "Paladin",
  "class.paladin.desc": "Steel and oath: smites the corrupt, shields an ally or a building and hallows the ground. Carries an aura of its choice (devotion, retribution or life) that helps the allies nearby. Standing by the keep, it guards it.",
  "class.druid": "Druid",
  "class.druid.desc": "The forest awakes: roots that hold and bring flyers down, the bear form and the Bloom, which slowly heals the whole party. Root: standing still, it heals.",
  "skill.whirl": "Whirling cut",
  "skill.whirl.desc": "A cut at everything around you.",
  "skill.leap": "Leap",
  "skill.leap.desc": "You leap to a far point and land striking and stunning around. To reach the ones shooting from behind.",
  "skill.frenzy": "Frenzy",
  "skill.frenzy.desc": "8 s unstoppable: you attack 40 % faster, run faster and get 40 % of the damage you deal back as life. You can still fall.",
  "skill.smite": "Smite",
  "skill.smite.desc": "A hammer of light falls from the sky on one nightmare, far off too. Twice as hard on elites, warlords, bosses, the inked and the undead; it takes one grade of ink.",
  "skill.aegis": "Aegis",
  "skill.aegis.desc": "A shield that soaks damage for 6 s, on an ally or on a building (on the keep, for half). Tap who or what to guard.",
  "skill.hallow": "Hallow",
  "skill.hallow.desc": "Holy ground for 6 s: nightmares on it hit 40 % softer, the ink burns and the heroes on it heal every second.",
  "skill.entangle": "Entangle",
  "skill.entangle.desc": "Roots over an area: nightmares are held for 2 s (they strike but can't move) and flyers come down while held.",
  "skill.bearForm": "Bear form",
  "skill.bearForm.desc": "5 s as a bear: more life and armor, and swipes that hit around. No other skills while it lasts.",
  "skill.bloom": "Bloom",
  "skill.bloom.desc": "A forest grows around you for 8 s: every second, the heroes in it recover part of their life. It doesn't raise the fallen.",
  "fork.whirlwind": "Whirlwind",
  "fork.whirlwind.desc": "You keep spinning as you walk: 4 more cuts, at 60 %.",
  "fork.rend": "Rend",
  "fork.rend.desc": "Whoever it cuts keeps bleeding for 3 s.",
  "fork.quake": "Quake",
  "fork.quake.desc": "The landing covers 50 % more and slows whoever it doesn't stun.",
  "fork.doubleLeap": "Double leap",
  "fork.doubleLeap.desc": "After a leap you can leap again right away.",
  "fork.bloodlust": "Bloodlust",
  "fork.bloodlust.desc": "Each nightmare you kill in the frenzy draws it out 1 s (up to 6 s more).",
  "fork.warpath": "War cry",
  "fork.warpath.desc": "While the frenzy lasts, allies nearby also attack 20 % faster.",
  "fork.judgment": "Sentence",
  "fork.judgment.desc": "The smite leaps on to the 2 nearest corrupt or elite nightmares, at 60 %.",
  "fork.healingLight": "Healing light",
  "fork.healingLight.desc": "You and the allies nearby heal half the smite's damage.",
  "fork.reprisal": "Reprisal",
  "fork.reprisal.desc": "What the aegis soaks goes back as damage to whoever struck.",
  "fork.faithWall": "Wall of faith",
  "fork.faithWall.desc": "The aegis also covers, for half, the allies and buildings nearby.",
  "fork.holyGround": "Sacred field",
  "fork.holyGround.desc": "The hallowed ground covers 40 % more and lasts 9 s.",
  "fork.faithWeight": "Weight of faith",
  "fork.faithWeight.desc": "Nightmares on hallowed ground are 40 % slower.",
  "fork.strangle": "Strangle",
  "fork.strangle.desc": "The roots squeeze: three times the damage while they hold.",
  "fork.spores": "Spores",
  "fork.spores.desc": "When they let go, the roots burst into a cloud that slows 40 % for 3 s.",
  "fork.direBear": "Dire bear",
  "fork.direBear.desc": "A bigger bear that draws the nightmares nearby to it, like the Challenge.",
  "fork.wildHeart": "Wild heart",
  "fork.wildHeart.desc": "Each swipe heals you and the allies nearby.",
  "fork.deepGrove": "Deep grove",
  "fork.deepGrove.desc": "A wider forest that lasts half again as long.",
  "fork.briars": "Briars",
  "fork.briars.desc": "Nightmares in the forest are slowed and get hurt every second.",
  "tree.amount.whirl": "Amount",
  "tree.amount.leap": "Amount",
  "tree.amount.frenzy": "Amount",
  "tree.amount.smite": "Amount",
  "tree.amount.aegis": "Soaks",
  "tree.amount.hallow": "Amount",
  "tree.amount.entangle": "Amount",
  "tree.amount.bearForm": "Amount",
  "tree.amount.bloom": "Heals per second (of life)",
  "hero.lose.tree": "the skill tree",
  "hero.lose.item": "{n} item",
  "hero.lose.items": "{n} items",
  "hero.lose.relic": "{n} relic",
  "hero.lose.relics": "{n} relics",
  "log.classChanged": "{who} started over as a {cls}",
  "log.classChanged.you": "You started over as a {cls}",
  "roster.title": "Your heroes",
  "hero.nameLabel": "Hero's name",
  "hero.rename": "Name your hero",
  "hero.renameSave": "Save the name",
  "roster.playing": "In play",
  "roster.play": "Play this one",
  "roster.retire": "Retire",
  "roster.new": "New hero",
  "roster.newSub": "Starts at level 1",
  "roster.pick": "Pick the class",
  "roster.hint": "You can keep up to 3 heroes in this campaign. Only the one in play fights and earns experience; the others wait just as they are.",
  "roster.newHint": "Your {cls} waits with everything it has. The new one starts at level 1, with no gear.",
  "roster.newYes": "Start a {cls}",
  "roster.retireHint": "Retire your level {n} {cls}?",
  "roster.retireLose": "You lose {what}, and it can't be undone.",
  "roster.retireNothing": "It has nothing to lose yet.",
  "roster.retireYes": "Yes, retire it",
  "roster.lose.levels": "its {n} levels",
  "log.heroNew": "{who} started a new hero: a {cls}",
  "log.heroNew.you": "You started a new hero: a {cls}",
  "log.heroSwitched": "{who} now plays their level {n} {cls}",
  "log.heroSwitched.you": "You now play your level {n} {cls}",
  "log.heroRetired": "{who} retired their level {n} {cls}",
  "log.heroRetired.you": "You retired your level {n} {cls}",
  "reason.rosterFull": "You already have 3 heroes: retire one to start another.",
  "reason.noHero": "That hero is gone.",
  "reason.badName": "That name won't do.",
  "reason.heroFighting": "Finish the fight under way before changing heroes.",
  "settings.audio": "Sound and music",
  "settings.sfx": "Effects",
  "settings.volume": "volume",
  "merc.until": "They serve until the end of Tide {m}: {n} waves left.",
  "merc.until1": "They serve until the end of Tide {m}: 1 wave left.",
  "merc.slots": "Places: {n} of {max}",
  "merc.pick": "Pick who to hire:",
  "merc.full": "No free places until the Tide ends.",
  "merc.fullUp": "No free places. A level {n} barracks fits one more.",
  "merc.next": "With a level {n} barracks: {s} mercenaries at once, at {p} %.",
  "reason.noMercSlot": "No free places in the barracks.",
  "party.mercTag": "Hired {cls}",
  "skill.gearGrenade": "Gear grenade",
  "skill.gearGrenade.desc": "Sticks where it lands and drags the nightmares around it to the center, then bursts. Bosses and elites don't move.",
  "skill.automaton": "Automaton",
  "skill.automaton.desc": "Plants a battle automaton for {s} s: it draws nearby nightmares, sweeps them with blows and makes towers around it fire faster. It can be broken.",
  "skill.aimOverload": "Tap one of your turrets to overload it",
  "skill.aimGuard": "Tap who or what to guard: an ally, a building or the keep.",
  "fork.shrapnel": "Shrapnel",
  "fork.shrapnel.desc": "The grenade bursts harder (+50 %) and its shards slow what they hit.",
  "fork.magnet": "Magnet",
  "fork.magnet.desc": "The grenade reaches farther (+50 %) and drags for longer.",
  "fork.colossus": "Colossus",
  "fork.colossus.desc": "One huge automaton: twice the life, draws from farther away and hits harder. It holds a gate on its own.",
  "fork.swarm": "Swarm",
  "fork.swarm.desc": "Instead of one automaton, three clockwork spiders that run at the nightmares and blow up when they get there.",
  "tree.amount.automaton": "Automaton life",
  "party.automaton": "Automaton",
  "bastion.cancelWork": "Cancel the work",
  "bastion.cancelRepair": "Cancel the repair",
  "bastion.cancelWorkAsk": "Cancel the work? What was done is lost and half of what was paid goes back to the store:",
  "bastion.cancelWorkAskUp": "Cancel? The structure stays as it was and half of what was paid goes back to the store:",
  "bastion.cancelWorkYes": "Yes, cancel",
  "bastion.cancelWorkNo": "No, keep going",
  "reason.noJob": "There is no work there.",
  "reason.noBlueprint": "There is no blueprint there.",
  "reason.greatWorkUnderway": "A Great Work is already under way.",
  "reason.noMoreDistricts": "The bastion can't grow any more.",
  "reason.badDistrict": "That kind of district doesn't exist.",
  "reason.heroesTooLow": "The group is still below the level this era asks.",
  "reason.sideBlocked": "A district doesn't fit on that side.",
  "reason.eraCap": "This era allows no more of that tower. Move on to the next era with the Great Work.",
  "reason.eraLocked": "That opens in the next era. Plan the Great Work at the keep.",
  "reason.unique": "There is one in the bastion already.",
  "reason.needsBuilding": "The artificer's workshop must be standing first.",
  "reason.ironLocked": "Iron cladding takes a level {n} hero.",
  "reason.needsLab": "The alchemist's laboratory must be standing.",
  "reason.noAilment": "That hero has nothing to cure.",
  "reason.needsTemple": "It takes a standing Temple, or a cleric with the day's cure.",
  "reason.badElixir": "That elixir doesn't exist.",
  "reason.elixirReady": "An elixir is already brewed for this wave.",
  "enemy.pumpkin": "Cursed pumpkin",
  "season.halloween": "Witching Night",
  "season.halloween.short": "Halloween: stronger nightmares",
  "season.halloween.desc": "Until November 1st the nightmares are tougher and hit harder, and cursed pumpkins join them that burst when they die: don't kill them against the wall or in the middle of the party.",
  "era.1": "Era I · Palisade",
  "era.2": "Era II · Citadel",
  "era.3": "Era III · Titan Fortress",
  "era.4": "Era IV · The Vigil's Bastion",
  "era.5": "Era V · Somnhold",
  "district.military": "Military district",
  "district.quarry": "Quarry district",
  "district.sacred": "Sacred district",
  "district.guild": "Guild district",
  "district.military.desc": "Whatever is built or improved inside costs {n} % less.",
  "district.quarry.desc": "After every wave it yields {wood} wood and {stone} stone for each active player.",
  "district.sacred.desc": "After every wave, what stands inside mends {n} %.",
  "district.guild.desc": "One more golem working in the bastion.",
  "structure.greatWork": "the Great Work",
  "great.title": "Great Work",
  "great.name": "Great Work: {d}",
  "great.intro": "Grow the bastion with a walled district, on the side you choose. The first of each era opens the next: {era}.",
  "great.needLevel": "The group's level (the average of the active heroes, anyone who played in the last 4 days) must reach {n}. Today it is {g}.",
  "great.below": "The active ones:",
  "great.ready": "The group has reached level {n}.",
  "great.frail": "While the work lasts, the keep takes {n} % more damage.",
  "great.plan": "Plan the Great Work",
  "great.pickKind": "Which district?",
  "great.pickSide": "Which side? Tap the board near a side or use the arrows.",
  "great.sideN": "Side {n}",
  "great.place": "Lay the plan",
  "great.maxed": "The bastion has grown as much as it can.",
  "great.districts": "Districts: {n}",
  "great.rose": "The {d} has risen!",
  "great.newEra": "The {era} begins.",
  "great.battleFrail": "The Great Work weakens the keep",
  "log.district": "The {d} rose: {era}",
  "log.contributeGreat": "to the Great Work",
  "advice.greatWork": "The bastion is running out of room. Tap the keep and plan the Great Work to add a district.",
  "prev": "Previous",
  "next": "Next",
  "district.military.short": "Military",
  "district.quarry.short": "Quarry",
  "district.sacred.short": "Sacred",
  "district.guild.short": "Guild",
  "great.cancel": "Cancel",
  "bastion.eraCap": "{n}/{m} this era",
  "great.introMore": "Grow the bastion with another walled district, on the side you choose. It is the second of the {era}.",
  "res.iron": "Iron",
  "restip.iron.use": "For iron cladding and level-4 towers (era II).",
  "restip.iron.from": "Only the iron mines give it; they open with era II (Incursions).",
  "bastion.material.3": "Iron",
  "bastion.toIron": "Clad in iron",
  "bastion.ironLocked": "Your hero needs level {n} to clad in iron (now level {m}).",
  "bastion.enchant.acid": "Acid",
  "bastion.eraTag": "Era {n}",
  "bastion.eraLockedAt": "That opens in era {n}. Plan the Great Work at the keep.",
  "bastion.needsWorkshop": "Needs the artificer's workshop",
  "bastion.onlyOne": "Already built",
  "bastion.level4Hint": "Level 4 comes with era II.",
  "bastion.level5Hint": "Level 5 comes with era IV.",
  "bastion.forgeNextHint": "The forge reaches level {n} (up to +{p}) with {era}.",
  "structure.workshop": "Artificer's workshop",
  "structure.workshop.desc": "Makes clockwork turrets and every repair in the bastion goes twice as fast. One per bastion.",
  "structure.clockwork": "Clockwork turret",
  "structure.clockwork.desc": "A geared turret: fast and light, shoots ground and air. In a fight an artificer can cast their turret on it to overload it: it bursts on whatever is near, then rests a few seconds.",
  "structure.lab": "Alchemist's laboratory",
  "structure.lab.desc": "The mage's enchantments last twice as long and acid joins them. It also brews an elixir for the next wave. One per bastion.",
  "lab.title": "Elixir for the next wave",
  "lab.hint": "Every hero who fights the wave drinks it, live or as a ghost. One per wave.",
  "lab.might": "Elixir of might",
  "lab.might.desc": "+{n} % damage.",
  "lab.vigor": "Elixir of vigor",
  "lab.vigor.desc": "+{n} % health.",
  "lab.brew": "Brew",
  "lab.ready": "Ready for wave {w}: {e}.",
  "workshop.title": "What the workshop does",
  "workshop.repairs": "Every repair goes twice as fast.",
  "workshop.turrets": "Unlocks clockwork turrets.",
  "inc.iron": "Iron mine",
  "inc.iron.desc": "Iron, the only place to get it.",
  "inc.twist.iron": "A plain assault, deep in the shell: they come down all three paths.",
  "site.18": "Eastern vein",
  "site.19": "Western vein",
  "log.elixir": "{who} brewed an {e}",
  "log.elixir.you": "You brewed an {e}",
  "inc.rule.iron": "Iron mine: a plain assault, deep in the shell.",
  "hero.stat.cooldown": "Cooldown",
  "hero.capCooldown": "Your gear is at the cooldown cap ({n} %): more cooldown on gear adds nothing (the level still does).",
  "hero.capArmor": "Your gear is at the armor cap ({n} %): more armor on gear adds nothing (the level still does).",
  "enemy.sapper": "Sapper",
  "enemy.sapper.desc": "When a wall or gate stands in its way it digs underneath and comes up inside. Underground it can't be hit.",
  "enemy.ram": "Bone ram",
  "enemy.ram.desc": "Slow and very tough; bolts barely pierce it and it can't be stunned or taunted. It doesn't stop for heroes: it goes to break the first gate or wall.",
  "enemy.mangonel": "Bone mangonel",
  "enemy.mangonel.desc": "It stops far off, out of the towers' reach, and throws rocks at the walls and gates; once they are down, at the towers. It can't be stunned or taunted: go out after it.",
  "enemy.mammoth": "Ash mammoth",
  "enemy.mammoth.desc": "Huge and slow, and very hard to kill. It never looks at a hero and can't be stunned or taunted: it walks straight for the keep and flattens the walls and towers in its way in moments. Fire scares it: oil or flames turn it back for a while, trampling the nightmares beside it.",
  "enemy.archer": "Spectral archer",
  "enemy.archer.desc": "From outside the walls it shoots the towers, farther than a ballista or a catapult reaches. Go out after it.",
  "enemy.slinger": "Goblin slinger",
  "enemy.slinger.desc": "Stays behind the pack and slings stones at the heroes from afar. Frail up close: go out after it.",
  "enemy.crow": "Soot crows",
  "enemy.crow.desc": "They come in flocks, fly over the walls and peck at the nearest hero. Frail: the arcane tower and area damage sweep them away.",
  "enemy.mourner": "Mourner",
  "enemy.mourner.desc": "Walks in the middle of a pack and every two seconds mends the nightmares around it with threads of ink. Its claw curses: the hero heals half for a while. Kill it first.",
  "enemy.ogre": "Shadow ogre",
  "enemy.ogre.desc": "A small giant, slow and very tough. Its sweep throws heroes back and its roar frightens them: a while without striking or using skills.",
  "enemy.troll": "Peat troll",
  "enemy.troll.desc": "Knits back from any wound very fast, unless it is burning: oil, fire, the mage's fireball.",
  "enemy.beetle": "Ink beetle",
  "enemy.beetle.desc": "Its shell stops nearly everything until a heavy blow splits it: the catapult, a shield bash, a critical. Its acid eats walls and gates.",
  "enemy.bannerman": "Bone bannerman",
  "enemy.bannerman.desc": "Under its banner the nightmares march faster and hit harder. When it falls, they falter for a moment.",
  "enemy.bonesinger": "Bonesinger",
  "enemy.bonesinger.desc": "Nightmares that fall near it rise again as skeletons. Go out and get it.",
  "enemy.wyvern": "Ash wyvern",
  "enemy.wyvern.desc": "It flies, hangs in the air out of the heroes' reach and spits fire at a tower, which keeps burning until a hero stands by it.",
  "enemy.giant": "Sleeping giant",
  "enemy.giant.desc": "It walks asleep and hurls rocks at towers from far off; its stomp stuns the heroes around it. At half health it wakes: it moves faster and its roar frightens.",
  "enemy.moth": "Sleep moth",
  "enemy.moth.desc": "They come in swarms and fall on the heroes. The one they wrap falls asleep until an ally comes close or something hits it.",
  "enemy.weaver": "Weaver",
  "enemy.weaver.desc": "It cocoons towers, which don't fire until a hero stands by to cut the silk. Its bite poisons, and when it dies it bursts into spiderlings.",
  "enemy.sentinel": "Fallen sentinel",
  "enemy.sentinel.desc": "A knight of the old garrison, dreamt twisted. Its tower shield stops shots from the front: strike it from the side or the back. They come three at a time, in a phalanx, and its shield bash stuns.",
  "enemy.frostColossus": "Frost colossus",
  "enemy.frostColossus.desc": "A giant of ice wrapped in fog. Towers near it fire slower, its breath freezes the heroes in front of it and what it strikes turns brittle. Fire hurts it badly.",
  "enemy.stormHerald": "Storm herald",
  "enemy.stormHerald.desc": "A black cloud with a face inside. It hovers by a tower and calls lightning that leaps to the buildings beside it: better not to crowd them.",
  "enemy.shellSerpent": "Shell serpent",
  "enemy.shellSerpent.desc": "A serpent of rock that travels under the ground, where nothing reaches it. It comes up inside the walls by a tower and eats it with acid.",
  "enemy.glassDrake": "Glass drake",
  "enemy.glassDrake.desc": "An adult child of the Burn, black glass with fire inside. It sweeps a cone of buildings with fire and leaves them burning. Its scales barely feel light blows: it takes heavy ones or criticals.",
  "enemy.shellback": "Shellback",
  "enemy.shellback.desc": "A piece of the shell that walks. Shots from afar hit it for half, and as it breaks it drops the nightmares clinging to its back.",
  "enemy.lidlessDreamer": "Lidless dreamer",
  "enemy.lidlessDreamer.desc": "It floats with a crown of closed eyes. When they open, the towers around fall silent and the heroes fall asleep. Struck hard, it vanishes and comes back a little way off.",
  "enemy.ashWatcher": "Ash watcher",
  "enemy.ashWatcher.desc": "A fallen angel of the Order with wings of ash. It dives on the weakest hero, tears away its shields and blessings, and mends on them.",
  "enemy.spiderling": "Spiderling",
  "enemy.spiderling.desc": "What the weaver leaves when it dies. Weak, but many.",
  "enemy.oracle": "Ink oracle",
  "enemy.oracle.desc": "It wraps the nightmares around it in a bubble of ink that soaks up light blows. A heavy blow or a critical bursts it.",
  "enemy.wyrmling": "Burn wyrmling",
  "enemy.wyrmling.desc": "A young of the dragon, of black glass. It flies at the heroes and burns a line across the ground: get out of the fire.",
  "host.common": "Common tide",
  "host.common.desc": "The usual mix.",
  "host.horde": "Horde",
  "host.horde.desc": "A great many weak nightmares and flocks: area damage and oil.",
  "host.flock": "Flock",
  "host.flock.desc": "Nearly everything flies over the walls: towers that shoot the air and ranged heroes.",
  "host.siege": "Siege",
  "host.siege.desc": "Few and tough: ogres, rams and the ones that shoot from afar. Repair, and go out after them.",
  "host.procession": "Procession",
  "host.procession.desc": "Mourners mending from the middle of their escort: kill them first.",
  "host.ambush": "Ambush",
  "host.ambush.desc": "Stalkers and sappers coming in where you don't expect: light and defence in depth.",
  "host.giantStep": "Giant's pass",
  "host.giantStep.desc": "One or two giants with a small escort: the whole party on one, and mind the stomp.",
  "inc.fort": "Sappers' fort",
  "inc.fort.desc": "Dream dust, and if you win, the next wave comes without sappers.",
  "inc.twist.fort": "Sappers' fort: almost all sappers, with a few archers. Take it and the next wave comes without sappers.",
  "inc.rule.fort": "Fort: win it and the next wave comes without sappers.",
  "site.20": "Horn fort",
  "bastion.reach": "Reach {n} cells",
  "history.mixed": "live and as ghosts",
  "inc.exploredLabel": "Explored",
  "inc.todayLabel": "Today's rewards",
  "inc.todayLeftShort": "{n} of {max} left",
  "inc.legend.near": "Near",
  "inc.legend.mid": "Middle",
  "inc.legend.far": "Far",
  "inc.legend.locked": "Locked",
  "inc.legend.unknown": "Unexplored",
  "inc.legend.opener": "Who opened it",
  "damage.title": "Damage",
  "damage.short": "Damage",
  "damage.walls": "Walls: {n} sections",
  "damage.towers": "Towers: {n} broken",
  "damage.traps": "Traps: {n} broken",
  "damage.ruin": "Ruin",
  "damage.none": "Nothing is broken. Everything stands.",
  "damage.repairAll": "Repair {n}",
  "damage.intro": "{n} damaged pieces, in the order worth mending them: gates, walls, towers, then the rest. Tap one to see it on the board.",
  "damage.unpaid": "Not enough for {n}: they stay in red.",
  "damage.allPaid": "Enough for all of them. The golems take them as they free up.",
  "damage.ordered": "You ordered {n} repairs: the golems work through them in order.",
  "dungeon.claimedTag": "took it today",
  "dungeon.claimedTip": "Already opened the crypt chest today: a win only gives experience.",
  "cryptEnd.claimed": "The crypt chest opens once a day for each hero, and you had already taken it today: this time you only earned experience. Tomorrow it holds a rare piece for you again.",
  "allies.online": "online now",
  "allies.seen": "played {t} ago",
  "allies.in.crypt": "in the crypt",
  "allies.in.incursion": "on an incursion",
  "allies.in.wave": "defending the wave",
  "temper.go": "Temper to {r}",
  "temper.hint": "Raises the piece to {r} with embers: it keeps its attributes and pluses and gains what it lacks.",
  "temper.embers": "{n} embers",
  "temper.embersTip": "Embers from level II incursions: at the forge they temper gear (raise its rarity).",
  "incEnd.embers": "+{n} embers to temper at the forge",
  "enemy.magmaLord": "Magma Lord",
  "reason.notEnoughEmbers": "Not enough embers: they come from level II · Embers incursions.",
  "reason.maxRarity": "Already rare: it can't be tempered further.",
  "ilevel.label": "Incursion level",
  "ilevel.1": "Level I",
  "ilevel.1.sub": "The usual one",
  "ilevel.2": "Level II · Embers",
  "ilevel.2.sub": "Lava, eruptions and the Magma Lord",
  "ilevel.2.twist": "Embers: the ground is cracked with lava that burns if you stand on it; now and then a red circle is marked and bursts 2 s later: get out of it. At the end the Magma Lord comes, raising eruptions under the heroes.",
  "ilevel.2.loot": "On a win: ×1.5 resources, {n} embers to temper gear at the forge, and a piece uncommon or better ({rare} % chance of rare).",
  "ilevel.winFirst": "Level II · Embers opens here once the group wins this place at level I.",
  "ilevel.go": "Go down into the Embers",
  "ilevel.title": "{place} · Embers",
  "ilevel.openTip": "Level II · Embers available",
  "ilevel.wonTip": "Won at level II · Embers",
  "tier.1": "Shadow",
  "tier.2": "Ink",
  "reveal.kicker": "Tide {n} · the titan stirs",
  "reveal.title": "The Embers wake",
  "reveal.lead": "With the new Tide, the titan burns inside. Every place the group has won now has a second level.",
  "reveal.p1": "Pick «Level II · Embers» on a place's card: the map marks with «II» where you can.",
  "reveal.p2": "Lava cracks that burn, eruptions marked before they burst, and the Magma Lord at the end.",
  "reveal.p3": "Win and you bring back embers: at the forge they temper your gear up a rarity.",
  "reveal.go": "See incursions",
  "reveal.later": "Later",
  "cine.omenFog.kicker": "Today's omen",
  "cine.omenFog.title": "Night of fog",
  "cine.omenFog.l1": "The titan breathes out and the fog climbs its back. Today, in the incursions and the crypt, sight is short: bows and spells reach 20 % less.",
  "cine.omenFog.l2": "You see the nightmares' eyes before their shapes. Meet them up close.",
  "cine.omenInk.kicker": "Today's omen",
  "cine.omenInk.title": "A night of ink",
  "cine.omenInk.l1": "The titan dreams in ink. Today, in the incursions, one nightmare in three comes inked.",
  "cine.omenInk.l2": "Tougher, and they mend if left alone: give them no rest.",
  "cine.omenStorm.kicker": "Today's omen",
  "cine.omenStorm.title": "Night of storm",
  "cine.omenStorm.l1": "The titan stirs in its sleep and the sky cracks above it. Today, in the incursions and the crypt, lightning falls: each bolt marks the ground a moment before and strikes everything under it.",
  "cine.omenStorm.l2": "Step out of the marks in time, or lead the nightmares into them.",
  "cine.omenFrenzy.kicker": "Today's omen",
  "cine.omenFrenzy.title": "Night of frenzy",
  "cine.omenFrenzy.l1": "The titan dreams badly and its nightmares wake hungry. Today, in the incursions and the crypt, they run 25 % faster.",
  "cine.omenFrenzy.l2": "There is no time to chase them: choose where to stand, and wait for them there.",
  "cine.omenStarfall.kicker": "Today's omen",
  "cine.omenStarfall.title": "Starfall",
  "cine.omenStarfall.l1": "Tonight the sky falls on the titan, piece by piece. Today, in the incursions and the crypt, a star lands nearby every so often: the first to reach it heals and hits 40 % harder for a while.",
  "cine.omenStarfall.l2": "The light draws the nightmares too, and more of them come tonight. Get there first.",
  "cine.omenBloodMoon.kicker": "Today's omen",
  "cine.omenBloodMoon.title": "Blood moon",
  "cine.omenBloodMoon.l1": "The moon rises red over the titan and its nightmares are thirsty. Today, in the incursions and the crypt, they hit 30 % harder.",
  "cine.omenBloodMoon.l2": "But blood flows both ways: every blow a hero lands gives back part of what it dealt.",
  "cine.omenSwarm.kicker": "Today's omen",
  "cine.omenSwarm.title": "Swarm",
  "cine.omenSwarm.l1": "Out of every crack in the titan climbs something small, and there are thousands. Today, in the incursions and the crypt, half again as many nightmares come, but each one takes less to fall.",
  "cine.omenSwarm.l2": "Don't stop them one by one. Bring it all down on them at once.",
  "cine.omenFrost.kicker": "Today's omen",
  "cine.omenFrost.title": "Frost",
  "cine.omenFrost.l1": "The titan grows cold in its sleep and frost covers its back. Today, in the incursions and the crypt, the nightmares walk 20 % slower, but endure 15 % more.",
  "cine.omenFrost.l2": "You have more time to hit them. You will need it.",
  "cine.saga.postern.kicker": "Chronicle · Chapter 5",
  "cine.saga.postern.l1": "On the east side of the fortress there is a small door no one has named in forty years.",
  "cine.saga.maelis.kicker": "Chronicle · Chapter 6",
  "cine.saga.maelis.l1": "Each night the Ash Witch appears a little closer to the village.",
  "cine.saga.burn.kicker": "Chronicle · Chapter 7",
  "cine.saga.burn.l1": "In the middle of the afternoon, the sky over the Burn turns black. That is how it began last time.",
  "cine.side.faces.back.l1": "Three came back in one week. Since then, at night, people go missing.",
  "cine.side.faces.shadow.l1": "Tonight all of Musgoviejo crosses the square under the lanterns. What casts a shadow is people.",
  "cine.side.faces.accuse.l1": "On the forest road there is a wool cart. No oxen. No one.",
  "cine.side.horn.hunt.l1": "On the titan's tail, something hunts the herd. The shepherds call it the Old Aurochs.",
  "cine.side.horn.alone.l1": "A woman of black glass walks at night among the clan's graves.",
  "cine.side.burn.patrol.l1": "Five wanderers went into the Burn to mark the way. None came back.",
  "cine.side.faces.mada.l1": "Mada mends nets by the lamp. She doesn't turn around.",
  "cine.side.rails.descent.l1": "At the foot of the keep, two rails run down into the dark. The fast rail has no brake.",
  "cine.side.rails.winder.l1": "Down there, the lamps are lit and the floors swept. Someone is still winding the machines.",
  "cine.side.rails.anvil.l1": "In the deepest hall, the Anvil is going cold.",
  "cine.side.rails.rising.l1": "At dawn the rails tremble. From below comes a hammer: one long blow and two short.",
  "cine.play": "Play",
  "cine.skip": "Skip",
  "cine.list": "Cinematics",
  "cine.none": "You haven't seen any yet.",
  "cine.close": "Close",
  "reveal.new": "New",
  "crypt2.title": "The crypt in embers",
  "crypt2.sub": "Five rooms, lava, fire vents and a seal on the Warden's door.",
  "crypt2.label": "Level II · In embers",
  "crypt2.pitch": "Longer: {n} rooms before the Warden. Lava cracks, vents that spit fire on a beat (cross between bursts) and a seal on the door: when the last room is cleared, three runes light up in order; step on them in that order. Get it wrong and they burn.",
  "crypt2.reward": "Its own chest, once a day per hero: a rare piece, {e} embers, dust, lots of XP and a {r} % shot at a relic.",
  "crypt2.claimed": "You already took the crypt in embers' chest today: going down again only gives XP.",
  "crypt2.go": "Go down into the crypt in embers",
  "crypt2.locked": "Level II · In embers opens once the group wins the crypt.",
  "party.crypt2": "Gathering for the crypt in embers: {names}",
  "hero.relicReserve": "In reserve",
  "hero.relicSwap": "Carry it instead of {r}",
  "incEnd.relicKept": "You already carry two: it waits in reserve, swap it in from the hero sheet.",
  "reason.noRelic": "That relic is not in your reserve.",
  "gain.damage": "Damage",
  "gain.stun": "Stun",
  "gain.aura": "Aura",
  "gain.hp": "Life",
  "gain.iron": "takes {n} % less damage",
  "gain.none": "Same effect, sturdier.",
  "chest.label": "Today's chests",
  "chest.crypt": "Crypt",
  "chest.crypt2": "In embers",
  "chest.ready": "ready",
  "chest.taken": "taken · back {t}",
  "chest.readyTip": "Win and the chest is yours (one a day per hero).",
  "chest.takenTip": "You took it today: it's back at {t}. Going down anyway gives XP (and the Warden's relic chance).",
  "chat.title": "Chat",
  "chat.placeholder": "Write to the group…",
  "chat.empty": "No one has written yet.",
  "chat.send": "Send",
  "chat.you": "You",
  "chat.someone": "Someone in the group",
  "chat.q.ready": "Ready!",
  "chat.q.wait": "Wait for me",
  "chat.q.go": "Let's go!",
  "chat.q.help": "Help!",
  "chat.q.thanks": "Thanks",
  "signal.button": "Signals",
  "signal.btnTip": "Signals for the group (G). Alt + click: the obvious one. Hold: help!",
  "signal.attack": "Attack here",
  "signal.defend": "Defend here",
  "signal.danger": "Watch out!",
  "signal.coming": "On my way",
  "signal.help": "Help!",
  "signal.whereTouch": "Tap where",
  "signal.whereMouse": "Click where",
  "signal.slow": "Wait a moment for another signal",
  "signal.tipTouch": "Signals: tap the signals button, pick one and tap where. Hold it to call for help.",
  "signal.tipMouse": "Signals: hold G, point and let go; or Alt + click on what you want to mark.",
  "res.embers": "Embers",
  "push.wave.title": "Wave {w} (Tide {n}) starts in 10 minutes",
  "push.wave.body": "{name}: come defend live or your ghost fights for you.",
  "push.enable": "Notify me before each wave",
  "push.on": "Wave notifications: on",
  "push.off": "Turn notifications off",
  "push.denied": "Your browser blocks Somnhold notifications: allow them in the site settings.",
  "push.unsupported": "This browser can't receive notifications.",
  "push.ios": "On iPhone: tap Share → «Add to Home Screen» and open Somnhold from that icon to get notifications.",
  "push.done": "Done: we'll tell you 10 minutes before each wave.",
  "push.test": "Test notification",
  "saga.garrison.title": "The new garrison",
  "saga.wall.title": "What was left on the wall",
  "saga.fire.title": "The children who dream of fire",
  "saga.deep.title": "The Hondura",
  "saga.postern.title": "The postern",
  "saga.maelis.title": "Maelis",
  "saga.burn.title": "The Burn",
  "saga.garrison.odna.l1": "Two Tides of watching the palisade burn from below. Today, for the first time, someone comes up from Musgoviejo.",
  "saga.garrison.odna.l2": "I'm Odna, mayor of Musgoviejo. I didn't come to thank you.",
  "saga.garrison.odna.l3": "Forty years ago the Order shut the gate and left us outside. Nobody in the village has forgotten.",
  "saga.garrison.odna.l5": "But the cold is coming. You need wood and we need walls. We're sending a caravan. The question is who pays for it.",
  "saga.garrison.odna.c.pay": "Pay for it from the storage",
  "saga.garrison.odna.c.pay.desc": "The Order pays what she asks: −120 stone and −40 crystal. Odna will remember.",
  "saga.garrison.odna.c.ask": "Let the village risk its own",
  "saga.garrison.odna.c.ask.desc": "Odna agrees, grudgingly. The village brings the carts and one more provision.",
  "saga.garrison.caravan.title": "The Musgoviejo caravan",
  "saga.garrison.caravan.goal": "Get the caravan from one road to the other in one piece. It stops while nightmares are on it.",
  "saga.garrison.brann.l1": "The caravan arrives whole. With it comes an old man with a scar across his face.",
  "saga.garrison.brann.l2": "Brann. Sergeant. I served in Somnhold until the Night of the Gate.",
  "saga.garrison.brann.l3": "You put the palisade where the old one stood. Not bad. You lack everything else.",
  "saga.garrison.brann.l4": "The Order paid this time. We'll see how long that lasts.",
  "saga.garrison.brann.l5": "The carts were ours. Don't let the Order forget it.",
  "saga.garrison.brann.l6": "I'll stay in the barracks, if you'll have me. And don't ask me about that night.",
  "saga.garrison.brann.c.welcome": "Give him a place in the barracks",
  "saga.garrison.brann.c.welcome.desc": "Brann stays, and takes a liking to the garrison.",
  "saga.garrison.brann.c.press": "Ask him what happened that night",
  "saga.garrison.brann.c.press.desc": "Brann shuts down. It will be hard to get him talking.",
  "saga.garrison.loss": "The caravan was lost in the woods. The village lost wood and trust.",
  "saga.wall.ruins.l1": "Brann lifts some boards at the back of the barracks. Below, a stair drops into the dark.",
  "saga.wall.ruins.l2": "The old barracks. They boarded it up after the Night of the Gate.",
  "saga.wall.ruins.l3": "At the far end is the armory, with the weapons of the fallen. You need them more than they do.",
  "saga.wall.ruins.c.go": "Go down to the old barracks",
  "saga.wall.barracks.title": "The old barracks",
  "saga.wall.barracks.goal": "Go down through the three halls of the old barracks to the armory door.",
  "saga.wall.gaspar.l1": "At the end, the armory door. Before it, a spectre in a commander's armor still stands guard.",
  "saga.wall.gaspar.l2": "Brann came down after you. He stands still, pale.",
  "saga.wall.gaspar.l3": "Ser Gaspar Venn. The commander who shut the gate that night.",
  "saga.wall.gaspar.l4": "The relief? Forty years late. And here they come again: what's left of my garrison.",
  "saga.wall.gaspar.c.listen": "Listen to Gaspar",
  "saga.wall.gaspar.c.listen.desc": "After the fight, Gaspar will tell you his side of that night. Brann doesn't like it.",
  "saga.wall.gaspar.c.leave": "Do as Brann says",
  "saga.wall.gaspar.c.leave.desc": "Gaspar won't tell you anything. Brann breathes again.",
  "saga.wall.captain.title": "The Ash Captain",
  "saga.wall.captain.goal": "The dead of the old garrison climb into the sunken yard of the barracks. Bring down their captain before they break the armory door.",
  "saga.wall.loss": "The nightmares broke the armory. Brann says nothing, but it shows.",
  "saga.fire.dreams.l1": "The village children all dream the same thing, every night.",
  "saga.fire.dreams.l2": "A woman with a green lantern who calls them by name.",
  "saga.fire.dreams.l3": "They all say she waits for them in the healer's house. Nobody has lived there since the Night of the Gate.",
  "saga.fire.dreams.c.go": "Spend the night in the house",
  "saga.fire.house.title": "The healer's house",
  "saga.fire.house.goal": "Hold the house until dawn.",
  "saga.fire.drawing.l1": "At dawn the house still stands. Inside: dried herbs, jars, and a drawing of a girl in the Order's cloak.",
  "saga.fire.drawing.l2": "Ilse.",
  "saga.fire.drawing.l3": "The healer's daughter. She was a guardian.",
  "saga.fire.drawing.l4": "If this house calls the Witch, let it burn. Let the children sleep.",
  "saga.fire.drawing.c.burn": "Burn the house",
  "saga.fire.drawing.c.burn.desc": "The children will sleep in peace. Odna is grateful.",
  "saga.fire.drawing.c.keep": "Keep it",
  "saga.fire.drawing.c.keep.desc": "Odna doesn't understand. There may be something more inside.",
  "saga.fire.loss": "That night, houses burned in Musgoviejo.",
  "saga.deep.books.l1": "My clan kept the forge's books. Everything in and out was written down.",
  "saga.deep.books.l2": "The Night of the Gate too. The records stayed below, in the Hondura.",
  "saga.deep.books.l3": "I want to know who failed. Let's go down.",
  "saga.deep.books.c.go": "Go down to the Hondura",
  "saga.deep.halls.title": "The halls of the Hondura",
  "saga.deep.halls.goal": "Reach the records. The Marrow Warden guards them.",
  "saga.deep.note.l1": "Among the records, a note written in haste:",
  "saga.deep.note.l2": "“The east postern was left open. A guardian opened it. Sergeant Brann helped her.”",
  "saga.deep.note.l3": "Did you find anything?",
  "saga.deep.note.c.show": "Show her the note",
  "saga.deep.note.c.show.desc": "Hilde will know. Brann will have some explaining to do.",
  "saga.deep.note.c.hide": "“No, nothing.”",
  "saga.deep.note.c.hide.desc": "The note stays with you.",
  "saga.deep.loss": "Hilde came back wounded from the Hondura.",
  "saga.postern.door.l1": "Hilde won't speak to me anymore. I suppose you already know.",
  "saga.postern.door.l2": "There's a door I didn't show you. The east postern.",
  "saga.postern.door.l3": "If you go, go at night. That's how it was.",
  "saga.postern.door.c.go": "Go to the postern at night",
  "saga.postern.night.title": "The postern",
  "saga.postern.night.goal": "Hold the postern tonight, as someone held it forty years ago.",
  "saga.postern.diary.l1": "Under the rubble lies a satchel with the Order's crest. Inside, a diary.",
  "saga.postern.diary.l2": "“Mother says the Order won't let them in. I won't let them die outside.” —Ilse",
  "saga.postern.diary.l3": "I lifted the bar for her. She asked for help and I gave it.",
  "saga.postern.diary.l4": "Some twenty got in. Behind them, the nightmares. Gaspar took the blame. I kept quiet.",
  "saga.postern.diary.l5": "I don't know what diary you're talking about.",
  "saga.postern.diary.c.tell": "Tell Odna that Ilse saved her",
  "saga.postern.diary.c.tell.desc": "Odna will know who let her in. And who hid it.",
  "saga.postern.diary.c.keep": "Keep Brann's secret",
  "saga.postern.diary.c.keep.desc": "Brann won't forget it.",
  "saga.postern.loss": "The postern collapsed. You'll have to dig again.",
  "saga.maelis.closer.l1": "The Witch shows up closer to the village every time.",
  "saga.maelis.closer.l2": "Her name is Maelis. I knew her: she tended my guards.",
  "saga.maelis.closer.l3": "The Witch was Maelis, the healer. Ilse's mother.",
  "saga.maelis.closer.l4": "If anyone can reach her, it's in her dream.",
  "saga.maelis.closer.c.go": "Go down into Maelis's dream",
  "saga.maelis.dream.title": "The dream of ash",
  "saga.maelis.dream.goal": "Cross the rooms of her dream to the way out at the far end. She waits on the other side.",
  "saga.maelis.witch.l1": "The Order. In my house again.",
  "saga.maelis.witch.l2": "You burned my house. Of course you did.",
  "saga.maelis.witch.l3": "You left my house standing. Why?",
  "saga.maelis.witch.l4": "You shut the gate and my daughter died at the foot of the wall.",
  "saga.maelis.witch.c.diary": "Show her Ilse's diary",
  "saga.maelis.witch.c.diary.desc": "The truth about her daughter. It may free her, or make her more dangerous.",
  "saga.maelis.witch.c.fight": "Fight",
  "saga.maelis.witch.c.fight.desc": "There's nothing to talk about.",
  "saga.maelis.ashes.title": "The Ash Witch",
  "saga.maelis.ashes.goal": "Defeat the Witch before they break the altar.",
  "saga.maelis.loss": "The ash burned the village fields.",
  "saga.burn.sky.l1": "In the middle of the afternoon, the sky over the Burn went black.",
  "saga.burn.sky.l2": "That's how that night began. Just like this.",
  "saga.burn.sky.l3": "The village is coming up to the fortress. This time, will you open the gate?",
  "saga.burn.sky.c.open": "Open the gate to the village",
  "saga.burn.sky.c.open.desc": "Odna won't forget it. The village brings what it has: one more provision.",
  "saga.burn.sky.c.closed": "Keep it shut",
  "saga.burn.sky.c.closed.desc": "As forty years ago.",
  "saga.burn.flight.title": "The climb",
  "saga.burn.flight.goal": "Get the village's caravan up to the fortress.",
  "saga.burn.dragon.title": "The Dragon of the Burn",
  "saga.burn.dragon.goal": "Bring the dragon down. Its glass won't give to blows alone.",
  "saga.burn.dawn.l1": "When dawn comes, the dragon is smoke over the Burn. The titan sleeps on.",
  "saga.burn.dawn.l2": "Now I can leave my watch. Thank you for listening.",
  "saga.burn.dawn.l3": "Ilse would have liked you. I… will try.",
  "saga.burn.dawn.l4": "This time the Order opened. The village won't forget.",
  "saga.burn.dawn.l5": "My clan's forge is at your service. For whatever comes.",
  "saga.burn.dawn.l6": "The Night of the Gate is over. At last.",
  "saga.burn.dawn.l7": "The chronicle of the Turtle is written. Somnhold has a garrison again.",
  "saga.burn.dawn.c.end": "Close the chronicle",
  "saga.burn.loss": "The dragon reached Musgoviejo. It all starts again.",
  "npc.brann": "Brann",
  "npc.odna": "Odna",
  "npc.hilde": "Hilde",
  "npc.gaspar": "Ser Gaspar",
  "npc.maelis": "Maelis",
  "npc.brann.role": "Sergeant of the old garrison",
  "npc.odna.role": "Mayor of Musgoviejo",
  "npc.hilde.role": "Smith of the Hondura",
  "npc.gaspar.role": "Fallen commander",
  "npc.maelis.role": "The Ash Witch",
  "rarity.unique": "Unique",
  "unique.gateBlade": "Blade of the Gate",
  "unique.gateBlade.desc": "Shield bash hits everything around its target for twice the damage and stuns the big beasts too (elites for a third; bosses never). Your blows on the stunned hit 50% harder.",
  "unique.lastWatch": "Breastplate of the Last Watch",
  "unique.lastWatch.desc": "While Challenge lasts, every melee blow you take strikes back for your whole attack, through armor, and heals you 1.5% of your life.",
  "unique.posternMedal": "Black Bone Medal",
  "unique.posternMedal.desc": "While Oath lasts, no ally it reaches drops below 1 life, and it raises the fallen at half their life.",
  "unique.garrisonKey": "Key of the Garrison",
  "unique.garrisonKey.desc": "One more turret. Turrets close together are joined by a beam that burns hard whoever crosses it.",
  "unique.anvilHarness": "Anvil Clan Harness",
  "unique.anvilHarness.desc": "The automaton walks with you, lasts twice as long and bursts hard when it breaks.",
  "unique.maelisKit": "Stilt-House Remedies",
  "unique.maelisKit.desc": "The grenade heals the allies it reaches (twice as much as before) and recharges 40% faster.",
  "unique.fallenStaff": "Staff of the Fallen Master",
  "unique.fallenStaff.desc": "The fireball leaps on to four more targets, at 80% of its damage.",
  "unique.frostMantle": "Frost Mantle",
  "unique.frostMantle.desc": "Low on life (40%), a ring of ice rises around you: it freezes the nightmares close by and you can't be hurt for 2 s (every 20 s).",
  "unique.stormEye": "Eye of the Storm",
  "unique.stormEye.desc": "The Storm follows you and lasts twice as long.",
  "unique.chapelLamp": "Lamp of the Old Chapel",
  "unique.chapelLamp.desc": "Your attack heals the most hurt ally nearby for all the damage it deals.",
  "unique.dwarfMail": "Dwarven Mail Robe",
  "unique.dwarfMail.desc": "Sanctuary goes with you, recharges 40% faster and those in it take 25% less damage.",
  "unique.healerRosary": "Coral Rosary",
  "unique.healerRosary.desc": "Dawn reaches the whole party, wherever they are, and recharges 40% faster.",
  "unique.watchBow": "Watchtower Bow",
  "unique.watchBow.desc": "Every third arrow goes through the line for twice the damage and marks: the marked take 30% more damage.",
  "unique.wandererCloak": "Wanderer's Cloak",
  "unique.wandererCloak.desc": "Net recharges twice as fast, and after casting it you leap back.",
  "unique.mossWhistle": "Bone Whistle",
  "unique.mossWhistle.desc": "Arrow rain reveals the unseen, slows by half, and lasts and hits 50% more.",
  "unique.wallAxe": "Axe of the Wall",
  "unique.wallAxe.desc": "Whirl pulls nightmares in toward you (elites too) and recharges 30% faster.",
  "unique.boarHide": "Stone Boar Hide",
  "unique.boarHide.desc": "Low on life (35%), Frenzy starts by itself (every 45 s).",
  "unique.tailFang": "Coral Fang",
  "unique.tailFang.desc": "A Leap that kills is ready again at once, and each nightmare it lands on gives you back 4% of your life.",
  "unique.gasparHammer": "Ser Gaspar's Hammer",
  "unique.gasparHammer.desc": "Smite stuns for 2 s, the big beasts too (elites for a third), and recharges 30% faster.",
  "unique.oathPlate": "Plates of the Oath",
  "unique.oathPlate.desc": "Aegis holds 50% more, covers you too, and taunts when it breaks.",
  "unique.vigilCandle": "Vigil Candle",
  "unique.vigilCandle.desc": "Hallowed ground goes with you and lasts twice as long.",
  "unique.oldRootStaff": "Old Root Staff",
  "unique.oldRootStaff.desc": "Entangle holds 50% longer and spreads to the nightmares nearby.",
  "unique.dwarfBark": "Dwarven Bark",
  "unique.dwarfBark.desc": "Bear form lasts 50% longer, and whoever strikes you in it takes your whole attack back.",
  "unique.maelisSeed": "Seed of the Deep Water",
  "unique.maelisSeed.desc": "Bloom walks with you and lasts 50% longer.",
  "unique.bound": "Bound to your hero: it can't be given, melted or tempered.",
  "saga.title": "Chronicle",
  "saga.chapter": "Chapter {n} of {of}",
  "saga.scene": "Scene",
  "saga.provisions": "Provisions",
  "saga.provisionsHint": "Losing a fight costs a provision. Out of provisions, the chapter is lost.",
  "saga.overTitle": "The chronicle is written",
  "saga.blocked.over": "The saga of the Turtle is over. You can still replay chapters for the unique pieces you lack.",
  "saga.blocked.resting": "It can start over tomorrow.",
  "saga.blocked.campaignLost": "The campaign was lost: the chronicle stays as it is.",
  "saga.waiting": "{who} is waiting for you.",
  "saga.waitingStory": "The story goes on.",
  "saga.openScene": "See the scene",
  "saga.play": "Play alone",
  "saga.together": "Play with friends",
  "saga.losingCosts": "Losing costs a provision. Out of provisions, the chapter is lost and starts over tomorrow.",
  "saga.rewardTitle": "When the chapter is done, into the storage:",
  "saga.rewardUnique": "and a unique piece ({slot}) for everyone who played an act",
  "saga.rewardXp": "and XP for everyone who played an act",
  "saga.cast": "Who you've met",
  "saga.mood.trust": "trusts the garrison",
  "saga.mood.warm": "likes you",
  "saga.mood.wary": "doesn't know what to think yet",
  "saga.mood.cold": "distrusts you",
  "saga.mood.hostile": "wants you gone",
  "saga.next": "Go on",
  "saga.prev": "Back",
  "saga.later": "Later",
  "saga.cart": "Caravan",
  "saga.road": "Road",
  "saga.bossHp": "Boss",
  "saga.result.won": "Act won",
  "saga.result.lost": "Act lost",
  "saga.result.onward": "The story goes on: the next act is in the chronicle.",
  "saga.result.provisions": "A provision was lost. {n} left.",
  "saga.result.chapterDone": "Chapter done: “{title}”. This goes into the common storage:",
  "saga.result.back": "Back to the bastion",
  "party.saga": "Gathering to go on with the chronicle: {names}",
  "log.saga.choice": "{who} chose in the chronicle",
  "log.saga.chapter": "The group finished a chapter of the chronicle",
  "log.saga.act.won": "{who} won an act of the chronicle",
  "log.saga.act.lost": "{who} lost an act of the chronicle",
  "log.saga.lost": "The group lost a chapter of the chronicle",
  "log.saga.replay": "{who} replayed a chapter for a unique piece",
  "cine.saga.garrison.kicker": "Chronicle · Chapter 1",
  "cine.saga.garrison.l1": "After two Tides, someone finally comes up from Musgoviejo.",
  "cine.saga.wall.kicker": "Chronicle · Chapter 2",
  "cine.saga.wall.l1": "Under the new barracks, the old garrison is still on watch.",
  "cine.saga.fire.kicker": "Chronicle · Chapter 3",
  "cine.saga.fire.l1": "The children dream of a woman with a green lantern.",
  "cine.saga.deep.kicker": "Chronicle · Chapter 4",
  "cine.saga.deep.l1": "In the Hondura, the forge's books keep what happened that night.",
  "ilevel.3": "Level III · Obsidian",
  "ilevel.3.sub": "Glass that cracks, and the Colossus",
  "ilevel.3.twist": "Obsidian: the ground is black glass and it cracks under anyone who stands still; a second and a half later it breaks and cuts. Inked nightmares leave shards when they fall. At the end comes the Obsidian Colossus: when it shines, it turns blows back. Don't hit it while it shines.",
  "ilevel.3.loot": "On a win: ×2 resources, {n} obsidian shards to carve gear at the forge, and an uncommon piece or better ({rare} % chance it's rare).",
  "ilevel.3.rule": "Obsidian: don't stand still, the glass cracks. When the Colossus shines, don't hit it.",
  "ilevel.winFirst3": "Level III · Obsidian opens here once the group wins this place at level II.",
  "ilevel.go3": "Into the Obsidian",
  "ilevel.title3": "{place} · Obsidian",
  "ilevel.openTip3": "Level III · Obsidian available",
  "ilevel.wonTip3": "Won at level III · Obsidian",
  "enemy.colossus": "Obsidian Colossus",
  "enemy.corvin": "Ser Corvin",
  "unsleeping.corvin.title": "the Knight of the Gate",
  "unsleeping.corvin.back": "You again.",
  "unsleeping.corvin.ult": "The Night of the Gate",
  "unsleeping.corvin.fled": "Ser Corvin faded into smoke. He will be back.",
  "unsleeping.corvin.slain": "{who} brought down Ser Corvin. He won't be back.",
  "unsleeping.corvin.stood": "Ser Corvin still stands. He will be back.",
  "unsleeping.corvin.trophy": "Ser Corvin's broken sword",
  "unsleeping.corvin.trophyNew": "Ser Corvin's broken sword rests by the keep.",
  "enemy.kaela": "Kaela of the Moss",
  "unsleeping.kaela.title": "the Druid of the Late Forest",
  "unsleeping.kaela.back": "Stand still. The forest is waiting.",
  "unsleeping.kaela.ult": "The Forest Comes",
  "unsleeping.kaela.fled": "Kaela faded into smoke and moss. She will be back.",
  "unsleeping.kaela.slain": "{who} brought down Kaela of the Moss. She won't be back.",
  "unsleeping.kaela.stood": "Kaela of the Moss still stands. She will be back.",
  "unsleeping.kaela.trophy": "Kaela's broken staff",
  "unsleeping.kaela.trophyNew": "Kaela's broken staff takes root by the keep.",
  "unsleeping.relicTo": "{who} kept the relic: {relic}.",
  "unsleeping.relicYou": "You kept the relic: {relic}.",
  "unsleeping.relicYouKept": "You kept the relic: {relic}. It waits in your reserve.",
  "enemy.lucan": "Prior Lucan",
  "unsleeping.lucan.title": "of the Empty Chapel",
  "unsleeping.lucan.back": "I prayed you would come back.",
  "unsleeping.lucan.ult": "The Empty Chapel",
  "unsleeping.lucan.fled": "Prior Lucan faded into smoke. He will be back.",
  "unsleeping.lucan.slain": "{who} brought down Prior Lucan. He won't be back.",
  "unsleeping.lucan.stood": "Prior Lucan still stands. He will be back.",
  "unsleeping.lucan.trophy": "Prior Lucan's cold censer",
  "unsleeping.lucan.trophyNew": "Prior Lucan's censer hangs cold by the keep.",
  "enemy.edda": "Ser Edda",
  "unsleeping.edda.title": "the Sworn",
  "unsleeping.edda.back": "I swore you would not pass. I swear it still.",
  "unsleeping.edda.ult": "The Cold Light",
  "unsleeping.edda.fled": "Ser Edda faded into smoke. She will be back.",
  "unsleeping.edda.slain": "{who} brought down Ser Edda. She won't be back.",
  "unsleeping.edda.stood": "Ser Edda still stands. She will be back.",
  "unsleeping.edda.trophy": "Ser Edda's split shield",
  "unsleeping.edda.trophyNew": "Ser Edda's split shield rests by the keep.",
  "enemy.vela": "Vela",
  "unsleeping.vela.title": "the Archer without arrows",
  "unsleeping.vela.back": "I kept watching you.",
  "unsleeping.vela.ult": "Endless Rain",
  "unsleeping.vela.fled": "Vela faded into smoke. She will be back.",
  "unsleeping.vela.slain": "{who} brought down Vela. She won't be back.",
  "unsleeping.vela.stood": "Vela still keeps the wall walk. She will be back.",
  "unsleeping.vela.trophy": "Vela's stringless bow",
  "unsleeping.vela.trophyNew": "Vela's stringless bow hangs by the keep.",
  "enemy.ansel": "Ansel",
  "unsleeping.ansel.title": "the Ash Scholar",
  "unsleeping.ansel.back": "I still have pages left.",
  "unsleeping.ansel.ult": "The Library Burns",
  "unsleeping.ansel.fled": "Ansel crumbled into ash. He will be back.",
  "unsleeping.ansel.slain": "{who} brought down Ansel. He won't be back.",
  "unsleeping.ansel.stood": "Ansel is still burning. He will be back.",
  "unsleeping.ansel.trophy": "Ansel's burnt book",
  "unsleeping.ansel.trophyNew": "Ansel's burnt book rests by the keep.",
  "enemy.bruni": "Bruni",
  "unsleeping.bruni.title": "the Hollow Forger",
  "unsleeping.bruni.back": "The forge is still warm. So are you.",
  "unsleeping.bruni.ult": "The Forge Turned",
  "unsleeping.bruni.fled": "Bruni faded into smoke. He will be back.",
  "unsleeping.bruni.slain": "{who} brought down Bruni. He won't be back.",
  "unsleeping.bruni.stood": "Bruni still stands. He will be back.",
  "unsleeping.bruni.trophy": "Bruni's split hammer",
  "unsleeping.bruni.trophyNew": "Bruni's split hammer rests on his anvil by the keep.",
  "enemy.ragna": "Ragna",
  "unsleeping.ragna.title": "the Horn",
  "unsleeping.ragna.back": "This time you won't get away.",
  "unsleeping.ragna.ult": "The Lone Sally",
  "unsleeping.ragna.fled": "Ragna faded into smoke. She will be back.",
  "unsleeping.ragna.slain": "{who} brought down Ragna. She won't be back.",
  "unsleeping.ragna.stood": "Ragna still stands. She will be back.",
  "unsleeping.ragna.trophy": "Ragna's split horn",
  "unsleeping.ragna.trophyNew": "Ragna's split horn hangs from her axe, driven in by the keep.",
  "unsleeping.broken": "Cut!",
  "unsleeping.flee": "{name} is fading into smoke",
  "unsleeping.fleeHint": "Strike now to stop the escape!",
  "unsleeping.held": "Escape stopped!",
  "unsleeping.rage": "Rage",
  "colossus.shine": "The Colossus shines! Don't hit it: it turns blows back. Then it slams the ground: get away.",
  "colossus.shineTag": "shining: don't hit",
  "obsidian.move": "The glass is cracking under your feet: move!",
  "deep.floor": "Floor {n} of {total} · {name}",
  "deep.floorName.0": "Stone",
  "deep.floorName.1": "Embers",
  "deep.floorName.2": "Obsidian",
  "deep.guardian.0": "The Marrow Warden",
  "deep.guardian.1": "The Magma Lord",
  "deep.guardian.2": "The Obsidian Colossus",
  "deep.chooseShort": "Stairs or way out: choose",
  "deep.choose": "Down, or back?",
  "deep.chooseHint": "Everyone together, on one of the two.",
  "deep.tapToGo": "tap to go",
  "deep.fold": "Fold",
  "goal.fold": "Fold the panel",
  "goal.unfold": "Show the whole panel",
  "deep.downName": "Go down",
  "deep.downWhere": "Everyone on the stairs",
  "deep.downRisk": "Fall, and you keep {half} %",
  "deep.backName": "Go back",
  "deep.backWhere": "Everyone at the way out",
  "deep.backSafe": "With the chest, safe",
  "deep.each": "each",
  "deep.xp": "XP",
  "deep.down": "Floor {n} · {name}",
  "deep.stairsOpen": "The guardian has fallen. The stairs down and the way out are open: all of you, stand together on one of them.",
  "puzzle.braziers.title": "The braziers",
  "puzzle.braziers.do": "Light the braziers: stand next to one. They must all burn at once. Lit: {lit} of {n}.",
  "puzzle.braziers.fail": "A brazier went out.",
  "puzzle.levers.title": "The twin levers",
  "puzzle.levers.do": "Two heroes, one on each glowing plate, at the same time, until the bar fills. Round {round} of {rounds} · on the plates: {on} of 2.",
  "puzzle.levers.fail": "A lever was let go.",
  "puzzle.runes.title": "The runes",
  "puzzle.runes.watch": "Watch the order the runes light up in.",
  "puzzle.runes.do": "Step on the runes in the order they lit up: {k} of {n}.",
  "puzzle.runes.fail": "Wrong rune: they burn, and the order shows again.",
  "puzzle.glass.title": "The glass bridge",
  "puzzle.glass.watch": "Remember the path: only those tiles hold.",
  "puzzle.glass.do": "Walk one tile at a time to the far end. If you fall, you're back at the start; step on the first tile to see the path again. Everyone has to make it.",
  "puzzle.glass.fail": "The glass broke: back to the start.",
  "puzzle.solved": "Solved! The way opens.",
  "puzzle.press": "Reinforcements in {n} s.",
  "crypt3.label": "Level III · The deep crypt",
  "crypt3.title": "The deep crypt",
  "crypt3.sub": "Three floors, a puzzle on each, and a guardian at the end of every floor.",
  "crypt3.pitch": "Three floors, each with a fighting room, a different puzzle every descent, and its guardian. When the guardian falls, the group chooses: go down to the next floor, harder and richer, or go back with what it has.",
  "crypt3.reward": "Every floor adds to the chest: XP, dust, obsidian shards (and embers from the second). From the second floor, a rare piece; back from the bottom, a good shot at a relic. If you fall, you keep {half} %.",
  "crypt3.claimed": "You already took the deep crypt's piece and relic today: going down again still gives XP, dust and shards.",
  "crypt3.go": "Down into the deep crypt",
  "crypt3.locked": "The deep crypt opens with the group at level 8, once it has won the crypt in embers.",
  "chest.crypt3": "Deep",
  "party.crypt3": "Gathering to go down into the deep crypt: {names}",
  "log.deepWon": "The group came back from the deep crypt with {n} floors ({names})",
  "log.deepLost": "The deep crypt brought the group down after {n} floors ({names})",
  "carve.go": "Carve the effect",
  "carve.hint": "Turns «{fx}» into another effect, at random (never the same one), with obsidian shards.",
  "carve.shards": "{n} shards",
  "carve.shardsTip": "Obsidian shards, from level III and the deep crypt: at the forge they carve a rare piece's effect.",
  "res.shards": "Shards",
  "incEnd.shards": "+{n} obsidian shards to carve at the forge",
  "reason.notRare": "Only a rare piece with an effect can be carved.",
  "reason.notEnoughShards": "Not enough shards: they come from level III · Obsidian and the deep crypt.",
  "log.rebuilt": "The Order sent masons up from the valley: {n} of the bastion's structures stand as good as new.",
  "damage.busy": "{n} repairs already ordered: the golems are on it.",
  "damage.noneLeft": "Nothing broken is left without a repair ordered.",
  "effect.fury": "Fury",
  "effect.execute": "Executioner",
  "effect.chain": "Chain lightning",
  "effect.frost": "Frost",
  "effect.cleave": "Cleave",
  "effect.guard": "Guard",
  "effect.echo": "Echo",
  "effect.banner": "Banner",
  "effect.burn.desc": "Your attack sets the target alight: it burns for {bp} % of the blow over {s} s.",
  "effect.lifesteal.desc": "Your attack heals you for {bp} % of the damage it deals.",
  "effect.thorns.desc": "Whoever strikes you in melee takes {bp} % of your attack back.",
  "effect.swift.desc": "You move {bp} % faster.",
  "effect.fury.desc": "Below {below} % health, your attack hits {bp} % harder.",
  "effect.execute.desc": "Your attack hits nightmares below {below} % health {bp} % harder.",
  "effect.chain.desc": "Every {every} blows, lightning leaps to {n} nearby nightmares for {bp} % of the blow.",
  "effect.frost.desc": "Your attack slows the target by {bp} % for {s} s (half on elites and bosses).",
  "effect.cleave.desc": "Your attack also reaches the nightmares next to the target, for {bp} % of the blow.",
  "effect.guard.desc": "Every {every} s a shield of {bp} % of your health rises for {s} s.",
  "effect.echo.desc": "Each nightmare you fell takes {s} s off your skills' recharge.",
  "effect.banner.desc": "Towers near you hit {bp} % harder (it doesn't add up with another banner).",
  "effect.stacked": "Repeated on another piece: worth {n} %.",
  "effect.stackHint": "The same effect on several pieces is worth less each time (100 %, 60 %, 30 %). Mixing different effects pays more.",
  "reforge.title": "Reforge an attribute",
  "attune.title": "Carve the affinity",
  "attune.hint": "Turns the affinity against {from} into another type, at the same value. Handy for getting ready for what the omen says is coming.",
  "reforge.hint": "Turns that attribute into another one the piece lacks, at random and with a new value. The pluses forged into it move to the new one. Each reforge of the same piece costs more.",
  "reforge.go": "Reforge {a}",
  "forge.pool": "Everything at the forge is paid with the dust in the common storage, which belongs to everyone. There is {n}.",
  "reforge.price": "Now {now}; the next reforge of this piece, {next}. Each one adds {add} to the price.",
  "reforge.after": "Then {n} dust is left in the common storage.",
  "reforge.big": "Careful: this reforge takes {p} % of everyone's dust. {n} would be left.",
  "reforge.done": "{from} was reforged into {to}.",
  "socket.open": "Open a setting",
  "socket.openHint": "Opens an obsidian setting in this rare piece: then a gem can be set in it.",
  "socket.empty": "Empty setting",
  "socket.pick": "Pick a gem",
  "socket.change": "Change gem",
  "socket.label": "Settings",
  "gem.ruby": "Ruby",
  "gem.garnet": "Garnet",
  "gem.sapphire": "Sapphire",
  "gem.amethyst": "Amethyst",
  "gem.onyx": "Onyx",
  "awaken.go": "Awaken",
  "uawaken.go": "Awaken · stage {n}",
  "awaken.hint": "At the forge, with shards, embers and dust, the relic awakens: it does the same, stronger. It stays awake even kept in reserve.",
  "awaken.badge": "Awake",
  "awaken.then": "Awake: {d}",
  "awaken.needForge": "Awakening relics needs a standing forge.",
  "uawaken.needForge": "Forge at level {n} (the bastion's is {m})",
  "relic.fateDie.awake": "Hits twice as hard on a 5 or a 6.",
  "relic.vigilGrimoire.awake": "Your spectre uses the ultimate twice a wave, and live your ultimate recharges 20 % faster.",
  "relic.vigilLantern.awake": "Lights farther, and stalkers in its light take 20 % more damage.",
  "relic.dreamerRing.awake": "When you fall you're back in 5 s.",
  "relic.warHorn.awake": "Longer reach, and nearby towers fire 25 % faster.",
  "relic.ashAmulet.awake": "Heals twice as much per nightmare felled.",
  "relic.corvinGate.awake": "Blows from the front hurt you 35 % less.",
  "relic.velaString.awake": "The smoked take 20 % more.",
  "relic.anselPage.awake": "It bursts every 4th basic attack.",
  "relic.lucanCenser.awake": "It heals 2 %.",
  "relic.bruniHammer.awake": "They take 45 % less.",
  "relic.ragnaHorn.awake": "5 % harder for every 10 % lost.",
  "relic.eddaShield.awake": "Untouchable for 3 s, and you heal 35 %.",
  "relic.kaelaSeed.awake": "Pinned for 1.5 s.",
  "offering.title": "Offerings",
  "offering.hint": "Burn dream dust from the storage at the keep: the blessing lasts every wave left in this Marea, in every sector. One of each kind per Marea.",
  "offering.oil": "Blessed oil",
  "offering.oil.desc": "Towers hit {n} % harder.",
  "offering.mortar": "Dream mortar",
  "offering.mortar.desc": "Walls, gates and towers take {n} % less damage.",
  "offering.vigil": "Vigil",
  "offering.vigil.desc": "Spectres fight with {n} % more power.",
  "offering.burn": "Offer",
  "offering.lit": "Lit until the end of Marea {m}",
  "offering.active": "Offerings lit: {list}",
  "pace.badge": "Keeping pace · ×2 XP",
  "pace.tip": "You're more than {n} levels below the group's average: you earn double experience until you catch up.",
  "gift.needEmpty": "has no {slot}",
  "gift.needBetter": "better than theirs",
  "gift.hint": "What you don't need may help someone else: gift it instead of melting it.",
  "log.offering": "{who} offered {o} at the keep",
  "log.offering.you": "You offered {o} at the keep",
  "log.awaken": "{who} awakened {r}",
  "log.awaken.you": "You awakened {r}",
  "log.relicEmbers": "{who} already had every relic: the new one melted into {n} embers",
  "log.relicEmbers.you": "You already had every relic: the new one melted into {n} embers",
  "reason.socketRare": "Only a rare piece takes a setting.",
  "reason.hasSocket": "This piece already has a setting.",
  "reason.noSocket": "Open a setting in it first.",
  "reason.sameGem": "It already has that gem.",
  "reason.badGem": "That gem doesn't exist.",
  "reason.awake": "That relic is already awake.",
  "reason.badOffering": "That offering doesn't exist.",
  "reason.offered": "That offering already burns this Marea.",
  "reason.notActive": "The campaign is over.",
  "forge.more": "More at the forge",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzpower.title": "Awakened uniques shine",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzpower.intro": "Awakening a unique now grows its power.",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzpower.power": "More power each stage, and it shows",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzpower.power.desc": "Each awakening stage makes the piece's own power stronger: more reach, more damage, more healing and less recharge. The hero wears it: a red glow at the feet, then embers, a halo and, at the end, a crown of fire.",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzzzzzzzzsomnhold.title": "Era V: Somnhold",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzzzzzzzzsomnhold.intro": "The whole fortress, as it was before the Night of the Gate.",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzzzzzzzzsomnhold.era5": "Era V · Somnhold",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzzzzzzzzsomnhold.era5.desc": "With the group at level 30, a second Great Work crowns the keep again: it adds a belfry and the Dream Beacon, the ring wall turns to titan stone (much tougher), the shell shows through the ground and the bastion takes a light of its own. The forge reaches level 6.",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzzzzzzzzsomnhold.beacon": "The Dream Beacon",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzzzzzzzzsomnhold.beacon.desc": "Once a wave the beacon pulses and the spectres of those away fight at full strength for a few seconds.",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzzzzzzzzsomnhold.nightmares": "Four more nightmares",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzzzzzzzzsomnhold.nightmares.desc": "The Glass drake (it sweeps fire over buildings; only heavy blows crack it), the Shellback (it drops nightmares off its back as it breaks), the Lidless dreamer (it puts towers and heroes to sleep) and the Ash watcher (it tears the shields off the weakest hero).",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzzzzzzzzsomnhold.towers5": "Level 5 towers look the part",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzzzzzzzzsomnhold.towers5.desc": "Level 5 towers and the level 5 forge were drawn as level 4. Now they show their pedestal and the Vigil's flames.",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzzzznightmares.title": "Era IV's nightmares",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzzzznightmares.intro": "The titan dreams the old garrison and the weather of its back.",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzzzznightmares.nightmares": "Four new nightmares",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzzzznightmares.nightmares.desc": "Era IV brings the Fallen sentinel (its shield stops shots from the front and they come three at a time), the Frost colossus (it chills towers and freezes heroes), the Storm herald (lightning that leaps from building to building) and the Shell serpent (it travels underground and comes up inside the walls; the watchtower gives it away).",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzeraiv.title": "Era IV",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzeraiv.intro": "The bastion can be the Order's seat again.",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzeraiv.era4": "Era IV · The Vigil's Bastion",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzeraiv.era4.desc": "With the group at level 20 and the four districts raised, the Great Work crowns the keep: it adds a fourth stage with the Vigil's white flame, and the wall's towers light the same flame and hang the Order's standard. Era IV opens the saga's last chapter.",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzeraiv.forge5": "The Vigil's forge",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzeraiv.forge5.desc": "In era IV the forge reaches level 5: pieces go up to +7 and the second stage of awakening a unique opens.",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzeraiv.towers5": "Level 5 towers",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzeraiv.towers5.desc": "In era IV the artificer can raise towers to level 5: they hit much harder and stand on a taller pedestal lit with the Vigil's white flames.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzsagaharder.title": "A harder saga",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzsagaharder.intro": "With the new uniques, the saga had become easy.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzsagaharder.saga": "Tougher nightmares in the saga",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzsagaharder.saga.desc": "From the Wall on, each chapter's nightmares and bosses hold out longer, more so in the chapters where you already wear uniques. The dragon too. Some fights were tuned to be as fair for 2 heroes as for 4.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzuniques.title": "Truly unique",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzuniques.intro": "The saga's unique pieces no longer lose to a rare one: they're better at everything and change how your hero plays.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzuniques.uniques": "Three attributes, their own effect and new powers",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzuniques.uniques.desc": "Every unique brings three attributes instead of two (the ones you have get the third on their own) and a rare effect of its own, 50% stronger than on a rare piece: cleave on the Gate Blade, thorns on the Last Watch, and so on. And every power grew: with the Blade, Shield bash hits an area and stuns big beasts; with the Medal, no one falls during Oath; the Eye's Storm lasts twice as long; the Fang's Leap heals. Check your piece's card to see what it does now.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzuniques.thorns": "Last Watch and Dwarf Bark really strike back",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzuniques.thorns.desc": "They gave back a share of the blow taken, which is little. Now they strike back with your whole attack, like thorns but much stronger.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzyields.title": "What the quarries yield",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzyields.intro": "You can now see what goes into the storehouse after every wave.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzyields.yields": "Quarries and grove in the wave report",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzyields.yields.desc": "Every wave report (and the history) shows how much wood and stone the quarries gave and how much wood the grove gave. The quarry district description says how much it yields: 12 wood and 12 stone for each active player.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzsecretplans.title": "The plan, kept secret",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzsecretplans.intro": "The enemy no longer warns how it will attack.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzsecretplans.secret": "The enemy's plan is not announced",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzsecretplans.secret.desc": "The omen tells which host is coming, but no longer which plan it brings, and nobody spells it out when the fight starts. Read it on the field: who waits outside, who charges, and where. The horn still sounds every time the general moves.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzskillcard.title": "The skill card, whole again",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzskillcard.intro": "A fix in the skill tree.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzskillcard.card": "The skill card reads in full",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzskillcard.card.desc": "Touching a skill in the tree opened a narrow card whose text spilled over the gear. It now takes the full width, on phones too.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzmoreplans.title": "Two more plans",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzmoreplans.intro": "The enemy learned two new ways to attack.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzmoreplans.rush": "Hold and rush",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzmoreplans.rush.desc": "From Tide III: what comes by the paths gathers outside, out of reach, and charges all together. Better have oil and area damage, and be on the wall when the horn sounds.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzmoreplans.pincer": "Pincer",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzmoreplans.pincer.desc": "From Tide IV: the bulk splits in two and storms both sides of the gate at once, above all when everyone is bunched in one spot.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzgeneral.title": "A general that thinks",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzgeneral.intro": "When you play live, the enemy general watches the fight.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzgeneral.general": "The general picks its moment",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzgeneral.general.desc": "In waves with a plan played live, the enemy general looks every few seconds at where the heroes are, which walls fell and how its squads stand, and decides when to make each move. If you see it coming, it waits; if you let your guard down, it strikes.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzharness.title": "The automaton gives you room",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzharness.intro": "The artificer no longer has to fight right next to the automaton.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzharness.harness": "Anvil Clan Harness: the automaton gives you room",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzharness.harness.desc": "The harness automaton no longer treads on your heels: it holds its ground while you stay within about three cells, and only walks toward you if you go farther. You can stand back, away from the nightmares it draws.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzplans.title": "The enemy has a plan",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzplans.intro": "From Tide III some waves come with a strategy.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzplans.plans": "Battle plans",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzplans.plans.desc": "Some waves bring a plan and a general to carry it out. In an escorted siege, the engines come with a guard and the bulk waits outside, out of reach, for a wall to fall; only then does it charge, and the flyers follow. In a feint, a loud group charges the gate to draw you while the bulk waits to come in beside it. The general watches what you do: if everyone goes out after the engines, it sends the bulk right then. The omen says which plan is coming, and a horn sounds every time the general moves.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzsiege.title": "A real siege",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzsiege.intro": "A machine that throws from afar comes to the citadel, and the ones attacking from outside the walls now make themselves felt.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzsiege.mangonel": "New: Bone mangonel",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzsiege.mangonel.desc": "From era II a siege engine stops far off, out of the towers' reach, and throws rocks at the walls and gates; once they are down, at the towers. You can see the rocks coming. Go out after it.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzsiege.siege": "Siege engines can't be taunted",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzsiege.siege.desc": "The ram and the mangonel no longer turn for the warrior's Challenge or anything else that taunts: they keep going for the wall.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzsiege.archer": "Deadlier spectral archer",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzsiege.archer.desc": "It shoots from a little farther than a catapult, hits harder and its arrow is much easier to see. A lone tower near the edge won't hold unless someone goes out after it.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzsupport.title": "More healing and support",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzsupport.intro": "The druid now heals, the paladin picks its aura, and the cleric leaves whoever it mends eager to fight.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzsupport.bloom": "Druid: Bloom",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzsupport.bloom.desc": "The druid's ultimate is now the Bloom: a forest grows around it and everyone inside recovers life for 8 seconds. Bear form becomes the second skill, shorter and more often. The thorn wall is gone; if you had points in that branch, they're back and you can rebuild your tree for free.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzsupport.auras": "Paladin: choose your aura",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzsupport.auras.desc": "In the paladin's skill tree you now pick which aura you carry: Devotion (allies take less damage), Retribution (whatever strikes your allies is struck back with light) or Life (allies heal a little every second).",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzsupport.inspire": "Cleric: Mend inspires",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzsupport.inspire.desc": "Mend now inspires the healed hero: for 4 seconds they attack 20% faster, even at full life. Mending whoever is fighting pays off now. It doesn't add to the barbarian's War cry: the stronger one counts.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzsupport.potency": "Cleric: Potency",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzsupport.potency.desc": "The damage node in the Dawn branch now adds healing (+7% per rank) instead of damage.",
  "news.2026-10-26-zzzzzzzzzzzzzzrampart.title": "The bastion wall, no false button",
  "news.2026-10-26-zzzzzzzzzzzzzzrampart.intro": "A button that did nothing is gone.",
  "news.2026-10-26-zzzzzzzzzzzzzzrampart.rampartStone": "No more “Rebuild in stone” on the wall",
  "news.2026-10-26-zzzzzzzzzzzzzzrampart.rampartStone.desc": "The bastion wall is already stone, yet it offered to rebuild it in stone and nothing happened. The button is gone; to keep it strong, repair it before the wave.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzcrypt.title": "Fixes in the crypt and the eras",
  "news.2026-10-26-zzzzzzzzzzzzzzzzcrypt.intro": "Two things you told us about today.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzcrypt.lobby": "While the group gathers, everyone waits in the crypt's entrance",
  "news.2026-10-26-zzzzzzzzzzzzzzzzcrypt.lobby.desc": "Before going down you could walk the whole crypt, and the run broke once it started; when someone joined, everyone snapped back to the entrance. Now the wait is in the entrance hall.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzcrypt.eraTag": "Every locked building says which era opens it",
  "news.2026-10-26-zzzzzzzzzzzzzzzzcrypt.eraTag.desc": "The clan hall said «Era II» though it opens in era III. Now each building shows its real era.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzfind.title": "Finding your hero in the crowd",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzfind.intro": "So you don't get lost when hundreds of nightmares arrive.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzfind.find": "Your hero always shows",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzfind.find.desc": "The red circle under your hero shows even with nightmares on top, and your name is never hidden behind others.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzfind.cursor": "A pointer you can see",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzfind.cursor.desc": "On a computer, over the field, the pointer is bigger and lighter, with a dark rim and a red tip.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzfind.chatSpot": "The chat no longer covers the resources",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzfind.chatSpot.desc": "On narrower screens the chat button covered the damage chip; now it always sits under the resources.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzgear.title": "Gear damage counts for everything",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzgear.intro": "What the item says is now true.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzgear.gearDamage": "«+% damage» adds to skills, turrets and the golem",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzgear.gearDamage.desc": "Damage from gear and the tree only made the basic attack stronger. Now it also adds to every class's skills and to what you build or call up: turrets, the golem, spiders, the grenade and incursion turrets. Heals, shields and the golem's health stay the same.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzend.title": "The end of every fight, at once",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzend.intro": "Winning or losing now shows the moment it happens.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzend.outcome": "Victory or defeat, no pause",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzend.outcome.desc": "When a wave, an incursion, a crypt or a saga battle ends, the outcome shows right away over the board, instead of a few still seconds before the card. If the result is slow to come, the screen says the battle is being recorded.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzpack.title": "The ogre shoves less",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzpack.intro": "A pack of ogres can no longer drag you around.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzpack.shove": "A shorter shove, and room to breathe",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzpack.shove.desc": "The ogre’s blow now throws you back a little less far, and after a shove no other ogre can shove you again for 3 seconds. Before, if two or three got on you, they passed you from shove to shove without letting you hit back.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzrejoin.title": "Back into your run if you got cut off",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzrejoin.intro": "If the game freezes or closes in the middle of a live run.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzrejoin.rejoin": "A button to go back into the run under way",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzrejoin.rejoin.desc": "If you reload the page in the middle of an incursion, mission or crypt with the group, the bastion shows «Your run is still under way» with a button to go back. Before, there was no way back in.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzlive.title": "Steadier live play",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzlive.intro": "We went through how the game connects in fights with friends.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzlive.steady": "If it freezes, it comes back on its own",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzlive.steady.desc": "If your phone locks or switches networks mid-fight, the game notices within seconds and reconnects on its own. Before, it could stay frozen until you reloaded.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzlive.leader": "Whoever opens an incursion no longer ends it by reconnecting",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzlive.leader.desc": "If the one who opened an incursion lost their connection, coming back called off everyone's run and the loot was lost. Not anymore.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzlive.lobby": "A blip in the waiting room doesn't take you out of the group",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzlive.lobby.desc": "While the group gathers, if your connection drops you keep your place for about 45 seconds, and nobody is sent back to the start.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzlive.clear": "If the fight won't go on, it says so",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzlive.clear.desc": "If the fight ended while you were away, you opened it in another tab, or the room is full, a notice shows with the button to go back, instead of a frozen screen.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzgpu.title": "Fewer black screens, and back into the wave",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzgpu.intro": "More fixes for live play.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzgpu.memory": "The game no longer runs out of memory after a few fights",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzgpu.memory.desc": "Every fight left video memory taken when it closed; on tablets and some phones, after a few, the screen went black. Now it is all freed. If it still happens, a notice offers a reload.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzgpu.waveBack": "Back into the wave if you got cut off",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzgpu.waveBack.desc": "If your connection drops in the middle of a live wave, the bastion offers the way back, as it already did for incursions and crypts.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzblade.title": "The Gate Blade, explained",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzblade.intro": "What the warrior's unique weapon does.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzblade.gateBlade": "A clearer Gate Blade",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzblade.gateBlade.desc": "Its description didn't say when it works. Now it does: when Shield bash stuns, it recharges at once and you can bash again, though never two free ones in a row. Against bosses, elites and siege beasts it does nothing, because they can't be stunned. The weapon works the same as before.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzphone.title": "Phones hold up better in big fights",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzphone.intro": "With hundreds of nightmares on screen.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzphone.cool": "Less work drawing the crowds",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzphone.cool.desc": "In fights with hundreds of nightmares a slow phone spent its whole processor drawing. Now it does about half the work: some effects are drawn in one go, and if the phone can't keep up, the screen drops to 30 frames a second until it eases off. The fight is the same; it should run cooler and not stall.",
  "news.2026-10-26-zzzzzzzzzzzzzkeep.title": "Chat at the keep, and named paths",
  "news.2026-10-26-zzzzzzzzzzzzzkeep.intro": "To agree on a plan without leaving the game.",
  "news.2026-10-26-zzzzzzzzzzzzzkeep.keepChat": "Chat at the keep",
  "news.2026-10-26-zzzzzzzzzzzzzkeep.keepChat.desc": "The bastion has a group chat, on the button at the top right. What is written stays: whoever comes in later reads what was said.",
  "news.2026-10-26-zzzzzzzzzzzzzkeep.paths": "Every path shows its number",
  "news.2026-10-26-zzzzzzzzzzzzzkeep.paths.desc": "Each gate reads «Path 1», «Path 2»…, the same numbers as your ghost's post. «I'll take path 1» now makes sense.",
  "news.2026-10-26-zzzzzzzzzzzzzkeep.enterChat": "Enter to talk, and the line over your head",
  "news.2026-10-26-zzzzzzzzzzzzzkeep.enterChat.desc": "Enter opens the chat, Enter sends it and closes it, at the keep and in live fights. What each one says shows for a few seconds over their hero's head.",
  "news.2026-10-26-zzzzzzzzzzzzlive.title": "Live fights no longer stall after an update",
  "news.2026-10-26-zzzzzzzzzzzzlive.intro": "If you had the game open from before an update, you no longer join a live fight on the old version.",
  "news.2026-10-26-zzzzzzzzzzzzlive.helpDistrict": "Helping on sites in a new district",
  "news.2026-10-26-zzzzzzzzzzzzlive.helpDistrict.desc": "Your hero couldn't help on a site past the old ring, in a district: it stood next to it and the clock didn't speed up. Now it helps just like inside.",
  "news.2026-10-26-zzzzzzzzzzzzlive.stale": "Updates before you join",
  "news.2026-10-26-zzzzzzzzzzzzlive.stale.desc": "A tab left open from before an update could stall or stutter in a live incursion, crypt or wave. Now, when you join, the page reloads on its own if there is a new version, and then you join again.",
  "news.2026-10-26-zzzzzzzzzzbattery.title": "Less battery on phones",
  "news.2026-10-26-zzzzzzzzzzbattery.intro": "The game does less work per frame on phones; it looks and plays the same.",
  "news.2026-10-26-zzzzzzzzzzbattery.battery": "Lighter on phones",
  "news.2026-10-26-zzzzzzzzzzbattery.battery.desc": "Battles ask less of the phone's processor, and the HUD cards no longer redraw a blur behind them every frame. Phones should run cooler and last longer. If anything looks different, tell us.",
  "news.2026-10-26-zzzzzzzzzfate.title": "The fate die rolls on every blow",
  "news.2026-10-26-zzzzzzzzzfate.intro": "The relic now helps all wave long, not just on the first blow.",
  "news.2026-10-26-zzzzzzzzzfate.fateDie": "Fate die, reworked",
  "news.2026-10-26-zzzzzzzzzfate.fateDie.desc": "It used to work once a wave and was nearly always spent on the first nightmare. Now every basic attack rolls the die: on a 6 it hits twice as hard. Awakened, it hits twice as hard on a 5 or a 6.",
  "news.2026-10-26-zzzzzzzoverload.title": "Overload gets its own button",
  "news.2026-10-26-zzzzzzzoverload.intro": "Placing turrets and blowing them up no longer get in each other's way.",
  "news.2026-10-26-zzzzzzzoverload.overload": "The artificer's overload has its own button",
  "news.2026-10-26-zzzzzzzoverload.overload.desc": "Blowing up a turret is now a separate button next to the turret's, with its own 2-second wait. Overloading no longer makes you wait to place the next turret, and placing a turret next to another places a new one instead of blowing up the old one. With a single turret out it goes at once; with more, tap which. On PC it's the F key. With no turrets out, the button stays, grayed out, instead of vanishing.",
  "news.2026-10-26-zzzzzzghosts.title": "Faithful replays, ghosts at their posts",
  "news.2026-10-26-zzzzzzghosts.intro": "A replay now shows what happened, and ghosts defend the road they were given.",
  "news.2026-10-26-zzzzzzghosts.replays": "Replays show the real wave",
  "news.2026-10-26-zzzzzzghosts.replays.desc": "The replay of a wave defended by ghosts sometimes showed a different fight: fewer nightmares reaching the tower than the report said. Now it is exactly the wave that was resolved. Replays from before this fix may still not match.",
  "news.2026-10-26-zzzzzzghosts.posts": "Ghosts keep to their road",
  "news.2026-10-26-zzzzzzghosts.posts.desc": "A ghost posted on a road no longer leaves for another while nightmares are coming down its own. If its road is quiet it goes to help where needed and heads back as soon as something comes. With \"No fixed post\" it roams the whole bastion.",
  "news.2026-10-26-zzzzzzghosts.woods": "Ghosts stay out of the woods",
  "news.2026-10-26-zzzzzzghosts.woods.desc": "Ghosts no longer chase nightmares far beyond the wall: they defend from the gate and step out a couple of cells at most. How far you roam in incursions no longer shapes how your ghost stands at the bastion.",
  "news.2026-10-26-zzzzzzzzzzzzzzzogre.title": "The ogre’s shove, without the jump",
  "news.2026-10-26-zzzzzzzzzzzzzzzogre.intro": "The shadow ogre’s sweep no longer looks like lag.",
  "news.2026-10-26-zzzzzzzzzzzzzzzogre.shove": "A shove you can see",
  "news.2026-10-26-zzzzzzzzzzzzzzzogre.shove.desc": "The ogre’s blow used to move a hero in one frame, sometimes across a wall or onto a pressure plate. Now the hero slides back over a third of a second, stops against anything it can’t stand on, and then keeps walking where you sent it from where it landed. A barbarian in a frenzy doesn’t budge.",
  "news.2026-10-26-zzzzzzzzzzzzscout.title": "Shorter reports",
  "news.2026-10-26-zzzzzzzzzzzzscout.intro": "The rangers’ report takes less room.",
  "news.2026-10-26-zzzzzzzzzzzzscout.scout": "The rangers’ report, to the point",
  "news.2026-10-26-zzzzzzzzzzzzscout.scout.desc": "Above the keep it now says how many nightmares are coming and the most numerous kinds. Tap it for the full list.",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzsaga.title": "The saga moves with the group",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzsaga.intro": "The saga's chapters open when the group is ready.",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzsaga.level": "Chapters by level and era",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzsaga.level.desc": "Every chapter opens when the group reaches a level (the active heroes' average), and some also ask for an era of the bastion; they no longer wait for a Marea. A chapter already begun goes on as before.",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzsaga.kept": "Your unique piece waits for you",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzsaga.kept.desc": "Unique pieces ask for a hero level: the weapon 5, the armor 10 and the amulet 15. Finish the chapter sooner and you still earn it: it comes when you reach that level.",
  "news.2026-10-28-zzzzzzzzzzzzzawaken.title": "The uniques awaken",
  "news.2026-10-28-zzzzzzzzzzzzzawaken.intro": "Unique pieces have room to grow, and rares are useful again.",
  "news.2026-10-28-zzzzzzzzzzzzzawaken.awaken": "Awaken a unique piece",
  "news.2026-10-28-zzzzzzzzzzzzzawaken.awaken.desc": "At the forge, every unique piece can awaken in stages: its attributes rise and its effect grows stronger. Each stage asks for a hero level, a forge level (the eras open them), a seal, dream dust and a few rare pieces from your bag to melt. The first stage asks for level 15 and the era III forge.",
  "news.2026-10-28-zzzzzzzzzzzzzawaken.seals": "Seals",
  "news.2026-10-28-zzzzzzzzzzzzzawaken.seals.desc": "Each awakening stage asks for its own seal, and each seal comes from a different place: the first from clearing the deep crypt to its last floor, the second from winning the centre of the Furrows, the third from felling a boss of the new Mareas.",
  "news.2026-10-28-zzzzzzzzzzzzskills.title": "Skills say why they don't go off",
  "news.2026-10-28-zzzzzzzzzzzzskills.intro": "When a skill can't go off, you now hear about it.",
  "news.2026-10-28-zzzzzzzzzzzzskills.said": "A word instead of nothing",
  "news.2026-10-28-zzzzzzzzzzzzskills.said.desc": "Aim a skill where it can't land (the woods or the slopes, off the open ground) and it tells you, and you can pick again without pressing the button twice. And when you're afraid, stunned or asleep, the button says so instead of waiting for a tap that wouldn't work.",
  "news.2026-10-28-zzzzzzzzzzzforge.title": "The group moves on together",
  "news.2026-10-28-zzzzzzzzzzzforge.intro": "The eras look at the whole group and the forge grows with the bastion.",
  "news.2026-10-28-zzzzzzzzzzzforge.group": "The eras ask for the group's level",
  "news.2026-10-28-zzzzzzzzzzzforge.group.desc": "Opening an era no longer needs every active hero at the level: the average of those who played in the last 4 days is enough. Era II asks for level 5 and era III for level 12. The Great Work shows the group's level and each hero's.",
  "news.2026-10-28-zzzzzzzzzzzforge.forge": "The era III forge",
  "news.2026-10-28-zzzzzzzzzzzforge.forge.desc": "With era III, the artificer can raise the forge to level 4 and pieces go up to +6. The forge also changes with every level: it starts as an open-air smithy and ends as a great forge whose furnace is a dragon's head.",
  "news.2026-10-28-zzzzzzzzzzzforge.keep": "The keep grows with every era",
  "news.2026-10-28-zzzzzzzzzzzforge.keep.desc": "In era II the keep raises a second stage with bartizans and long banners. In era III it adds a third tier, flying buttresses and a great beacon of red fire seen from the whole bastion.",
  "news.2026-10-28-zzzzzzzzzzrooms.title": "Crypt rooms feel more natural",
  "news.2026-10-28-zzzzzzzzzzrooms.intro": "Moving through the crypts is smoother.",
  "news.2026-10-28-zzzzzzzzzzrooms.rooms": "No more jerks between waves or when entering a room",
  "news.2026-10-28-zzzzzzzzzzrooms.rooms.desc": "Between waves your hero no longer walks back on its own to where you left it: it stays where the fight ended. You can walk right up to the edge of the room without being pushed back toward the middle. And when the door shuts, whoever was left in the corridor walks in instead of popping up inside.",
  "news.2026-10-28-zzzzzzzztide.title": "The tide never stops",
  "news.2026-10-28-zzzzzzzztide.intro": "Beating the sixth Marea no longer ends the campaign.",
  "news.2026-10-28-zzzzzzzztide.tide": "More Mareas after the sixth",
  "news.2026-10-28-zzzzzzzztide.tide.desc": "Beating the Hollow Shell wins the first season: everyone takes the victory's experience and the campaign goes on with Marea VII, VIII and the ones after, each stronger than the last.",
  "news.2026-10-28-zzzzzzzztide.repeat": "Losing no longer ends the campaign",
  "news.2026-10-28-zzzzzzzztide.repeat.desc": "From Marea VI on, a lost Marea starts over, with new waves, on the next slot of the calendar. Two losses in a row stir the titan a little: everything built is left at half its life and the storage loses a quarter.",
  "news.2026-10-28-zzzzzzzztide.xp": "More experience in the new Mareas",
  "news.2026-10-28-zzzzzzzztide.xp.desc": "From Marea VII on, all experience is worth 10 % more for each Marea, so the high levels stay within reach.",
  "news.2026-10-28-zzzzzzzmail.title": "Fewer emails",
  "news.2026-10-28-zzzzzzzmail.intro": "The bastion no longer writes to you for every Tide.",
  "news.2026-10-28-zzzzzzzmail.mail": "No more Tide emails",
  "news.2026-10-28-zzzzzzzmail.mail.desc": "The omen 12 hours ahead and the summary at the end of each Tide are no longer sent. Email is now only for signing in. To get a heads-up before a wave, turn on browser notifications; what happened in each Tide is still in the bastion's history.",
  "news.2026-10-28-zzzzzzhitches.title": "No more hitches when nightmares appear",
  "news.2026-10-28-zzzzzzhitches.intro": "A fix for the stutters of about a second.",
  "news.2026-10-28-zzzzzzhitches.hitches": "No more stalls entering a room or when a pack comes in",
  "news.2026-10-28-zzzzzzhitches.hitches.desc": "In the crypts, the cellars and the Furrows the screen could stand still for about a second when you moved into a new room or a nightmare not seen yet appeared, mostly on computers. Now the game gets all of that ready before it is needed, in waves and incursions too.",
  "news.2026-10-28-zzzzzmammoth.title": "The mammoth won't be distracted",
  "news.2026-10-28-zzzzzmammoth.intro": "A fix to the siege beasts.",
  "news.2026-10-28-zzzzzmammoth.automaton": "The automaton no longer stops the mammoth",
  "news.2026-10-28-zzzzzmammoth.automaton.desc": "The artificer's automaton drew in the ash mammoth, the ram and the mangonel, even though their descriptions say they can't be taunted. Now they ignore it and keep to their own business.",
  "news.2026-10-28-zzzztomes.title": "The missing pages",
  "news.2026-10-28-zzzztomes.intro": "A fix to the ultimates' tomes.",
  "news.2026-10-28-zzzztomes.pages": "The Witch and the saga now count",
  "news.2026-10-28-zzzztomes.pages.desc": "Tomes arrived after some groups had beaten the Ash Witch or finished saga chapters, and those pages were never given. Now every hero has the pages for what they already did. Note: not every Marea has a boss; pages come from the Ash Witch, the Hollow Shell and each saga chapter.",
  "news.2026-10-28-zzzkeep.title": "The keep no longer pays twice",
  "news.2026-10-28-zzzkeep.intro": "A fix to the keep's health.",
  "news.2026-10-28-zzzkeep.keep": "Old damage is not charged again",
  "news.2026-10-28-zzzkeep.keep.desc": "When a wave was played live with the keep already hurt, the keep lost the damage it carried from before all over again, even if nobody touched it that wave. Now it loses only what was done to it in that fight. This Marea's keep already got back what it lost by mistake.",
  "news.2026-10-28-zzsiege.title": "Ghosts go out after the mangonels",
  "news.2026-10-28-zzsiege.intro": "A change in how the heroes of absent players defend.",
  "news.2026-10-28-zzsiege.ghosts": "No one watches the walls come down",
  "news.2026-10-28-zzsiege.ghosts.desc": "When a bone mangonel throws at the walls from afar, a ghost goes out to break it even with a couple of nightmares at the gate, and it also goes to the far side of the bastion, where no gate is near. One goes out per mangonel; the rest keep the walls. If the gate fills up, they come back.",
  "news.2026-10-28-zailments.title": "The bosses leave their mark",
  "news.2026-10-28-zailments.intro": "Wounds that last days are no longer just the witch's doing.",
  "news.2026-10-28-zailments.marks": "Blows that mark",
  "news.2026-10-28-zailments.marks.desc": "The Warden, the magma lord and the obsidian colossus mark the ground before they strike. If they catch you twice in the same fight, they leave something on you for half a day or more: grave dust (you attack slower), cinders in the bones (fire hurts you more) or glass in the blood (blows hurt you more). One mark is forgiven, and you take at most one new one a day. Ghosts never catch them.",
  "news.2026-10-28-zailments.cleric": "The cleric cures and learns",
  "news.2026-10-28-zailments.cleric.desc": "Curing a friend earns the cleric XP, and the advisor tells them when today's cure is ready and someone needs it, even if that friend is away. Without a cleric, the Temple cures for dust.",
  "news.2026-10-28-zailments.ash": "A shorter ash curse",
  "news.2026-10-28-zailments.ash.desc": "The witch's curse lasts a day instead of a day and a half.",
  "news.2026-10-26-zzzzzzzzzzzailments.title": "Wounds that last days",
  "news.2026-10-26-zzzzzzzzzzzailments.intro": "Some bosses leave marks that don't go away when the fight ends.",
  "news.2026-10-26-zzzzzzzzzzzailments.ailments": "Ash curse and dread",
  "news.2026-10-26-zzzzzzzzzzzailments.ailments.desc": "If the Ash Witch fells you while you play live, she leaves you her ash curse: −15 % health for a day and a half. If an elite giant fells you, it leaves you dread: you start every fight frightened for a moment, for a day. Ghosts never catch them. A cleric friend cures them for free once a day (even if you're away), or the Temple for dust.",
  "news.2026-10-26-zzzzzzzzzzzailments.ward": "Warding elixir",
  "news.2026-10-26-zzzzzzzzzzzailments.ward.desc": "A new elixir in the laboratory: everyone who fights the next wave resists the damage type the omen names by 30 %.",
  "news.2026-10-26-zzzzzzzzzzattune.title": "Getting ready for what's coming",
  "news.2026-10-26-zzzzzzzzzzattune.intro": "The omen says what damage type the Tide brings, and the forge can carve affinities to meet it.",
  "news.2026-10-26-zzzzzzzzzzattune.attune": "Carve the affinity",
  "news.2026-10-26-zzzzzzzzzzattune.attune.desc": "At the forge, armor or an amulet with an affinity can turn it to another type at the same value, for a little common dust. If fire is coming, carve against fire.",
  "news.2026-10-26-zzzzzzzzzzattune.omenType": "The omen names the type",
  "news.2026-10-26-zzzzzzzzzzattune.omenType.desc": "Next to the host that's coming, the bastion clock says what damage type it brings, when it brings plenty of one (“Flock, mostly fire”).",
  "news.2026-10-26-zzzzzzzzdamage.title": "Damage types",
  "news.2026-10-26-zzzzzzzzdamage.intro": "Every blow now has a type: physical, fire, frost, lightning, acid, poison, shadow or holy.",
  "news.2026-10-26-zzzzzzzzdamage.types": "Strong and weak",
  "news.2026-10-26-zzzzzzzzdamage.types.desc": "Nightmares resist some types and fear others: the troll and the moths burn, the slime doesn't feel acid and shatters under frost, skeletons and wraiths suffer holy, wyverns and the Burn wyrmling barely feel fire. Damage numbers show their type's colour. The arcane tower and the mage deal lightning; the cleric and the paladin, holy; an enchanted tower, its element.",
  "news.2026-10-26-zzzzzzzzdamage.affinity": "Affinity on gear",
  "news.2026-10-26-zzzzzzzzdamage.affinity.desc": "Armor and amulets can come with affinity: they guard against one type (fire, frost, lightning, acid, poison or shadow) and leave you half as much more open to its opposite. It comes in drops and in reforging.",
  "news.2026-10-26-zzzzzzzzdamage.wood": "Wood burns",
  "news.2026-10-26-zzzzzzzzdamage.wood.desc": "Wooden buildings take more from fire; stone holds against it but acid eats it; iron resists both.",
  "news.2026-10-26-zzzzztitan.title": "Creatures of the Titan's Fortress",
  "news.2026-10-26-zzzzztitan.intro": "When the bastion reaches era III, the titan dreams five more nightmares.",
  "news.2026-10-26-zzzzztitan.era3": "Five nightmares of era III",
  "news.2026-10-26-zzzzztitan.era3.desc": "The sleeping giant walks with its eyes shut, hurls rocks at towers from far off and its stomp stuns; at half health it wakes and its roar frightens. Sleep moths come in swarms and put the hero they wrap to sleep. The weaver cocoons towers, poisons, and bursts into spiderlings when it dies. The ink oracle shields the ones around it with a bubble only a heavy blow or a critical bursts. The Burn wyrmling, of black glass, burns a line across the ground.",
  "news.2026-10-26-zzzzztitan.giantStep": "Giant's pass",
  "news.2026-10-26-zzzzztitan.giantStep.desc": "A new era III host: one or two giants with a small escort. The whole party on one.",
  "news.2026-10-26-zzzzztitan.conditions": "Asleep, poisoned, cocooned",
  "news.2026-10-26-zzzzztitan.conditions.desc": "A sleeping hero wakes when an ally comes close or something hits it. Poison takes a little every second. A cocooned tower doesn't fire until a hero stands by to cut the silk. These creatures also come in era III's incursions and crypts.",
  "news.2026-10-26-zzzzcitadel.title": "Creatures of the Citadel",
  "news.2026-10-26-zzzzcitadel.intro": "Once the bastion reaches era II, the titan dreams five new nightmares.",
  "news.2026-10-26-zzzzcitadel.era2": "Five era II nightmares",
  "news.2026-10-26-zzzzcitadel.era2.desc": "The peat troll knits back from any wound unless it burns. The ink beetle's shell only splits under a heavy blow, and its acid eats walls. Under the bone bannerman's banner nightmares march faster and hit harder; when it falls, they falter. The bonesinger raises the fallen around it as skeletons. The ash wyvern spits fire at a tower, which keeps burning until a hero stands by it.",
  "news.2026-10-26-zzzzcitadel.outside": "Out there too",
  "news.2026-10-26-zzzzcitadel.outside.desc": "In era II these creatures also come out in incursions and crypts.",
  "news.2026-10-26-zcreatures.title": "New creatures and war hosts",
  "news.2026-10-26-zcreatures.intro": "The titan dreams new things. From Tide II the waves bring nightmares that change how you defend, and every wave comes with a shape of its own.",
  "news.2026-10-26-zcreatures.creatures": "Four new nightmares",
  "news.2026-10-26-zcreatures.creatures.desc": "The goblin slinger throws stones at heroes from the back. Soot crows come in flocks and fly over the walls. The mourner mends those around it and its claw curses: kill it first. The shadow ogre's sweep throws heroes back and its roar frightens them: a while without striking or using skills.",
  "news.2026-10-26-zcreatures.hosts": "Every wave, a war host",
  "news.2026-10-26-zcreatures.hosts.desc": "Horde, flock, siege, procession, ambush or the common tide: each wave changes what it brings and how much. The wave clock says which host is coming, so you can ready the bastion ahead.",
  "news.2026-10-26-zcreatures.delves": "In incursions and crypts too",
  "news.2026-10-26-zcreatures.delves.desc": "The new creatures show up in incursions and in all three crypts. From Tide III an incursion's elite may be an ogre.",
  "news.2026-10-26-zcreatures.crits": "Critical hits",
  "news.2026-10-26-zcreatures.crits.desc": "Heroes sometimes land a critical: a far harder blow, with its big number. Against a stunned or held nightmare the blow is always critical: the warrior stuns and the barbarian finishes. Weapons and amulets can carry certainty, which raises the chance.",
  "news.title": "What's new",
  "news.sub": "Everything we add, change and fix, with its date.",
  "news.open": "What's new",
  "news.all": "All",
  "news.tag.new": "New",
  "news.tag.improved": "Improved",
  "news.tag.balance": "Balance",
  "news.tag.fixed": "Fixed",
  "news.unseen": "Unread",
  "news.close": "Close",
  "news.toast": "There's news: tap «What's new» to see it.",
  "news.count": "{n} changes",
  "news.empty": "Nothing in this category.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzcaravan.title": "The caravan, with no node",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzcaravan.intro": "In the saga's escorts only the caravan matters, and now it shows.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzcaravan.caravan": "Nothing to guard in the middle",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzcaravan.caravan.desc": "Escorts still had the incursion node in the middle of the clearing: far-off nightmares went to hit it, though its life counted for nothing. It is gone. Every nightmare on the clearing now comes for the caravan: the near ones straight at it, the far ones along the roads. A hero in the way still holds them.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzcaravan.balance": "A sturdier caravan",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzcaravan.balance.desc": "Since they all come for it now, the caravan has more life, and more the more heroes escort it. Escorts are about as hard as before, with four heroes too.",
  "news.2026-10-26-zzzwavexp.title": "What each wave leaves you",
  "news.2026-10-26-zzzwavexp.intro": "Each wave's report now says how much experience your hero earned.",
  "news.2026-10-26-zzzwavexp.waveXp": "Wave experience, in plain sight",
  "news.2026-10-26-zzzwavexp.waveXp.desc": "Every defended wave always gave experience: 250 if you played it live and 80 if your ghost fought it, plus 1000 for a boss. Now the damage report and the history show how much you got. A lost wave gives no experience.",
  "news.2026-10-26-zzskills.title": "Skills that come alive",
  "news.2026-10-26-zzskills.intro": "Several skills look better and read at a glance.",
  "news.2026-10-26-zzskills.skillLook": "Arrow rain, net, storm and more",
  "news.2026-10-26-zzskills.skillLook.desc": "The ranger's arrow rain marks its circle and the arrows fall and stick in the ground; the net flies open and covers the nightmare it catches. The mage's frost wall raises spikes of ice that shatter as it melts, and the storm brings its cloud and bolts. The warrior's challenge draws a line to every nightmare it calls, and the oath covers it in a dome of light. The barbarian's whirl and leap leave their trail and cracks in the ground, and the stunned see stars. It's only how they look: no skill changed what it does.",
  "news.2026-10-26.title": "The omen shows in the bastion",
  "news.2026-10-26.intro": "The day's weather shows as soon as you come in.",
  "news.2026-10-26.omenSky": "The bastion under the day's omen",
  "news.2026-10-26.omenSky.desc": "The bastion takes on the light and weather of the day's omen, lightly. It is only the look: the omen still changes incursions and the crypt, not the waves.",
  "news.2026-10-26.helpPhone": "On a phone, helping on a build no longer covers the screen",
  "news.2026-10-26.helpPhone.desc": "While your hero helps, the build's sheet stays small: the clock and the button to stop helping. You can see the build and the circle where you help.",
  "news.2026-10-25-zzzzglass.title": "The colossus can't hide in the glass",
  "news.2026-10-25-zzzzglass.intro": "In Obsidiana, the colossus could end up off the path, where no hero could reach it.",
  "news.2026-10-25-zzzzglass.glass": "Nightmares stay on the path",
  "news.2026-10-25-zzzzglass.glass.desc": "A nightmare chasing a hero no longer steps onto ground heroes can't stand on: it goes around by the path. And if one ends up out there anyway, it comes back on its own.",
  "news.2026-10-25-zzzlive.title": "Going together pays",
  "news.2026-10-25-zzzlive.intro": "Three going live brought nearly half of what three apart did. Not anymore.",
  "news.2026-10-25-zzzlive.together": "Each live friend brings their share",
  "news.2026-10-25-zzzlive.together.desc": "In a live incursion, each friend who joins brings their whole share of what the place gives (it was 30 % more) and spends one of their runs of the day. Three together bring as much as three apart, and everyone gets the same experience, the embers or shards and the chance of a piece.",
  "news.2026-10-25-zzdust.title": "Where the dust goes",
  "news.2026-10-25-zzdust.intro": "What is spent at the forge now shows beforehand and stays in the log.",
  "news.2026-10-25-zzdust.price": "Reforging tells you what the next one costs",
  "news.2026-10-25-zzdust.price.desc": "Each reforge of the same piece costs more than the last. The forge now shows the price now and the next one, reminds you it is all paid with everyone's dust and how much is left after, and warns in red when a single reforge takes a good part of it.",
  "news.2026-10-25-zzdust.log": "The forge in the log",
  "news.2026-10-25-zzdust.log.desc": "Forging, reforging, carving, tempering, opening settings and setting gems now show in the log: who, on which piece and how much dust it took.",
  "news.2026-10-25-zparty.title": "The party stays out of the way",
  "news.2026-10-25-zparty.intro": "On phones, the party list no longer opens and closes when you mean to move or shoot.",
  "news.2026-10-25-zparty.strip": "The party as a strip",
  "news.2026-10-25-zparty.strip.desc": "On phones, the party is a row of chips under the wave bar that taps go straight through. Those doing fine are dimmed, anyone in trouble shows in red, and a fallen hero shows the seconds left. When the cleric readies a heal, the full list opens so you can touch who to heal.",
  "news.2026-10-25-wide.title": "The crypts stay open",
  "news.2026-10-25-wide.intro": "If others already went down, you can still go in.",
  "news.2026-10-25-wide.rooms": "Several runs in the same crypt",
  "news.2026-10-25-wide.rooms.desc": "Before, while a party was inside a crypt, the button to go down did nothing for everyone else. Now another entrance opens beside it: the rest of the group gathers there and goes down on their own.",
  "news.2026-10-25-way.title": "The crypt shows the way",
  "news.2026-10-25-way.intro": "No more hunting for the next door.",
  "news.2026-10-25-way.way": "An arrow to the next room",
  "news.2026-10-25-way.way.desc": "Once a room is cleared, a red arrow marks the door to the next one (or to the guardian). If the door is out of view, the arrow waits at the edge of the screen, pointing toward it. In the deep crypt, after each guardian, it marks the stairs and the way out.",
  "news.2026-10-25-tide.title": "Harder waves late in the Tide",
  "news.2026-10-25-tide.intro": "A Tide's last waves are harder than its first ones again.",
  "news.2026-10-25-tide.ink": "More inked nightmares once a wave is already huge",
  "news.2026-10-25-tide.ink.desc": "Past a certain size, a wave doesn't bring more nightmares: it brings more inked ones, tougher and faster. Before, on a very large bastion, waves stopped growing and the Tide went flat.",
  "news.2026-10-25-target.title": "Aiming on PC",
  "news.2026-10-25-target.intro": "On PC, skills show where they go before they leave your hands.",
  "news.2026-10-25-target.aim": "Hold the key to aim",
  "news.2026-10-25-target.aim.desc": "With Q, W or E held, you see the reach around your hero and where the skill lands (or whom it takes). It goes when you let go; Esc or right click cancels it. A quick tap still casts at once, as before.",
  "news.2026-10-25-target.hover": "The nightmare under the cursor is marked",
  "news.2026-10-25-target.hover.desc": "A red ring under the nightmare your mouse is on: you know whom you are hitting before you press.",
  "news.2026-10-25-armory.title": "The armory",
  "news.2026-10-25-armory.intro": "Gear and relics have much more to do, and the dust, embers and shards that kept piling up are finally worth something.",
  "news.2026-10-25-armory.effects": "Eight new rare effects",
  "news.2026-10-25-armory.effects.desc": "Fury, Executioner, Chain lightning, Frost, Cleave, Guard, Echo and Banner join the four from before. Every piece says what it does, with its numbers, and you can see them in the fight.",
  "news.2026-10-25-armory.reforge": "Reforge",
  "news.2026-10-25-armory.reforge.desc": "At the forge, turn one attribute of a piece into another it lacks, for dust. The forged pluses move to the new one; each reforge of the same piece costs more.",
  "news.2026-10-25-armory.gems": "Settings and gems",
  "news.2026-10-25-armory.gems.desc": "Obsidian shards open a setting in a rare piece; crystal from the storage sets a gem in it: ruby, garnet, sapphire, amethyst or onyx.",
  "news.2026-10-25-armory.awaken": "Awakened relics",
  "news.2026-10-25-armory.awaken.desc": "Each relic can be awakened at the forge with shards, embers and dust: it does the same, stronger. And a relic you already have melts into embers.",
  "news.2026-10-25-armory.offerings": "Offerings at the keep",
  "news.2026-10-25-armory.offerings.desc": "The group burns dust from the storage for a blessing on the rest of the Marea: blessed oil (towers), dream mortar (walls) and vigil (spectres). They burn by the keep.",
  "news.2026-10-25-armory.pace": "Keeping pace",
  "news.2026-10-25-armory.pace.desc": "If your hero is more than 2 levels below the group's average, it earns double experience until it catches up.",
  "news.2026-10-25-armory.board": "This board",
  "news.2026-10-25-armory.board.desc": "Everything we add, change and fix stays here, with its date. What you haven't read is marked.",
  "news.2026-10-25-armory.gifts": "Gift to whoever needs it",
  "news.2026-10-25-armory.gifts.desc": "When gifting a piece, whoever needs it shows first, and why: an empty slot, or better than theirs.",
  "news.2026-10-25-armory.cards": "The forge, tidied",
  "news.2026-10-25-armory.cards.desc": "Temper, carve, reforge and set now sit together under «More at the forge» on each piece, with the price in sight.",
  "news.2026-10-25-armory.stack": "A repeated effect is worth less",
  "news.2026-10-25-armory.stack.desc": "A second piece with the same effect is worth 60 % and a third 30 %: three thorns give 190 % instead of 300 %. Mixing effects pays more.",
  "news.2026-10-25.title": "Marea III: Obsidian",
  "news.2026-10-25.intro": "The third Marea opens level III, the deep crypt and the saga of the Turtle.",
  "news.2026-10-25.obsidian": "Level III · Obsidian and the deep crypt",
  "news.2026-10-25.obsidian.desc": "Glass that cracks under your feet, the obsidian colossus and a three-floor crypt with a puzzle on each.",
  "news.2026-10-25.saga": "The saga of the Turtle",
  "news.2026-10-25.saga.desc": "A story in chapters the whole group moves forward, with its own choices and fights.",
  "news.2026-10-25.omens": "Omens you can see",
  "news.2026-10-25.omens.desc": "The day's omen changes the incursions and the crypt, and shows on screen. There are more of them than you have met.",
  "news.2026-10-25.cap": "Level cap 50",
  "news.2026-10-25.cap.desc": "Heroes no longer stop at level 11.",
  "news.2026-10-25.lag": "Less waiting in live play",
  "news.2026-10-25.lag.desc": "Your hero starts walking as soon as you tap, without waiting for the rest of the room.",
  "news.2026-10-25.thorns": "Thorns gave back 1 per blow",
  "news.2026-10-25.thorns.desc": "Now they give back a share of your attack.",
  "news.2026-10-25.deepStuck": "A dropped player stalled the deep crypt",
  "news.2026-10-25.deepStuck.desc": "The stairs, the exit and the glass bridge now wait only for those still playing.",
  "news.2026-10-25.cryptScroll": "The crypt's end screen didn't scroll on phones",
  "news.2026-10-25.cryptScroll.desc": "The loot window now scrolls.",
  "news.2026-10-24.title": "New classes, Embers and eras",
  "news.2026-10-24.intro": "Three classes, level II incursions and a bastion that grows into districts.",
  "news.2026-10-24.classes": "Barbarian, paladin and druid",
  "news.2026-10-24.classes.desc": "Three new classes, each with its tree, its building in the bastion and its spectre.",
  "news.2026-10-24.ascuas": "Embers: level II incursions and the crypt in embers",
  "news.2026-10-24.ascuas.desc": "Lava cracks, eruptions and the Magma Lord. They give embers to temper gear at the forge.",
  "news.2026-10-24.eras": "Bastion eras",
  "news.2026-10-24.eras.desc": "The Great Work on the keep raises walled districts, each with its own character.",
  "news.2026-10-24.push": "Alerts before each wave",
  "news.2026-10-24.push.desc": "Ten minutes before each wave an alert reaches your phone or computer, if you turn it on; tapping it opens the campaign.",
  "news.2026-10-24.halloween": "Seasons: Halloween",
  "news.2026-10-24.halloween.desc": "Pumpkins, costumes and a festive bastion while it lasts.",
  "news.2026-10-24.smooth": "Smooth movement",
  "news.2026-10-24.smooth.desc": "Heroes and nightmares move without jumps between steps.",
  "news.2026-10-24.minis": "Miniatures by level",
  "news.2026-10-24.minis.desc": "Your hero changes look at levels 4, 7 and 10.",
  "news.2026-10-24.repairAll": "Damage at a glance and «Repair all»",
  "news.2026-10-24.repairAll.desc": "What's broken is marked in the bastion and repaired at once.",
  "news.2026-10-24.mercs": "Barracks and mercenaries remade",
  "news.2026-10-24.mercs.desc": "Hired for the whole bastion; the barracks' level sets how many and how strong, and they grow with each Marea.",
  "news.2026-10-24.relics": "Relics within reach",
  "news.2026-10-24.relics.desc": "More bosses give them, and with both slots full they wait in reserve.",
  "news.2026-10-24.rareFx": "Rare gear effects did nothing",
  "news.2026-10-24.rareFx.desc": "Burn, lifesteal, thorns and swift step now reach the fight.",
  "news.2026-10-23.title": "A new tree and the cleric",
  "news.2026-10-23.intro": "Skills that change how each class plays, and much to read the bastion better.",
  "news.2026-10-23.tree": "New skill tree",
  "news.2026-10-23.tree.desc": "One branch per skill and one for the bastion; each ends in a fork that changes how it works. Starting over is free on level-up.",
  "news.2026-10-23.cleric": "New class: the cleric",
  "news.2026-10-23.cleric.desc": "Heals, shields and raises the fallen.",
  "news.2026-10-23.classChange": "Change class",
  "news.2026-10-23.classChange.desc": "You can start another hero in the same campaign.",
  "news.2026-10-23.countdown": "Wave countdown",
  "news.2026-10-23.countdown.desc": "A big clock in the waiting room, with drums in the last seconds.",
  "news.2026-10-23.golems": "Golems in sight",
  "news.2026-10-23.golems.desc": "What each golem does, what waits in line and where more come from.",
  "news.2026-10-23.ranges": "Tower reach and plans before building",
  "news.2026-10-23.ranges.desc": "Picking a building shows its reach on the cell before you confirm it.",
  "news.2026-10-23.forge": "The forge: you pick what goes up",
  "news.2026-10-23.forge.desc": "And the piece burns brighter with each plus.",
  "news.2026-10-23.names": "Names over the miniatures",
  "news.2026-10-23.names.desc": "Yours highlighted, spectres in turquoise and mercenaries in violet.",
  "news.2026-10-23.ghosts": "Spectres go where the danger is",
  "news.2026-10-23.ghosts.desc": "They guard gates and broken walls according to the nightmares coming.",
  "news.2026-10-23.walls": "Heroes walked through the wall",
  "news.2026-10-23.walls.desc": "Now they only pass through gates and breaches.",
  "news.2026-10-23.loot": "Fairer warlord loot",
  "news.2026-10-23.loot.desc": "It goes to whoever needs it most, not to whoever landed the last blow.",
  "news.2026-10-23.flyers": "The warrior's Challenge brings flyers down",
  "news.2026-10-23.flyers.desc": "Flyers no longer ignore the taunt.",
  "news.2026-10-25-armory.buildCards": "Build cards you can read in full",
  "news.2026-10-25-armory.buildCards.desc": "Names and materials are no longer cut off, and what's locked says why. On phones each card is a row.",
  "news.2026-10-25-armory.waitRoom": "The waiting room, only at the end",
  "news.2026-10-25-armory.waitRoom.desc": "«Wait for the wave live» shows up in the last 10 minutes, not two hours before.",
  "news.2026-10-25-armory.descend": "\"Down, or back?\", clearer",
  "news.2026-10-25-armory.descend.desc": "In the deep crypt the two choices sit side by side with what each brings and the risk of going down, and fill as the group stands on one.",
  "news.2026-10-25-armory.glassBridge": "The glass bridge no longer lies",
  "news.2026-10-25-armory.glassBridge.desc": "Walking the marked path, heroes sometimes fell anyway: they cut across the corner of a glass tile. Now they step tile to tile, and tapping a lit tile walks back along the path.",
  "news.2026-10-25-armory.meleeChase": "Melee heroes go after them",
  "news.2026-10-25-armory.meleeChase.desc": "Warrior, barbarian and paladin, left standing, go after a nightmare up to 3 tiles away on their own and then come back. Bosses they only chase up close, so you can still walk away.",
  "dtype.physical": "physical",
  "dtype.fire": "fire",
  "dtype.frost": "frost",
  "dtype.lightning": "lightning",
  "dtype.acid": "acid",
  "dtype.poison": "poison",
  "dtype.shadow": "shadow",
  "dtype.holy": "holy",
  "ailment.ashCurse": "Ash curse",
  "ailment.ashCurse.desc": "The witch left her ash in you: −15 % max health in every fight.",
  "ailment.dread": "Dread",
  "ailment.dread.desc": "The giant left fear in your bones: you start every fight frightened for a second and a half.",
  "ailment.graveDust": "Grave dust",
  "ailment.graveDust.desc": "The Warden's marked blows filled you with grave dust: −10 % attack speed in every fight.",
  "ailment.cinders": "Cinders in the bones",
  "ailment.cinders.desc": "The magma lord's eruptions left embers inside you: fire deals you 15 % more damage.",
  "ailment.glassBlood": "Glass in the blood",
  "ailment.glassBlood.desc": "The obsidian colossus's slam left glass in your blood: blows deal you 10 % more damage.",
  "ailment.left": "Wears off in {t}.",
  "ailment.cureSelf": "Cure myself (cleric)",
  "ailment.cureTemple": "Cure at the Temple · {n} dust",
  "ailment.how": "A cleric friend can cure it, or the Temple if the bastion has one.",
  "ailment.friends": "Friends to cure",
  "ailment.clericRest": "Your next cure, in {t}.",
  "ailment.cureFriend": "Cure",
  "log.ailment": "{who} came away with {a}",
  "log.ailment.you": "You came away with {a}",
  "log.cureCleric": "{who} cured {to} ({a})",
  "log.cureCleric.you": "You cured {to} ({a})",
  "log.cureClericXp": "{who} cured {to} ({a}), +{x} XP",
  "log.cureClericXp.you": "You cured {to} ({a}), +{x} XP",
  "log.cureTemple": "{who} paid the Temple to cure {to} ({a}), −{d} common dust",
  "log.cureTemple.you": "You paid the Temple to cure {to} ({a}), −{d} common dust",
  "lab.ward": "Warding elixir",
  "lab.ward.desc": "+{n} % against the damage type the omen names (a little against all of them if it names none).",
  "saga.wall.ruins.l4": "And no, I won't talk about that night. Go down.",
  "saga.wall.ruins.l5": "I'll keep the stair. Go down.",
  "saga.wall.ruins.c.go.desc": "Three dark halls to the armory door. What stayed down there won't let you through.",
  "saga.wall.gaspar.l5": "Hold this door with me. Afterwards, if you want, I'll tell you why I shut the gate.",
  "saga.wall.gaspar.l6": "Don't listen to him. Let the dead rest.",
  "saga.wall.armory.l1": "The captain falls and crumbles into dream dust. The old barracks goes quiet.",
  "saga.wall.armory.l2": "That night the nightmares came mixed in with the village folk. If I opened, they all came in.",
  "saga.wall.armory.l3": "I shut it. And still the fortress fell, from within. Someone knows how.",
  "saga.wall.armory.l4": "When you turn around, the spectre is gone. Brann doesn't say a word.",
  "saga.wall.armory.l5": "The old garrison's weapons are still in the armory, whole under the dust. There is one for each of you.",
  "saga.wall.armory.l6": "Take them. Use them better than we did.",
  "saga.wall.armory.c.take": "Take the weapons",
  "saga.wall.armory.c.take.desc": "Every guardian who played an act of this chapter gets their class's unique weapon.",
  "saga.maelis.remedies.l1": "The Witch falls to her knees. The ash peels off her like an old cloak, and a tired woman is left.",
  "saga.maelis.remedies.l2": "Ilse opened the door. My daughter. And I blamed the Order for forty years.",
  "saga.maelis.remedies.l3": "When what comes from the Burn comes, I'll be there.",
  "saga.maelis.remedies.l4": "This doesn't end here. What comes from the Burn is worse than me.",
  "saga.maelis.remedies.l5": "When the ash settles, she is gone. Her remedies are left: jars of a frost that never melts. There are enough for everyone.",
  "saga.maelis.remedies.c.take": "Take the remedies",
  "saga.maelis.remedies.c.take.desc": "Every guardian who played an act of this chapter gets the whole Frost glyph (one who has it already, another conversion glyph they lack).",
  "reforge.uniqueHint": "A unique piece is reforged by choice: tap the attribute to change, then what it becomes. The piece sets its number (the ones that grow with your level follow it); the forged + stay.",
  "reforge.into": "Becomes:",
  "saga.result.continue": "Continue the story",
  "saga.result.chapterTitle": "Chapter complete",
  "saga.deep.forge.l1": "Back at the bastion, Hilde lights the forge with what you brought up from the Deep.",
  "saga.deep.forge.l2": "Brann and I are going to have a talk. But first, this.",
  "saga.deep.forge.l3": "You found nothing, I know. You brought something back anyway.",
  "saga.deep.forge.l4": "A mark of my clan, carved for each of you. Lightning splits what the cold makes brittle: anyone in the Deep knows that.",
  "saga.deep.forge.c.take": "Take the mark",
  "saga.deep.forge.c.take.desc": "Every guardian who played an act of this chapter gets the whole Storm glyph (one who has it already, another conversion glyph they lack).",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzquests.title": "Uniques to fit you and a clearer chronicle",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzquests.intro": "The saga's unique pieces can be fitted to your role, and the chapters tell better what is going on and why.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzquests.uniques": "Reforge your uniques",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzquests.uniques.desc": "At the forge, a unique piece is reforged by choice: pick the attribute to change and what it becomes, keeping its value and forged pluses. A tank can trade their weapon's attack speed for life or armor.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzquests.story": "Chapters that close",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzquests.story.desc": "“What Was Left on the Wall” explains better why you go down to the old barracks, who waits below and why you have to fight, and ends with a scene in the armory. Every chapter that gives a unique piece now closes with a scene that tells where it comes from.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzquests.flow": "From the fight to the story",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzquests.flow.desc": "When you win an act, “Continue the story” opens the next scene right away. When a chapter ends you see what the group earned before going on.",
  "exp.label": "Group expedition",
  "exp.title": "The garrison cellars",
  "exp.sub": "Go down the courtyard well and bring up the gate bell.",
  "exp.pitch": "Under the courtyard, shut since the Night of the Gate: the cisterns, the powder store and the watch tower. You go down together to the great floodgate, split up one per wing, and meet again to bring up the gate bell.",
  "exp.factParty": "For {min} to {max} guardians connected at once.",
  "exp.factOnline": "{n} connected right now.",
  "exp.factOnlineOne": "Right now you are the only one connected.",
  "exp.factGathering": "Already gathering at the well: {names}",
  "exp.factDrop": "If someone drops out and isn't back within {s} seconds, the run is lost.",
  "exp.factReward": "One chest a day for each of you: a rare piece, experience, dream dust for the store and a chance at a relic.",
  "exp.factClaimed": "You already opened today's cellars chest: going down again earns experience for the locks.",
  "exp.go": "Gather at the well",
  "exp.onlineOnly": "Online campaigns only: it takes {min} to {max} guardians connected at once.",
  "exp.closed": "The cellars are not open right now.",
  "exp.full": "They have gone down already or there are four: wait until they come up.",
  "exp.someone": "Someone",
  "party.cellars": "Gathering at the courtyard well: {names}",
  "log.cellarsWon": "The group brought the gate bell up from the cellars ({names})",
  "log.cellarsLost": "The group went down to the cellars and came back without the bell ({names})",
  "exp.scene.o1": "By the courtyard well a dwarf is waiting for you, her apron scorched and a coil of rope on her shoulder.",
  "exp.scene.o2": "I'm Hilde, the smith of the forge. The rope is for you.",
  "exp.scene.o3": "Down there, behind the floodgate of the great cistern, lies the gate bell.",
  "exp.scene.o4": "It rang the alarm the whole Night of the Gate. When the tower fell, it sank into the water.",
  "exp.scene.o5": "The well goes down to the garrison cellars: cisterns, a powder store and a watch tower, shut since that night.",
  "exp.scene.o6": "No bell, no alarm. The next Tide walks in and nobody hears it.",
  "exp.scene.o7": "My clan cast it. Bring it back whole.",
  "exp.scene.go": "Go down the well",
  "exp.scene.later": "Not now",
  "exp.scene.w1": "The bell comes up the well dripping black water. Hilde takes it with both hands.",
  "exp.scene.w2": "Whole. As ugly as my grandfather left it, but whole.",
  "exp.scene.w3": "That night it hangs again in the bastion's bell tower, above the gate.",
  "exp.scene.w4": "Let the Tide come. Now they'll hear it all the way to Musgoviejo.",
  "exp.scene.ink1": "The ink filled the great cistern before the bell reached the winch. You came up without it.",
  "exp.scene.ink2": "It's still down there. The ink drains in a few days: we try again.",
  "exp.scene.fallen1": "You all fell in the cellars. Hilde hauled you up the well one by one with her rope.",
  "exp.scene.fallen2": "The bell has waited forty years. It can wait for you to heal.",
  "exp.scene.gone1": "{name} didn't come back in time, and with fewer you can't go on: you came up the well.",
  "exp.scene.gone2": "Down there it takes all of you. Next time, go down together and come up together.",
  "exp.scene.other1": "You came up the well without the bell.",
  "exp.lobby": "At the courtyard well",
  "exp.needOne": "One more to go down: it takes {min} connected.",
  "exp.needMany": "{n} more to go down: it takes {min} connected.",
  "exp.ready": "{n} of {max}: you can go down.",
  "exp.lobbyHint": "{min} to {max} go down. Below, you split up the wings. If someone drops out and isn't back within {s} s, the run is lost.",
  "exp.enter": "Go down",
  "exp.claimedTip": "Already opened today's cellars chest: a win only brings experience.",
  "exp.area.entry": "The way down",
  "exp.area.guard": "Guard room",
  "exp.area.hub": "The great floodgate",
  "exp.area.cisternA": "Cisterns",
  "exp.area.cisternB": "Cisterns",
  "exp.area.towerA": "Watch tower",
  "exp.area.towerB": "Watch tower",
  "exp.area.powderA": "Powder store",
  "exp.area.powderB": "Powder store",
  "exp.area.cells": "Cells",
  "exp.area.cistern": "Great cistern",
  "exp.area.winch": "Well winch",
  "exp.wing.cistern": "Cisterns",
  "exp.wing.tower": "Tower",
  "exp.wing.powder": "Powder store",
  "exp.wing.cells": "Cells",
  "exp.wingShort.cistern": "Cisterns",
  "exp.wingShort.tower": "Tower",
  "exp.wingShort.powder": "Powder",
  "exp.wingShort.cells": "Cells",
  "exp.goal.entry": "Go down together: the guard room waits below.",
  "exp.goal.guard": "Clear the room: then the way to the great floodgate opens.",
  "exp.goal.split": "Split up, one per wing: each wing opens one lock of the floodgate.",
  "exp.goal.wheels": "Turn both wheels to lower the water: the powder store's passage is flooded. ({k}/{n})",
  "exp.goal.cisternWait": "The water is down. The lock's grate is raised by the tower's lever.",
  "exp.goal.cisternGo": "The grate is up: go to the lock at the back of the cisterns.",
  "exp.goal.lever": "Stay at the lever to raise the cisterns' grate.",
  "exp.goal.rubble": "Rubble blocks the stair: a barrel from the powder store will blow it.",
  "exp.goal.towerGo": "The stair is clear: climb to the tower's lock.",
  "exp.goal.barrel": "Take a barrel from the stack and carry it to the rubble on the tower's stair. Put it down there and step back.",
  "exp.goal.barrelHeld": "Carry the barrel to the tower's stair and put it down by the rubble. If it takes too many blows, it goes off.",
  "exp.goal.powderWait": "The passage below is flooded: the cisterns' wheels will drain it.",
  "exp.goal.powderGo": "The water is down: go down to the powder store's lock.",
  "exp.goal.lock": "Stay by the lock to open it.",
  "exp.goal.lockDone": "Lock open. Go back to the great floodgate or help another wing.",
  "exp.goal.key": "The lock's key is here: carry it to the great floodgate and put it down by the gate.",
  "exp.goal.keyHeld": "Carry the key to the great floodgate and put it down by the gate.",
  "exp.goal.bell": "The bell lies by the water and something guards it. Two of you carry it to the winch in the middle of the great floodgate.",
  "exp.goal.bellOne": "The bell is heavy: it takes two.",
  "exp.goal.bellMove": "Take it to the winch and put it down beside it: it hangs on the hook.",
  "exp.goal.winch": "Someone stays at the winch until it is up. The rest, hold on.",
  "exp.goal.down": "You're down. If nobody comes, you get up at the great floodgate in {n} s.",
  "exp.ws.line": "{wing} · {k}/2: {what}",
  "exp.ws.done": "{wing} · lock open",
  "exp.ws.who": "{names}",
  "exp.ws.nobody": "nobody",
  "exp.ws.cistern1": "turn the wheels",
  "exp.ws.tower1": "pull the lever",
  "exp.ws.powder1": "blow the rubble",
  "exp.ws.cells1": "bring the key",
  "exp.ws.cisternWait": "waits for the tower's lever",
  "exp.ws.towerWait": "waits for the powder store's barrel",
  "exp.ws.powderWait": "waits for the cisterns' water",
  "exp.ws.lock": "open the lock",
  "exp.locks": "Locks",
  "exp.falls": "Falls: {n}",
  "exp.fallsTip": "Each fall brings the ink {s} s sooner.",
  "exp.ink": "Ink",
  "exp.inkTip": "If the ink fills the cistern before the bell is up, the run is lost.",
  "exp.away": "{name} dropped out: {n} s to come back",
  "exp.upIn": "Up in {n} s",
  "exp.reviveHint": "Pick up {name} ({n} s)",
  "exp.carry": "Carry",
  "exp.drop": "Put down",
  "exp.carryTip": "Pick up what is at hand (a barrel, the key, the bell) or put down what you carry. Carrying, you walk slower and don't strike; skills still work. To pass it on, put it down near a friend.",
  "exp.nothingNear": "Nothing at hand to carry.",
  "exp.ev.guard": "The guard room is clear: the way to the great floodgate opens.",
  "exp.ev.wheel": "The cisterns turned a wheel ({k}/{n}).",
  "exp.ev.cisternB": "The tower raised the grate: the cisterns' lock can be reached.",
  "exp.ev.powderB": "The water is down: the powder store's passage can be crossed.",
  "exp.ev.towerB": "The rubble is blown: the tower's stair is clear.",
  "exp.ev.gate": "The last lock is off: the floodgate opens and the ink starts to rise.",
  "exp.ev.lock": "The {wing} lock is open ({k} of {n}).",
  "exp.ev.fuse": "The fuse is lit by the rubble: get back, it goes off in {s} s.",
  "exp.ev.barrelBurst": "The barrel went off too soon. The powder stack has another.",
  "exp.ev.hooked": "The bell is on the winch's hook: someone turn it.",
  "exp.ev.raised": "The bell goes up the well.",
  "exp.ev.fallen": "{name} is down: if nobody comes, they get up at the floodgate in {n} s. Each fall brings the ink {s} s sooner.",
  "exp.ev.gone": "{name} dropped out: {n} s to come back.",
  "exp.way.guard": "Way open",
  "exp.way.gate": "The floodgate",
  "exp.way.cisternB": "Grate up",
  "exp.way.powderB": "Passage dry",
  "exp.way.towerB": "Stair clear",
  "exp.way.fuse": "Get back!",
  "exp.way.rubble": "The rubble",
  "exp.way.gateLock": "The floodgate",
  "exp.way.bell": "The bell",
  "exp.way.winch": "The winch",
  "exp.end.see": "See what you earned",
  "exp.end.won": "The bell is back",
  "exp.end.wonSub": "It hangs again in the bastion's bell tower.",
  "exp.end.lost": "Without the bell",
  "exp.end.why.ink": "The ink got there first.",
  "exp.end.why.fallen": "You all fell.",
  "exp.end.why.gone": "{name} dropped out and didn't come back in time.",
  "exp.end.why.other": "You came up before bringing the bell.",
  "exp.end.party": "What each one earned",
  "exp.end.chest": "{name}: the day's chest (a rare piece, {xp} experience and a chance at a relic).",
  "exp.end.locksXp": "{name}: {xp} experience for the locks.",
  "exp.end.nothing": "{name}: nothing this time.",
  "exp.end.taken": "Already opened today's chest.",
  "exp.end.trophy": "The group has brought up the bell {n} times ({f} without a fall).",
  "allies.in.expedition": "in the cellars",
  "exp.goal.downTogether": "You are down. Down here only a friend standing by you gets you up.",
  "exp.ev.fallenTogether": "{name} is down: stand by them to get them up.",
  "exp.upTogether": "Wait for a friend",
  "exp.reviveTogether": "Get {name} up",
  "exp.trophy.label": "Trophy of the cellars",
  "exp.trophy.title": "The gate bell",
  "exp.trophy.count": "Brought up {n} times · {f} with nobody falling.",
  "exp.trophy.notYet": "Still at the bottom of the great cistern. Bring it up and it will hang from the keep.",
  "exp.trophy.hung": "Hangs from the keep",
  "exp.trophy.hungHow": "Bring it up once.",
  "exp.trophy.banners": "The old garrison’s banners",
  "exp.trophy.bannersHow": "Bring it up {need} times ({n} of {need}).",
  "exp.trophy.sash": "The red sash",
  "exp.trophy.sashHow": "Bring it up with nobody falling.",
  "exp.trophy.new": "The gate bell hangs from the keep again. Tap the keep to hear it.",
  "exp.trophy.newBanners": "The old garrison’s banners hang beside the bell.",
  "exp.trophy.newSash": "The bell wears the red sash: brought up with nobody falling.",
  "exp.trophy.countOne": "Brought up once · {f} with nobody falling.",
  "exp.sceneAgain": "Hear Hilde again",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzcellars.title": "Group expedition: the garrison cellars",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzcellars.intro": "From Tide III there is a new outing that can only be played with 3 or 4 guardians connected at once.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzcellars.cellars": "New: the garrison cellars",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzcellars.cellars.desc": "Under Incursions, below the crypt. You go down the courtyard well together, split up through the wings (cisterns, powder store, watch tower and, with four, the cells), and what each one does opens the way for someone else. At the end you meet again to raise the gate bell before the ink fills the cistern. Anyone who drops out has 45 seconds to come back. One chest a day each.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzcellars.carry": "New: carrying things",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzcellars.carry.desc": "«Carry» button (key C): powder kegs, a key, the bell between two. With your hands full you walk slower and don’t strike, but skills work. To hand something to a friend, put it down beside them.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzcellars.trophy": "New: a trophy in the bastion",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzcellars.trophy.desc": "Once it is up, the bell hangs from the keep for the whole group, and it earns banners and a sash as you bring it up again. Tap the keep to see what is left.",
  "reason.voting": "The group is still voting on what came before: the scene goes on once it's decided.",
  "reason.noVote": "That vote is already closed.",
  "reason.notDone": "That chapter isn't finished yet.",
  "push.vote.title": "The group is voting in the chronicle",
  "push.vote.body": "{name}: {who} reached a decision. Come vote and talk it over.",
  "log.saga.vote": "{who} put a decision of the chronicle to the vote",
  "log.saga.decided": "The group decided in the chronicle",
  "log.saga.rerun": "{who} played a chapter of the chronicle again",
  "saga.vote.title": "Vote",
  "saga.vote.what": "{who} reached a decision in «{title}». The group decides: the most voted wins.",
  "saga.vote.closes": "It closes when one side has {need} votes or everyone has voted. Otherwise, in {h} h the most voted wins.",
  "saga.vote.closesNow": "The day is over: it closes with the votes it has as soon as someone comes in.",
  "saga.vote.cast": "See the scene and vote",
  "saga.vote.change": "See the scene or change your vote",
  "saga.vote.waits": "The next scene waits for the group to finish voting. Battles can be played meanwhile.",
  "saga.vote.opens": "The group decides: your vote opens the vote and the story goes on meanwhile. On a tie, yours wins.",
  "saga.vote.pick": "Pick a side to vote.",
  "saga.vote.yours": "Your vote is marked. You can change it until it closes.",
  "saga.vote.done": "Done",
  "saga.vote.chat": "Talk it over with the group",
  "saga.vote.chatEmpty": "Nobody has said anything yet.",
  "saga.vote.chatHint": "Tell the group what you think",
  "saga.vote.group": "The group decides",
  "saga.vote.closedTitle": "The group has decided",
  "saga.vote.count": "{n} of {of} voted",
  "saga.vote.missing": "Still to vote: {names}",
  "saga.vote.you": "you",
  "saga.vote.mine": "Your vote",
  "saga.vote.decided": "The group's choice",
  "saga.vote.sending": "Voting…",
  "saga.vote.say": "Say",
  "saga.rerun.title": "Play again",
  "saga.rerun.hint": "A finished chapter, start to end, for whoever missed it. Friends can come along to the fights: they get a call to join, and if they win the last fight with you they get the unique piece of their class they lack. The group already made its decisions: you see them, they don’t change.",
  "saga.rerun.goOn": "Go on with «{title}» (act {n} of {of})",
  "saga.rerun.gainXp": "Experience, since you didn't play this chapter",
  "saga.rerun.gainStory": "Just the story",
  "saga.rerun.kicker": "Again",
  "saga.rerun.chosen": "The group chose this",
  "saga.rerun.chosenBy": "The group chose this. Voted: {names}",
  "saga.rerun.decided": "The group already decided.",
  "saga.rerun.stillVoting": "The group is still voting on it.",
  "saga.rerun.onward": "The story goes on: your replay is kept act by act.",
  "saga.rerun.lost": "Playing again, losing costs nothing: try again whenever you like.",
  "saga.rerun.doneTitle": "Chapter played again",
  "saga.rerun.doneXp": "You earned {xp} experience for the chapter you had missed.",
  "saga.rerun.doneStory": "You already had what this chapter gives: this time it was just for the story.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzvote.title": "The chronicle, together",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzvote.intro": "Finished chapters can be played again, and the group votes on decisions.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzvote.rerun": "Play a chapter again",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzvote.rerun.desc": "From the chronicle, any finished chapter can be played again start to end, alone: the scenes as they were and their battles. The group's decisions show, with who voted what, but they don't change. If you had missed it, it gives you its experience and your class's unique piece. Losing a battle costs no provisions.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzvote.vote": "Decisions go to a vote",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzvote.vote.desc": "Whoever reaches a decision opens the vote with theirs, and the rest get a notice. The scene shows the votes and has a chat to talk it over. The most voted wins: it closes when one side has the group's majority or after a day, and on a tie whoever opened it decides. Battles can be played meanwhile; the next scene waits for the vote.",
  "party.rerun": "{name} is playing chapter {n} again and wants help",
  "party.side": "{name} is heading into {title} and wants help",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzrerun.title": "Play it again, with friends",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzrerun.rerun": "Replay a chapter with company",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzrerun.rerun.desc": "The fights of a chapter you play again can now be done with friends: they get a call to join, and if nobody comes you can go alone. If you lose, you go back to the bastion instead of straight into the same act.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzrerun.intro": "For whoever missed a chapter of the saga.",
  "host.general.pending": "An enemy general gathers an army",
  "host.general.air": "An enemy general: wings on the horizon",
  "host.general.siege": "An enemy general: siege engines creak",
  "host.general.range": "An enemy general: bows and slings in the mist",
  "host.general.swarm": "An enemy general: a countless horde",
  "host.general.heavy": "An enemy general: heavy footsteps in the mist",
  "host.general.foot": "An enemy general: close ranks on foot",
  "host.general.mixed": "An enemy general: a bit of everything",
  "news.2026-10-27-mammoth.title": "Ash mammoth",
  "news.2026-10-27-mammoth.intro": "Something huge is walking toward the citadel.",
  "news.2026-10-27-mammoth.mammoth": "New: Ash mammoth",
  "news.2026-10-27-mammoth.mammoth.desc": "From era II a huge, slow beast that is very hard to kill can come. It never looks at a hero and can't be stunned or taunted: it walks straight for the keep and flattens the walls and towers in its way. It comes one or two to a sector. Fire scares it: oil in its way turns it back for a while, trampling the nightmares beside it.",
  "news.2026-10-27-general.title": "The general thinks",
  "news.2026-10-27-general.intro": "The enemy general no longer just waits for its moment.",
  "news.2026-10-27-general.army": "The general builds its army",
  "news.2026-10-27-general.army.desc": "On waves with a plan, the general looks at the bastion as you left it and picks, one by one, the nightmares it brings to break it. The further the campaign goes, the better it thinks. The omen only gives a hint of what is coming.",
  "news.2026-10-27-general.moves": "More moves in battle",
  "news.2026-10-27-general.moves.desc": "The general picks where to strike by where the heroes stand: the gate, a flank or the breach. And if everyone guards one gate, it can take its reserve to the other.",
  "news.2026-10-27-zzzbraziers.title": "Braziers where you see them",
  "news.2026-10-27-zzzbraziers.intro": "A fix in the deep crypt.",
  "news.2026-10-27-zzzbraziers.braziers": "Braziers in their place",
  "news.2026-10-27-zzzbraziers.braziers.desc": "If someone joined or left the party before the descent, the braziers could show in one place and catch in another. Now each brazier's circle marks exactly where to stand.",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzcrowds.title": "Lighter waves",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzcrowds.intro": "Big waves ask less of your phone, with the same picture.",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzcrowds.crowds": "Smoother with many nightmares",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzcrowds.crowds.desc": "Nightmares are drawn with far fewer calls to the graphics card, and each wave's are prepared before they show up instead of in the middle of the fight. On phones it shows most with a full field and the first time each creature appears.",
  "news.2026-10-27-zzzzzzzzzzzzzzzzsmooth.title": "Smoother",
  "news.2026-10-27-zzzzzzzzzzzzzzzzsmooth.intro": "The game asks less of your graphics card, without changing how it looks.",
  "news.2026-10-27-zzzzzzzzzzzzzzzzsmooth.smooth": "Lighter crypts and blur",
  "news.2026-10-27-zzzzzzzzzzzzzzzzsmooth.smooth.desc": "In the crypts, the Furrows and other dark halls only the lights that reach the screen are worked out, which helps phones most. On computers the miniature blur costs about half as much. The picture is the same.",
  "news.2026-10-27-zcompare.title": "Compare gear at a glance",
  "news.2026-10-27-zcompare.intro": "The bag tells you whether a piece is worth it before you equip it.",
  "news.2026-10-27-zcompare.compare": "Better, worse or mixed",
  "news.2026-10-27-zcompare.compare.desc": "Every piece in the bag says whether it beats what you wear in that slot. Tap it to see each attribute next to yours, how much you gain or lose, and which effect you gain or leave behind.",
  "hero.wearing": "Wearing now: {what}",
  "hero.wearingNone": "Nothing in that slot: equip it.",
  "fork.bashCharge.when": "To reach the ones shooting from afar.",
  "fork.bashCleave.when": "For packs pressed against the gate.",
  "fork.ironWall.when": "To hold a big rush at the gate.",
  "fork.warCry.when": "To buy the towers time.",
  "fork.sharedOath.when": "To save the group when it turns ugly.",
  "fork.secondWind.when": "If you fight alone with no healer.",
  "fork.frostTurret.when": "To slow the fast ones.",
  "fork.fireTurret.when": "Against crowds walking the same path.",
  "fork.meteor.when": "Against elites and big packs.",
  "fork.embers.when": "In corridors and gates, where they all step.",
  "fork.longWall.when": "To cut off a whole path.",
  "fork.bitingFrost.when": "Against heavily armored nightmares.",
  "fork.stillStorm.when": "To give the towers more time.",
  "fork.thunderclap.when": "Against a pack already bunched up.",
  "fork.volley.when": "Against many weak ones.",
  "fork.frostArrows.when": "To slow the fast ones.",
  "fork.wideNet.when": "Against packs that arrive together.",
  "fork.steelNet.when": "Against warlords and elites.",
  "fork.pinningRain.when": "To stall a wave in a narrow pass.",
  "fork.wideRain.when": "Against spread-out waves.",
  "fork.mendChain.when": "When several fight up close.",
  "fork.mendWard.when": "To guard whoever holds the line.",
  "fork.consecrate.when": "When the group fights standing in one spot.",
  "fork.bulwark.when": "For a group defending a gate.",
  "fork.dawnRebirth.when": "When several fall at once.",
  "fork.dawnSmite.when": "When you need to heal and clear at once.",
  "fork.whirlwind.when": "Surrounded by many weak ones.",
  "fork.rend.when": "Against the ones with lots of health.",
  "fork.quake.when": "To land in the middle of a pack.",
  "fork.doubleLeap.when": "To dive at the shooters and get back.",
  "fork.bloodlust.when": "Against long, crowded waves.",
  "fork.warpath.when": "If you fight next to others.",
  "fork.judgment.when": "Against ink, undead and elites.",
  "fork.healingLight.when": "If there is no cleric in the group.",
  "fork.reprisal.when": "Against the hard hitters.",
  "fork.faithWall.when": "To protect a gate and its guard.",
  "fork.holyGround.when": "Against big, spread-out waves.",
  "fork.faithWeight.when": "To stall a wave in front of the towers.",
  "fork.strangle.when": "Against elites and the ones with lots of health.",
  "fork.spores.when": "Against crowds that keep coming.",
  "fork.direBear.when": "If there is no warrior to draw them.",
  "fork.wildHeart.when": "To fight up close next to others.",
  "fork.deepGrove.when": "For a spread-out group.",
  "fork.briars.when": "When the group fights standing in one spot.",
  "fork.shrapnel.when": "Against packs and the fast ones.",
  "fork.magnet.when": "To bunch them up before an area blow.",
  "fork.colossus.when": "To hold a gate on its own.",
  "fork.swarm.when": "Against many weak ones spread out.",
  "reason.badLoadout": "That preparation can't be saved like that.",
  "reason.badMode": "That kind of fight doesn't exist.",
  "reason.needsLevel": "You're not high enough level to learn it yet.",
  "reason.needsSkill": "You need to know the skill first.",
  "tree.tab.skills": "Combat",
  "tree.tab.bastion": "Bastion",
  "tree.slot.0": "Short",
  "tree.slot.1": "Medium",
  "tree.slot.2": "Ultimate",
  "tree.rankNow": "Rank {n}",
  "tree.rankNext": "rank {n} at level {l}",
  "tree.since": "Since level {l}",
  "tree.lockedAt": "Level {l}",
  "tree.leaves": "{n} of {m} variants",
  "tree.ways": "Ways to carry it",
  "tree.variant.none": "No variant",
  "tree.variant.noneDesc": "The skill alone, as it comes.",
  "tree.variant.learned": "Learned",
  "tree.variant.learn": "Learn · 1 point",
  "tree.when": "Good for: {w}",
  "tree.changes": "Changes",
  "tree.carryHint": "What you learn here is picked in \"What to carry\", for free, before each fight.",
  "carry.title": "What to carry",
  "carry.prep": "Preparation {n}",
  "carry.new": "New",
  "carry.name": "Preparation name",
  "carry.usedIn": "Used in",
  "carry.mode.wave": "Waves",
  "carry.mode.crypt": "Crypts",
  "carry.mode.incursion": "Incursions",
  "carry.mode.expedition": "Expeditions",
  "carry.mode.saga": "Saga",
  "carry.ghost": "Your spectre fights with the waves preparation.",
  "carry.gear": "Gear",
  "carry.gear.worn": "Goes with whatever you're wearing. To set up a fire or frost preparation, put those pieces on and keep them here.",
  "carry.gear.own": "Goes with its own pieces, even if you change what you wear later:",
  "carry.gear.gone": "You no longer have the {slots} piece: it goes with whatever you wear there.",
  "carry.gear.keep": "Keep what I'm wearing",
  "carry.gear.update": "Swap for what I'm wearing",
  "carry.gear.drop": "Go with what's worn",
  "carry.pick": "Pick one",
  "carry.free": "Changing is free outside a fight.",
  "carry.inUse": "In use",
  "carry.notLearned": "Learn it in the tree first",
  "carry.variant": "How to carry {s}",
  "news.2026-10-27-zzpowers.title": "What to carry",
  "news.2026-10-27-zzpowers.intro": "A skill's variants no longer shut each other out: you learn both and pick which to carry before each fight.",
  "news.2026-10-27-zzpowers.carry": "Preparations",
  "news.2026-10-27-zzpowers.carry.desc": "The hero sheet and the waiting room have a \"What to carry\" section: up to three named preparations, each with one variant per button (and the aura, for a paladin). Each kind of fight (waves, crypts, incursions, expeditions, saga) remembers its own. Changing is free, as often as you like, outside a fight. Your spectre fights with the waves one.",
  "news.2026-10-27-zzpowers.tree": "A new tree",
  "news.2026-10-27-zzpowers.tree.desc": "The tree only teaches now: each point learns a variant or a bastion perk. Every variant says what it changes and what it's good for. Your points are given back and starting over is free; the variants you had stay learned.",
  "news.2026-10-27-zzpowers.ranks": "Ranks and stats with the level",
  "news.2026-10-27-zzpowers.ranks.desc": "They aren't paid with points anymore: rank II arrives at level 7 and rank III at 16, for all three skills. What the tree gave in damage, health, speed, armor, range and cooldown grows with the level by itself, little at first and all of it at level 30.",
  "tree.spare": "You have {n} spare points: nothing else to learn for now. The new skills for each button will be learned with them.",
  "news.2026-10-27-zzztree.title": "A clearer tree",
  "news.2026-10-27-zzztree.intro": "Now you can see what each point learns.",
  "news.2026-10-27-zzztree.tree": "A clearer tree",
  "news.2026-10-27-zzztree.tree.desc": "The skill tree comes first on the hero sheet, before \"What to carry\". Each skill shows its two variants by name: tap \"+\" to learn one. If you have spare points, the tree says so: the new skills for each button will be learned with them.",
  "skill.decoy": "Decoy",
  "skill.decoy.desc": "Plants a dummy with a banner for {s} s: it draws nearby nightmares and takes their blows. It deals no damage. It can be broken.",
  "tree.amount.decoy": "Decoy life",
  "skill.frostOrb": "Frost orb",
  "skill.frostOrb.desc": "An orb of frost rolls slowly to the chosen point: it slows and bites whatever it touches, and melts a moment later.",
  "tree.amount.frostOrb": "Amount",
  "skill.hawk": "Familiar",
  "skill.hawk.desc": "A hawk goes hunting for {s} s: it strikes the nearest nightmare and marks it, so everyone hits it 15 % harder. Nightmares can't reach it.",
  "tree.amount.hawk": "Amount",
  "skill.guardTotem": "Guard totem",
  "skill.guardTotem.desc": "Plants a totem for {s} s: allies around it take 30 % less damage.",
  "tree.amount.guardTotem": "Amount",
  "skill.spinHammer": "Spinning hammer",
  "skill.spinHammer.desc": "A hammer of light whirls around you for {s} s: it strikes everything in reach and turns aside half of the blows you take.",
  "tree.amount.spinHammer": "Amount",
  "skill.clanRoar": "Clan roar",
  "skill.clanRoar.desc": "A roar that lasts {s} s: you and the allies near you take 20 % less damage and hit 20 % harder.",
  "tree.amount.clanRoar": "Amount",
  "fork.spikedDecoy": "Spiked decoy",
  "fork.spikedDecoy.desc": "Nightmares striking the decoy take half the blow back.",
  "fork.spikedDecoy.when": "Against many hard hitters.",
  "fork.twinDecoy": "Twin decoys",
  "fork.twinDecoy.desc": "Two decoys side by side, each with 60 % of the life.",
  "fork.twinDecoy.when": "To cover a wide pass or two paths.",
  "fork.orbBurst": "Bursting orb",
  "fork.orbBurst.desc": "When it melts, the orb bursts: it hurts and freezes everything around for a moment.",
  "fork.orbBurst.when": "To end in the middle of a pack.",
  "fork.deepOrb": "Deep orb",
  "fork.deepOrb.desc": "A slower orb that lasts twice as long and slows by 70 %.",
  "fork.deepOrb.when": "To stall a long wave in a pass.",
  "fork.talons": "Talons",
  "fork.talons.desc": "Whatever the hawk strikes keeps bleeding for 3 s.",
  "fork.talons.when": "Against the ones with lots of health.",
  "fork.hawkEye": "Hawk's eye",
  "fork.hawkEye.desc": "A stronger mark (30 % more), and the hawk shows stalkers near it.",
  "fork.hawkEye.when": "Against elites and stalkers.",
  "fork.mendingTotem": "Mending totem",
  "fork.mendingTotem.desc": "The totem also heals the allies around it a little every second.",
  "fork.mendingTotem.when": "When the group holds one spot.",
  "fork.lightTotem": "Totem of light",
  "fork.lightTotem.desc": "Every second the totem strikes the nearest nightmare with light.",
  "fork.lightTotem.when": "If nobody else clears around.",
  "fork.stunHammer": "Stunning hammer",
  "fork.stunHammer.desc": "Every third turn the hammer stuns what it strikes for a moment.",
  "fork.stunHammer.when": "To hold back the ones surrounding you.",
  "fork.wideHammer": "Wide hammer",
  "fork.wideHammer.desc": "The hammer whirls farther out (50 % more).",
  "fork.wideHammer.when": "Against spread-out crowds.",
  "fork.dreadRoar": "Dread roar",
  "fork.dreadRoar.desc": "Nightmares nearby freeze in fear for a moment.",
  "fork.dreadRoar.when": "When they suddenly surround you.",
  "fork.longRoar": "Long roar",
  "fork.longRoar.desc": "The roar lasts half again as long.",
  "fork.longRoar.when": "For long waves.",
  "tree.amount.gearGrenade": "Amount",
  "news.2026-10-27-zzzzlearned.title": "Six new skills",
  "news.2026-10-27-zzzzlearned.intro": "Six classes get a second skill for one of their buttons, learned in the tree with 1 point and carried from \"What to carry\", with two variants each.",
  "news.2026-10-27-zzzzlearned.skills": "Decoy, frost orb, familiar, totem, hammer and roar",
  "news.2026-10-27-zzzzlearned.skills.desc": "From level 6: the warrior plants a Decoy that draws the nightmares; the mage throws a Frost orb that rolls slowing what it touches; the ranger lets loose a Familiar, a hawk that hunts and marks; the cleric plants a Guard totem that protects those near it; the paladin whirls a Hammer of light that strikes everything around and turns blows aside. From level 10 the barbarian has the Clan roar as an ultimate: the whole group takes less and hits harder. They take that button's skill's place while you carry them.",
  "news.2026-10-27-zzzzlearned.spectres": "Your spectre uses them",
  "news.2026-10-27-zzzzlearned.spectres.desc": "If you carry them in your waves preparation, your spectre uses them too while you are away.",
  "tree.noPoint": "No points",
  "tree.variantsLater": "Its variants (learned after the skill)",
  "tree.toLearn": "To learn",
  "tree.allLearned": "You know both its variants: pick which to carry in \"What to carry\", below.",
  "skill.repairDrone": "Repair drone",
  "skill.repairDrone.desc": "A clockwork drone flies for {s} s to the most damaged structure near you and mends it little by little. Nightmares can't reach it.",
  "tree.amount.repairDrone": "Mends per pulse",
  "skill.wasps": "Wasps",
  "skill.wasps.desc": "A cloud of wasps falls on a nightmare and poisons it for {s} s.",
  "tree.amount.wasps": "Amount",
  "fork.welderDrone": "Welder drone",
  "fork.welderDrone.desc": "While it mends, the drone sparks at the nearest nightmare.",
  "fork.welderDrone.when": "When you mend with nightmares on top.",
  "fork.armorDrone": "Armor drone",
  "fork.armorDrone.desc": "Structures near the drone take 30 % less damage while it is there.",
  "fork.armorDrone.when": "To save a gate about to fall.",
  "fork.jumpingWasps": "Jumping plague",
  "fork.jumpingWasps.desc": "If the nightmare falls poisoned, the wasps move on to the nearest with what they had left.",
  "fork.jumpingWasps.when": "Against many weak ones.",
  "fork.denseWasps": "Dense swarm",
  "fork.denseWasps.desc": "The cloud stings the chosen one and the two nearest.",
  "fork.denseWasps.when": "Against packs.",
  "news.2026-10-27-zzzzzdrone.title": "The artificer and the druid choose too",
  "news.2026-10-27-zzzzzdrone.intro": "Every class now has a new skill to learn in the tree.",
  "news.2026-10-27-zzzzzdrone.skills": "Repair drone and Wasps",
  "news.2026-10-27-zzzzzdrone.skills.desc": "From level 6 the artificer lets loose a Repair drone that flies to the most damaged structure and fixes it (instead of the grenade). From level 3 the druid sends a cloud of Wasps that poisons a nightmare (instead of the roots). Each with two variants.",
  "react.frost.name": "Shatter.",
  "react.frost": "Chills what it hits: lightning (yours or a friend's) bursts it in ice.",
  "react.bolt.name": "Shatter.",
  "react.bolt": "Bursts in ice the nightmares chilled by frost (yours or a friend's).",
  "react.fire.name": "Combust.",
  "react.fire": "Sets off the poison and acid on the nightmares that carry them.",
  "react.poison.name": "Combust.",
  "react.poison": "Fire (yours or a friend's) sets its poison off on those around.",
  "news.2026-10-27-zzzzzzreact.title": "Reactions",
  "news.2026-10-27-zzzzzzreact.intro": "Some damage types feed each other, even when they come from different heroes.",
  "news.2026-10-27-zzzzzzreact.react": "Shatter and Combust",
  "news.2026-10-27-zzzzzzreact.react.desc": "Shatter: frost damage chills a nightmare, and lightning on a chilled one bursts it in ice, hurting those around. Combust: fire on a poisoned or acid-eaten nightmare sets the poison off on those around. Each skill's card says what it reacts with.",
  "skill.lowBlow": "Low blow",
  "skill.lowBlow.desc": "A dirty blow: the nightmare is exposed for {s} s and everyone hits it 15 % harder.",
  "tree.amount.lowBlow": "Amount",
  "skill.chainLightning": "Chain lightning",
  "skill.chainLightning.desc": "Lightning jumps from nightmare to nightmare ({n} jumps), a little weaker on each.",
  "tree.amount.chainLightning": "Jumps",
  "skill.poisonArrow": "Poison arrow",
  "skill.poisonArrow.desc": "A poisoned arrow: the nightmare is poisoned for {s} s.",
  "tree.amount.poisonArrow": "Amount",
  "skill.faithRay": "Ray of faith",
  "skill.faithRay.desc": "A ray of light to the chosen point: it hurts the nightmares it crosses and heals the allies it touches.",
  "tree.amount.faithRay": "Heals",
  "skill.throwingAxe": "Throwing axe",
  "skill.throwingAxe.desc": "You throw your axe at a far nightmare: it strikes going and again coming back.",
  "tree.amount.throwingAxe": "Amount",
  "skill.blindingLight": "Blinding light",
  "skill.blindingLight.desc": "A holy flash ahead: it burns the nightmares it reaches and they hit half as hard for {s} s.",
  "tree.amount.blindingLight": "Amount",
  "skill.spikeMine": "Spike mine",
  "skill.spikeMine.desc": "You plant a mine: the first nightmare to step on it sets it off, hurting and slowing those around. Up to {n} at once.",
  "tree.amount.spikeMine": "Mines at once",
  "skill.charge": "Charge",
  "skill.charge.desc": "You run to the chosen point through the nightmares in your way: you strike and stun them.",
  "tree.amount.charge": "Amount",
  "skill.deepRoot": "Deep root",
  "skill.deepRoot.desc": "Roots on an ally for {s} s: nothing holds or throws it, and it heals every second.",
  "tree.amount.deepRoot": "Heals (of life)",
  "fork.crippleBlow": "Crippling blow",
  "fork.crippleBlow.desc": "It also slows it by half for 2 s.",
  "fork.crippleBlow.when": "Against the fast ones.",
  "fork.exposeBlow": "Exposing blow",
  "fork.exposeBlow.desc": "A stronger mark: it takes 40 % more.",
  "fork.exposeBlow.when": "Against elites and bosses, with the group on it.",
  "fork.longArc": "Long arc",
  "fork.longArc.desc": "It jumps to 7, but each jump hits 25 % less.",
  "fork.longArc.when": "Against big, spread-out waves.",
  "fork.overcharge": "Overcharge",
  "fork.overcharge.desc": "It jumps to 3, and the last one bursts around.",
  "fork.overcharge.when": "When they come in small packs.",
  "fork.piercingVenom": "Piercing venom",
  "fork.piercingVenom.desc": "The arrow goes through: it poisons everything in its line.",
  "fork.piercingVenom.when": "In corridors and narrow paths.",
  "fork.virulentArrow": "Virulent arrow",
  "fork.virulentArrow.desc": "A stronger, longer poison (50 % more).",
  "fork.virulentArrow.when": "Against the ones with lots of health.",
  "fork.brightRay": "Wide ray",
  "fork.brightRay.desc": "A wider ray (60 % more).",
  "fork.brightRay.when": "To reach more allies at once.",
  "fork.mendingRay": "Mending ray",
  "fork.mendingRay.desc": "The ray heals 60 % more.",
  "fork.mendingRay.when": "If you are the only healer.",
  "fork.bleedingAxe": "Rending axe",
  "fork.bleedingAxe.desc": "The nightmare keeps bleeding for 3 s.",
  "fork.bleedingAxe.when": "Against the ones with lots of health.",
  "fork.cleavingAxe": "Bouncing axe",
  "fork.cleavingAxe.desc": "Coming back, it also cuts the two nearest.",
  "fork.cleavingAxe.when": "Against packs.",
  "fork.searingLight": "Searing light",
  "fork.searingLight.desc": "The flash burns twice as hard.",
  "fork.searingLight.when": "Against ink and undead.",
  "fork.wideLight": "Wide light",
  "fork.wideLight.desc": "A wider, longer cone.",
  "fork.wideLight.when": "When they surround you.",
  "fork.clusterMine": "Cluster",
  "fork.clusterMine.desc": "Three smaller mines in a triangle.",
  "fork.clusterMine.when": "To cover a wide gate.",
  "fork.tarMine": "Tar mine",
  "fork.tarMine.desc": "It slows harder (70 %) and for longer.",
  "fork.tarMine.when": "To buy the towers time.",
  "fork.longCharge": "Long charge",
  "fork.longCharge.desc": "You run much farther.",
  "fork.longCharge.when": "To reach the ones shooting from afar.",
  "fork.crushingCharge": "Crushing charge",
  "fork.crushingCharge.desc": "It strikes and stuns 50 % more.",
  "fork.crushingCharge.when": "Against a tight pack.",
  "fork.barkskin": "Barkskin",
  "fork.barkskin.desc": "The rooted ally also takes 30 % less damage.",
  "fork.barkskin.when": "For whoever holds the line.",
  "fork.spreadingRoots": "Spreading roots",
  "fork.spreadingRoots.desc": "The roots also reach the allies nearby.",
  "fork.spreadingRoots.when": "When the group fights together.",
  "news.2026-10-27-zzzzzzzbatch.title": "Nine more skills",
  "news.2026-10-27-zzzzzzzbatch.intro": "Every class gets another skill to learn in the tree and carry instead of one of its own.",
  "news.2026-10-27-zzzzzzzbatch.skills": "From the low blow to the deep root",
  "news.2026-10-27-zzzzzzzbatch.skills.desc": "From level 3: Low blow (warrior), Spike mine (artificer), Chain lightning (mage), Poison arrow (ranger), Ray of faith (cleric), Throwing axe (barbarian) and Blinding light (paladin). From level 6: Charge (barbarian) and Deep root (druid). Each with two variants, its own effect and its own sound. Chain lightning shatters chilled nightmares, and fire sets off the arrow's poison.",
  "enemy.dragger": "Dragger",
  "enemy.dragger.desc": "A small thing of shadow that never fights: it hauls the chests left on the ground back to its hole. If it gets there, the chest is lost.",
  "plunder.title": "Plunder",
  "plunder.twist": "Plunder: the old garrison's caches lie scattered across the clearing and the roads. Carry the chests to the cart in the middle; {n} are worth an extraction, and what you load late is worth more. You leave when you want.",
  "plunder.rule": "Plunder · carry the chests to the cart and head back when you want",
  "plunder.intro": "Plunder. Pick up a chest (C) and carry it to the cart in the middle: {n} on the cart are worth an extraction, and what you load late is worth more. Every wave comes stronger. To head back, everyone by the cart and tap Leave (V).",
  "plunder.cart": "Cart",
  "plunder.golem": "The golem leaves on its own in",
  "plunder.leave": "Leave",
  "plunder.leaveTip": "Back to the bastion with what is on the cart. Everyone still standing has to be by the cart. With fewer than {n}, the place doesn't count as won.",
  "plunder.leaveFar": "To leave, everyone still standing has to be by the cart.",
  "plunder.loaded": "on the cart · {n} are worth an extraction",
  "plunder.wave": "Wave {w} · next in {s} s",
  "plunder.stolen": "{n} being hauled off!",
  "plunder.left": "{n} left",
  "plunder.none": "nothing left on the field",
  "plunder.fallen": "Everyone fell: half of what was on the cart comes home.",
  "plunder.home": "Back to the bastion with the load.",
  "plunder.loot": "Plunder: you're paid for what reaches the cart, up to {cap} % of this. If everyone falls, half.",
  "plunder.way.cart": "To the cart",
  "plunder.way.stolen": "Being hauled off!",
  "plunder.way.coffer": "Coffer: takes two",
  "plunder.way.chest": "Chest",
  "plunder.way.home": "Leave",
  "news.2026-10-27-plunder.title": "Plunder",
  "news.2026-10-27-plunder.intro": "Incursions are no longer always the same.",
  "news.2026-10-27-plunder.plunder": "Plunder incursions",
  "news.2026-10-27-plunder.plunder.desc": "From Tide II, quarries and crystal mines sometimes call for a plunder: the old garrison's caches lie scattered across the clearing and the roads. Carry the chests to the cart in the middle (the coffers take two), watch out for the draggers that haul them back to their holes, and head back when you want. Every wave comes stronger and what you load late is worth more: leaving early is safe, staying pays. If everyone falls, half comes home. The place's card says what it is before you go in.",
  "news.2026-10-27-plunder.runs": "Every incursion, its own",
  "news.2026-10-27-plunder.runs.desc": "Playing a place again the same day no longer gives the same map and the same waves.",
  "plunder.late": "from wave {w}: chests +{n}",
  "plunder.lateOn": "chests +{n}",
  "enemy.prowler": "The Prowler",
  "enemy.prowler.desc": "It prowls the Furrows and never falls. If it hears a hero, it hunts them. Hit it hard and it goes away a while; stuns hold it. It never goes into the centre.",
  "maze.label": "The week's labyrinth",
  "maze.title": "The Furrows",
  "maze.sub": "Map the Furrows together and reach the centre.",
  "maze.pitch": "Between plate and plate of the shell run deep corridors of stone and moss. Every week they take another shape. What one of you walks stays on everyone's map, and so do the gates and the camps.",
  "maze.factWeek": "Laid out anew in {n} days.",
  "maze.factWeekOne": "Laid out anew tomorrow.",
  "maze.factMap": "This week's map: {p}%.",
  "maze.factCamps": "Camps pitched: {k} of {n}.",
  "maze.factCentre": "The centre has fallen this week.",
  "maze.factCentreNot": "The centre still stands.",
  "maze.factWho": "Out this week: {names}.",
  "maze.factParty": "Alone or with up to {max} friends online.",
  "maze.factGathering": "Already gathering at the way in: {names}",
  "maze.factReward": "When the centre falls, a chest for everyone who went out that week: a rare piece, experience, dream dust and a shot at a relic.",
  "maze.factPaid": "You already took the Furrows' chest this week.",
  "maze.go": "Go down into the Furrows",
  "maze.sceneAgain": "Hear Brann again",
  "maze.onlineOnly": "Only in an online campaign.",
  "maze.closed": "The Furrows open when the group reaches level {n}.",
  "maze.full": "They already went down, or there are four: wait for them to come back.",
  "maze.lobby": "The way into the Furrows",
  "maze.lobbyHint": "From 1 to {max} go down. The torch lasts {m} minutes. What you map stays for everyone.",
  "maze.enter": "Go down",
  "maze.scene.o1": "In the barracks, an old man with a mug in his hand watches you come in.",
  "maze.scene.o2": "Brann, sergeant of the old garrison. Sit down: this takes long to explain and little to do.",
  "maze.scene.o3": "Between plate and plate of the shell there are deep furrows. Corridors of living stone, moss and rockfalls.",
  "maze.scene.o4": "We sent the recruits there to learn not to get lost. The ones who came back, came back knowing.",
  "maze.scene.o5": "In the middle, the wayfarers left a waystone. Something old and big guards it.",
  "maze.scene.o6": "The Furrows change every week: the titan breathes and the corridors shift.",
  "maze.scene.o7": "Something big prowls down there. It doesn't fall. Hit it hard and it goes away a while.",
  "maze.scene.o8": "Draw what you see. What one of you walks, all of you walk. And take a torch: it lasts what it lasts.",
  "maze.scene.go": "Go down into the Furrows",
  "maze.scene.later": "Not now",
  "maze.scene.c1": "In the centre, the wayfarers' waystone. The old ogre that guarded it won't get up again.",
  "maze.scene.c2": "Brann runs a finger over the new map and laughs under his breath.",
  "maze.scene.c3": "You reached the middle. In my day it took us a month.",
  "maze.scene.c4": "This week's map is carved on the table of the Furrows, by the keep.",
  "maze.scene.b1": "You came up the rope with the map a little bigger.",
  "maze.scene.b2": "What you walked is already on everyone's map. The next run starts from there.",
  "maze.scene.t1": "The torch went out. You came up the nearest rope, feeling your way.",
  "maze.scene.t2": "What you saw stayed on the map. Next time, keep count of the light.",
  "maze.scene.f1": "You all fell in the Furrows. Brann pulled you out one by one, hauling on the rope.",
  "maze.scene.f2": "The map stays. What was in the chests doesn't: the dark kept that.",
  "maze.goal.title": "The Furrows",
  "maze.goal.find": "Find the centre of the Furrows. What you walk stays on everyone's map.",
  "maze.goal.back": "By the rope. «Climb the rope» ends the run: everyone goes back with what you won. Everyone has to be here.",
  "maze.goal.torch": "The torch is dying: back to a rope.",
  "maze.goal.lever": "Stay at the lever to open the gate.",
  "maze.goal.camp": "Stay here to pitch the camp: the next run starts here, with its rope.",
  "maze.goal.chest": "Stay to open the chest.",
  "maze.goal.hall": "The old ogre by the waystone woke: bring it down.",
  "maze.goal.done": "The centre has fallen this week. What's left is to map and open chests.",
  "maze.goal.down": "You fell. If a friend reaches your side, they get you up.",
  "maze.ev.gate": "Gate open: it stays that way for everyone this week.",
  "maze.ev.camp": "Camp pitched: the next run starts here, and it has a rope to go back.",
  "maze.ev.chest": "Chest opened: what it held comes home with you if you walk out.",
  "maze.ev.hall": "The old ogre by the waystone woke.",
  "maze.ev.prowler": "Something prowls nearby.",
  "maze.ev.prowlerAway": "The Prowler went away. It will be back.",
  "maze.ev.fallen": "{name} fell: whoever reaches their side gets them up.",
  "maze.torch": "Torch",
  "maze.mapPct": "Map {p}%",
  "maze.camps": "Camps {k}/{n}",
  "maze.map": "Map",
  "maze.mapClose": "Close the map",
  "maze.mapTitle": "This week's map",
  "maze.how.title": "How it works",
  "maze.how.goal": "The goal.",
  "maze.how.goal.desc": "Reach the centre and bring down the old ogre. Where you go stays on everyone's map, and each run starts a little deeper.",
  "maze.how.lever": "Levers.",
  "maze.how.lever.desc": "Stand by one for a few seconds: it opens a gate, and it stays open all week for everyone.",
  "maze.how.camp": "Camps (the tents).",
  "maze.how.camp.desc": "Stay a few seconds to pitch it: the next run starts there and it has a rope to go back.",
  "maze.how.chest": "Chests.",
  "maze.how.chest.desc": "Stay to open it. What it holds comes back with you if you leave on your feet.",
  "maze.how.rope": "The rope.",
  "maze.how.rope.desc": "At the entrance and at every pitched camp. «Climb the rope» ends the run and everyone goes back with what you won; you all have to be there together.",
  "maze.how.torch": "The torch.",
  "maze.how.torch.desc": "It is the run's time. When it goes out, you are hauled out with what you found.",
  "maze.how.down": "If someone falls.",
  "maze.how.down.desc": "A green arrow takes you to them; stay close and they get up. If everyone falls, that run's chests are lost.",
  "maze.how.prowler": "The Prowler.",
  "maze.how.prowler.desc": "It doesn't fall. Hit it hard and it leaves for a while.",
  "maze.how.close": "Got it",
  "maze.mapHint": "Up is where you are looking. Tap a known place to walk there.",
  "maze.key.me": "You",
  "maze.key.ally": "Friends",
  "maze.key.down": "Down: go and lift them",
  "maze.key.entry": "Entrance, with a rope",
  "maze.key.camp": "Camp to pitch",
  "maze.key.campDone": "Pitched camp, with a rope",
  "maze.key.lever": "Lever: opens a gate",
  "maze.key.chest": "Chest",
  "maze.key.centre": "The centre",
  "maze.way.lift": "Lift {name}",
  "maze.way.rope": "Rope",
  "maze.way.prowler": "Something prowls",
  "maze.end.see": "See what you won",
  "maze.end.centre": "The centre fell",
  "maze.end.centreSub": "The table of the Furrows holds this week's map.",
  "maze.end.back": "Back up the rope",
  "maze.end.backSub": "What you walked stays on everyone's map.",
  "maze.end.torch": "The torch went out",
  "maze.end.torchSub": "What you saw stayed on the map.",
  "maze.end.fallen": "Everyone fell",
  "maze.end.fallenSub": "The map stays; this run's chests don't.",
  "maze.end.party": "What each one won",
  "maze.end.found": "You mapped {n} new crossings ({p}% of the labyrinth): {xp} experience each.",
  "maze.end.foundNone": "This run added nothing new to the map.",
  "maze.end.chests": "Chests opened: {n} (dream dust for the storage).",
  "maze.end.week": "{name}: the week's chest (a rare piece, {xp} experience and a shot at a relic).",
  "maze.end.weekAway": "And the week's chest for those who went out before, too: {names}.",
  "maze.trophy.label": "The Furrows' trophy",
  "maze.trophy.title": "The table of the Furrows",
  "maze.trophy.count": "You reached the centre {n} weeks · {f} with nobody falling.",
  "maze.trophy.countOne": "You reached the centre one week · {f} with nobody falling.",
  "maze.trophy.notYet": "Reach the centre of the Furrows and the table will stand by the keep, with the map carved on it.",
  "maze.trophy.table": "The table, by the keep",
  "maze.trophy.tableHow": "Take the centre one week.",
  "maze.trophy.posts": "The wayfarers' lanterns",
  "maze.trophy.postsHow": "Take the centre {need} weeks ({n} of {need}).",
  "maze.trophy.sash": "The waystone's red cord",
  "maze.trophy.sashHow": "Take the centre with nobody falling in that run.",
  "maze.trophy.new": "The table of the Furrows stands by the keep, with this week's map carved on it.",
  "maze.trophy.newPosts": "The wayfarers' lanterns light the table of the Furrows.",
  "maze.trophy.newSash": "The waystone wears the red cord: you reached the centre with nobody falling.",
  "sima.winch.label": "The Chasm's trophy",
  "sima.winch.title": "The Chasm's winch",
  "sima.winch.mark": "The group's mark: floor {n}",
  "sima.winch.noMark": "No mark yet",
  "sima.winch.week": "this week: {n}",
  "sima.winch.weekNone": "this week: no floor yet",
  "sima.winch.remake": "remakes itself in {d} days",
  "sima.winch.remakeOne": "remakes itself in a day",
  "sima.winch.notYet": "Win the deep crypt to its bottom and Hilde sets up the winch by the forge.",
  "sima.winch.who": "Each time the mark went deeper",
  "sima.winch.floor": "Floor {n}",
  "sima.winch.stones": "Stones on the rope: {n} of {max}",
  "sima.winch.stonesHow": "One for each stratum whose guardian you fell (a guardian every {every} floors).",
  "sima.winch.pulley": "The second pulley and the kibble",
  "sima.winch.banners": "The banners of Hilde's clan",
  "sima.winch.smoke": "The shaft smokes and its light beats",
  "sima.winch.reach": "Reach floor {n}.",
  "sima.winch.moves": "Build on this cell and the winch moves to another free one by the forge.",
  "sima.winch.new": "Hilde set up the Chasm's winch by the forge. For every guardian that falls, she hangs a stone on its rope.",
  "sima.winch.newStone": "Hilde hung {what} on the winch: the guardian of floor {n} fell.",
  "sima.winch.newStage1": "The winch has a second pulley: the group reached floor {n}.",
  "sima.winch.newStage2": "The banners of Hilde's clan hang by the winch: the group reached floor {n}.",
  "sima.winch.newStage3": "Smoke rises from the winch's shaft and its red light beats: the group reached floor {n}.",
  "sima.winch.newMark": "The winch's slab now reads floor {n}.",
  "sima.winch.token.ossuary": "a slate from the Ossuary",
  "sima.winch.token.marrow": "a basalt with an ember inside",
  "sima.winch.token.glass": "an obsidian from the Black Glass",
  "sima.winch.token.cisterns": "a stone from the Cisterns, still dripping",
  "sima.winch.token.buried": "a piece of root from the Buried Forest",
  "sima.winch.token.grotto": "a glowing mushroom cap",
  "sima.winch.token.frost": "frost in a jar",
  "sima.winch.token.geode": "a violet crystal from the Geode",
  "sima.winch.token.archive": "a scroll from the Archive sealed with red wax",
  "sima.winch.token.forge": "a soot-black iron ring from the Dead Forge",
  "sima.winch.token.nest": "a silk cocoon from the Nest",
  "sima.winch.token.ribs": "a bone shard from the Ribs",
  "party.maze": "Gathering at the way into the Furrows: {names}",
  "log.mazeCentre": "The centre of the Furrows fell ({names})",
  "log.mazeRun": "Out in the Furrows, mapping {n} crossings ({names})",
  "maze.scene.n1": "Brann sets the mug down and spreads his hand on the table, as if it were a map.",
  "maze.scene.n2": "He hands you a torch and a coil of rope.",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzzzzzend.title": "The end of the wave",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzzzzzend.intro": "Live fights no longer hang at the very end.",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzzzzzend.end": "The victory always shows",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzzzzzend.end.desc": "When a live fight ended, the screen could freeze with one nightmare on the field and then say the battle was already over. Now it shows the result. And if the connection drops right at the end, coming back shows how it ended.",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzzzzbell.title": "The keep's bell and the tomes",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzzzzbell.intro": "Two fixes for the keep and the skill tree.",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzzzzbell.bell": "The bell rings once",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzzzzbell.bell.desc": "Tapping the keep rang the cellars' bell over and over while its panel stayed open. Now it rings once each time you tap it.",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzzzzbell.tome": "Where the pages come from",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzzzzbell.tome.desc": "The tree said every crypt won gives a page, but the page comes with the day's chest: the first crypt you win each day (in embers and the deep crypt, two pages each, also once a day).",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzzzbuilt.title": "Lighter bastion",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzzzbuilt.intro": "Big citadels take less work to draw, with the same picture.",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzzzbuilt.built": "Less work per building",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzzzbuilt.built.desc": "Towers, walls and workshops are drawn together instead of one by one. With a big bastion, waves run smoother, especially on phones.",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzzzzzzzmidfight.title": "Joining a fight under way",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzzzzzzzmidfight.intro": "Joining a live fight late no longer leaves you watching a different one.",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzzzzzzzmidfight.midfight": "The same fight for everyone",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzzzzzzzmidfight.midfight.desc": "Joining or coming back to a live fight already under way, the nightmares could take another path on your screen than on everyone else's, and the fight might never end for you. Now everyone sees exactly the same one.",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzzzzzzways.title": "The Furrows and the crypt, clearer",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzzzzzzways.intro": "Less guessing about what to do and where to go.",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzzzzzzways.map": "A map you can follow",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzzzzzzways.map.desc": "The Furrows map turns with the camera, zooms in on what you know, shows every friend by name and has a full legend. Tap a place on the map and your hero walks there.",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzzzzzzways.how": "How the Furrows work",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzzzzzzways.how.desc": "A «?» button explains levers, camps, chests, the rope and the torch.",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzzzzzzways.fallen": "Finding whoever fell",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzzzzzzways.fallen.desc": "If a friend falls in the Furrows, a green arrow with their name takes you to them, and the map shows them with a cross.",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzzzzzzways.rope": "Climbing the rope, without confusion",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzzzzzzways.rope.desc": "Going back up the rope is no longer announced as a victory: it says you came back with what you found.",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzzzzzzways.stairs": "The stairs, one tap away",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzzzzzzways.stairs.desc": "In the deep crypt, tap «Go down» or «Go back» and your hero walks there. The panel folds, and on phones it starts small. The arrows at the screen's edge take you there with a tap too.",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzzzzzzways.levers": "Easier levers",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzzzzzzways.levers.desc": "The twin levers are bigger, glow over the wall and stand on their plate: standing beside one counts.",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzzjoin.title": "Joining answers at once",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzzjoin.intro": "No more wondering whether the game froze.",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzzjoin.join": "Joining a friend shows it right away",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzzjoin.join.desc": "When you tap Join, the screen darkens at once and says where you are going, until the fight is ready.",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzfloors.title": "Two fixes in the depths",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzfloors.intro": "The deep crypt and the Furrows, tidier.",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzfloors.floors": "One floor at a time in the deep crypt",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzfloors.floors.desc": "On the lower floors you no longer see the halls and guardians of the floors above glowing in the dark.",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzfloors.map": "The Furrows map closes with its button",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzfloors.map.desc": "Close the map now does what it says; before, only a tap outside the map worked.",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzcosts.title": "Full upgrade prices",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzcosts.intro": "The bastion buttons show everything an upgrade asks for.",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzcosts.costs": "Upgrade buttons show their whole cost",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzcosts.costs.desc": "Clad in iron also asks for stone, and the button now says so next to the iron. Clad in stone shows its price before you tap it, and raising a level counts the military district discount. A number goes red when the storage doesn't have enough.",
  "news.2026-10-27-zzzzzzzzzzzzzzzzznumbers.title": "Tidier numbers",
  "news.2026-10-27-zzzzzzzzzzzzzzzzznumbers.intro": "Texts read better, especially on phones.",
  "news.2026-10-27-zzzzzzzzzzzzzzzzznumbers.numbers": "Rounded numbers and texts that stay in place",
  "news.2026-10-27-zzzzzzzzzzzzzzzzznumbers.numbers.desc": "Skills, gear and upgrades show their numbers with one decimal instead of strings like 15.583333 s. And the note on an effect repeated on another piece now wraps instead of running out of its card.",
  "news.2026-10-27-zzzzzzzzzzzzzzzzvote.title": "Chronicle votes, fixed",
  "news.2026-10-27-zzzzzzzzzzzzzzzzvote.intro": "Deciding as a group no longer leaves anyone stuck in the scene.",
  "news.2026-10-27-zzzzzzzzzzzzzzzzvote.vote": "Your vote always counts",
  "news.2026-10-27-zzzzzzzzzzzzzzzzvote.vote.desc": "If someone in the group chose first, tapping a side did nothing and there was no way out. Now your pick counts as a vote even if someone else opened it, the scene shows live how many voted, who is missing and how many votes close it, and «Later» (or Esc) lets you leave whenever you want. When the group decides, you see it right there.",
  "news.2026-10-27-zzzzzzzzzzzzzzzresume.title": "Rooms survive the hiccups",
  "news.2026-10-27-zzzzzzzzzzzzzzzresume.intro": "A fix for when the server restarts mid-game.",
  "news.2026-10-27-zzzzzzzzzzzzzzzresume.resume": "Pick up where you were",
  "news.2026-10-27-zzzzzzzzzzzzzzzresume.resume.desc": "Now and then the server restarts on its own, and the crypt, the maze, the incursion or the saga battle went back to the start. Now they are saved every few seconds: after a pause of a few seconds, the party is back in the same run, in the same place.",
  "news.2026-10-27-zzzzzzzzzzzzzzswarm.title": "No moths under the vault",
  "news.2026-10-27-zzzzzzzzzzzzzzswarm.intro": "A change to how the swarm omen looks.",
  "news.2026-10-27-zzzzzzzzzzzzzzswarm.swarm": "The swarm, outdoors only",
  "news.2026-10-27-zzzzzzzzzzzzzzswarm.swarm.desc": "With the swarm omen, in the crypts and the Furrows a cloud of moths wheeled over your hero and seemed to follow it everywhere. Now the flock only flies in the open; under the vault, the flies around each nightmare stay.",
  "news.2026-10-27-zzzzzzzzzzzfurrowsfix.title": "Steadier Furrows",
  "news.2026-10-27-zzzzzzzzzzzfurrowsfix.intro": "Two fixes in the labyrinth.",
  "news.2026-10-27-zzzzzzzzzzzfurrowsfix.walk": "No walking through walls",
  "news.2026-10-27-zzzzzzzzzzzfurrowsfix.walk.desc": "In the Furrows your hero was sometimes drawn cutting a corner or walking into the dark, then jumped somewhere else. Now what you see as you move is exactly the walk it makes: around corners and, if you tap somewhere dark, as far as the torch lights.",
  "news.2026-10-27-zzzzzzzzzzzfurrowsfix.doors": "Straight gates",
  "news.2026-10-27-zzzzzzzzzzzfurrowsfix.doors.desc": "Some gates and breathing walls were turned at odd angles. Now they all stand across their corridor.",
  "news.2026-10-27-zzzzzzzzzzzchest.title": "Chests of the Furrows",
  "news.2026-10-27-zzzzzzzzzzzchest.intro": "What waits in the dead ends now looks the part.",
  "news.2026-10-27-zzzzzzzzzzzchest.chest": "New chests",
  "news.2026-10-27-zzzzzzzzzzzchest.chest.desc": "The chests in the dead ends are proper chests now: dark planks, a curved lid, iron bands with rivets and a lock that glows red, with a halo over it you can spot from the corridor. Once opened, the lid stays up and the lock goes dark.",
  "news.2026-10-27-zzzzzzzzzztable.title": "The table of the Furrows",
  "news.2026-10-27-zzzzzzzzzztable.intro": "The Furrows' trophy is now the group's own.",
  "news.2026-10-27-zzzzzzzzzztable.table": "Your labyrinth, carved",
  "news.2026-10-27-zzzzzzzzzztable.table.desc": "The table by the keep no longer shows just any drawing: it has the labyrinth you won carved into it, corridor by corridor, with the way from the rope to the middle lit. Every week you win, the table carves the new one.",
  "news.2026-10-27-zzzzzzzzzvariants.title": "Variants in use",
  "news.2026-10-27-zzzzzzzzzvariants.intro": "Two fixes in the tree and in what to carry.",
  "news.2026-10-27-zzzzzzzzzvariants.variant": "A learned variant is used",
  "news.2026-10-27-zzzzzzzzzvariants.variant.desc": "If you already had a preparation saved, learning a variant did not put it in use: the skill stayed \"no variant\" until you changed it by hand. Now the first variant you learn for a skill goes into every preparation that carried that skill alone. If you already learned both, pick which one to carry in \"What to carry\".",
  "news.2026-10-27-zzzzzzzzzvariants.numbers": "Numbers on the cards",
  "news.2026-10-27-zzzzzzzzzvariants.numbers.desc": "Some cards in the tree showed a stray placeholder instead of the number (for example, how many mines at once or how many seconds the automaton lasts).",
  "news.2026-10-27-zzzzzzzzpaths.title": "Clear way",
  "news.2026-10-27-zzzzzzzzpaths.intro": "Moving around the bastion no longer gets stuck between towers and walls.",
  "news.2026-10-27-zzzzzzzzpaths.walk": "Walking between towers and walls",
  "news.2026-10-27-zzzzzzzzpaths.walk.desc": "Tapping a tower surrounded by other towers left the hero standing still. Now it goes through the towers and stops on the free cell nearest the one you tapped. Heroes also climb over the walls they build (without stopping on top), so nobody gets walled in. The ring wall stays as it was: out through the gates or a breach.",
  "news.2026-10-27-zzzzzzzfurrows.title": "The Furrows: a labyrinth a week",
  "news.2026-10-27-zzzzzzzfurrows.intro": "From Tide II, a new labyrinth every week that the group works out bit by bit.",
  "news.2026-10-27-zzzzzzzfurrows.furrows": "The Furrows of the shell",
  "news.2026-10-27-zzzzzzzfurrows.furrows.desc": "In the incursions panel. Go down alone or with up to three friends online, with a 7-minute torch. What each of you walks stays on everyone's map for the week, and so do opened gates and camps, which let you start deeper in. When the centre falls, everyone who went out that week gets a chest, and the bastion gains the table of the Furrows by the keep. Mind what prowls the corridors: it can't be killed.",
  "maze.goal.start": "Tap a corridor to move on. The rope here is the way out: come back to it, or to a camp, to go up.",
  "maze.way.ropeOut": "Rope · way out",
  "maze.climb": "Climb the rope",
  "maze.ev.climbWait": "To climb, everyone has to be by the rope.",
  "maze.way.centre": "Centre",
  "maze.end.camps": "You pitched {n} camps: the next run starts deeper in.",
  "maze.end.campsOne": "You pitched a camp: the next run starts deeper in.",
  "maze.end.gates": "You opened {n} gates: they stay open all week.",
  "maze.end.gatesOne": "You opened a gate: it stays open all week.",
  "skill.guardBanner": "Guard's banner",
  "skill.guardBanner.desc": "You plant the banner where you stand, for {s} s: allies near it take 25 % less damage and nothing stuns or pushes them.",
  "tree.amount.guardBanner": "Amount",
  "skill.blizzard": "Blizzard",
  "skill.blizzard.desc": "A blizzard over the chosen point, for {s} s: it slows everything under it, flyers too, and the frost keeps biting.",
  "tree.amount.blizzard": "Amount",
  "skill.titanArrow": "Titan's arrow",
  "skill.titanArrow.desc": "A huge arrow that goes through everything in its line, armor and all.",
  "tree.amount.titanArrow": "Amount",
  "skill.dawnJudgment": "Dawn's judgment",
  "skill.dawnJudgment.desc": "A pillar of light falls on the chosen point and burns everything around it; the inked, twice as hard.",
  "tree.amount.dawnJudgment": "Amount",
  "skill.holyRampart": "Holy rampart",
  "skill.holyRampart.desc": "For {s} s, every structure near the paladin takes half the damage.",
  "tree.amount.holyRampart": "Amount",
  "skill.fieldMortar": "Mortar",
  "skill.fieldMortar.desc": "{n} fire shells land one after another around the chosen point.",
  "tree.amount.fieldMortar": "Shells",
  "skill.plague": "Plague",
  "skill.plague.desc": "A plague cloud follows you for {s} s and poisons the nightmares that step into it.",
  "tree.amount.plague": "Amount",
  "fork.rallyBanner": "Rallying banner",
  "fork.rallyBanner.desc": "Allies near the banner also heal.",
  "fork.rallyBanner.when": "When you hold one spot for long.",
  "fork.wideBanner": "Tall banner",
  "fork.wideBanner.desc": "It covers half again as much ground.",
  "fork.wideBanner.when": "When the party fights spread out.",
  "fork.whiteout": "Whiteout",
  "fork.whiteout.desc": "A wider blizzard.",
  "fork.whiteout.when": "For big hordes.",
  "fork.deepFreeze": "Deep freeze",
  "fork.deepFreeze.desc": "Every now and then it freezes everything under it for a moment.",
  "fork.deepFreeze.when": "To stop the ones that must not get through.",
  "fork.pinningArrow": "Pinning arrow",
  "fork.pinningArrow.desc": "What it goes through is pinned for a moment.",
  "fork.pinningArrow.when": "Against a line marching down the path.",
  "fork.burstingArrow": "Bursting arrow",
  "fork.burstingArrow.desc": "Where you aimed, the arrow bursts and hurts those around.",
  "fork.burstingArrow.when": "Against a tight group.",
  "fork.mercifulDawn": "Merciful dawn",
  "fork.mercifulDawn.desc": "The light also heals the allies it touches.",
  "fork.mercifulDawn.when": "When the party fights in the middle of the horde.",
  "fork.blindingDawn": "Blinding dawn",
  "fork.blindingDawn.desc": "Those that survive are left blind: they hit half as hard for a few seconds.",
  "fork.blindingDawn.when": "Against elites and bosses.",
  "fork.sacredRampart": "Blessed rampart",
  "fork.sacredRampart.desc": "Allies nearby take less damage too.",
  "fork.sacredRampart.when": "When you defend at the foot of the walls.",
  "fork.longRampart": "Long rampart",
  "fork.longRampart.desc": "The rampart lasts half again as long.",
  "fork.longRampart.when": "Against long siege waves.",
  "fork.heavyMortar": "Howitzer",
  "fork.heavyMortar.desc": "A single shell, much harder and wider, that stuns.",
  "fork.heavyMortar.when": "Against a big group standing still.",
  "fork.incendiaryMortar": "Incendiary mortar",
  "fork.incendiaryMortar.desc": "Each shell leaves the ground burning.",
  "fork.incendiaryMortar.when": "On a path many walk down.",
  "fork.virulentPlague": "Virulent plague",
  "fork.virulentPlague.desc": "A stronger poison.",
  "fork.virulentPlague.when": "Against nightmares with a lot of life.",
  "fork.witheringPlague": "Withering plague",
  "fork.witheringPlague.desc": "The cloud also slows.",
  "fork.witheringPlague.when": "So they don't slip out of the cloud.",
  "news.2026-10-27-zzzzzzzdults.title": "Seven new ultimates",
  "news.2026-10-27-zzzzzzzdults.intro": "From level 10 every class can learn a second ultimate in the tree and choose which one to carry.",
  "news.2026-10-27-zzzzzzzdults.skills": "From the banner to the plague",
  "news.2026-10-27-zzzzzzzdults.skills.desc": "Guard's banner (warrior): nothing stuns the allies near it and they take less damage. Blizzard (mage): a frost storm that slows everything. Titan's arrow (ranger): it goes through the whole line. Dawn's judgment (cleric): a pillar of light that burns the inked twice as hard. Holy rampart (paladin): the structures nearby take half the damage. Mortar (artificer): three fire shells. Plague (druid): a poison cloud that follows you. Each with two variants, its own effect and its own sound.",
  "carry.combos": "Combos with the others ({m})",
  "react.shatter.with": "Shatter with {who}:",
  "react.combust.with": "Combust with {who}:",
  "react.pair": "your {mine} and their {theirs}.",
  "news.2026-10-27-zzzzzzzeshow.title": "Ultimates stand out",
  "news.2026-10-27-zzzzzzzeshow.intro": "Casting an ultimate is now a moment everyone sees.",
  "news.2026-10-27-zzzzzzzeshow.ult": "The ultimate's moment",
  "news.2026-10-27-zzzzzzzeshow.ult.desc": "When cast, its name appears large under the class's seal, the edge of the screen takes its type's colour and the hero lights up in a column of light.",
  "news.2026-10-27-zzzzzzzeshow.glow": "What you carry shows",
  "news.2026-10-27-zzzzzzzeshow.glow.desc": "Each hero's weapon glows with the colour of its ultimate's type (fire, frost, lightning, poison or light) and sheds sparks of it while walking.",
  "news.2026-10-27-zzzzzzzeshow.combos": "Combos with the others",
  "news.2026-10-27-zzzzzzzeshow.combos.desc": "\"What to carry\" shows which reactions you set off with what the others carry to that kind of fight, like a shatter between your Blizzard and their Chain lightning.",
  "skill.grapple": "Chain",
  "skill.grapple.desc": "You throw a chain at a far nightmare: it is dragged to you and held a moment. Elites and bosses don't budge.",
  "tree.amount.grapple": "Amount",
  "skill.tuneUp": "Wrench",
  "skill.tuneUp.desc": "You fix the most damaged structure near the point at once: it gets {n} life back.",
  "tree.amount.tuneUp": "Repair",
  "skill.frostLance": "Frost lance",
  "skill.frostLance.desc": "A lance of ice that goes through everything in its line, slowing and chilling it.",
  "tree.amount.frostLance": "Amount",
  "skill.piercingShot": "Piercing shot",
  "skill.piercingShot.desc": "An arrow that goes through everything in its line.",
  "tree.amount.piercingShot": "Amount",
  "skill.renew": "Renew",
  "skill.renew.desc": "You bless an ally: it heals a little every second for {s} s.",
  "tree.amount.renew": "Heal per second",
  "skill.brutalBlow": "Brutal blow",
  "skill.brutalBlow.desc": "A blow at one nightmare, harder the more hurt you are: up to 80 % more.",
  "tree.amount.brutalBlow": "Amount",
  "skill.holySeal": "Seal",
  "skill.holySeal.desc": "You mark a nightmare for {s} s: every hero who strikes it heals part of the blow.",
  "tree.amount.holySeal": "Heal",
  "skill.briarLash": "Briar lash",
  "skill.briarLash.desc": "A lash of briars ahead: the nightmares it catches are dragged towards you, held a moment and left bleeding.",
  "tree.amount.briarLash": "Amount",
  "fork.heavyChain": "Heavy chain",
  "fork.heavyChain.desc": "It hits twice as hard and holds longer.",
  "fork.heavyChain.when": "Against a dangerous nightmare coming alone.",
  "fork.twinChain": "Twin chain",
  "fork.twinChain.desc": "It also drags the two nearest.",
  "fork.twinChain.when": "To bunch a group up in front of your friends.",
  "fork.deepRepair": "Deep fix",
  "fork.deepRepair.desc": "It repairs more.",
  "fork.deepRepair.when": "To save a gate about to fall.",
  "fork.wideRepair": "Round of fixes",
  "fork.wideRepair.desc": "It also half-fixes the next two most damaged nearby.",
  "fork.wideRepair.when": "When several towers are under attack.",
  "fork.longLance": "Long lance",
  "fork.longLance.desc": "It reaches further.",
  "fork.longLance.when": "Against long lines down the path.",
  "fork.bitingLance": "Biting lance",
  "fork.bitingLance.desc": "It hits harder.",
  "fork.bitingLance.when": "To set up a big shatter.",
  "fork.heavyShot": "Heavy arrow",
  "fork.heavyShot.desc": "It hits harder.",
  "fork.heavyShot.when": "Against armoured nightmares.",
  "fork.pinShot": "Pinning arrow",
  "fork.pinShot.desc": "What it goes through is pinned a moment.",
  "fork.pinShot.when": "To stop the ones slipping past.",
  "fork.longRenew": "Long blessing",
  "fork.longRenew.desc": "It lasts half again as long.",
  "fork.longRenew.when": "For whoever holds the front.",
  "fork.sharedRenew": "Shared blessing",
  "fork.sharedRenew.desc": "The allies around the chosen one get it too.",
  "fork.sharedRenew.when": "When everyone fights together.",
  "fork.executeBlow": "Finisher",
  "fork.executeBlow.desc": "Against a nightmare low on life, it hits twice as hard.",
  "fork.executeBlow.when": "To finish elites and bosses.",
  "fork.stunBlow": "Stunning blow",
  "fork.stunBlow.desc": "It leaves it stunned a moment.",
  "fork.stunBlow.when": "To cut a caster off.",
  "fork.brightSeal": "Bright seal",
  "fork.brightSeal.desc": "It heals more.",
  "fork.brightSeal.when": "Against a boss, with the whole group striking it.",
  "fork.burningSeal": "Burning seal",
  "fork.burningSeal.desc": "The seal's light burns it too.",
  "fork.burningSeal.when": "Against the inked.",
  "fork.longLash": "Long lash",
  "fork.longLash.desc": "It reaches further.",
  "fork.longLash.when": "To bring in the ones at the back.",
  "fork.deepThorns": "Deep thorns",
  "fork.deepThorns.desc": "They bleed more.",
  "fork.deepThorns.when": "Against nightmares with a lot of life.",
  "tree.tomePages": "Tome {n} of {m}",
  "tree.tome": "Tome: {s}, {n} of {m} pages",
  "tree.tomeWhere.0": "The first crypt you win each day gives a page (the crypt in embers and the deep crypt, two each, also once a day). With all of them you learn it without spending points.",
  "tree.tomeWhere.1": "Each incursion won gives a page. With all of them you learn it without spending points.",
  "tree.tomeWhere.2": "The two Marea bosses (the Ash Witch and the Hollow Shell) and each saga chapter finished give a page. With all of them you learn it without spending points.",
  "reason.needsTome": "That one is learned by gathering its tome's pages.",
  "log.tomePage": "{who} found a page of the «{s}» tome ({n} of {m})",
  "log.tomeFull": "{who} completed the «{s}» tome and learned the skill",
  "log.tomePage.you": "You found a page of the «{s}» tome ({n} of {m})",
  "log.tomeFull.you": "You completed the «{s}» tome and learned the skill",
  "tome.shelfNew": "A new tome on the shelf by the keep: someone learned a skill by gathering its pages.",
  "news.2026-10-27-zzzzzzzftomes.title": "Tomes",
  "news.2026-10-27-zzzzzzzftomes.intro": "Some skills aren't learned with points: they're learned by gathering their tome's pages.",
  "news.2026-10-27-zzzzzzzftomes.tomes": "Pages for playing",
  "news.2026-10-27-zzzzzzzftomes.tomes.desc": "The first crypt you win each day gives a page of your class's tome for the short button (the crypt in embers and the deep crypt, two each, also once a day). With 5 pages you learn the skill, without spending points or needing a level. Expeditions give a page to the tome furthest behind. The tree shows how many you have.",
  "news.2026-10-27-zzzzzzzftomes.skills": "Eight tome skills",
  "news.2026-10-27-zzzzzzzftomes.skills.desc": "Chain (warrior), Wrench (artificer), Frost lance (mage), Piercing shot (ranger), Renew (cleric), Brutal blow (barbarian), Seal (paladin) and Briar lash (druid). Their variants cost a point each, like the others.",
  "news.2026-10-27-zzzzzzzftomes.shelf": "The tomes' shelf",
  "news.2026-10-27-zzzzzzzftomes.shelf.desc": "By the keep a shelf appears with a book for each tome the group has completed, in its skill's colour, and a lectern with an open book while someone is gathering pages.",
  "skill.defyShout": "Shout of defiance",
  "skill.defyShout.desc": "A shout that stuns everything around you a moment and draws it onto you for {s} s.",
  "tree.amount.defyShout": "Amount",
  "skill.teslaCoil": "Coil",
  "skill.teslaCoil.desc": "You plant a coil for {s} s: every second it arcs lightning to {n} nightmares nearby.",
  "tree.amount.teslaCoil": "Arcs per pulse",
  "skill.blink": "Blink",
  "skill.blink.desc": "You vanish and appear at the chosen point; where you stood bursts in flame.",
  "tree.amount.blink": "Amount",
  "skill.snare": "Snare",
  "skill.snare.desc": "You set a snare: the first ground nightmare to step on it is caught and hurt. Up to {n} at a time.",
  "tree.amount.snare": "Snares at a time",
  "skill.sharedPrayer": "Shared prayer",
  "skill.sharedPrayer.desc": "A prayer for all: every ally in sight heals part of its life.",
  "tree.amount.sharedPrayer": "Heal",
  "skill.bloodletting": "Bloodletting",
  "skill.bloodletting.desc": "For {s} s your blows leave what you strike bleeding.",
  "tree.amount.bloodletting": "Amount",
  "skill.intervene": "Intervene",
  "skill.intervene.desc": "You leap beside an ally: it takes 60 % less damage for {s} s and the nightmares near it turn on you.",
  "tree.amount.intervene": "Amount",
  "skill.thornWall": "Thorn wall",
  "skill.thornWall.desc": "A wall of thorns across the way for {s} s: it slows and pricks what crosses it.",
  "tree.amount.thornWall": "Hexes",
  "fork.wideShout": "Wide shout",
  "fork.wideShout.desc": "It reaches further.",
  "fork.wideShout.when": "When many surround you.",
  "fork.longShout": "Chilling shout",
  "fork.longShout.desc": "It stuns them longer.",
  "fork.longShout.when": "To give the ones behind room to breathe.",
  "fork.bigCoil": "Big coil",
  "fork.bigCoil.desc": "It arcs to two more.",
  "fork.bigCoil.when": "Against hordes of small nightmares.",
  "fork.fastCoil": "Fast coil",
  "fork.fastCoil.desc": "It arcs more often.",
  "fork.fastCoil.when": "Against a few strong nightmares.",
  "fork.frostBlink": "Frost blink",
  "fork.frostBlink.desc": "What's left behind is frost and slows.",
  "fork.frostBlink.when": "To shake off one chasing you.",
  "fork.farBlink": "Far blink",
  "fork.farBlink.desc": "You jump further.",
  "fork.farBlink.when": "To cross the field fast.",
  "fork.barbedSnare": "Barbed snare",
  "fork.barbedSnare.desc": "It leaves its catch bleeding.",
  "fork.barbedSnare.when": "Against nightmares with a lot of life.",
  "fork.twinSnare": "Twin snare",
  "fork.twinSnare.desc": "You set two side by side.",
  "fork.twinSnare.when": "To cover a gate.",
  "fork.deepPrayer": "Deep prayer",
  "fork.deepPrayer.desc": "It heals more.",
  "fork.deepPrayer.when": "When everyone is badly hurt.",
  "fork.wardPrayer": "Warding prayer",
  "fork.wardPrayer.desc": "They also take less damage for a few seconds.",
  "fork.wardPrayer.when": "Before a boss's big blow.",
  "fork.longLetting": "Long bloodletting",
  "fork.longLetting.desc": "It lasts half again as long.",
  "fork.longLetting.when": "For long fights.",
  "fork.thirstyLetting": "Thirsty bloodletting",
  "fork.thirstyLetting.desc": "While it lasts, you heal part of what you deal.",
  "fork.thirstyLetting.when": "When you fight alone up front.",
  "fork.steadfast": "Steadfast shield",
  "fork.steadfast.desc": "The ally takes even less.",
  "fork.steadfast.when": "To save one about to fall.",
  "fork.healingStep": "Healing step",
  "fork.healingStep.desc": "On arriving, you also heal it.",
  "fork.healingStep.when": "When there's no cleric nearby.",
  "fork.longThorns": "Long wall",
  "fork.longThorns.desc": "Two more hexes.",
  "fork.longThorns.when": "To close a wide path.",
  "fork.sharpThorns": "Sharp thorns",
  "fork.sharpThorns.desc": "They prick twice as hard.",
  "fork.sharpThorns.when": "Where many pass.",
  "news.2026-10-27-zzzzzzzzzzzzzmid.title": "Tomes of the medium button",
  "news.2026-10-27-zzzzzzzzzzzzzmid.intro": "Incursions won now give pages of your class's tome for the medium button.",
  "news.2026-10-27-zzzzzzzzzzzzzmid.skills": "Eight more skills to gather",
  "news.2026-10-27-zzzzzzzzzzzzzmid.skills.desc": "Shout of defiance (warrior), Coil (artificer), Blink (mage), Snare (ranger), Shared prayer (cleric), Bloodletting (barbarian), Intervene (paladin) and Thorn wall (druid). With 5 pages they're learned without spending points; each has two variants, its own effect and its own sound.",
  "skill.lastStand": "Last line",
  "skill.lastStand.desc": "For {s} s you can't fall: your life doesn't drop below 1.",
  "tree.amount.lastStand": "Amount",
  "skill.clockHound": "Clockwork hound",
  "skill.clockHound.desc": "You let a clockwork hound loose at the chosen point: it runs at the nightmares, bites and draws them until it breaks or {s} s pass.",
  "tree.amount.clockHound": "Life",
  "skill.fireRain": "Rain of fire",
  "skill.fireRain.desc": "For {s} s meteors fall at random spots in a wide area.",
  "tree.amount.fireRain": "Amount",
  "skill.eagleEye": "Hawk eye",
  "skill.eagleEye.desc": "For {s} s you reach half again as far and every shot at an elite or a boss is a critical.",
  "tree.amount.eagleEye": "Reach",
  "skill.intercession": "Intercession",
  "skill.intercession.desc": "You mark an ally for {s} s: if it falls, it gets straight back up with half its life.",
  "tree.amount.intercession": "Life on rising",
  "skill.ancestralFury": "Ancestral fury",
  "skill.ancestralFury.desc": "For {s} s each of your blows also hits the nightmares around your target.",
  "tree.amount.ancestralFury": "Blow around",
  "skill.avatarOfLight": "Avatar of light",
  "skill.avatarOfLight.desc": "For {s} s your blows also land light around your target and allies near you take less damage.",
  "tree.amount.avatarOfLight": "Blow around",
  "skill.forestAwakening": "Forest awakening",
  "skill.forestAwakening.desc": "You wake living trees at the chosen point: they fight and draw the nightmares for {s} s.",
  "tree.amount.forestAwakening": "Life",
  "fork.sharedStand": "Shared line",
  "fork.sharedStand.desc": "Allies nearby can't fall either, for half as long.",
  "fork.sharedStand.when": "When the whole group is in trouble.",
  "fork.longStand": "Long line",
  "fork.longStand.desc": "It lasts half again as long.",
  "fork.longStand.when": "Against bosses that hit for a long time.",
  "fork.ironHound": "Iron hound",
  "fork.ironHound.desc": "It holds out longer.",
  "fork.ironHound.when": "Against hard-hitting elites.",
  "fork.packHound": "Pack",
  "fork.packHound.desc": "Two hounds, each with less life.",
  "fork.packHound.when": "Against groups coming from two sides.",
  "fork.emberStorm": "Ember storm",
  "fork.emberStorm.desc": "They fall more often.",
  "fork.emberStorm.when": "Against hordes standing still.",
  "fork.greatMeteors": "Great meteors",
  "fork.greatMeteors.desc": "Bigger and stronger.",
  "fork.greatMeteors.when": "Against tight groups.",
  "fork.longEye": "Patient eye",
  "fork.longEye.desc": "It lasts half again as long.",
  "fork.longEye.when": "For long waves.",
  "fork.keenEye": "Keen eye",
  "fork.keenEye.desc": "All your shots are criticals while it lasts.",
  "fork.keenEye.when": "Against hordes of common nightmares.",
  "fork.longIntercession": "Long intercession",
  "fork.longIntercession.desc": "The mark lasts half again as long.",
  "fork.longIntercession.when": "Before a long fight.",
  "fork.fullIntercession": "Full intercession",
  "fork.fullIntercession.desc": "It gets back up with all its life.",
  "fork.fullIntercession.when": "For whoever holds the front.",
  "fork.longFury": "Long fury",
  "fork.longFury.desc": "It lasts half again as long.",
  "fork.longFury.when": "For long waves.",
  "fork.wideFury": "Wide fury",
  "fork.wideFury.desc": "The blows reach further around.",
  "fork.wideFury.when": "Against spread-out hordes.",
  "fork.radiantAvatar": "Radiant avatar",
  "fork.radiantAvatar.desc": "The light lands harder around.",
  "fork.radiantAvatar.when": "Against the inked in groups.",
  "fork.guardianAvatar": "Guardian avatar",
  "fork.guardianAvatar.desc": "Allies nearby take even less.",
  "fork.guardianAvatar.when": "When the group fights beside you.",
  "fork.ancientTreant": "Ancient tree",
  "fork.ancientTreant.desc": "A single tree, much stronger.",
  "fork.ancientTreant.when": "To plug a gate.",
  "fork.threeTreants": "Grove",
  "fork.threeTreants.desc": "Three smaller trees.",
  "fork.threeTreants.when": "To cover a wide path.",
  "news.2026-10-27-zzzzzzzzzzzzzzults.title": "Tomes of the ultimates",
  "news.2026-10-27-zzzzzzzzzzzzzzults.intro": "Each Marea boss beaten and each saga chapter finished give a page of your class's ultimate tome.",
  "news.2026-10-27-zzzzzzzzzzzzzzults.skills": "Eight more ultimates",
  "news.2026-10-27-zzzzzzzzzzzzzzults.skills.desc": "Last line (warrior), Clockwork hound (artificer), Rain of fire (mage), Hawk eye (ranger), Intercession (cleric), Ancestral fury (barbarian), Avatar of light (paladin) and Forest awakening (druid). With 5 pages they're learned without spending points; each with two variants, its own effect and its own sound.",
  "skill.shieldSlam": "Shield slam",
  "skill.shieldSlam.desc": "A shield blow ahead: it hurts, pushes back and staggers the nightmares it catches.",
  "tree.amount.shieldSlam": "Amount",
  "skill.shieldWall": "Shield wall",
  "skill.shieldWall.desc": "For {s} s you take half the damage and allies nearby take 25 % less.",
  "tree.amount.shieldWall": "Amount",
  "skill.shieldEcho": "Shield echo",
  "skill.shieldEcho.desc": "You strike the ground with your shield: a wide ring stuns and hurts everything it reaches.",
  "tree.amount.shieldEcho": "Amount",
  "skill.flamethrower": "Flamethrower",
  "skill.flamethrower.desc": "A short jet of fire ahead: it burns what it catches and leaves it burning.",
  "tree.amount.flamethrower": "Amount",
  "skill.ironBarricade": "Iron barricade",
  "skill.ironBarricade.desc": "An iron barricade across the way for {s} s: what crosses it barely moves.",
  "tree.amount.ironBarricade": "Hexes",
  "skill.fortifyAll": "Fortify",
  "skill.fortifyAll.desc": "For {s} s the structures nearby take 30 % less damage.",
  "tree.amount.fortifyAll": "Amount",
  "skill.acidDart": "Acid dart",
  "skill.acidDart.desc": "A dart that hurts and leaves the nightmare eaten by acid: it takes more from everything for {s} s.",
  "tree.amount.acidDart": "Amount",
  "skill.shadowChains": "Shadow chains",
  "skill.shadowChains.desc": "You bind {n} nightmares for {s} s: what a hero deals to one also hurts the others.",
  "tree.amount.shadowChains": "Bound",
  "skill.dreamRift": "Dream rift",
  "skill.dreamRift.desc": "A rift at the chosen point drags everything near into its middle, then bursts.",
  "tree.amount.dreamRift": "Amount",
  "skill.disengage": "Disengage",
  "skill.disengage.desc": "You leap back away from the nightmares and leave caltrops where you stood.",
  "tree.amount.disengage": "Amount",
  "skill.signalFlare": "Signal flare",
  "skill.signalFlare.desc": "A flare over the chosen point for {s} s: it shows the unseen and everything under it takes more damage.",
  "tree.amount.signalFlare": "Amount",
  "skill.hiddenShot": "Hidden shot",
  "skill.hiddenShot.desc": "For {s} s the nightmares in melee leave you alone and your shots hit twice as hard.",
  "tree.amount.hiddenShot": "Amount",
  "skill.piercingLight": "Piercing light",
  "skill.piercingLight.desc": "A light that burns a nightmare and heals the most hurt ally nearby.",
  "tree.amount.piercingLight": "Heal",
  "skill.cleanse": "Cleanse",
  "skill.cleanse.desc": "Allies nearby are freed of stuns, fear, sleep, curses and poison, and heal a little.",
  "tree.amount.cleanse": "Heal",
  "skill.choir": "Choir",
  "skill.choir.desc": "For {s} s allies nearby heal a share of every blow they land.",
  "tree.amount.choir": "Heal per blow",
  "skill.kick": "Kick",
  "skill.kick.desc": "A kick that hurts, throws the nightmare far back and leaves it stunned.",
  "tree.amount.kick": "Amount",
  "skill.terrify": "Terrifying roar",
  "skill.terrify.desc": "A roar: the nightmares around cower in fear and take more damage for {s} s.",
  "tree.amount.terrify": "Amount",
  "skill.duel": "Duel",
  "skill.duel.desc": "You challenge one nightmare (an elite or a boss if there is one) for {s} s: it fights only you and you hit it twice as hard.",
  "tree.amount.duel": "Amount",
  "skill.atone": "Atone",
  "skill.atone.desc": "Your next blow hits 50 % harder and heals the most hurt ally nearby more than it deals.",
  "tree.amount.atone": "Heal",
  "skill.blessWeapon": "Bless weapon",
  "skill.blessWeapon.desc": "For {s} s an ally's blows are holy and hit 30 % harder.",
  "tree.amount.blessWeapon": "Blow",
  "skill.sacrifice": "Sacrifice",
  "skill.sacrifice.desc": "For {s} s allies nearby take half the damage: you take the other half.",
  "tree.amount.sacrifice": "Share",
  "skill.sporeCloud": "Spores",
  "skill.sporeCloud.desc": "A cloud of spores at the chosen point for {s} s: it poisons and slows.",
  "tree.amount.sporeCloud": "Amount",
  "skill.wolfForm": "Wolf form",
  "skill.wolfForm.desc": "For {s} s you run faster and your blows leave bleeding.",
  "tree.amount.wolfForm": "Speed",
  "skill.rootQuake": "Root quake",
  "skill.rootQuake.desc": "The ground of an area heaves: it throws, holds and hurts everything there, and stays broken and slow for {s} s.",
  "tree.amount.rootQuake": "Amount",
  "fork.wideSlam": "Wide slam",
  "fork.wideSlam.desc": "A wider cone.",
  "fork.wideSlam.when": "When they press you from the front.",
  "fork.hardSlam": "Heavy slam",
  "fork.hardSlam.desc": "It hits harder and staggers longer.",
  "fork.hardSlam.when": "Against an elite coming in.",
  "fork.bulwarkWall": "Bulwark",
  "fork.bulwarkWall.desc": "You take even less.",
  "fork.bulwarkWall.when": "When you hold off many.",
  "fork.wideWall": "Wide wall",
  "fork.wideWall.desc": "It covers allies further away.",
  "fork.wideWall.when": "When the group fights spread out.",
  "fork.thunderEcho": "Thundering echo",
  "fork.thunderEcho.desc": "It hits much harder.",
  "fork.thunderEcho.when": "Against hordes.",
  "fork.longEcho": "Long echo",
  "fork.longEcho.desc": "It stuns longer.",
  "fork.longEcho.when": "To give the group room to breathe.",
  "fork.longFlame": "Long flame",
  "fork.longFlame.desc": "It reaches further.",
  "fork.longFlame.when": "To burn from behind.",
  "fork.napalm": "Burning pitch",
  "fork.napalm.desc": "It burns twice as long and hard.",
  "fork.napalm.when": "Against nightmares with a lot of life.",
  "fork.longBarricade": "Long barricade",
  "fork.longBarricade.desc": "Two more plates.",
  "fork.longBarricade.when": "To close a wide path.",
  "fork.spikedBarricade": "Spiked barricade",
  "fork.spikedBarricade.desc": "It hurts what crosses it.",
  "fork.spikedBarricade.when": "Where many pass.",
  "fork.reinforce": "Reinforce",
  "fork.reinforce.desc": "It also repairs part of each structure at once.",
  "fork.reinforce.when": "After a heavy blow.",
  "fork.longFortify": "Long fortify",
  "fork.longFortify.desc": "It lasts half again as long.",
  "fork.longFortify.when": "Against long siege waves.",
  "fork.corrosiveDart": "Corrosive dart",
  "fork.corrosiveDart.desc": "The acid lasts twice as long.",
  "fork.corrosiveDart.when": "Against bosses.",
  "fork.splashDart": "Splashing dart",
  "fork.splashDart.desc": "It splashes those around.",
  "fork.splashDart.when": "Against tight groups.",
  "fork.widerChains": "Long chains",
  "fork.widerChains.desc": "It binds five.",
  "fork.widerChains.when": "Against hordes.",
  "fork.heavyChains": "Heavy chains",
  "fork.heavyChains.desc": "They pass on more of the blow.",
  "fork.heavyChains.when": "With a hard-hitting group.",
  "fork.deepRift": "Deep rift",
  "fork.deepRift.desc": "The burst hits harder.",
  "fork.deepRift.when": "Against grouped elites.",
  "fork.wideRift": "Wide rift",
  "fork.wideRift.desc": "It drags from further away.",
  "fork.wideRift.when": "Against spread-out hordes.",
  "fork.farLeap": "Far leap",
  "fork.farLeap.desc": "You leap further.",
  "fork.farLeap.when": "To escape the fast ones.",
  "fork.sharpCaltrops": "Sharp caltrops",
  "fork.sharpCaltrops.desc": "They prick twice as hard.",
  "fork.sharpCaltrops.when": "Where many pass.",
  "fork.brightFlare": "Bright flare",
  "fork.brightFlare.desc": "It covers more.",
  "fork.brightFlare.when": "Against unseen stalkers.",
  "fork.burningFlare": "Burning flare",
  "fork.burningFlare.desc": "It bursts in fire where it falls.",
  "fork.burningFlare.when": "To set off a friend's poison.",
  "fork.longHidden": "Long cover",
  "fork.longHidden.desc": "It lasts half again as long.",
  "fork.longHidden.when": "For long waves.",
  "fork.deadlyHidden": "Deadly shot",
  "fork.deadlyHidden.desc": "Your shots hit even harder.",
  "fork.deadlyHidden.when": "Against bosses.",
  "fork.brightLance": "Bright light",
  "fork.brightLance.desc": "It burns more.",
  "fork.brightLance.when": "Against the inked.",
  "fork.mercyLight": "Merciful light",
  "fork.mercyLight.desc": "It heals more.",
  "fork.mercyLight.when": "When someone is about to fall.",
  "fork.wideCleanse": "Wide cleanse",
  "fork.wideCleanse.desc": "It reaches further.",
  "fork.wideCleanse.when": "When the group is spread out.",
  "fork.wardCleanse": "Warding cleanse",
  "fork.wardCleanse.desc": "They also take less damage for a few seconds.",
  "fork.wardCleanse.when": "Against casters.",
  "fork.longChoir": "Long choir",
  "fork.longChoir.desc": "It lasts half again as long.",
  "fork.longChoir.when": "For long bosses.",
  "fork.loudChoir": "Loud choir",
  "fork.loudChoir.desc": "It heals more of each blow.",
  "fork.loudChoir.when": "With a group that hits a lot.",
  "fork.farKick": "Long kick",
  "fork.farKick.desc": "It throws it further.",
  "fork.farKick.when": "To get one off a friend.",
  "fork.bruteKick": "Brutal kick",
  "fork.bruteKick.desc": "It hits twice as hard.",
  "fork.bruteKick.when": "Against elites.",
  "fork.wideTerrify": "Wide roar",
  "fork.wideTerrify.desc": "It reaches further.",
  "fork.wideTerrify.when": "When many surround you.",
  "fork.deepTerrify": "Terror",
  "fork.deepTerrify.desc": "They take even more damage.",
  "fork.deepTerrify.when": "Before the group charges.",
  "fork.longDuel": "Long duel",
  "fork.longDuel.desc": "It lasts half again as long.",
  "fork.longDuel.when": "Against bosses with a lot of life.",
  "fork.bloodDuel": "Blood duel",
  "fork.bloodDuel.desc": "You heal part of what you deal it.",
  "fork.bloodDuel.when": "When you fight a boss alone.",
  "fork.greaterAtone": "Greater atonement",
  "fork.greaterAtone.desc": "It heals more.",
  "fork.greaterAtone.when": "For whoever holds the front.",
  "fork.sharedAtone": "Shared atonement",
  "fork.sharedAtone.desc": "It heals every ally nearby, at half.",
  "fork.sharedAtone.when": "When everyone is hurt.",
  "fork.longBlessing": "Long blessing",
  "fork.longBlessing.desc": "It lasts half again as long.",
  "fork.longBlessing.when": "For long waves.",
  "fork.brightBlessing": "Bright blessing",
  "fork.brightBlessing.desc": "The blows hit even harder.",
  "fork.brightBlessing.when": "Against the inked and the undead.",
  "fork.longSacrifice": "Long sacrifice",
  "fork.longSacrifice.desc": "It lasts half again as long.",
  "fork.longSacrifice.when": "Against bosses that hit an area.",
  "fork.wardedSacrifice": "Warded sacrifice",
  "fork.wardedSacrifice.desc": "You take less of what you shoulder.",
  "fork.wardedSacrifice.when": "When there's no cleric.",
  "fork.thickSpores": "Thick spores",
  "fork.thickSpores.desc": "A wider cloud.",
  "fork.thickSpores.when": "To cover a gate.",
  "fork.venomSpores": "Venom spores",
  "fork.venomSpores.desc": "A stronger poison.",
  "fork.venomSpores.when": "For combusts with a fire mage.",
  "fork.longWolf": "Long wolf",
  "fork.longWolf.desc": "It lasts half again as long.",
  "fork.longWolf.when": "For long waves.",
  "fork.swiftWolf": "Swift wolf",
  "fork.swiftWolf.desc": "You run even faster.",
  "fork.swiftWolf.when": "To reach another path in time.",
  "fork.longQuake": "Long quake",
  "fork.longQuake.desc": "The ground stays broken longer.",
  "fork.longQuake.when": "To slow a long wave.",
  "fork.shatterQuake": "Shattering quake",
  "fork.shatterQuake.desc": "It hits much harder.",
  "fork.shatterQuake.when": "Against hordes.",
  "news.2026-10-27-zzzzzzzzzzzzzzzthird.title": "Twenty-four more skills",
  "news.2026-10-27-zzzzzzzzzzzzzzzthird.intro": "Every class gets a third skill for each button: the short one from level 14, the medium from 18 and the ultimate from 22.",
  "news.2026-10-27-zzzzzzzzzzzzzzzthird.skills": "Short and medium",
  "news.2026-10-27-zzzzzzzzzzzzzzzthird.skills.desc": "Warrior: Shield slam and Shield wall. Artificer: Flamethrower and Iron barricade. Mage: Acid dart and Shadow chains. Ranger: Disengage and Signal flare. Cleric: Piercing light and Cleanse. Barbarian: Kick and Terrifying roar. Paladin: Atone and Bless weapon. Druid: Spores and Wolf form.",
  "news.2026-10-27-zzzzzzzzzzzzzzzthird.ults": "Ultimates",
  "news.2026-10-27-zzzzzzzzzzzzzzzthird.ults.desc": "Shield echo (warrior), Fortify (artificer), Dream rift (mage), Hidden shot (ranger), Choir (cleric), Duel (barbarian), Sacrifice (paladin) and Root quake (druid). All with two variants, their own effect and their own sound.",
  "news.2026-10-28-zzzzzzzzzexit.title": "The way out of the dream",
  "news.2026-10-28-zzzzzzzzzexit.intro": "A fix in the saga.",
  "news.2026-10-28-zzzzzzzzzexit.exit": "Saga descents without a boss end at a way out",
  "news.2026-10-28-zzzzzzzzzexit.exit.desc": "In the saga descents that have no boss, the arrow said \"To the guardian\" and the last room looked like the Warden's hall, but stepping in ended the fight with no one there. Now that room is a way out, with a shaft of light and a ladder, and the arrow says \"To the way out\".",
  "news.2026-10-28-chat.title": "The chat no longer covers the panel",
  "news.2026-10-28-chat.intro": "A fix in the bastion.",
  "news.2026-10-28-chat.sheet": "The chat no longer sits on top of the close button",
  "news.2026-10-28-chat.sheet.desc": "On a computer, with a cell's panel open, the chat button sat over the panel's close button. Now the chat steps aside while the panel is open and goes back when you close it. On a phone, the open chat no longer overlaps the panel.",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzlights.title": "No more freezes between rooms",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzlights.intro": "A fix in the crypts, the cellars and the Furrows.",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzlights.freeze": "The screen no longer freezes when you change rooms",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzlights.freeze.desc": "Coming within reach of another room's light could freeze the screen for a second or more, mostly on computers with a modest graphics card. Now the game gets that light ready ahead of time and play stays smooth.",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzscreen.title": "The table comes back on its own",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzscreen.intro": "A fix for when the screen drops out.",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzscreen.gl": "If the screen drops out, the game waits for it",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzscreen.gl.desc": "Sometimes the browser takes the graphics card away from the game for a moment. We used to ask you to reload right away, and reloading too soon showed \"couldn't start WebGL\". Now the game waits for the screen to come back and reloads by itself, and if the card still isn't ready it keeps trying on its own.",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzzzzzzzzzhelpers.title": "Helping replay a chapter gives your unique piece",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzzzzzzzzzhelpers.intro": "An improvement to chapters played again.",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzzzzzzzzzhelpers.unique": "Those who come along get their unique piece too",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzzzzzzzzzhelpers.unique.desc": "If you come along with a friend playing a chapter again and you win its last fight together, you get the unique piece of your class that chapter gives, if you don’t have it yet. Handy above all if you changed hero.",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzzzzzzzzmammoth.title": "The mammoth doesn’t stop",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzzzzzzzzmammoth.intro": "A fix for waves with a battle plan.",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzzzzzzzzmammoth.march": "The mammoth no longer stands still",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzzzzzzzzmammoth.march.desc": "When the general held its nightmares outside the walls, the ash mammoth waited with them without fighting back. Now it never waits: it walks in on its own, straight for the keep, as its description says.",
  "tree.caps": "Armor and cooldown: how far you are",
  "tree.capGear": "{n} % from gear (cap {m} %)",
  "tree.capLevel": "{n} % from level ({m} % at level {l})",
  "tree.capOver": "{n} % wasted",
  "tree.capNoLevel": "Level adds none",
  "tree.capClass": "{n} % from your class",
  "tree.capGearFull": "{n} % from gear (at its cap)",
  "tree.capTotal.armor": "{n} %",
  "tree.capTotal.cooldown": "−{n} %",
  "levelGain.hp": "+{v} health",
  "levelGain.attack": "+{v} attack",
  "levelGain.rank": "skills to rank {n}",
  "hero.nextLevel": "At level {l}: {gains}",
  "news.2026-10-28-zzzzzzzzzzzzzzzbulk.title": "The bulk won't stand and take it",
  "news.2026-10-28-zzzzzzzzzzzzzzzbulk.intro": "A change to how waves with a plan attack.",
  "news.2026-10-28-zzzzzzzzzzzzzzzbulk.bulk": "Going out after the bulk sets it off",
  "news.2026-10-28-zzzzzzzzzzzzzzzbulk.bulk.desc": "When a wave has a plan, its bulk waits outside, away from the towers, until the horn. Now, if a hero comes out to hit it while it waits, the bulk charges at once at the gate or the flank left uncovered, instead of standing there taking blows.",
  "news.2026-10-28-zzzzzzzzzzzzzzlevel.title": "What each level gives",
  "news.2026-10-28-zzzzzzzzzzzzzzlevel.intro": "An improvement to the hero sheet.",
  "news.2026-10-28-zzzzzzzzzzzzzzlevel.level": "What you gain on a level, said plainly",
  "news.2026-10-28-zzzzzzzzzzzzzzlevel.level.desc": "When you level up, the card at the end says what you gained: health, attack, armor, cooldown and your skills' rank when it changes. The hero sheet shows the same for the next level. The armor and cooldown box now gives the total and where it comes from: your class, your gear and your level.",
  "news.2026-10-28-zzzzzzzzzzzcaps.title": "Caps in sight",
  "news.2026-10-28-zzzzzzzzzzzcaps.intro": "An improvement to the hero sheet.",
  "news.2026-10-28-zzzzzzzzzzzcaps.caps": "How much armor and cooldown you have",
  "news.2026-10-28-zzzzzzzzzzzcaps.caps.desc": "Under the skills there is a box for armor and cooldown: how much your gear gives against its cap, and how much your level gives against its maximum. If your gear goes past the cap, it says how much is wasted, so you know to forge something else.",
  "uawaken.title": "Awaken",
  "uawaken.stage": "Awake {n}",
  "uawaken.done": "Fully awake: nothing left to wake.",
  "uawaken.gives": "The next stage adds {a} % to the attributes that don't grow with your level, makes its effect {e} % stronger and its power {p} % stronger (more reach, more damage, less recharge). The other attributes follow your level.",
  "uawaken.needLevel": "Hero at level {n} (you are {m})",
  "uawaken.needSeal": "A {s} (you have {n})",
  "uawaken.needDust": "{n} dream dust from the storage (it holds {m})",
  "uawaken.needRares": "{n} rare pieces from your bag to melt (you have {m})",
  "uawaken.melts": "The {n} weakest rares in your bag are melted.",
  "seal.deep": "deep crypt seal (clear it to the last floor)",
  "seal.furrows": "Furrows seal (win the centre)",
  "seal.tide": "tide seal (fell a boss of the new Mareas)",
  "seal.dragon": "dragon seal (fell the Drowned Dragon, at the Shore)",
  "log.uniqueAwakened": "{who} awakened {u} (stage {n})",
  "log.uniqueAwakened.you": "You awakened {u} (stage {n})",
  "log.seal": "{who} earned a {s}",
  "log.seal.you": "You earned a {s}",
  "reason.notUnique": "Only unique pieces can be awakened.",
  "reason.maxAwaken": "That piece is fully awake.",
  "reason.heroLevel": "Your hero isn't at the level that stage asks yet.",
  "reason.noSeal": "You need that stage's seal.",
  "reason.fuel": "Not enough rare pieces in the bag to melt.",
  "seal.count": "{n} {s}",
  "seal.deep.short": "deep crypt seal",
  "seal.furrows.short": "Furrows seal",
  "seal.tide.short": "tide seal",
  "seal.dragon.short": "dragon seal",
  "saga.blocked.level": "This chapter opens when the group reaches level {n} (today it is {g}: the active heroes' average).",
  "saga.blocked.era": "This chapter opens when the bastion reaches {era}.",
  "log.uniqueKept": "{who} earned the unique piece ({s}): it comes on reaching level {n}",
  "log.uniqueKept.you": "You earned the unique piece ({s}): it comes on reaching level {n}",
  "saga.result.uniqueKept": "It is yours: it comes when you reach level {n}.",
  "news.2026-10-28-zzzzzzzzzzzzzzzzlive.title": "Tougher waves when you play live",
  "news.2026-10-28-zzzzzzzzzzzzzzzzlive.intro": "A change to the bastion's waves.",
  "news.2026-10-28-zzzzzzzzzzzzzzzzlive.live": "The wave grows with who is there",
  "news.2026-10-28-zzzzzzzzzzzzzzzzlive.live.desc": "Every hero who joins a wave live makes it bigger: ghosts don't play as well as you do. And in the late Tides, once every nightmare already comes inked, what used to be lost now makes them tougher and hit harder.",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzhelp.title": "Helping on boxed-in sites",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzhelp.intro": "A fix in the bastion.",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzhelp.boxed": "Helping on a site surrounded by towers",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzhelp.boxed.desc": "When a site against the wall was surrounded by towers and walls, your hero walked out through the gate and stood outside without helping. Now they stand on the nearest free spot inside, even if it is a little farther, and the help counts from there.",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzzrooms.title": "Smoother rooms",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzzrooms.intro": "An improvement for more modest computers.",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzzrooms.smooth": "Fewer stalls when entering a crypt room",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzzrooms.smooth.desc": "On some computers the screen still froze for a moment when a pack of nightmares came into a new room, or when a warrior raised their oath. Now the game prepares that in the first seconds of the run, before it is needed.",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzzzwatch.title": "What rises in era IV",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzzzwatch.intro": "Three new buildings for the Vigil's Bastion.",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzzzwatch.trebuchet": "Trebuchet",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzzzwatch.trebuchet.desc": "A new era IV tower: it hurls huge stones from farther than the catapult, slowly and in an area, and hits giants, colossi and siege engines harder. It can't reach flyers. It goes up to level 5 like the others.",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzzzwatch.watchtower": "The ranger's watchtower",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzzzwatch.watchtower.desc": "Towers nearby reach farther, more so with a ranger in the fight. It reveals the invisible and marks what moves under the ground so it can be hit before it surfaces. One per bastion.",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzzzwatch.sanctum": "The cleric's sanctum",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzzzwatch.sanctum.desc": "After every wave it mends a little of what stands nearby, and in a fight it slowly heals the heroes who stay beside it; more with a cleric. One per bastion.",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzzzmemory.title": "Lighter long sessions",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzzzmemory.intro": "An improvement for those who play for a good while.",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzzzmemory.lighter": "Less memory when going in and out of fights",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzzzmemory.lighter.desc": "Each time you left a fight or the bastion, the page unintentionally kept a copy of what you left behind, and after many trips it grew heavy. Now it lets go when you leave: even an hour of play without reloading stays just as quick.",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzstages.title": "Waves that build up",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzstages.intro": "The bastion's waves change their rhythm.",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzstages.stages": "The wave builds as it comes",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzstages.stages.desc": "Waves no longer arrive evenly: they start light and grow thicker to the end, where the warlord comes. Same nightmares, but the fight lasts longer and tightens at the close.",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzstages.last": "Shooters don't stay outside",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzstages.last.desc": "Once everything else has fallen, the archers and mangonels shooting from afar stop and come in to fight. The wave no longer drags on waiting for one that won't come closer.",
  "great.crown": "Crown the keep",
  "great.crownName": "Crowning of the keep",
  "great.crownDesc": "From era IV the Great Work raises no district: it crowns the keep and restores it to what it was. The golems raise it over hours, like any work.",
  "great.crowned": "The keep is crowned! {era} begins.",
  "log.crowned": "The keep was crowned: {era} begins",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzzzzzzfonts.title": "The menu opens without a jump",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzzzzzzfonts.intro": "A fix when opening the game.",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzzzzzzfonts.fonts": "The lettering no longer changes on opening",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzzzzzzfonts.fonts.desc": "When opening the game, the menu showed for an instant in other lettering and then switched. Now it waits for the game's lettering and appears all at once.",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzzzzzzzzzstart.title": "Fights that start without stutter",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzzzzzzzzzstart.intro": "An improvement for more modest phones and computers.",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzzzzzzzzzstart.smooth": "Incursions start smoothly",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzzzzzzzzzstart.smooth.desc": "On some phones the first seconds of an incursion stuttered, because the game prepared the coming nightmares while you were already fighting. Now it prepares them before the clock starts: the fight may take a moment longer to begin, but it begins smoothly. The bastion no longer freezes either when a friend comes online or a companion turns into a spectre.",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzzzzzperk.title": "The bastion shows what you added up",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzzzzzperk.intro": "A fix in the skill tree.",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzzzzzperk.total": "Bastion perks show the total",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzzzzzperk.total.desc": "After learning the second rank of a bastion perk, the tree kept showing the percentage of a single rank, even though the effect did add up. Now it shows your total and what the next rank gives.",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzzzzcarry.title": "What you carry, on your buttons",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzzzzcarry.intro": "A fix for those who switch preparation before setting out.",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzzzzcarry.buttons": "The buttons show the preparation picked in the waiting room",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzzzzcarry.buttons.desc": "If you switched preparation in the waiting room, the hero set out with the new skills but the buttons kept the picture, name and description of the old ones. Now the buttons change along with what you carry.",
  "gear.name": "{base} {suffix}",
  "gear.hands.1": "One-handed",
  "gear.hands.2": "Two-handed",
  "weight.cloth": "Cloth",
  "weight.leather": "Leather",
  "weight.mail": "Mail",
  "weight.plate": "Plate",
  "rarity.veryRare": "Very rare",
  "slot.offhand": "Off hand",
  "slot.head": "Head",
  "slot.boots": "Boots",
  "slot.ring": "Ring",
  "reason.notYourClass": "Your class can't use that piece.",
  "reason.slotLocked": "That slot opens later, as you level up.",
  "reason.tooPowerful": "That piece is still too powerful for your level.",
  "reason.twoHanded": "A two-handed weapon leaves no hand free.",
  "gear.base.longsword": "Longsword",
  "gear.base.handaxe": "Hand axe",
  "gear.base.mace": "Mace",
  "gear.base.warhammer": "War hammer",
  "gear.base.wand": "Wand",
  "gear.base.sickle": "Sickle",
  "gear.base.shortbow": "Short bow",
  "gear.base.greatsword": "Greatsword",
  "gear.base.greataxe": "Great axe",
  "gear.base.maul": "Maul",
  "gear.base.staff": "Staff",
  "gear.base.quarterstaff": "Quarterstaff",
  "gear.base.longbow": "Longbow",
  "gear.base.heavyCrossbow": "Heavy crossbow",
  "gear.base.shield": "Shield",
  "gear.base.offAxe": "Off-hand axe",
  "gear.base.grimoire": "Grimoire",
  "gear.base.orb": "Orb",
  "gear.base.holySymbol": "Holy symbol",
  "gear.base.quiver": "Quiver",
  "gear.base.toolkit": "Toolkit",
  "gear.base.totem": "Totem",
  "gear.base.circlet": "Circlet",
  "gear.base.hood": "Hood",
  "gear.base.coif": "Mail coif",
  "gear.base.helm": "Helm",
  "gear.base.robe": "Robe",
  "gear.base.jerkin": "Leather jerkin",
  "gear.base.hauberk": "Hauberk",
  "gear.base.breastplate": "Breastplate",
  "gear.base.clothBoots": "Cloth boots",
  "gear.base.leatherBoots": "Leather boots",
  "gear.base.mailBoots": "Mail boots",
  "gear.base.greaves": "Greaves",
  "gear.base.pendant": "Pendant",
  "gear.base.reliquary": "Reliquary",
  "gear.base.torc": "Torc",
  "gear.base.eye": "Eye",
  "gear.base.talisman": "Talisman",
  "gear.base.signet": "Signet",
  "gear.base.band": "Band",
  "gear.base.stoneRing": "Stone ring",
  "gear.base.eyeRing": "Eye ring",
  "gear.base.wardRing": "Ward ring",
  "gear.suffix.damage": "of Might",
  "gear.suffix.hp": "of Vigor",
  "gear.suffix.attackSpeed": "of Swiftness",
  "gear.suffix.cooldown": "of the Scholar",
  "gear.suffix.armor": "of Iron",
  "gear.suffix.crit": "of Precision",
  "gear.suffix.resFire": "of the Flame",
  "gear.suffix.resFrost": "of Winter",
  "gear.suffix.resLightning": "of the Storm",
  "gear.suffix.resAcid": "of Acid",
  "gear.suffix.resPoison": "of Venom",
  "gear.suffix.resShadow": "of Shadow",
  "gear.suffix.burn": "of Ash",
  "gear.suffix.lifesteal": "of the Bloodthirsty",
  "gear.suffix.thorns": "of Thorns",
  "gear.suffix.swift": "of the Wanderer",
  "gear.suffix.fury": "of Fury",
  "gear.suffix.execute": "of the Headsman",
  "gear.suffix.chain": "of the Spark",
  "gear.suffix.frost": "of Frost",
  "gear.suffix.cleave": "of the Reaper",
  "gear.suffix.guard": "of the Watch",
  "gear.suffix.echo": "of Echoes",
  "gear.suffix.banner": "of the Standard-bearer",
  "gear.ringN": "Ring {n}",
  "gear.trait.title": "Trait",
  "gear.trait.boosted": "(+{n}% from the set)",
  "gear.trait.none": "No trait: your class's usual piece.",
  "gear.trait.legacy": "A piece from before piece types: no trait.",
  "gear.trait.uniqueNone": "Unique pieces carry no trait: their power is their effect.",
  "gear.trait.melee": "Fights in melee",
  "gear.trait.attack": "{v}% basic attack blow",
  "gear.trait.attackSpeed": "{v}% attack speed",
  "gear.trait.range": "{v}% reach",
  "gear.trait.damage": "{v}% damage",
  "gear.trait.hp": "{v}% life",
  "gear.trait.armor": "{v}% armor",
  "gear.trait.speed": "{v}% movement",
  "gear.trait.cooldown": "{v}% skill cooldown",
  "gear.trait.crit": "{v}% critical chance",
  "gear.trait.bigFoe": "{v}% against elites, bosses and guardians",
  "gear.trait.cleave": "Cleave: {v}% of the blow reaches those beside (does not add to {fx}: the stronger counts)",
  "gear.trait.stun": "Every {n} blows stuns for {s} s",
  "gear.trait.pierce": "The bolt carries on into the nightmare behind",
  "gear.trait.block": "{v}% chance to block a melee blow (you take half)",
  "gear.trait.skill": "{v}% skill damage",
  "gear.trait.heal": "{v}% healing",
  "gear.trait.summon": "Turrets and automaton last {v}%",
  "gear.trait.res": "{v}% against {type}",
  "gear.power": "Power {n}",
  "gear.powerHint": "Power comes from where the piece fell: your level plus what the place adds. The deeper, the more power.",
  "gear.avgPower": "Power {n}",
  "gear.forgedHint": "Forge points in this attribute",
  "gear.inBag": "In the bag",
  "gear.reachAt": "You'll be able to wear it at level {n}.",
  "gear.equipRing": "To ring {n}",
  "gear.lockedAt": "Opens at level {n}",
  "gear.lv": "Lv {n}",
  "gear.heldByTwo": "Taken by the two-handed weapon",
  "gear.emptySlot": "Empty",
  "gear.fits": "From your bag, this fits here:",
  "gear.pick": "Tap a slot or a piece to see it up close.",
  "gear.bagEmpty": "The bag is empty. What drops and isn't worn waits here.",
  "gear.setOn": "{w} set: traits +{n}%",
  "gear.setHint": "Head, chest and feet of one weight: their traits count more.",
  "gear.dustHint": "Dust in everyone's storage (the forge uses it).",
  "gear.what.weapon": "The weapon: one-handed (with something in the other hand) or two-handed.",
  "gear.what.offhand": "The other hand: a shield, grimoire, orb, holy symbol, quiver, second axe, toolkit or totem, by class. A two-handed weapon takes it.",
  "gear.what.head": "A circlet, hood, coif or helm, up to the weight your class wears.",
  "gear.what.armor": "A robe, jerkin, hauberk or breastplate, up to the weight your class wears.",
  "gear.what.boots": "Cloth, leather or mail boots, or greaves, up to the weight your class wears.",
  "gear.what.amulet": "A pendant, reliquary, torc, eye or talisman: amulets suit any class.",
  "gear.what.ring": "A signet, band, stone ring, eye ring or ward ring. Two alike are not worth double: mix them.",
  "gear.dust": "{n} dust",
  "slot.plural.weapon": "Weapons",
  "slot.plural.offhand": "Off hands",
  "slot.plural.head": "Head",
  "slot.plural.armor": "Chest",
  "slot.plural.boots": "Boots",
  "slot.plural.amulet": "Amulets",
  "slot.plural.ring": "Rings",
  "news.2026-10-29-zzzgear.title": "New gear",
  "news.2026-10-29-zzzgear.intro": "More slots, pieces with a name and a shape, and loot that grows with how far you go.",
  "news.2026-10-29-zzzgear.slots": "Five more slots",
  "news.2026-10-29-zzzgear.slots.desc": "Besides weapon, armor and amulet: boots from level 3, the other hand from 4 (shield, grimoire, orb, quiver, second axe and more, by class), head from 6, and two rings at 26 and 36. What you already wear stays the same.",
  "news.2026-10-29-zzzgear.bases": "Every piece is something",
  "news.2026-10-29-zzzgear.bases.desc": "A piece is now a longsword, a greatsword, a wand, a sickle, a hauberk or greaves, with its own name and a trait: a shield blocks, a greatsword cuts those beside, a crossbow bolt carries on, a sickle takes the druid into melee. Two hands, or one hand and something in the other: each class picks between two styles. Head, chest and feet have a weight (cloth, leather, mail, plate), and all three of one weight count for more.",
  "news.2026-10-29-zzzgear.power": "What drops has power",
  "news.2026-10-29-zzzgear.power.desc": "Every new piece carries a power number: your level plus what the place where it fell adds. The deeper the place (high incursions, the deep crypt, the cellars, the heart of the Furrows), the stronger its numbers. From power 20 on, very rare pieces show up, with one more attribute. A piece too powerful for your level waits in your bag until you get there.",
  "news.2026-10-29-zzzgear.sheet": "The Gear tab, rebuilt",
  "news.2026-10-29-zzzgear.sheet.desc": "Your hero in the middle with the slots around, each piece with its miniature and its rarity color. Tap a slot or a piece in your bag to see it all: trait, attributes, effect, power, how it compares with what you wear, and the forge. If your class can’t use it, it tells you who in the group it suits.",
  "news.2026-10-29-zzzzwork.title": "Helping on a site, at its real pace",
  "news.2026-10-29-zzzzwork.intro": "The site clock counts everything your hero adds.",
  "news.2026-10-29-zzzzwork.help": "The work bonus shows",
  "news.2026-10-29-zzzzwork.help.desc": "With the work bonus, or as a barbarian, the site already went faster, but the clock, the bar and the «×6» stayed as if without it, and the gain showed up all at once a while later. Now they show the real pace: for example ×7.5 with the full bonus and a golem on the site.",
  "news.2026-10-29-zzzzzlook.title": "Your hero wears what you equip",
  "news.2026-10-29-zzzzzlook.intro": "Your gear shows on the miniature, from head to boots.",
  "news.2026-10-29-zzzzzlook.hands": "Your gear, in plain sight",
  "news.2026-10-29-zzzzzlook.hands.desc": "In the bastion, in fights and on the sheet, your hero holds the weapon you wear, with the runes of its rarity, and what you carry in the other hand: shield, orb, totem, second axe. With a two-handed weapon, the other hand stays free. The helm, hood or circlet, the armor and the boots change with their weight: cloth, leather, mail or plate. On the sheet your hero faces you, so both hands show.",
  "gem.emerald": "Emerald",
  "gem.withCut": "{cut} {gem}",
  "gemCut.chipped": "Chipped",
  "gemCut.whole": "Whole",
  "gemCut.polished": "Polished",
  "gemCut.perfect": "Perfect",
  "gemCut.titan": "Titan's",
  "socket.take": "Take out",
  "socket.noGems": "No gems in your pouch: cut them from crystal in the gem pouch, on the Gear tab.",
  "socket.max": "This piece already has all its settings ({n}).",
  "socket.openLevel": "Setting {n} opens at level {l}.",
  "socket.openN": "Open setting {n}",
  "gems.title": "Gem pouch",
  "gems.needForge": "Gems are cut at the forge: build one to start.",
  "gems.cut": "Cut {cut}",
  "gems.fuse": "Fuse 3 into {cut}",
  "gems.fuseLevel": "The {cut} cut opens at level {n}.",
  "gems.hint": "Gems are cut from the storage’s crystal; three of a cut fuse into one of the next. They count by slot (half on head, boots, off hand and rings) and the gems of one attribute add up to +{cap}% at most. Taking a gem out keeps it: it comes back here.",
  "reason.maxSockets": "That piece already has all its settings.",
  "reason.levelTooLow": "You don't have the level for that yet.",
  "reason.noGem": "You don't have that gem in your pouch.",
  "log.gemSet": "{who} set {gem} in their {what}",
  "log.gemSet.you": "You set {gem} in your {what}",
  "log.gemCut": "{who} cut {gem}: −{c} crystal and −{d} common dust",
  "log.gemCut.you": "You cut {gem}: −{c} crystal and −{d} common dust",
  "log.gemFuse": "{who} fused three gems into {gem}: −{d} common dust",
  "log.gemFuse.you": "You fused three gems into {gem}: −{d} common dust",
  "news.2026-10-29-zzzzzzgems.title": "Settings and gems",
  "news.2026-10-29-zzzzzzgems.intro": "Every piece takes settings, and gems are cut and fused.",
  "news.2026-10-29-zzzzzzgems.settings": "Settings on everything",
  "news.2026-10-29-zzzzzzgems.settings.desc": "Any piece can take settings, not only rares: commons and uncommons one, and a very rare two-handed weapon up to three. The first opens from level 5 for 50 dust; the second from 12 with embers; the third from 25 with shards. The settings you already had stay as they are.",
  "news.2026-10-29-zzzzzzgems.gems": "Gems by cut",
  "news.2026-10-29-zzzzzzgems.gems.desc": "The Gear tab has a gem pouch: gems are cut from the storage’s crystal (chipped or whole) and three of a cut fuse into one of the next: polished, perfect and, later on, titan’s. The emerald arrives, adding precision. Taking a gem out of a setting no longer breaks it: it goes back to the pouch. Gems count by slot, and the gems of one attribute add up to +24% at most.",
  "loot.dayBase": "Falling more today: {base}",
  "loot.dayBaseHint": "Each day one piece drops three times as often in incursions, crypts, cellars and the Furrows.",
  "gear.meltCommons": "Melt {n} commons",
  "gear.meltCommonsHint": "Melts every common piece in the bag into dust for the storage.",
  "gear.suits": "It suits: {who}",
  "gear.suitsNobody": "nobody in the group, for now",
  "news.2026-10-29-zzzzzzzloot.title": "Loot for the group",
  "news.2026-10-29-zzzzzzzloot.intro": "What drops is also for your friends, and each place drops its own.",
  "news.2026-10-29-zzzzzzzloot.group": "Pieces to give away",
  "news.2026-10-29-zzzzzzzloot.group.desc": "Some of what drops is for another class in your group. The sheet says who it suits and lets you give it away: it reaches them even if they are not online. Amulets and rings suit anyone.",
  "news.2026-10-29-zzzzzzzloot.places": "Each place, its loot",
  "news.2026-10-29-zzzzzzzloot.places.desc": "Incursions drop more weapons; lairs, more off-hands; the crypt, more armor; the cellars, more helms; the Furrows, more amulets; the deep crypt, more boots. And each day one piece drops three times as often: the incursions panel names it next to the omen.",
  "news.2026-10-29-zzzzzzzloot.bag": "A bigger bag",
  "news.2026-10-29-zzzzzzzloot.bag.desc": "The bag goes from 12 to 20 places, and one button melts every common piece at once.",
  "armory.title": "The group’s armory",
  "armory.count": "{n} of {of}",
  "armory.hint": "The best piece of each kind the group has found, and who found it. The missing ones are in shadow. The six best stand on the rack by the forge.",
  "armory.missing": "Not found yet",
  "news.2026-10-29-zzzzzzzzarmory.title": "The armory",
  "news.2026-10-29-zzzzzzzzarmory.intro": "The best the group has found, on show.",
  "news.2026-10-29-zzzzzzzzarmory.rack": "A rack by the forge",
  "news.2026-10-29-zzzzzzzzarmory.rack.desc": "A rack rises by the forge with the six best pieces the group has found, runes and all. On the Gear tab, «The group’s armory» shows the best of each kind, who found it and, in shadow, the ones still missing.",
  "gear.set.garrison": "of the Garrison",
  "gear.set.depths": "of the Warden",
  "gear.set.furrows": "of the Furrows",
  "gear.set.tide": "of the Tide",
  "set.garrison": "the Garrison",
  "set.depths": "the Warden",
  "set.furrows": "the Furrows",
  "set.tide": "the Tide",
  "set.garrison.place": "the garrison cellars",
  "set.depths.place": "the deep crypt",
  "set.furrows.place": "the Furrows",
  "set.tide.place": "the deep Tides (warlords and bosses)",
  "gear.setName": "Set of {set}",
  "gear.setTwo": "2 pieces: {what}",
  "gear.setThree": "All of them: {what}",
  "gear.setWhere": "Its pieces drop in {place}, from level {n}.",
  "reforge.directedTitle": "Directed reforge",
  "reforge.directedHint": "Pick the attribute and what it becomes; the value is rolled anew in its range. It costs three reforges.",
  "masterwork.title": "Masterwork",
  "masterwork.hint": "Raises every attribute of this piece to the top of its range. One per hero: choose well.",
  "masterwork.level": "From level {n}, a very rare piece can become your masterwork.",
  "masterwork.used": "Your hero has already made its masterwork.",
  "masterwork.done": "This piece is your masterwork.",
  "masterwork.go": "Make the masterwork",
  "masterwork.badge": "Masterwork",
  "gear.titan": "Titan’s mark",
  "gear.titanHint": "Level 50: your hero wears its own glow, in the bastion and in fights.",
  "reason.notVeryRare": "Only a very rare piece can be a masterwork.",
  "reason.masterworkUsed": "Your hero has already made its masterwork.",
  "log.masterwork": "{who} made their {what} a masterwork: −{d} common dust",
  "log.masterwork.you": "You made your {what} your masterwork: −{d} common dust",
  "news.2026-10-29-zzzzzzzzzlong.title": "Sets and the high-level forge",
  "news.2026-10-29-zzzzzzzzzlong.intro": "For the long stretch from 18 to 50.",
  "news.2026-10-29-zzzzzzzzzlong.sets": "Four sets",
  "news.2026-10-29-zzzzzzzzzlong.sets.desc": "Four sets of three pieces, each from one place: the Garrison (cellars, from level 18), the Warden (deep crypt, 28), the Furrows (33) and the Tide (deep Tides, 42). Two pieces give a bonus; all three, an effect. They can be given away like any piece, so the group builds the set together.",
  "news.2026-10-29-zzzzzzzzzlong.forge": "Directed reforge and masterwork",
  "news.2026-10-29-zzzzzzzzzlong.forge.desc": "From level 38, the forge lets you pick what an attribute becomes, at triple the dust. From 48, a very rare piece can become your masterwork: every attribute at the top, one per hero.",
  "deeds.dmg": "Damage",
  "deeds.heal": "Healing",
  "deeds.taken": "Taken",
  "deeds.kills": "Kills",
  "deeds.perSec": "{n}/s",
  "deeds.selfHeal": "{n} self",
  "deeds.downs": "fell {n} times",
  "deeds.downsOne": "fell once",
  "deeds.noDowns": "never fell",
  "deeds.ghost": "Fought as a ghost",
  "deeds.fights": "{n} fights",
  "deeds.fightOne": "1 fight",
  "deeds.title.dmg": "Scourge",
  "deeds.title.dmgWhy": "Dealt the most damage",
  "deeds.title.heal": "Healing hand",
  "deeds.title.healWhy": "Gave the others back the most life",
  "deeds.title.taken": "Living wall",
  "deeds.title.takenWhy": "Withstood the most blows",
  "deeds.title.kills": "Headsman",
  "deeds.title.killsWhy": "Finished off the most nightmares",
  "deeds.fightTitle": "How each one fought",
  "deeds.go": "Continue",
  "deeds.waveOpen": "See who did what",
  "deeds.hall": "Deeds",
  "deeds.intro": "The campaign's ranking: what each of you did in the fights you played live (what ghosts do doesn't count) and in the bastion.",
  "deeds.empty": "No deeds yet. Every fight you play live (waves, incursions, crypts, cellars, the Furrows or the saga) adds up here.",
  "deeds.modes": "Kind of fight",
  "deeds.mode.all": "All",
  "deeds.mode.wave": "Waves",
  "deeds.mode.incursion": "Incursions",
  "deeds.mode.crypt": "Crypts",
  "deeds.mode.expedition": "Cellars",
  "deeds.mode.maze": "Furrows",
  "deeds.mode.saga": "Saga",
  "deeds.records": "Single-fight records",
  "deeds.record.dps": "Most damage per second",
  "deeds.record.hps": "Most healing to others per second",
  "deeds.record.taken": "Most damage withstood",
  "deeds.record.kills": "Most kills",
  "works.title": "The bastion",
  "works.intro": "What each of you did for the bastion. Counted since October 30.",
  "works.gathered": "Gathered",
  "works.given": "Given",
  "works.workMin": "Work",
  "works.raised": "Raised",
  "works.dust": "+{n} dust",
  "works.min": "{n} min",
  "news.2026-10-31-zzzzzzzzzzzzzzworks.hint.desc": "In Deeds, under Gathered, Given, Work and Raised, a line explains what each one adds up: loot brought home from incursions, materials put into blueprints and tasks, minutes on site and the works you planned that got finished.",
  "news.2026-10-31-zzzzzzzzzzzzzzworks.hint": "What each tab counts",
  "news.2026-10-31-zzzzzzzzzzzzzzworks.intro": "The bastion tabs now say what they count.",
  "news.2026-10-31-zzzzzzzzzzzzzzworks.title": "Clearer deeds",
  "works.raised.desc": "Works they planned that got finished: buildings, level and material upgrades, and great works.",
  "works.workMin.desc": "Minutes they worked on site.",
  "works.given.desc": "What they took from the storehouse and put into blueprints and board tasks. Bringing loot home from incursions doesn't count here.",
  "works.gathered.desc": "What they brought back to the storehouse from incursions. When several went live, it is shared among them.",
  "news.2026-10-29-zzzzzzzzzzzzzzzzzzdeeds.title": "Deeds",
  "news.2026-10-29-zzzzzzzzzzzzzzzzzzdeeds.intro": "Who hit hardest, who healed most and who held the line.",
  "news.2026-10-29-zzzzzzzzzzzzzzzzzzdeeds.deeds": "How each one fought",
  "news.2026-10-29-zzzzzzzzzzzzzzzzzzdeeds.deeds.desc": "At the end of any fight (waves, incursions, crypts, cellars, the Furrows and the saga) you see each hero's damage and damage per second, the healing they gave, the damage they took and the nightmares they finished off, with titles for the best at each. In the history, every wave keeps its own.",
  "news.2026-10-29-zzzzzzzzzzzzzzzzzzdeeds.hall": "The campaign's ranking",
  "news.2026-10-29-zzzzzzzzzzzzzzzzzzdeeds.hall.desc": "The Deeds button in the bastion adds up everything each of you did in the fights you played live, by kind of fight, with single-fight records. It starts counting today.",
  "bet.title": "Brann and Hilde's bets",
  "bet.intro": "Brann and Hilde agree on nothing. Now they bet, and you are the ones who play.",
  "bet.barrels": "Barrels won: {n}. They stand by the keep.",
  "bet.favor": "{yes} bets you can. {no} bets you can't.",
  "bet.won": "Won",
  "bet.take": "Take the bet",
  "bet.again": "Play again",
  "bet.locked": "From group level {n} (now: {g})",
  "bet.result.wonTitle": "Bet won",
  "bet.result.lostTitle": "Bet lost",
  "bet.result.won": "{no} pays {yes} a barrel. \"Don't make a habit of it.\"",
  "bet.result.again": "{no} already paid for this one. This time it's a grudging \"well done\".",
  "bet.result.lost": "{no} laughs. You can try again.",
  "bet.result.barrel": "The barrel stands by the keep.",
  "bet.result.best": "Most you felled together: {n} of {of}.",
  "bet.hud.of": "of {n} in 10 s",
  "bet.hud.left": "{t} left",
  "bet.hud.time": "Time",
  "bet.result.barrelTitle": "A barrel for the pile",
  "bet.result.xp": "+{n} experience for each hero.",
  "bet.hud.best": "best {n}",
  "bet.cart": "Barrel",
  "bet.towers.title": "No towers",
  "bet.towers.rule": "Hold the clearing with heroes alone: not a single turret may be planted.",
  "bet.towers.hud": "No turrets: heroes only.",
  "bet.towers.brann": "\"In my day we defended with sticks.\"",
  "bet.towers.hilde": "\"In your day the fortress fell.\"",
  "bet.towers.brann2": "\"That's why I came back.\"",
  "bet.dark.title": "In the dark",
  "bet.dark.rule": "At night. Only what the heroes' lanterns and the clearing's brazier light can be seen.",
  "bet.dark.hud": "In the dark: what no lantern lights can't be seen or attacked.",
  "bet.dark.brann": "\"These ones see in the dark. Like me.\"",
  "bet.dark.hilde": "\"You can't see by day.\"",
  "bet.barrel.title": "The barrel",
  "bet.barrel.rule": "Take the old garrison's barrel of beer from the barracks to the forge. If it gets hit, it leaks.",
  "bet.barrel.hud": "Get the barrel to the forge with something still in it.",
  "bet.barrel.brann": "\"Forty years waiting for that barrel.\"",
  "bet.barrel.hilde": "\"If it arrives empty, you pay for it.\"",
  "bet.hundred.title": "A hundred at a blow",
  "bet.hundred.rule": "Fell a hundred nightmares within ten seconds, before time runs out.",
  "bet.hundred.hud": "A hundred down within ten seconds.",
  "bet.hundred.brann": "\"Can't be done.\"",
  "bet.hundred.hilde": "\"You'll see.\"",
  "bet.unscathed.title": "Not a scratch",
  "bet.unscathed.rule": "Hilde ringed the clearing with her walls. If a single nightmare hits them, the bet is lost.",
  "bet.unscathed.hud": "Not one blow on Hilde's walls.",
  "bet.unscathed.brann": "\"Walls are there to be hit.\"",
  "bet.unscathed.hilde": "\"Not mine.\"",
  "bet.unscathed.hit": "Hilde's wall took a blow!",
  "bet.unscathed.lost": "A nightmare reached Hilde's walls.",
  "bet.beside.title": "Beside",
  "bet.beside.rule": "Hilde brought her towers and set them in pairs round the node. They only shoot with a hero beside them. No turrets.",
  "bet.beside.hud": "Hilde's towers only shoot with a hero beside them.",
  "bet.beside.brann": "\"Towers don't think.\"",
  "bet.beside.hilde": "\"Mine do.\"",
  "bet.race.title": "The race",
  "bet.race.rule": "Go down the deep crypt to its Warden and fell it in under three minutes. The clock starts when you go in.",
  "bet.race.hud": "Fell the Warden before time runs out.",
  "bet.race.brann": "\"I used to do it in half that.\"",
  "bet.race.hilde": "\"You used to do it drunk.\"",
  "bet.race.ready": "The clock starts when you go in",
  "bet.race.brannAt": "Brann: {t}",
  "bet.race.brannPast": "Past Brann's time",
  "bet.race.beatBrann": "{t}: faster than Brann",
  "bet.race.inTime": "{t}: in time",
  "bet.race.out": "Time ran out: the Warden was still standing.",
  "bet.race.took": "You felled it in {t}.",
  "bet.race.beat": "You felled it in {t}. Brann says he used to take {b}; this time he says nothing.",
  "bet.race.slower": "You felled it in {t}. Brann says he used to take {b}.",
  "bet.alone.title": "One alone",
  "bet.alone.rule": "The whole fight comes down a single road, and there are no turrets. Brann drove stakes at its mouth: if {n} nightmares get into the clearing, the bet is lost.",
  "bet.alone.hud": "Nothing past Brann's stakes: {n} of {of}.",
  "bet.alone.brann": "\"Gaspar did it.\"",
  "bet.alone.hilde": "\"Gaspar had towers.\"",
  "bet.alone.hit": "One got through! That's {n} of {of}.",
  "bet.alone.lost": "Too many nightmares got past the road's mouth.",
  "log.betWon": "{names} won the bet \"{bet}\": {payer} pays a barrel.",
  "bet.pileNew": "One more barrel by the keep: won on a bet.",
  "side.title": "Other stories",
  "side.soon": "The story goes on soon.",
  "side.retry": "Losing costs nothing: try again whenever you like. The clues you find stay.",
  "side.forMore": "Made for two or more: with «Play with friends», whoever is online can come in and help.",
  "side.chapter": "Chapter {n} of {of} · {title}",
  "side.closeChapter": "Close the chapter",
  "side.diff.light": "Light",
  "side.diff.medium": "Medium",
  "side.diff.hard": "Hard",
  "side.diff.heroic": "Heroic",
  "side.board.title": "Clue board",
  "side.board.count": "{n} clues on the board",
  "side.board.hint": "What the group found. No clue lies: what confuses is what's missing.",
  "side.board.by": "Found by {who}, {when}",
  "side.board.justNow": "just now",
  "side.board.hours": "{n} h ago",
  "side.board.days": "{n} days ago",
  "side.board.missing": "Something still to find…",
  "side.result.retry": "No harm done: try again whenever you like.",
  "side.result.found": "New clues: {n}",
  "side.result.chapterDone": "Chapter of “{title}” done. What it left goes to the storage.",
  "side.clueFound": "Clue:",
  "side.clueRule": "There are clues in the clearing: stand on one a moment to pick it up.",
  "log.sideClue": "{who} found a clue: \"{clue}\"",
  "log.sideClue.you": "You found a clue: \"{clue}\"",
  "log.sideDone": "The group finished chapter {n} of \"{saga}\"",
  "side.faces.title": "Borrowed faces",
  "side.faces.question": "Of the three who came back, which one isn't who they say?",
  "side.faces.over": "The mystery is solved.",
  "side.faces.back.title": "The ones who came back",
  "side.faces.back.odna.l1": "Odna climbs to the bastion at night, something she never does.",
  "side.faces.back.odna.l2": "Three came back in one week: Ebbe, the drover; Lis, who had gone far away to marry; and Cal, Mada's son.",
  "side.faces.back.odna.l3": "And since they came back, people go missing at night. You know the nightmares: tell me what this is.",
  "side.faces.back.odna.l4": "There's a nightmare that copies faces. The old ones of the Order called it the Facetaker.",
  "side.faces.back.odna.l5": "It can only copy someone who isn't here: someone gone far away, or dead.",
  "side.faces.back.night.title": "Night in Musgoviejo",
  "side.faces.back.night.goal": "Defend the village until dawn and pick up the clues lying in the clearing.",
  "side.faces.back.door.l1": "At dawn, Cal stands in the doorway of Mada's house, in the dark, watching the heroes.",
  "side.faces.back.door.l2": "He says nothing. He goes in and shuts the door.",
  "side.faces.back.door.l3": "What you found goes on the board in the hall. We'll need it.",
  "clue.walked": "Ebbe came back on foot. A drover doesn't leave his cart.",
  "clue.taken": "Two more are missing tonight: the woodcutter and his daughter. The door was left open, no fight.",
  "clue.tracks": "The tracks from the woodcutter's house lead to the forest, not to the village.",
  "side.board.new": "A new clue on the board, by the keep.",
  "side.faces.shadow.title": "No shadow",
  "side.faces.accuse.title": "The accusation",
  "side.faces.mada.title": "Mada",
  "side.waiting": "{who} wants to talk to you about this.",
  "side.openScene": "Listen to {who}",
  "side.done.title": "Chapter done",
  "side.done.body": "“{title}”, chapter {n}: what it left goes to the storage, and everyone who played gains {xp} experience.",
  "side.faces.shadow.order.l1": "Odna orders a night of lanterns.",
  "side.faces.shadow.order.l2": "Tonight the whole village crosses the square, one by one, under the light.",
  "side.faces.shadow.order.l3": "Whatever has a shadow is people. Whatever doesn't is your business.",
  "side.faces.shadow.order.l4": "Carry lanterns. If someone has no shadow, stay by them: a borrowed face can't stand the light up close.",
  "side.faces.shadow.lanterns.title": "The night of lanterns",
  "side.faces.shadow.lanterns.goal": "Walk with your lantern among the people. Whoever has no shadow, stay by them until the face falls off. Don't let one reach the other side.",
  "side.faces.shadow.paper.l1": "Under the lantern, a woman has no shadow. She turns, and her face peels off like wet paper.",
  "side.faces.shadow.paper.l2": "What's underneath is tall and thin. The people scream, and then, little by little, fall silent.",
  "side.faces.shadow.paper.l3": "One is missing. Cal didn't cross the square: Mada says he has a fever.",
  "side.crowdRule": "No shadow under your lantern = impostor. Stay by them.",
  "side.result.escaped": "One reached the other side wearing a borrowed face and was lost in the night.",
  "clue.ebbeFace": "One of the impostors wore Ebbe's face.",
  "clue.missingFaces": "Two others wore the faces of the woodcutter and his daughter, the ones who went missing.",
  "clue.lisShadow": "Lis walked under the lantern: she has a shadow.",
  "clue.calAbsent": "Cal didn't cross the square. Mada said he had a fever.",
  "side.crowdOf": "of {n} faces torn off",
  "side.crowdCrossed": "{n} of {of} have crossed",
  "npc.fenn": "Fenn",
  "npc.fenn.role": "Peddler",
  "side.faces.accuse.fenn.l1": "Fenn the peddler comes running up the bastion's slope, his cart bouncing behind him.",
  "side.faces.accuse.fenn.l2": "Fenn, the peddler. If anyone knows what goes on on the titan, it's him.",
  "side.faces.accuse.fenn.l3": "On the forest road there's a cart of wool. No oxen. No one.",
  "side.faces.accuse.fenn.l4": "Anything else?",
  "side.faces.accuse.fenn.l5": "This. Cal gave it to me on the tail, three days ago. For his mother.",
  "side.faces.accuse.fenn.l6": "Cal is still up there with the herders. He's doing fine. That's what the letter says.",
  "side.faces.accuse.pit.title": "The pit among the roots",
  "side.faces.accuse.pit.goal": "Go into the forest at night, to the cart. Pull the two who went missing out of the pit and bring them to the clearing before the nightmares reach them.",
  "side.faces.accuse.accuse.l1": "The board is full. Odna gathers the heroes in the hall.",
  "side.faces.accuse.accuse.l2": "Three came back. One was Ebbe, and wasn't. I want to know if there's another, and who.",
  "side.faces.accuse.accuse.l3": "Remember the rule: it only copies someone who isn't here. Read the board before you vote.",
  "side.faces.accuse.accuse.vote": "Who do you accuse?",
  "side.faces.accuse.accuse.c.cal": "Cal, in Mada's house",
  "side.faces.accuse.accuse.c.lis": "Lis",
  "side.faces.accuse.accuse.c.nobody": "No one else: Ebbe was the only one",
  "side.faces.accuse.morning.r1": "At night they board up Mada's house. Inside, something walks until dawn, from one wall to the other.",
  "side.faces.accuse.morning.r2": "We have it shut in. Tomorrow we go in, and you choose where the lanterns go.",
  "side.faces.accuse.morning.w1": "In the morning, Mada's house is open and empty. In the mud, long footprints lead to the forest.",
  "side.faces.accuse.morning.w2": "It got away. With Cal's face, into the forest. Now we have to go and find it there.",
  "side.rescueRule": "Stay by the pit to pull one out: they follow you. Bring them to the clearing.",
  "side.rescueOf": "of {n} safe",
  "side.rescueWhere": "In the pit: {pit} · Following you: {with}",
  "side.result.rescueLost": "The nightmares caught one of the people you were bringing back. You'll have to go for them again.",
  "side.voteCloses": "closes in {h} h at most",
  "log.sideVote": "{who} called for an accusation in \"{saga}\": the group votes",
  "log.sideVote.you": "You called for an accusation in \"{saga}\": the group votes",
  "log.sideDecided": "The group decided in \"{saga}\"",
  "clue.letter": "Three days ago, Cal was on the tail. The Cal in Mada's house came back a week ago.",
  "clue.ebbeDead": "Ebbe died on the forest road, by his cart. The one who came back wasn't him.",
  "clue.farAway": "The missing were kept far from the village, so their faces could be used.",
  "side.faces.accuse.morning.cal": "The group accused Cal, the one in Mada's house.",
  "side.faces.accuse.morning.lis": "The group accused Lis. Lis cries all night in her mother's house.",
  "side.faces.accuse.morning.nobody": "The group said there was no other: Ebbe was the only one.",
  "side.rescueHome": "Everyone is out: bring them to the clearing before they're caught.",
  "side.wayPit": "The pit",
  "side.wayHome": "To the clearing",
  "side.result.saved": "{n} of {of} safe",
  "side.voteChange": "Change my vote",
  "land.title": "The bastion from scratch",
  "land.sub": "Tide {n}",
  "land.hint": "Only the keep on the crest. Drag with the wall to draw it and set gates wherever you like. Each Tide cracks the field open somewhere, never inside your walls, and the nightmares climb out; nobody warns you where.",
  "land.erase": "Remove",
  "land.eraseHint": "Tap or drag over what you built to take it down (half back)",
  "land.next": "Next Tide",
  "land.again": "Play this Tide again",
  "land.reset": "New land",
  "land.hide": "Hide",
  "land.showPanel": "Show",
  "land.last": "That was the trial's last Tide",
  "menu.landTrial": "Bastion from scratch (unchecked: the classic ring)",
  "bastion.wallDrawn": "{n} plans drawn. Drag again to carry the wall on.",
  "bastion.drawHint": "Or drag across the land to draw the wall in one stroke.",
  "bastion.turnLeft": "Turn left",
  "bastion.turnRight": "Turn right",
  "structure.depot": "Gathering post",
  "structure.depot.desc": "Golems unload what they gather here: by a wood, a quarry or a vein they bring in almost as much as beside the keep. Takes 3 cells and is an exposed target.",
  "structure.golemworks": "Golem works",
  "structure.golemworks.desc": "Makes golems for the group: one more for every level of the works, while it stands. Takes 3 cells. One per bastion.",
  "reason.uneven": "A big building needs its 3 cells on the same level.",
  "reason.tooManyGolems": "There aren't that many golems.",
  "reason.noGolemTable": "This bastion has no golem table.",
  "bastion.bigHint": "Takes 3 cells on the same level. Turn the plan to fit it to the ground.",
  "bastion.bigTag": "3 cells",
  "bastion.turnBuilding": "Turn",
  "golems.tableTitle": "What each golem does",
  "golems.builders": "Building and repairs",
  "golems.perDay": "{n} a day · {d} from the store",
  "golems.noSource": "None of this on the map",
  "golems.tableHint": "The group's golems are shared out as anyone likes. Those with nothing to build gather wood and stone on their own. A gathering post by a wood, a quarry or a vein makes the trip shorter.",
  "advice.landTowers": "The keep stands alone on the crest. Put the first towers round it: the nightmares may come from any side.",
  "advice.landWall": "Raise a palisade round the crest: pick Wall and drag your finger or mouse. Leave it a gate.",
  "advice.landDepot": "A gathering post beside a wood or a quarry makes the golems bring in much more.",
  "golems.whereLand": "You have {base} for the group, {era} more for the bastion's eras and {works} from the golem works. Rescuing the lost golem in an incursion adds one more for this Tide (now: {extra}). Your hero can help on any site.",
  "golems.idleLand": "No work now: the golems gather.",
  "golems.buildersIdle": "{n} with no work, gathering",
  "history.rifts": "Fissures cracked open to the {list}",
  "history.sky.fog": "Under fog",
  "history.sky.storm": "Storm: {n} bolts, {rods} to the lightning rods",
  "history.sky.frost": "Frost: {warm} of {n} towers kept warm",
  "compass.n": "north",
  "compass.ne": "northeast",
  "compass.e": "east",
  "compass.se": "southeast",
  "compass.s": "south",
  "compass.sw": "southwest",
  "compass.w": "west",
  "compass.nw": "northwest",
  "campaigns.bastion": "Bastion",
  "campaigns.land": "From scratch",
  "campaigns.land.desc": "Only the keep atop new land, with heights, rivers and woods. The group raises everything: palisade, towers, buildings. Nightmares climb out of fissures nobody sees coming.",
  "campaigns.ring": "Classic ring",
  "campaigns.ring.desc": "The ring wall already stands, with its fixed roads and gates.",
  "bastion.drawingCount": "{n} runs planned",
  "bastion.drawUndo": "Undo",
  "bastion.build": "Build",
  "bastion.lineTag": "Drawn",
  "bastion.placeOneHint": "Tap where it goes.",
  "bastion.placeMoveHint": "This is how it would look. Tap another cell to move it.",
  "bastion.placeLineHint": "Drag to lay a straight run; to turn, lift and carry on from its end. Or tap cells: each tap carries the line on from the last. Two fingers move the camera.",
  "bastion.placeConfirm": "Build",
  "bastion.placedOne": "{s}: plan laid. It's paid from the store while it lasts.",
  "bastion.placedMany": "{n} runs of {s} planned. They're paid from the store while it lasts.",
  "bastion.placeCancel": "Cancel",
  "bastion.erase": "Remove",
  "bastion.eraseTool": "Remove or fix",
  "bastion.eraseHint": "Tap or drag over what you want gone: plans, works or structures. Tap one again to keep it.",
  "bastion.eraseCount": "{n} to remove",
  "bastion.eraseBack": "Back to the store:",
  "bastion.eraseConfirm": "Remove",
  "bastion.eraseTitle": "Pull down {s}",
  "bastion.erased": "Done: {n} fewer on the bastion.",
  "bastion.replaces": "Replaces {n} waiting; what was paid comes back in full.",
  "npc.mada": "Mada",
  "npc.mada.role": "Net-mender in Musgoviejo",
  "side.faces.mada.mada.l1": "Mada, Cal's mother. She mends nets. She wants to talk to you first.",
  "side.faces.mada.mada.l2": "Mada speaks softly, the needle still in her hand.",
  "side.faces.mada.mada.l3": "I know it isn't him. I knew the moment he walked through the door.",
  "side.faces.mada.mada.w1": "It went to the forest with his face. But it's still his face.",
  "side.faces.mada.mada.l4": "It hasn't hurt anyone. I want one more day.",
  "side.faces.mada.mada.vote": "Do you give Mada her day?",
  "side.faces.mada.mada.c.wait": "Let her say goodbye",
  "side.faces.mada.mada.c.now": "End this tonight",
  "side.faces.mada.facetaker.title": "The Facetaker",
  "side.faces.mada.facetaker.goal": "It fights wearing the face of a friend who didn't come today. Fight it by a lantern: in the light its face falls off and it's easy to hit.",
  "side.faces.mada.dawn.l1": "In the morning, a young man comes down from the tail with a shepherd's staff on his shoulder. It's Cal, the real one.",
  "side.faces.mada.dawn.l2": "Mada holds him without a word.",
  "side.faces.mada.dawn.w1": "Thank you for waiting.",
  "side.faces.mada.dawn.l3": "In the square, the woodcutter and his daughter drink soup wrapped in blankets.",
  "side.faces.mada.dawn.l4": "Next time someone comes back, I'll call you first.",
  "side.face.now": "Now it wears {name}'s face.",
  "side.face.cal": "It still wears Cal's face.",
  "side.face.slip": "In the lantern's light, its face falls off.",
  "side.lanternRule": "Fight it by a lantern: in the light its face falls off and it's easy to hit.",
  "clue.truth": "The one in Mada's house was the Facetaker. The real Cal never left the tail.",
  "side.result.sceneNext": "What comes next is told in a scene.",
  "side.wayBoss": "The Facetaker",
  "npc.ulla": "Ulla",
  "npc.ulla.role": "Chief of the Horn clan",
  "npc.cal": "Cal",
  "npc.cal.role": "Shepherd from Musgoviejo",
  "side.horn.title": "The Horn",
  "side.horn.question": "What is happening to the Horn clan?",
  "side.horn.over": "The Horn clan is at peace.",
  "side.horn.drive.title": "The drive",
  "side.horn.lash.title": "The lash",
  "side.horn.hunt.title": "The hunt for the Uro",
  "side.horn.alone.title": "She who came back alone",
  "side.horn.drive.ulla.l1": "Fenn climbs to the bastion with a tall woman wrapped in furs, a hunting horn at her belt.",
  "side.horn.drive.ulla.l2": "Ulla, chief of the Horn clan. The clans ask the Order for nothing. If she came, it's bad.",
  "side.horn.drive.ulla.l3": "I have two hundred boars and three herders. I'm short of hands. Something is hunting the herd.",
  "side.horn.drive.ulla.l4": "Twelve were left up at the tip of the tail. Help me bring them down to the winter pen. I pay in meat and stone.",
  "side.horn.drive.drive.title": "The drive",
  "side.horn.drive.drive.goal": "Take the stone boars to the pen. They shy away from you: drive them from behind. From nightmares they bolt any which way. Six are needed.",
  "side.horn.drive.pen.l1": "The boars file into the pen one by one, snorting stone dust. A lanky herder shuts the gate.",
  "side.horn.drive.pen.l2": "Cal, from Musgoviejo. I told my mother this was quiet work.",
  "side.horn.drive.pen.l3": "I'm staying until winter. Don't tell her about the wolves.",
  "side.horn.drive.pen.l4": "Whatever hunts the herd is still up there. Come back.",
  "side.herdRule": "The boars shy away from you: drive them from behind to the pen.",
  "side.herdOf": "in the pen · {n} needed",
  "side.herdOut": "Out: {n}",
  "side.herdLost": "Lost: {n}",
  "side.herd.stampede": "Stampede! The herd runs from the ogre and tramples whatever is in the way.",
  "side.herd.wolves": "A boar strayed alone: the wolves are coming.",
  "side.herd.lost": "The nightmares brought a boar down.",
  "side.result.penned": "{n} of {of} in the pen",
  "side.result.herdLost": "Too few boars left to reach the pen. Go back for them.",
  "clue.calHerding": "Cal is herding up in the tail with the Horn clan: you saw him yourselves.",
  "side.horn.corralNew": "A new pen beside the keep: the Horn clan left you two stone boars.",
  "side.wayPen": "The pen",
  "side.horn.lash.camp.l1": "The clan's summer camp sits on the tip of the tail: hide tents and posts driven into the stone, and far below, the sea.",
  "side.horn.lash.camp.l2": "Some days the titan swings its tail in its sleep, and doesn't stop until nightfall.",
  "side.horn.lash.camp.l3": "Every year we lose someone. And when it moves, the nightmares climb up.",
  "side.horn.lash.camp.l4": "When the ground creaks, grab a post. Whatever isn't tied down goes into the sea.",
  "side.horn.lash.lash.title": "The lash",
  "side.horn.lash.lash.goal": "Hold the camp until nightfall. When the ground creaks, everything slides: stay by a mooring post. Nightmares near the edge go into the sea.",
  "side.horn.lash.calm.l1": "At dusk the tail goes still. The herders count heads, twice.",
  "side.horn.lash.calm.l2": "This year we lost no one.",
  "side.horn.lash.calm.l3": "Fenn, who came up with a load of salt, stays for supper.",
  "side.horn.lash.calm.l4": "Down in Musgoviejo, people who had gone away came back. Strange.",
  "side.lashRule": "When the ground creaks, everything slides: stay by a post.",
  "side.lashIn": "Lash in {n} s",
  "side.lashNow": "Grab a post!",
  "side.lashCalm": "The tail is still",
  "side.lashFell": "Into the sea: {n}",
  "side.lash.warn": "The tail is moving! Grab a post.",
  "side.lash.big": "The big lash!",
  "side.horn.postNew": "A clan mooring post beside the keep: this year they lost no one.",
  "side.horn.hunt.tracks.l1": "On the slope of the tail there are deep tracks of a cloven hoof, still smoking. Around them, stone boars smashed to pieces.",
  "side.horn.hunt.tracks.l2": "What hunts our herd is the Old Uro. A bull of ash. It charges anything that moves.",
  "side.horn.hunt.tracks.l3": "It won't die in a day. My father tried. You hit it, come back, and whoever goes next finds it wounded.",
  "side.horn.hunt.tracks.l4": "They say if you stand still it can't see you. I'm not about to try.",
  "side.horn.hunt.uro.title": "The Old Uro",
  "side.horn.hunt.uro.goal": "Follow its tracks and hit it all you can. It charges what moves: if it sees you, stand still. Its wounds and the traps stay for whoever goes out next.",
  "side.horn.hunt.spear.l1": "The Old Uro crumbles into dust, like every nightmare. What is left is the spear that finished it, stuck in the ground.",
  "side.horn.hunt.spear.l2": "This spear is yours. Take it to the bastion.",
  "side.horn.hunt.spear.l3": "Back home I'll say I hunted it. Nobody's coming up here to ask.",
  "side.horn.hunt.spear.l4": "Plant it where it shows. Let them see it from afar.",
  "side.huntRule": "It charges what moves. It can't see whoever stands still.",
  "side.huntLeft": "Uro: {n}%",
  "side.huntTraps": "Traps: {n}",
  "side.huntTime": "Outing: {t}",
  "side.hunt.seen": "The Uro saw you! Stand still.",
  "side.hunt.lost": "It lost sight of you.",
  "side.hunt.caught": "The Uro stepped in a trap!",
  "side.hunt.leave": "To camp",
  "side.hunt.leaveTip": "Ends the outing. Everyone has to be back at the camp. The Uro's wounds stay.",
  "side.hunt.leaveFar": "Everyone back to the camp to end the outing.",
  "side.hunt.trap": "Trap",
  "side.hunt.trapTip": "Sets a trap at your feet. If the Uro steps in it, it is caught and hurt. Up to {n} per outing, and they stay for the next one.",
  "side.hunt.noTraps": "You have no traps left this outing.",
  "side.hunt.go": "Go hunting",
  "side.hunt.retry": "Each outing lasts up to 8 minutes. Whatever you do to it stays for whoever goes out next.",
  "side.hunt.none": "Nobody has gone after the Uro yet.",
  "side.hunt.life": "The Old Uro has left",
  "side.hunt.place.0": "The tracks lead to the watering hole",
  "side.hunt.place.1": "The tracks lead to the fallen stones",
  "side.hunt.place.2": "The tracks lead to the ash pasture",
  "side.hunt.heals": "It heals {n}% a day",
  "side.hunt.wounds": "Wounds: {list}",
  "side.result.outing": "Outing over",
  "side.result.hunt": "This outing: {took}% of its life. It has {left}% left.",
  "side.result.huntOut": "The wounds stay: whoever goes out next finds it as you left it. It heals a little each day.",
  "log.huntWound": "{who} wounded the Old Uro ({pct}% left)",
  "log.huntWound.you": "You wounded the Old Uro ({pct}% left)",
  "log.huntWoundLast": "{who} wounded the Old Uro",
  "log.huntWoundLast.you": "You wounded the Old Uro",
  "log.huntUro": "{who} finished the Old Uro",
  "log.huntUro.you": "You finished the Old Uro",
  "enemy.uro": "The Old Uro",
  "enemy.uro.desc": "A bull of ash that hunts the clan's herd. It charges anything that moves; whoever stands still, it can't see. It won't die in a day.",
  "side.horn.spearNew": "The spear that finished the Old Uro, planted beside the keep.",
  "side.horn.alone.grave.l1": "Ulla climbs to the bastion alone, at night. She brings neither Fenn nor the herders. She sits by the fire and takes a long time to speak.",
  "side.horn.alone.grave.l2": "My sister Ragna went to serve in Somnhold with the clan's horn. I was nine. Neither she nor the horn came back. They say she died the night the fortress fell.",
  "side.horn.alone.grave.l3": "The herders saw a woman of black glass in our graveyard. She walks among the graves, at night. A horn hangs from her belt.",
  "side.horn.alone.grave.l4": "Ragna. She fought beside me. She went out through the gate to hunt them, alone, and we never saw her again.",
  "side.horn.alone.grave.m1": "We've seen her already. She came with the nightmares and went up in smoke. She doesn't forget who hurt her.",
  "side.horn.alone.grave.f1": "Brann looks at the ones who brought her down. So does Ulla. For a while nobody says anything.",
  "side.horn.alone.grave.f2": "So you found her. She still has to be brought home. I'll bury what's left of her beside our mother. At night, in the graveyard, I won't be alone.",
  "side.horn.alone.grave.l5": "I have my father's hunting horn. It's the clan's call to come home. I don't know if she can still hear it. You decide: I can't.",
  "side.horn.alone.grave.vote": "What do you do about Ragna?",
  "side.horn.alone.grave.c.call": "Let Ulla blow the horn: the clan's call to come home",
  "side.horn.alone.grave.c.fall": "Fight until she falls: put an end to what's left of her",
  "side.horn.alone.ragna.title": "Ragna of the Horn",
  "side.horn.alone.ragna.goal": "In the clan's graveyard, at night. This time Ragna doesn't flee: she fights until she falls.",
  "side.horn.alone.ragna.goalCall": "In the clan's graveyard, at night. Ragna fights just as hard. Ulla waits at the gate with the horn: hold on until she hears it.",
  "side.horn.alone.ragna.goalFelled": "Ragna has already fallen. Ulla buries what's left of her beside their mother: keep the nightmares away from the graves.",
  "side.horn.alone.home.c1": "Over the wind a horn sounds, long and low. Ragna goes still. She lowers her axe.",
  "side.horn.alone.home.c2": "She kneels. She leaves the axe at the graveyard's gate and walks slowly to her mother's grave. She sits beside it and moves no more.",
  "side.horn.alone.home.c3": "You came back, Ragna. Late, but you came back. The axe is yours: she doesn't need it now.",
  "side.horn.alone.home.k1": "Ragna falls among the graves and the black glass goes dark. Ulla kneels beside her for a long while.",
  "side.horn.alone.home.k2": "I'll bury her with the clan's horn. It was hers. Take her axe: let it be seen from afar.",
  "side.horn.alone.home.f1": "Ulla digs at the foot of her mother's grave and buries the shards of black glass. She lays a stone on top, and another, and another.",
  "side.horn.alone.home.f2": "She's home now. Thank you for bringing her.",
  "side.horn.alone.home.l1": "I'll tell my mother this was quiet.",
  "side.horn.alone.home.l2": "The Horn clan doesn't forget. If a horn ever sounds at the bastion, we all come down.",
  "side.callRule": "Ulla waits at the graveyard's gate with the clan's horn.",
  "side.call.heard": "The clan's horn sounds. Ragna stops.",
  "side.horn.axeNew": "Ragna's axe is at the bastion, the clan's red wool tied round its haft.",
  "out.title": "Outings",
  "out.badge": "{n} for today",
  "out.close": "Close",
  "out.filter": "Filter outings",
  "out.cat.all": "All",
  "out.cat.story": "Stories",
  "out.cat.inc": "Incursions",
  "out.cat.crypt": "Crypts",
  "out.cat.group": "Together",
  "out.cat.bet": "Bets",
  "out.who.hero": "{name} · {cls}",
  "out.who.group": "Group level",
  "out.today.title": "Today",
  "out.today.reset": "Chests come back at midnight",
  "out.today.none": "Nothing left that pays today: what you play gives experience.",
  "out.today.inc": "{n} more full ones ({done} of {max})",
  "out.today.chest": "Chest not opened",
  "out.today.claimed": "Claimed today",
  "out.today.saga": "Chapter {ch}, goes on",
  "out.today.side": "Chapter {ch}, goes on",
  "out.today.centre": "The centre still stands · {n} days",
  "out.live.at": "are gathering at {place}",
  "out.live.join": "See",
  "out.kind.saga": "The titan's saga",
  "out.kind.side": "Another story · {d}",
  "out.kind.inc": "Incursions",
  "out.kind.crypt": "Crypt · level {n}",
  "out.kind.cellars": "Expedition · {min} to {max}",
  "out.kind.maze": "The week's labyrinth · 1 to {max}",
  "out.kind.bet": "Bet · from group {n}",
  "out.saga.title": "The Turtle's saga",
  "out.saga.line": "{done} of {n} chapters done. Now: chapter {ch}, “{title}”.",
  "out.saga.lineLevel": "{done} of {n} chapters done. “{title}” opens with the group at level {lv} (it is at {g}).",
  "out.saga.over": "All {n} chapters done. They can be played again.",
  "out.side.line": "Chapter {ch} of {n}, “{title}”: act {act}.",
  "out.side.lineLevel": "Chapter {ch} of {n}, “{title}”: opens with the group at level {lv} ({left} to go).",
  "out.side.over": "All {n} chapters done.",
  "out.inc.title": "The titan's body",
  "out.inc.line": "Today you did {done} of {max} full ones; after that they pay a quarter. Won by the group: level I {a}/{n}, II {b}/{n}, III {c}/{n}.",
  "out.crypt1.title": "The Crypt of the Shell",
  "out.crypt2.title": "In embers",
  "out.crypt3.title": "The deep crypt",
  "out.crypt1.line": "Three rooms and the Warden. The fallen don't get up on their own.",
  "out.crypt2.line": "Longer: {n} rooms, lava on a rhythm and the runes on the door.",
  "out.crypt3.line": "Three floors and three guardians; after each, go down or walk out with what you have.",
  "out.cellars.line": "Raise the gate bell before the ink rises.",
  "out.maze.line": "The week's labyrinth, alone or with friends.",
  "out.maze.lineOpen": "The centre still stands. Camps: {k} of {n}.",
  "out.maze.lineWon": "This week's centre has fallen ({names}).",
  "out.maze.notYou": "You haven't gone out this week.",
  "out.bet.won": "Won in {n} tries.",
  "out.bet.tries": "{n} tries.",
  "out.st.play": "To play",
  "out.st.over": "Finished",
  "out.st.group": "Group {n}",
  "out.st.era": "Era {n}",
  "out.st.resting": "Resting today",
  "out.st.lost": "Campaign lost",
  "out.st.soon": "More soon",
  "out.st.hours": "In {h} h",
  "out.st.incLeft": "{n} more full",
  "out.st.incReduced": "Pay a quarter",
  "out.st.today": "Today ✓",
  "out.st.chest": "Today's chest",
  "out.st.den": "Open a den",
  "out.st.cryptBefore": "Win the one before",
  "out.st.marea": "Tide {n}",
  "out.st.week": "Week ✓",
  "out.st.days": "New in {n} days",
  "out.st.centre": "Centre stands",
  "out.st.won": "Won ✓",
  "out.rw.xp": "XP",
  "out.rw.xpChapter": "XP per chapter",
  "out.rw.unique": "unique",
  "out.rw.uniqueOf": "for your class",
  "out.rw.storage": "resources to the storage",
  "out.rw.res": "resources",
  "out.rw.ofPlace": "of the place",
  "out.rw.rare": "rare",
  "out.rw.dust": "dust",
  "out.rw.embers": "embers",
  "out.rw.relic": "relic",
  "out.rw.perFloor": "per floor",
  "out.rw.perFloorWhat": "XP, dust and shards",
  "out.rw.fromFloor2": "from the 2nd floor",
  "out.rw.weekly": "weekly",
  "out.rw.corridor": "dust per corridor chest",
  "out.rw.xpAgain": "XP again",
  "out.rw.barrel": "barrel",
  "out.rw.forBastion": "for the bastion",
  "out.go.story": "Open the chronicle",
  "out.go.map": "Open the map",
  "out.go.bet": "Take the bet",
  "out.go.again": "Play again",
  "out.note.xpOnly": "Already claimed today: until midnight it only gives experience.",
  "out.note.party": "Alone or together, up to {max} online; friends who aren’t here can come as spectres.",
  "out.mine.never": "You haven't gone yet",
  "out.mine.line": "Went {n} · won {won} · {when}",
  "out.mine.with": "with",
  "out.mine.alone": "alone",
  "out.when.today": "today {t}",
  "out.when.yesterday": "yesterday {t}",
  "out.sec.numbers": "Your numbers",
  "out.sec.reward": "If you win, each one takes",
  "out.sec.history": "History",
  "out.fact.went": "Went",
  "out.fact.won": "Won",
  "out.fact.group": "The group",
  "out.fact.runs": "{n} outings",
  "out.hist.whose": "Whose",
  "out.hist.me": "You",
  "out.hist.group": "The whole group",
  "out.hist.none": "Nobody has gone yet.",
  "out.hist.noneMe": "You haven't gone yet.",
  "out.hist.won": "Won",
  "out.hist.lost": "Lost",
  "out.hist.chapter": "ch. {n}",
  "out.hist.floors": "{n} floors",
  "out.hist.falls": "{n} falls",
  "out.hist.flawless": "no falls",
  "out.hist.tier": "level {n}",
  "out.bet.wonOne": "Won at the first try.",
  "out.bet.triesOne": "1 try.",
  "sima.stratum.ossuary": "Ossuary",
  "sima.stratum.marrow": "Burning Marrow",
  "sima.stratum.glass": "Black Glass",
  "sima.stratum.cisterns": "Black Cisterns",
  "sima.stratum.buried": "Buried Wood",
  "sima.stratum.grotto": "Mushroom Grotto",
  "sima.stratum.frost": "Frost Veins",
  "sima.stratum.geode": "Geode",
  "sima.stratum.archive": "Sunken Archive",
  "sima.stratum.forge": "Dead Forge",
  "sima.stratum.nest": "Nest",
  "sima.stratum.ribs": "Ribs",
  "sima.guardian.warden": "The Marrow Warden",
  "sima.guardian.magmaLord": "The Magma Lord",
  "sima.guardian.colossus": "The Obsidian Colossus",
  "sima.guardian.leechMother": "The Leech Mother",
  "sima.guardian.rootking": "The Rootking",
  "sima.guardian.sporeMother": "The Spore Mother",
  "sima.guardian.frostLady": "The Frost Lady",
  "sima.guardian.prism": "The Prism",
  "sima.guardian.archivist": "The Archivist",
  "sima.guardian.bellows": "The Bellows",
  "sima.guardian.broodQueen": "The Brood Queen",
  "sima.guardian.marrowWorm": "The Marrow Worm",
  "sima.rule.mender": "it mends from any wound unless it burns. Drag it onto the embers.",
  "sima.mend.mending": "Mending",
  "sima.mend.burning": "Burning: not mending",
  "sima.rule.warden": "The mark on the floor tells you where to go.",
  "sima.rule.magmaLord": "Get out of the circle before it bursts.",
  "sima.rule.colossus": "Don't strike it while it shines.",
  "sima.rule.leechMother": "Strike her when the water drains.",
  "sima.rule.rootking": "When it sinks its roots, get out of the circle.",
  "sima.rule.sporeMother": "When she swells, get away.",
  "sima.rule.frostLady": "If she locks one of you in ice, the others break it.",
  "sima.rule.prism": "The crystals feed it: break them.",
  "sima.rule.archivist": "When he reads, hit him hard until he stops.",
  "sima.rule.bellows": "When it blows, get behind an anvil.",
  "sima.rule.broodQueen": "Break the cocoons before they open.",
  "sima.rule.marrowWorm": "It dives and comes up at the end of the crack: wait beside it.",
  "sima.act.low": "Out of the water",
  "sima.act.roots": "Sinking its roots",
  "sima.act.swell": "Swelling",
  "sima.act.ice": "Ice",
  "sima.act.read": "Reading",
  "sima.act.inhale": "Drawing breath",
  "sima.act.blow": "Blowing",
  "sima.act.dive": "Underground",
  "sima.act.hatch": "Cocoons",
  "sima.actHint.low": "The water drained! Now.",
  "sima.actHint.roots": "Roots! Out of the green circle.",
  "sima.actHint.swell": "She swells: get away.",
  "sima.actHint.ice": "Ice: break it with blows.",
  "sima.actHint.read": "He reads: hit him hard to cut it.",
  "sima.actHint.inhale": "It draws breath: behind an anvil.",
  "sima.actHint.blow": "Fire!",
  "sima.actHint.dive": "It dove: away from the crack.",
  "sima.actHint.hatch": "A new cocoon.",
  "sima.readTitle": "The Archivist reads",
  "sima.readDo": "Hit him hard: if he finishes, nightmares come.",
  "sima.sign.procession": "Procession",
  "sima.sign.embers": "Embers",
  "sima.sign.frost": "Frost",
  "sima.sign.pair": "Pairs",
  "sima.sign.echo": "Echo",
  "sima.sign.rage": "Rage",
  "sima.sign.ward": "Ward against {type}",
  "sima.sign.gloom": "Gloom",
  "sima.signText.procession": "Every room brings one more mourner.",
  "sima.signText.embers": "Nightmares leave fire where they fall.",
  "sima.signText.frost": "Their blows chill.",
  "sima.signText.pair": "Elites and captain come in pairs.",
  "sima.signText.echo": "The fallen rise once more, as shadows.",
  "sima.signText.rage": "Wounded, they hit harder.",
  "sima.signText.ward": "They resist {type} a lot.",
  "sima.signText.gloom": "You see less far.",
  "sima.band.ink": "Ink: the nightmares are born deeper.",
  "sima.band.ash": "Ash: the light dims.",
  "sima.band.obsidian": "Obsidian: the black glass reaches down here.",
  "sima.band.abyss": "Abyss: below, no bottom can be seen.",
  "sima.bandName.shadow": "Shadow",
  "sima.bandName.ink": "Ink",
  "sima.bandName.ash": "Ash",
  "sima.bandName.obsidian": "Obsidian",
  "sima.bandName.abyss": "Abyss",
  "sima.haz.niche": "Niches: skeletons spill from the marked ones.",
  "sima.haz.water": "The water slows you.",
  "sima.haz.deep": "Leeches come out of the deep water.",
  "sima.haz.roots": "Green circle: roots. Get out before they grab you.",
  "sima.haz.spores": "Spores: if they wrap you, you fall asleep.",
  "sima.haz.rime": "Rime chills: stay on it and you freeze.",
  "sima.haz.beam": "The beams between crystals burn: get off the line.",
  "sima.haz.ink": "The ink curses: you heal less.",
  "sima.haz.hammer": "Trip hammers: out of the circle before they fall.",
  "sima.haz.web": "The webs slow you and call spiderlings.",
  "sima.haz.rockfall": "Rockfall: out of the circle.",
  "sima.haz.embers": "Embers: don't stand in the fire.",
  "sima.haz.molten": "Molten metal: it burns.",
  "sima.haz.quake": "Out of the circle!",
  "sima.held": "Roots have you: you can strike, not walk.",
  "sima.floor": "Floor {n} · {name}",
  "sima.arrive": "Floor {n}: {name}",
  "sima.captain": "The floor's captain",
  "sima.captainOf": "Captain: {name}",
  "sima.chooseHint": "Floor {n} waits below. Everyone stand on the stairs or the way out.",
  "sima.backPieces": "And {n} guardian piece(s), safe.",
  "sima.title": "The Chasm",
  "sima.label": "Under the deep crypt",
  "sima.pitch": "A crack with no known bottom. Every floor is harder and somewhere else. The group's mark is the deepest floor anyone finished.",
  "sima.scene1": "At the bottom of the crypt, past the glass, there is a crack. My clan dropped a stone down it once.",
  "sima.scene2": "We never heard it land.",
  "sima.scene3": "Then go down roped. And don't drop stones.",
  "sima.factMark": "The group's mark: floor {n}",
  "sima.factNoMark": "Nobody has gone down yet.",
  "sima.factWeek": "This week: floor {n} · remade in {d} days",
  "sima.factWeekOne": "This week: floor {n} · remade tomorrow",
  "sima.factWent": "Went down this week: {names}",
  "sima.factPiece": "Your piece today: already taken.",
  "sima.factPieceTodo": "Your piece today: yours when you walk out with something.",
  "sima.factParty": "1 to {max}; falling keeps half.",
  "sima.factGathering": "Gathering: {names}",
  "sima.start": "Where from",
  "sima.startFloor": "Floor {n}",
  "sima.next": "What comes this week",
  "sima.guardianAt": "Guardian",
  "sima.go": "Go down",
  "sima.lock": "Opens once the group wins the deep crypt to its bottom.",
  "sima.resWon": "You climbed back from floor {n}",
  "sima.resWonSub": "{k} floor(s) finished, from floor {from}.",
  "sima.resLost": "You fell on floor {n}",
  "sima.resLostSub": "Half of what was in the chest comes back.",
  "sima.resRecord": "The group's new mark: floor {n}!",
  "sima.resMark": "The group's mark: floor {n}.",
  "party.sima": "In the Chasm: {names}",
  "out.sima.line": "Go as deep as you can: every floor harder, and the group's mark grows.",
  "out.kind.sima": "Chasm · 1 to {max}",
  "out.st.sima": "Mark: floor {n}",
  "out.rw.perFloorSima": "per floor",
  "out.rw.pieceDay": "piece of the day",
  "out.rw.weekChest": "the week's chest",
  "chest.sima": "The Chasm's piece",
  "enemy.leech": "Leeches",
  "enemy.rootwight": "Rootwight",
  "enemy.puffball": "Wandering puffball",
  "enemy.rime": "Living rime",
  "enemy.shardling": "Crystal echo",
  "enemy.scribe": "Scribe",
  "enemy.molten": "Molten",
  "enemy.boneworm": "Bone worms",
  "enemy.leechMother": "The Leech Mother",
  "enemy.rootking": "The Rootking",
  "enemy.sporeMother": "The Spore Mother",
  "enemy.frostLady": "The Frost Lady",
  "enemy.prism": "The Prism",
  "enemy.archivist": "The Archivist",
  "enemy.bellows": "The Bellows",
  "enemy.broodQueen": "The Brood Queen",
  "enemy.marrowWorm": "The Marrow Worm",
  "enemy.crystal": "Crystal",
  "enemy.cocoon": "Cocoon",
  "enemy.iceBlock": "Block of ice",
  "out.rw.xpDust": "XP and dust",
  "sima.factWeekNone": "Nobody went down this week · remade in {d} days",
  "news.2026-11-01-zzzzdrinker.title": "Down the well",
  "news.2026-11-01-zzzzdrinker.intro": "The well goes on.",
  "news.2026-11-01-zzzzdrinker.drinker": "The well, chapter 2",
  "news.2026-11-01-zzzzdrinker.drinker.desc": "From group 2. Something is drinking Musgoviejo's water. Someone has to go down and see what it is.",
  "news.2026-11-01-zzzwell.title": "The well",
  "news.2026-11-01-zzzwell.intro": "A new saga, to start with.",
  "news.2026-11-01-zzzwell.well": "The well, chapter 1",
  "news.2026-11-01-zzzwell.well.desc": "From group 1. In Musgoviejo the water comes out black, and at night something climbs up the rope.",
  "side.well.title": "The well",
  "side.well.question": "Will the water come back to Musgoviejo?",
  "side.well.over": "Musgoviejo's water runs clear.",
  "side.well.ink.title": "The water tastes of ink",
  "side.well.drinker.title": "The Drinker",
  "side.well.fair.title": "Fair day",
  "side.well.ink.bucket.l1": "Brann, the old sergeant of the barracks. He survived the fall of Somnhold, and today he trains the new garrison.",
  "side.well.ink.bucket.l2": "This is Pell, Musgoviejo's well-keeper. If he says the water's bad, it's bad.",
  "side.well.ink.bucket.l3": "Pell tips his bucket over the table. The water comes out black.",
  "side.well.ink.bucket.l4": "Last night something climbed up the rope. It took two hens and the Holms' door.",
  "side.well.ink.bucket.l5": "Tonight more will come up. It has to be shut, and the only thing heavy enough is the millstone.",
  "side.well.ink.square.title": "The square",
  "side.well.ink.square.goal": "The nightmares climb out of the well in the square. Look after the houses and, once it's out, take the millstone to the well: two push it quicker.",
  "side.well.ink.lid.l1": "The stone drops onto the well with a dull thud. Ink seeps out of the cracks, and then, silence.",
  "side.well.ink.lid.l2": "The lid will hold a week. Whatever it is, it's still down there.",
  "side.well.ink.lid.l3": "The houses that were saved have their lights on. The others are still smoking.",
  "side.well.ink.lid.l4": "Pell left his bucket in the bastion. He says he'll come for it when the water runs clear.",
  "side.wellRule": "The nightmares come out of the well and go for the houses. Once the millstone is out, stay by it to push it to the well (two push it quicker).",
  "side.wellOf": "houses standing · lost with {n} burned",
  "side.wellWait": "The millstone, in {s} s",
  "side.wellPush": "The stone is {p} % of the way",
  "side.well.burn": "A house is burning!",
  "side.well.stone": "The millstone is ready! Push it to the well.",
  "side.well.seal": "The well is shut!",
  "side.well.bucketNew": "Pell's bucket, in the bastion, waiting for clear water.",
  "npc.pell": "Pell",
  "npc.pell.role": "Musgoviejo's well-keeper",
  "side.well.drinker.stone.l1": "A week later, Pell comes up to the bastion with an empty bucket.",
  "side.well.drinker.stone.l2": "The water comes out of the rock. It always has. Something is drinking it.",
  "side.well.drinker.stone.l3": "I know the way down: the old pipes the Order dug. They've been dry for years.",
  "side.well.drinker.stone.l4": "If it's drinking it, when it dies the water comes back all at once. Don't stay down there.",
  "side.well.drinker.stone.l5": "There are three rooms down there: the dry cistern, the pipes and the vein. Whatever it is, it's at the vein.",
  "side.well.drinker.vein.title": "The vein",
  "side.well.drinker.vein.goal": "Go down through the cistern and the pipes to the vein. Hit the Drinker when it's swollen: slow, it takes double. When it bursts, the water comes back: run up to the first room.",
  "side.well.drinker.fountain.l1": "First, a roar in the dry pipes. Then, a wall of white water at the end of the tunnel.",
  "side.well.drinker.fountain.l2": "The next day, the fountain in the square runs.",
  "side.well.drinker.fountain.l3": "Tastes of stone. Like before.",
  "side.well.drinker.fountain.l4": "Pell sends a jar of water up to the bastion. It stays by the keep.",
  "enemy.drinker": "The Drinker",
  "enemy.drinker.desc": "A leech of ink the size of a cart, its mouth stuck to the vein. Swollen it is slow and takes double; empty it is quick and spits ink.",
  "side.drinker.phase0": "empty",
  "side.drinker.phase1": "drinking",
  "side.drinker.phase2": "swollen",
  "side.drinker.drink": "It goes back to the vein to drink.",
  "side.drinker.swell": "It's swollen! Now it takes double.",
  "side.drinker.empty": "It emptied: quick, and spitting ink.",
  "side.drinker.burst": "It burst! Something roars in the dry pipes…",
  "side.drinker.wave": "The water's coming! Get up to the first room.",
  "side.drinker.out": "Out of the water!",
  "side.drinker.hall": "The vein",
  "side.drinker.toHall": "To the vein",
  "side.drinker.runTitle": "Up, quick!",
  "side.drinker.runSub": "The water is rising behind: in it you wade slowly, and whoever stays drowns.",
  "side.drinker.outTitle": "Out",
  "side.drinker.wayOut": "Way out",
  "side.well.jarNew": "A jar of water from the well, by the keep.",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzland.title": "The bastion from scratch",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzland.intro": "Building is no longer filling the gaps in a ring: the bastion rises whole, from the keep, on land with heights, rivers and woods. Pick it when you create a new campaign: «From scratch».",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzland.land": "Land with heights",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzland.land.desc": "Build anywhere on the map. From high ground towers reach farther; slopes and cliffs change where anything can pass.",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzland.walls": "Walls by dragging",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzland.walls.desc": "Drag to lay a straight run of wall and put the gates wherever you like. Anything still waiting is replaced just by placing something else on it, and «Remove or fix» clears what is left over.",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzland.rifts": "Rifts without warning",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzland.rifts.desc": "Nightmares have no fixed paths: each wave opens rifts in the field and comes in where the bastion is weakest.",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzland.golems": "Golems that gather",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzland.golems.desc": "The golems belong to the group: a table says how many gather wood, stone or crystal, and the rest build and repair. A gathering post near a wood or a quarry brings in more.",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzland.big": "Big buildings",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzland.big.desc": "The forge, barracks, temple and the other buildings take three cells at the same height; turn them to fit the ground.",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzland.eras": "Every era brings its own",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzland.eras.desc": "The foundry and the trebuchet in the second era; the wall-walk (a tower on top of the wall) and the arsenal in the third; the lightning rod and the gate tower in the fourth; the Titan's Eye in the fifth. Towers climb to level 6 and class buildings do more with every level.",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzland.branches": "Tower branches",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzland.branches.desc": "From the third era a level 4 tower picks one of two branches: a repeating or harpoon ballista, a catapult with pitch or a counterweight, an arcane tower with focus or turned to the sky. Each says what it answers.",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzland.levels": "Levels you can see",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzland.levels.desc": "On the new land, an upgraded building shows it: runestones and a lantern on the temple, a second cauldron at the lab, a war drum at the clan hall. Traps look crueler at each level, up to the fifth.",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzland.earth": "Earthworks",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzland.earth.desc": "Clear woods and quarry rock to make room; from the third era, raise and lower the ground and dig ditches; from the fourth, open fords across rivers. The keep is never shut in.",
  "news.2026-11-01-zzzzzzglyphs.title": "Glyphs",
  "news.2026-11-01-zzzzzzglyphs.intro": "A mark carved on a button that changes whatever skill it carries.",
  "news.2026-11-01-zzzzzzglyphs.glyphs": "One glyph per button",
  "news.2026-11-01-zzzzzzglyphs.glyphs.desc": "At level 12 a slot opens on the short button; at 20, on the medium one; at 28, on the ultimate. A glyph changes any skill it fits, of any class, and you pick it in «What to carry» like the variants, free and whenever you like.",
  "news.2026-11-01-zzzzzzglyphs.four": "The first four",
  "news.2026-11-01-zzzzzzglyphs.four.desc": "Prolong and Celerity come from incursions; Amplitude and Focus, from crypts. Each win gives a fragment, and three complete one. Each gives something and costs something: longer effects for a longer wait, or more area for less strength.",
  "news.2026-11-01-zzzzzzglyphs.stone": "The glyph stone",
  "news.2026-11-01-zzzzzzglyphs.stone.desc": "In front of the keep, by the tomes: a red mark for each glyph anyone in the group completes.",
  "carry.glyph": "Glyph on {s}",
  "glyph.locked": "This button's slot opens at level {n}.",
  "glyph.none": "No glyph",
  "glyph.none.desc": "The button as it is.",
  "glyph.prolong": "Prolong",
  "glyph.prolong.desc": "Lasts 40% longer; takes 25% longer to come back.",
  "glyph.celerity": "Celerity",
  "glyph.celerity.desc": "Comes back 25% sooner; strikes and heals 20% less.",
  "glyph.amplitude": "Amplitude",
  "glyph.amplitude.desc": "30% more area (one more wall hex); 15% less strength.",
  "glyph.focus": "Focus",
  "glyph.focus.desc": "35% less area; 30% more strength.",
  "glyph.frags": "{n} of {m} fragments",
  "glyph.where.crypt": "Its fragments come from the crypts.",
  "glyph.where.incursion": "Its fragments come from incursions.",
  "glyph.no.duration": "Doesn't fit: it doesn't last.",
  "glyph.no.area": "Doesn't fit: it has no area.",
  "glyph.no.damage": "Doesn't fit: it deals no damage.",
  "glyph.inOther": "Already carved on another button.",
  "glyph.stoneNew": "A new mark on the glyph stone, by the tomes: someone completed a glyph.",
  "reason.badGlyph": "That glyph can't go there: it isn't complete, the slot isn't open, or it doesn't fit that skill.",
  "log.glyphFrag": "{who} found a fragment of the «{s}» glyph ({n} of {m})",
  "log.glyphFull": "{who} completed the «{s}» glyph",
  "log.glyphFrag.you": "You found a fragment of the «{s}» glyph ({n} of {m})",
  "log.glyphFull.you": "You completed the «{s}» glyph: you can carve it on a button now",
  "news.2026-11-01-zzzzzzzzconversion.title": "Type glyphs",
  "news.2026-11-01-zzzzzzzzconversion.intro": "Four more glyphs, which change a skill's damage type.",
  "news.2026-11-01-zzzzzzzzconversion.turn": "Ember, Rime, Storm and Venom",
  "news.2026-11-01-zzzzzzzzconversion.turn.desc": "Everything the skill does turns to fire, frost, lightning or poison: its blows, the ground it leaves, its shots, turrets, summons and what keeps burning. The combos change with it: a skill with Rime and a friend's with Storm shatter. They fit any skill that deals damage of another type.",
  "news.2026-11-01-zzzzzzzzconversion.bosses": "Their fragments",
  "news.2026-11-01-zzzzzzzzconversion.bosses.desc": "They come from Marea bosses and from every saga chapter finished.",
  "news.2026-11-01-zzzzzzzzconversion.buttons": "The glyph, on the button",
  "news.2026-11-01-zzzzzzzzconversion.buttons.desc": "In a fight each button shows the glyph carved on it, and an ultimate with a type glyph makes the weapon glow in that colour.",
  "glyph.ember": "Ember",
  "glyph.ember.desc": "Everything it deals turns to fire: blows, ground, shots, what it summons and what keeps burning.",
  "glyph.rime": "Rime",
  "glyph.rime.desc": "Everything it deals turns to frost, and chills: the prey is ready to shatter with lightning.",
  "glyph.storm": "Storm",
  "glyph.storm.desc": "Everything it deals turns to lightning: it shatters the chilled.",
  "glyph.venom": "Venom",
  "glyph.venom.desc": "Everything it deals turns to poison: the prey is ready to set alight with fire.",
  "glyph.no.same": "Doesn't fit: it's that type already.",
  "glyph.where.boss": "Its fragments come from Marea bosses and saga chapters.",
  "news.2026-11-01-zzzzzzzzzzforms.title": "Form glyphs",
  "news.2026-11-01-zzzzzzzzzzforms.intro": "Five more glyphs, which change how a skill reaches.",
  "news.2026-11-01-zzzzzzzzzzforms.forms": "Echo, Fan, Trail, Vortex and Pack",
  "news.2026-11-01-zzzzzzzzzzforms.forms.desc": "Echo casts the skill again on its own a second later, weaker. Fan opens it in three. Trail leaves ground of its type where it struck. Vortex drags what it catches toward the middle. Pack adds one more summon. Each costs something in return.",
  "news.2026-11-01-zzzzzzzzzzforms.where": "Where to gather them",
  "news.2026-11-01-zzzzzzzzzzforms.where.desc": "Echo, Fan and Trail in the crypts; Vortex and Pack in incursions.",
  "glyph.echo": "Echo",
  "glyph.echo.desc": "A second later the skill comes again on its own where you cast it, at 45%.",
  "glyph.fan": "Fan",
  "glyph.fan.desc": "It goes out in three, 20° apart: each at 40%.",
  "glyph.trail": "Trail",
  "glyph.trail.desc": "Leaves 4 s of ground of its type where it struck; the blow, 15% less.",
  "glyph.vortex": "Vortex",
  "glyph.vortex.desc": "As it lands it drags what it catches a hex toward the middle (not bosses or elites); 15% less strength.",
  "glyph.pack": "Pack",
  "glyph.pack.desc": "One summon more; each with 45% less life and damage.",
  "glyph.no.lasts": "Doesn't fit: it lasts (echo is for what strikes at once).",
  "glyph.no.form": "Doesn't fit: it doesn't have that form.",
  "glyph.no.aimed": "Doesn't fit: it goes at a target, not at a point.",
  "glyph.bond": "Bond",
  "glyph.bond.desc": "What it does on you or on an ally reaches the nearest ally too, at half its length and strength.",
  "glyph.no.own": "Doesn't fit: its effect belongs to whoever casts it.",
  "glyph.where.expedition": "Its fragments come from expeditions and the Furrows (and from bosses, once the conversions are complete).",
  "bet.gate.title": "The open gate",
  "bet.gate.rule": "Brann raised a wall round the node with a single gate, and left it open: it can't be shut. Hold the whole wave. Win, and Hilde forges a plaque for the bastion's gate with your names.",
  "bet.gate.hud": "The gate won't shut: whatever comes in, comes in there.",
  "bet.gate.brann": "\"An open gate doesn't hold. Prove me wrong.\"",
  "bet.gate.hilde": "\"They'll prove it.\"",
  "bet.gate.brann2": "\"I hope so. That's why I'm betting on them.\"",
  "bet.favorBoth": "Brann and Hilde both bet you can.",
  "bet.result.both": "Brann looks at the gate a long while. \"Good. Very good.\" Hilde is already thinking about the plaque.",
  "bet.result.bothAgain": "Brann nods. \"I knew it. I still like seeing it.\"",
  "bet.result.bothLost": "Brann sighs. \"I told you an open gate doesn't hold. I don't like being right.\" You can try again.",
  "bet.result.plaqueTitle": "A plaque for the gate",
  "bet.result.plaque": "Hilde forges an iron plaque with your names and sets it by the bastion's gate.",
  "bet.gate.plaqueHead": "They held with the gate open",
  "bet.gate.plaqueNew": "Hilde set her plaque by the gate: the names of those who held with the gate open.",
  "log.betGate": "{names} held a wave with the gate open. Hilde forges a plaque with their names for the bastion's gate.",
  "out.rw.plaque": "plaque",
  "saga.burn.dawn.g1": "For the first time in centuries, the black glass of the Burn is cold to the touch.",
  "saga.burn.dawn.g2": "This glass can be worked now. A piece for each of you: what burned you will cover you.",
  "saga.burn.dawn.c.end.desc": "Every guardian who played an act of this chapter gets their class's unique armor, plated with black glass of the Burn.",
  "side.shore.drowned.still.u1": "The stilt-houses carved these from what its bones left behind: black bone and coral. One for each of you.",
  "unique.lastWatch.lore": "Hilde added plates of the Burn's black glass, cold since the day the dragon fell.",
  "unique.anvilHarness.lore": "Its buckles and rivets are black glass of the Burn, tempered at the clan's forge.",
  "unique.frostMantle.lore": "Sewn with beads of the Burn's black glass. They are still cold, as on the day the dragon fell.",
  "unique.dwarfMail.lore": "Among the dwarven rings, rings of the Burn's black glass. Hilde swears they don't break.",
  "unique.wandererCloak.lore": "Its clasp and hems are black glass of the Burn, the ground the wayfarers walked.",
  "unique.boarHide.lore": "Hilde set scales of the Burn's black glass along its back, like a stone boar's.",
  "unique.oathPlate.lore": "The oath is engraved on black glass of the Burn, cold since the dragon fell.",
  "unique.dwarfBark.lore": "Between the bark, sheets of the Burn's black glass. When the bear rises, they shine.",
  "unique.posternMedal.lore": "The stilt-houses carved it from a bone of the Drowned Dragon. It weighs more than it looks.",
  "unique.maelisKit.lore": "Coral flasks tied with sinew, like the ones Yorra's fishers take out to sea.",
  "unique.healerRosary.lore": "Beads of coral and black bone. Yorra says her mother prayed with one just like it.",
  "unique.mossWhistle.lore": "Carved from a hollow bone of the Drowned Dragon. It sounds like the wind among the stilt-houses.",
  "unique.tailFang.lore": "A fang of the dragon of bone, with the coral that grew on it at the bottom of the sea.",
  "unique.maelisSeed.lore": "A seed the sea brought in with the bones. At the stilt-houses they say it is still growing.",
  "unique.gateBlade.short": "The Blade",
  "unique.gateBlade.wants": "The Blade wants",
  "unique.garrisonKey.short": "The Key",
  "unique.garrisonKey.wants": "The Key wants",
  "unique.fallenStaff.short": "The Staff",
  "unique.fallenStaff.wants": "The Staff wants",
  "unique.chapelLamp.short": "The Lamp",
  "unique.chapelLamp.wants": "The Lamp wants",
  "unique.watchBow.short": "The Bow",
  "unique.watchBow.wants": "The Bow wants",
  "unique.wallAxe.short": "The Axe",
  "unique.wallAxe.wants": "The Axe wants",
  "unique.gasparHammer.short": "The Hammer",
  "unique.gasparHammer.wants": "The Hammer wants",
  "unique.oldRootStaff.short": "The Rootstaff",
  "unique.oldRootStaff.wants": "The Rootstaff wants",
  "unique.lastWatch.short": "The Breastplate",
  "unique.lastWatch.wants": "The Breastplate wants",
  "unique.anvilHarness.short": "The Harness",
  "unique.anvilHarness.wants": "The Harness wants",
  "unique.frostMantle.short": "The Mantle",
  "unique.frostMantle.wants": "The Mantle wants",
  "unique.dwarfMail.short": "The Robe",
  "unique.dwarfMail.wants": "The Robe wants",
  "unique.wandererCloak.short": "The Cloak",
  "unique.wandererCloak.wants": "The Cloak wants",
  "unique.boarHide.short": "The Hide",
  "unique.boarHide.wants": "The Hide wants",
  "unique.oathPlate.short": "The Plates",
  "unique.oathPlate.wants": "The Plates want",
  "unique.dwarfBark.short": "The Bark",
  "unique.dwarfBark.wants": "The Bark wants",
  "unique.posternMedal.short": "The Medal",
  "unique.posternMedal.wants": "The Medal wants",
  "unique.maelisKit.short": "The Remedies",
  "unique.maelisKit.wants": "The Remedies want",
  "unique.stormEye.short": "The Eye",
  "unique.stormEye.wants": "The Eye wants",
  "unique.healerRosary.short": "The Rosary",
  "unique.healerRosary.wants": "The Rosary wants",
  "unique.mossWhistle.short": "The Whistle",
  "unique.mossWhistle.wants": "The Whistle wants",
  "unique.tailFang.short": "The Fang",
  "unique.tailFang.wants": "The Fang wants",
  "unique.vigilCandle.short": "The Candle",
  "unique.vigilCandle.wants": "The Candle wants",
  "unique.maelisSeed.short": "The Seed",
  "unique.maelisSeed.wants": "The Seed wants",
  "feat.gateBlade.1": "stun {m} big beasts with the Shield bash",
  "feat.gateBlade.2": "stun {k} or more with a single bash, {m} times",
  "feat.garrisonKey.1": "deal {m} damage with the beams between turrets",
  "feat.garrisonKey.2": "join three turrets with {k} or more nightmares inside the triangle, {m} times",
  "feat.fallenStaff.1": "hit {m} targets with the fireball's leaps",
  "feat.fallenStaff.2": "one fireball that hits {k} or more and kills them all, {m} times",
  "feat.chapelLamp.1": "heal {m} with your attack",
  "feat.chapelLamp.2": "heal an ally under {p} % of their life who doesn't fall in the next {sec} s, {m} times",
  "feat.watchBow.1": "pierce {m} nightmares",
  "feat.watchBow.2": "one shot through {k} or more, {m} times",
  "feat.wallAxe.1": "pull {m} nightmares in with the Whirling cut",
  "feat.wallAxe.2": "pull {k} or more with a single whirl, {m} times",
  "feat.gasparHammer.1": "stun {m} with Smite",
  "feat.gasparHammer.2": "kill an elite within {sec} s of stunning it with Smite, {m} times",
  "feat.oldRootStaff.1": "hold {m} with Entangle",
  "feat.oldRootStaff.2": "hold {k} or more with a single cast, {m} times",
  "feat.lastWatch.1": "strike back {m} damage with Challenge",
  "feat.lastWatch.2": "last a whole Challenge with {k} or more hitting you, without falling, {m} times",
  "feat.anvilHarness.1": "have the automaton take {m} damage",
  "feat.anvilHarness.2": "an automaton burst that kills {k} or more, {m} times",
  "feat.frostMantle.1": "freeze {m} with the ring of ice",
  "feat.frostMantle.2": "kill {k} or more frozen by the ring before they thaw, {m} times",
  "feat.dwarfMail.1": "spare {m} damage with the Sanctuary",
  "feat.dwarfMail.2": "{a} or more allies inside the Sanctuary at once for {sec} s, {m} times",
  "feat.wandererCloak.1": "catch {m} with the Net",
  "feat.wandererCloak.2": "catch a big beast with the Net (or an elite, with Steel net), {m} times",
  "feat.boarHide.1": "kill {m} during Frenzies that started by themselves",
  "feat.boarHide.2": "go from under {lo} % to over {hi} % of your life in a single Frenzy, {m} times",
  "feat.oathPlate.1": "soak {m} with the Aegis",
  "feat.oathPlate.2": "have the Aegis break taunting {k} or more, {m} times",
  "feat.dwarfBark.1": "strike back {m} damage in bear form",
  "feat.dwarfBark.2": "last a whole bear form with {k} or more hitting you, without falling, {m} times",
  "feat.posternMedal.1": "save {m} allies who were about to fall",
  "feat.posternMedal.2": "raise {a} or more of the fallen with a single Oath, {m} times",
  "feat.maelisKit.1": "heal {m} with the Gear grenade",
  "feat.maelisKit.2": "heal {a} or more allies with a single grenade, {m} times",
  "feat.stormEye.1": "deal {m} damage with the Storm",
  "feat.stormEye.2": "have the Storm hit {k} or more at once, {m} times",
  "feat.healerRosary.1": "raise {m} of the fallen with Dawn",
  "feat.healerRosary.2": "raise {a} or more with a single Dawn, {m} times",
  "feat.mossWhistle.1": "deal {m} damage with the Arrow rain",
  "feat.mossWhistle.2": "hit {k} or more with a single Rain, {m} times",
  "feat.tailFang.1": "chain {m} Leaps (a Leap that kills and comes back)",
  "feat.tailFang.2": "{k} chained Leaps in a row, {m} times",
  "feat.vigilCandle.1": "deal {m} damage with Hallow",
  "feat.vigilCandle.2": "{k} or more inked nightmares inside Hallow at once, {m} times",
  "feat.maelisSeed.1": "heal {m} with the Bloom",
  "feat.maelisSeed.2": "{a} or more allies inside the Bloom at once for {sec} s, {m} times",
  "feat.deep": "{goal}, in hard places",
  "feat.legend": "defeat {m} different great bosses wearing the piece, using its power {k} times in each fight",
  "feat.deepHint": "Hard places: the deep crypt, the Furrows, the late Tides (from the VII on), the hard and heroic saga chapters from group 21, and the Chasm from floor {f}.",
  "feat.legendHint": "They count: the Dragon of the Burn, the Drowned Dragon, the Obsidian Colossus, the Chasm's guardians (from floor {f}), the Unsleeping and the bosses of the late Tides. Again, too.",
  "feat.felled": "Already felled: {list}",
  "feat.stage.1": "Habit",
  "feat.stage.2": "Trial",
  "feat.stage.3": "In the Deep",
  "feat.stage.4": "Legend",
  "feat.title": "Feat",
  "feat.of": "Feat {n} of 4 · {s}",
  "feat.ready": "Feat done: it can awaken stage {n} at the forge.",
  "feat.readyAhead": "The feat for stage {n} is done; the next one counts meanwhile.",
  "feat.all": "All four feats done.",
  "feat.none": "No feat yet: it counts from the next fight.",
  "feat.where": "It counts in every fight, live and as a spectre. Bets add nothing; chapters played again, only the Legend.",
  "feat.stages": "Stages",
  "feat.ghost": "{u} · your spectre added {n} ({have} / {m})",
  "feat.ghostTitle": "What your pieces gained",
  "log.featDone": "{who} did a feat: {u} can awaken stage {n}",
  "log.featDone.you": "You did a feat: {u} can awaken stage {n}",
  "log.uniqueGiven": "{who} received {u}",
  "log.uniqueGiven.you": "You received {u}",
  "uawaken.needFeat": "Feat: {goal} · {n} / {m}",
  "uawaken.featDone": "Feat done: {goal}",
  "uawaken.sealKept": "A {s} (not spent: you have {n})",
  "reason.feat": "First, that stage's feat.",
  "unique.follows": "Damage, life, speed and certainty follow your level.",
  "enemy.dragon": "The Dragon of the Burn",
  "enemy.sunken": "The Drowned Dragon",
  "enemy.warden": "The Marrow Warden",
  "uform.wave": "Wave",
  "uform.wave.desc": "What the blow reaches and doesn't fully stun (elites, rams) is thrown back a hex. Bosses aren't.",
  "uform.wave.up": "Throws back elites and rams",
  "uform.wave.when": "Against elites and rams reaching the gate.",
  "uform.rift": "Rift",
  "uform.rift.desc": "The blow cracks the ground 3 hexes ahead: whatever crosses it within 2 s is stunned for half as long.",
  "uform.rift.up": "Stuns the ones coming behind",
  "uform.rift.down": "Half the stun",
  "uform.rift.when": "In corridors, against lines that keep coming.",
  "uform.slowBeam": "Slowing beam",
  "uform.slowBeam.desc": "The beam between turrets slows whatever crosses it by 40 %.",
  "uform.slowBeam.up": "Nightmares cross slowly",
  "uform.slowBeam.when": "To buy the towers time.",
  "uform.discharge": "Discharge",
  "uform.discharge.desc": "Every 8 s each beam arcs lightning onto the 4 nearest nightmares. It shatters the chilled.",
  "uform.discharge.up": "Area lightning damage",
  "uform.discharge.when": "Next to a frost ally: lightning sets off the shatter.",
  "uform.wake": "Wake",
  "uform.wake.desc": "Each leap leaves a line of fire for 2 s from where the ball burst to its target.",
  "uform.wake.up": "Fire on the ground between targets",
  "uform.wake.when": "In corridors and gates, where they all walk.",
  "uform.prong": "Prong",
  "uform.prong.desc": "The ball leaps to 2 more targets, but each leap hits 19 % less than before (≈ 65 % instead of 80 %, from what it hits already).",
  "uform.prong.up": "6 leaps instead of 4",
  "uform.prong.down": "Each leap hits softer",
  "uform.prong.when": "Against big, spread-out packs.",
  "uform.highLamp": "High lamp",
  "uform.highLamp.desc": "Your attack also heals the second most hurt ally, for half.",
  "uform.highLamp.up": "Heals two allies",
  "uform.highLamp.down": "The second for half",
  "uform.highLamp.when": "When the whole party is taking blows.",
  "uform.lightWard": "Ward of light",
  "uform.lightWard.desc": "What the heal has left over stays as a shield, up to 10 % of the ally's life.",
  "uform.lightWard.up": "Overflowing heals aren't wasted",
  "uform.lightWard.when": "To guard whoever holds the front.",
  "uform.deepMark": "Deep mark",
  "uform.deepMark.desc": "The piercing shot's mark rises to +45 % damage taken and lasts twice as long.",
  "uform.deepMark.up": "A stronger, longer mark",
  "uform.deepMark.when": "Next to heavy hitters, against elites.",
  "uform.flurry": "Flurry",
  "uform.flurry.desc": "Every 2nd arrow goes through instead of every 3rd, but that arrow hits 25 % less than before (≈ 150 % instead of double, from what it hits already).",
  "uform.flurry.up": "Pierces more often",
  "uform.flurry.down": "Each one hits softer",
  "uform.flurry.when": "Against long lines of small nightmares.",
  "uform.anchor": "Anchor",
  "uform.anchor.desc": "The whirl pulls from twice as far, and for 2 s after nothing moves or throws you.",
  "uform.anchor.up": "Pulls from twice as far",
  "uform.anchor.when": "To gather the whole pack in one spot.",
  "uform.bloodSwirl": "Blood swirl",
  "uform.bloodSwirl.desc": "Each nightmare the whirl pulls in heals you 1 % of your life.",
  "uform.bloodSwirl.up": "Heals you for each one pulled",
  "uform.bloodSwirl.when": "To hold out in the middle of the pack.",
  "uform.toll": "Toll",
  "uform.toll.desc": "The smitten rings while stunned: whatever is within 1 hex is 30 % slower.",
  "uform.toll.up": "Slows those around",
  "uform.toll.when": "Against escorted elites.",
  "uform.heavy": "Heavy hammer",
  "uform.heavy.desc": "Smite stuns 1 s longer, and the stunned takes +30 % holy damage.",
  "uform.heavy.up": "Longer stun, open to holy",
  "uform.heavy.when": "Next to another paladin or cleric.",
  "uform.bitterSap": "Bitter sap",
  "uform.bitterSap.desc": "Whatever the roots hold bleeds poison. It readies a combustion.",
  "uform.bitterSap.up": "Poison on the held",
  "uform.bitterSap.when": "Next to whoever throws fire.",
  "uform.deepRoot": "Deep root",
  "uform.deepRoot.desc": "The roots hold 1 s longer, and elites twice as long.",
  "uform.deepRoot.up": "Holds longer",
  "uform.deepRoot.when": "Against elites and packs that must be stopped.",
  "uform.parapet": "Parapet",
  "uform.parapet.desc": "While Challenge lasts, allies within 2 hexes take 30 % less.",
  "uform.parapet.up": "Guards those beside you",
  "uform.parapet.when": "When the party fights close together.",
  "uform.vengeance": "Vengeance",
  "uform.vengeance.desc": "When Challenge ends you burst around with 30 % of everything you struck back.",
  "uform.vengeance.up": "A burst at the end",
  "uform.vengeance.when": "Against packs that stay stuck to you.",
  "uform.ironGuard": "Iron guard",
  "uform.ironGuard.desc": "While the automaton stands within 2 hexes, you take 20 % less.",
  "uform.ironGuard.up": "You take less damage",
  "uform.ironGuard.down": "You have to stay close",
  "uform.ironGuard.when": "To fight beside the automaton.",
  "uform.forge": "Forge",
  "uform.forge.desc": "The automaton's burst leaves the ground burning for 4 s, and it is built again once.",
  "uform.forge.up": "Built again once",
  "uform.forge.when": "When the automaton breaks fast, against many.",
  "uform.glacier": "Glacier",
  "uform.glacier.desc": "The ring of ice is 50 % wider and freezes elites too (a third).",
  "uform.glacier.up": "A wider ring that freezes elites",
  "uform.glacier.when": "Against elites that reach you.",
  "uform.counterFrost": "Counterfrost",
  "uform.counterFrost.desc": "Whatever strikes you while the ring stands is chilled: it readies the shatter.",
  "uform.counterFrost.up": "Chills whoever strikes you",
  "uform.counterFrost.when": "Next to whoever throws lightning.",
  "uform.firmStep": "Firm step",
  "uform.firmStep.desc": "On the Sanctuary nothing throws or holds you or your allies.",
  "uform.firmStep.up": "Nothing throws or holds you there",
  "uform.firmStep.when": "Against ogres and whatever throws.",
  "uform.atrium": "Atrium",
  "uform.atrium.desc": "Nightmares stepping onto the Sanctuary are 40 % slower.",
  "uform.atrium.up": "Slows the ones that come in",
  "uform.atrium.when": "So the party can strike longer.",
  "uform.emptyCloak": "Empty cloak",
  "uform.emptyCloak.desc": "Where you stood your cloak stays 3 s, and the nightmares nearby attack it.",
  "uform.emptyCloak.up": "A decoy as you leap",
  "uform.emptyCloak.when": "When they chase you close.",
  "uform.doubleNet": "Double net",
  "uform.doubleNet.desc": "The Net goes out twice: the second at the nightmare nearest behind the first.",
  "uform.doubleNet.up": "Catches two",
  "uform.doubleNet.when": "Against lines of big beasts.",
  "uform.coldBlood": "Cold blood",
  "uform.coldBlood.desc": "The Frenzy that starts by itself leaves you taking 20 % less while it lasts.",
  "uform.coldBlood.up": "You take less in that Frenzy",
  "uform.coldBlood.when": "To come out alive from the worst.",
  "uform.boar": "Boar",
  "uform.boar.desc": "When the Frenzy starts by itself you charge the biggest nightmare near: a double blow that stuns it.",
  "uform.boar.up": "A charge that stuns",
  "uform.boar.when": "Against elites and big beasts.",
  "uform.relay": "Relay",
  "uform.relay.desc": "When the Aegis breaks, the most hurt ally gets a new one with 40 % of what it held.",
  "uform.relay.up": "A shield for someone else",
  "uform.relay.when": "When the whole party needs looking after.",
  "uform.steelEcho": "Steel echo",
  "uform.steelEcho.desc": "When the Aegis breaks it stuns those it taunts for 1 s (elites a third).",
  "uform.steelEcho.up": "Stuns as it taunts",
  "uform.steelEcho.when": "Against packs that surround you.",
  "uform.moss": "Moss",
  "uform.moss.desc": "In bear form you heal 1 % of your life every second.",
  "uform.moss.up": "You heal as a bear",
  "uform.moss.when": "To hold the front alone.",
  "uform.hug": "Hug",
  "uform.hug.desc": "Whatever strikes you in bear form is held for 1 s (once every 4 s each).",
  "uform.hug.up": "Holds whoever strikes you",
  "uform.hug.when": "Against packs that surround you.",
  "uform.allVow": "Vow of all",
  "uform.allVow.desc": "The Oath reaches the whole party, wherever they are.",
  "uform.allVow.up": "Reaches everyone",
  "uform.allVow.when": "When the party fights spread out.",
  "uform.longVow": "Long vow",
  "uform.longVow.desc": "The Oath keeps them standing twice as long, but reaches half as far.",
  "uform.longVow.up": "Lasts twice as long",
  "uform.longVow.down": "Reaches half as far",
  "uform.longVow.when": "When the party fights together.",
  "uform.puddle": "Puddle",
  "uform.puddle.desc": "The grenade leaves a puddle that heals the allies on it for 4 s.",
  "uform.puddle.up": "Heals for longer",
  "uform.puddle.when": "Where the party holds still.",
  "uform.pair": "Pair",
  "uform.pair.desc": "Two grenades a charge, each at 60 %.",
  "uform.pair.up": "Two places at once",
  "uform.pair.down": "Each heals and hits less",
  "uform.pair.when": "When the party fights spread out.",
  "uform.stillEye": "Still eye",
  "uform.stillEye.desc": "If you don't move for 2 s, the Storm strikes 40 % harder.",
  "uform.stillEye.up": "Hits harder if you stay",
  "uform.stillEye.down": "You must stand still",
  "uform.stillEye.when": "When you can plant yourself behind the towers.",
  "uform.leapBolt": "Leaping bolt",
  "uform.leapBolt.desc": "Each pulse of the Storm leaps to one more target, outside it.",
  "uform.leapBolt.up": "Reaches one more",
  "uform.leapBolt.when": "Against nightmares slipping past its edge.",
  "uform.guardingDawn": "Guarding dawn",
  "uform.guardingDawn.desc": "Those Dawn raises get a shield of 20 % of their life.",
  "uform.guardingDawn.up": "The raised don't fall again at once",
  "uform.guardingDawn.when": "When the raised fall again straight away.",
  "uform.earlyDawn": "Early dawn",
  "uform.earlyDawn.desc": "Dawn recharges 25 % sooner, but reaches only allies within 6 hexes, not the whole party.",
  "uform.earlyDawn.up": "Comes back sooner",
  "uform.earlyDawn.down": "Reaches fewer",
  "uform.earlyDawn.when": "When the party fights together.",
  "uform.spikes": "Spikes",
  "uform.spikes.desc": "Whatever steps into the Rain is pinned for 1 s.",
  "uform.spikes.up": "Pins the ones coming in",
  "uform.spikes.when": "Against packs on the run.",
  "uform.followRain": "Following rain",
  "uform.followRain.desc": "The Rain follows the biggest nightmare under it.",
  "uform.followRain.up": "Goes after the biggest",
  "uform.followRain.when": "Against walking elites and beasts.",
  "uform.crescendo": "Crescendo",
  "uform.crescendo.desc": "Each chained Leap hits 25 % harder than the one before.",
  "uform.crescendo.up": "Each leap hits harder",
  "uform.crescendo.when": "Against big packs of small nightmares.",
  "uform.hunger": "Hunger",
  "uform.hunger.desc": "A chained Leap heals twice as much.",
  "uform.hunger.up": "Heals twice as much",
  "uform.hunger.when": "To hold out without a cleric.",
  "uform.leapFlame": "Leaping flame",
  "uform.leapFlame.desc": "When it ends, Consecrate leaps to the most beset ally and lasts 3 s more there.",
  "uform.leapFlame.up": "Lasts longer, somewhere else",
  "uform.leapFlame.when": "When an ally gets surrounded.",
  "uform.blindFlame": "Blinding flame",
  "uform.blindFlame.desc": "Inked nightmares inside Consecrate strike 20 % softer.",
  "uform.blindFlame.up": "Inked ones hit softer",
  "uform.blindFlame.when": "Against tides of ink.",
  "uform.tangle": "Tangle",
  "uform.tangle.desc": "Whatever steps into the Bloom is held for 1 s (once every 6 s each).",
  "uform.tangle.up": "Holds the ones coming in",
  "uform.tangle.when": "To guard the party up close.",
  "uform.pollen": "Pollen",
  "uform.pollen.desc": "The Bloom chills the nightmares it touches: it readies the shatter.",
  "uform.pollen.up": "Chills the ones inside",
  "uform.pollen.when": "Next to whoever throws lightning.",
  "uform.gateShut": "Gate shut",
  "uform.gateShut.desc": "The Shield bash stuns bosses too, 1 s, once every 10 s per boss.",
  "uform.holdFast": "Hold fast",
  "uform.holdFast.desc": "While three turrets stand joined they wear out at half the pace. And one turret more.",
  "uform.masterRain": "The master's rain",
  "uform.masterRain.desc": "Each leap of the ball leaps once more, to the nearest nightmare it hasn't reached.",
  "uform.lucerna": "Lucerna",
  "uform.lucerna.desc": "Every 5th attack is a beam of light through the line: it strikes what it crosses and heals every ally it touches.",
  "uform.lance": "The watchtower's lance",
  "uform.lance.desc": "The piercing shot pins the last one it reaches: stunned 1 s, elites too.",
  "uform.eye": "Eye of the hurricane",
  "uform.eye.desc": "The whirl pulls bosses too (one hex) and whatever flies, and brings it to the ground for 2 s.",
  "uform.guard": "Gaspar's guard",
  "uform.guard.desc": "A Smite that kills calls a spectre of the old garrison for 4 s; it strikes and taunts. If the group listened to him, Ser Gaspar comes himself.",
  "uform.oldForest": "The old forest",
  "uform.oldForest.desc": "Whatever dies held leaves a root that holds the next nightmare to step there.",
  "uform.lastTurn": "The last watch",
  "uform.lastTurn.desc": "About to fall during Challenge, you stay at 1 and it lasts 3 s more (once every 60 s).",
  "uform.living": "Living anvil",
  "uform.living.desc": "The automaton no longer wears out: it lasts until it is broken.",
  "uform.winter": "Winter",
  "uform.winter.desc": "The ring of ice also rises when 5 or more surround you, whatever your life (with the same rest).",
  "uform.walkingGround": "Walking ground",
  "uform.walkingGround.desc": "Two sanctuaries: one stays where you cast it and the other goes with you.",
  "uform.lostTrail": "Lost trail",
  "uform.lostTrail.desc": "After the leap you stay hidden for 2 s, and your first shot is a critical.",
  "uform.unfallen": "Unfallen",
  "uform.unfallen.desc": "While a Frenzy lasts you can't fall: you stay at 1.",
  "uform.steelOath": "Oath of steel",
  "uform.steelOath.desc": "The Aegis rises again by itself once, 4 s after it breaks.",
  "uform.oldBear": "The old bear",
  "uform.oldBear.desc": "When the bear form ends, a bear of bark stays and fights for 8 s by itself.",
  "uform.medal": "The medal",
  "uform.medal.desc": "If an ally falls with your Oath ready, it goes off by itself (once every 90 s).",
  "uform.flasks": "Rain of flasks",
  "uform.flasks.desc": "Every 3rd grenade splits in three.",
  "uform.twoStorms": "Two storms",
  "uform.twoStorms.desc": "One Storm follows you and another stays where you cast it.",
  "uform.secondDawn": "Second dawn",
  "uform.secondDawn.desc": "Whoever falls in the 10 s after your Dawn gets up by themselves.",
  "uform.closedSky": "Closed sky",
  "uform.closedSky.desc": "Where the Rain has killed 5, a second, smaller one falls by itself.",
  "uform.endless": "Endless leap",
  "uform.endless.desc": "The Leap is ready again also when it didn't kill but struck 3 or more.",
  "uform.vigil": "Vigil",
  "uform.vigil.desc": "When Consecrate ends it leaves a circle for 6 s that no nightmare enters (bosses and flyers do).",
  "uform.garden": "The garden",
  "uform.garden.desc": "When it ends, the Bloom leaves three sprouts that heal by themselves for 10 s.",
  "uform.title": "Piece form",
  "uform.pick": "Pick how to carry its power",
  "uform.none": "No form",
  "uform.none.desc": "The piece's power, unchanged.",
  "uform.final": "Final form",
  "uform.final.plus": "Adds to whichever form you pick.",
  "uform.locked": "Both forms open at awakening II.",
  "uform.finalLocked": "The final form comes at awakening IV.",
  "uform.noSkill": "It goes with {skill}: without that skill, the piece gives only its attributes and effect.",
  "uform.swarm": "With Swarm there is no automaton: the piece gives only its attributes and effect.",
  "uform.clash": "It doesn't stack with {what} on this button: it stays out.",
  "uform.carried": "Carried",
  "uform.passive": "{piece}'s form",
  "reason.badForm": "That form can't go: the piece must be worn and awakened to II.",
  "reason.badGear": "That piece can't go in this preparation: it must be yours, once, and wearable in that slot.",
  "feat.readyAt": "Feat done: stage {n} is ready; it awakens at level {l}.",
  "log.featDoneAt": "{who} did a feat: {u} has stage {n} ready; it awakens at level {l}",
  "log.featDoneAt.you": "You did a feat: {u} has stage {n} ready; it awakens at level {l}",
  "saga.burn.rule.old": "On the clearing's rim stand old harpoons. Someone left them here long ago.",
  "saga.burn.rule.vigil": "On the clearing's rim, the first Vigil's harpoons. They still point at the sky.",
  "saga.burn.rule.fire": "The dragon doesn't feel fire: it closes it.",
  "saga.burn.hud.sky": "In the sky",
  "saga.burn.hud.ground": "On the ground",
  "saga.burn.hud.down": "Brought down!",
  "saga.burn.hud.fury": "Fury",
  "saga.burn.hud.clock": "Its fury comes in {m}",
  "saga.burn.hud.glass": "The glass comes in {s} s · covers the clearing in {m}",
  "saga.burn.hud.cold": "Cold",
  "saga.burn.hud.coldHint": "The glass's cold: full, it cracks",
  "saga.burn.hud.scalesHint": "Its six glass scales",
  "saga.burn.hud.dragonDown": "Brought down! Its glass creaks.",
  "saga.burn.hud.dragonFury": "Fury: the clearing turns to glass from the rim.",
  "saga.burn.hud.dragonRise": "It goes up again. Its scales close.",
  "saga.burn.hud.harpoon": "A harpoon bites!",
  "saga.burn.hud.lane": "An old harpoon points along its way.",
  "saga.burn.hint.fire": "Hot glass closes. Cold and a dry blow: that's how it cracks.",
  "saga.burn.hint.scales": "Hitting it like that does nothing. Cold glass cracks under a dry blow.",
  "saga.burn.hint.harpoons": "Those old harpoons aren't there for show.",
  "saga.burn.hint.eaten": "Every time it eats one, it gets up more whole.",
  "saga.burn.hint.glass": "At the end you go all in: the glass doesn't wait.",
  "saga.burn.scars.1": "The dragon bears a scar: a scale that never closes again.",
  "saga.burn.scars.2": "The dragon bears two scars: two scales that never close again.",
  "saga.burn.scarsBy": "Made by: {names}.",
  "saga.burn.planB": "Hilde forged the armour from the glass its furies left. The dragon is still there.",
  "saga.burn.ghosts.title": "Spectres coming along",
  "saga.burn.ghosts.hint": "Friends who aren't here fight as spectres. They count for less than someone live, and the dragon can eat them.",
  "saga.burn.ghosts.none": "Nobody else in the group",
  "saga.burn.ghosts.count": "{n} of {of}",
  "saga.burn.lastTry": "The last try",
  "log.saga.scar": "{who} left a scar on the dragon",
  "log.saga.planB": "Hilde forged armour from the glass of the dragon's furies",
  "saga.burn.hud.line": "{what} · fury in {m}",
  "saga.burn.hud.furyLine": "Fury · glass in {s} s · {m}",
  "saga.burn.hud.now": "now!",
  "saga.burn.hud.in": "{s} s",
  "saga.rewardGlyph": "and the whole {glyph} glyph for everyone who played an act (once per hero)",
  "saga.rerun.prizeUnique": "your unique {slot}",
  "saga.rerun.prizeGlyph": "the whole {glyph} glyph",
  "saga.rerun.gainXpAnd": "Experience and {prize}",
  "saga.rerun.gainPrize": "Still yours to take: {prize}",
  "side.replay.title": "{title}, again.",
  "side.replay.yours": "You still lack the amulet or the dragon's seal: win it and they're yours. Friends who come live take what they lack.",
  "side.replay.legend": "You already have what it gives; playing it again only counts for the Legend.",
  "party.eaten": "eaten",
  "saga.prize.whole": "Whole glyph",
  "saga.prize.glyphNote": "For everyone who played an act, once per hero.",
  "stats.title": "Statistics",
  "stats.sub": "{n} heroes under arms · since {d}",
  "stats.back": "Back to the bastion",
  "stats.loading": "Opening the records…",
  "stats.err.noCampaign": "No campaign given: come in from the game.",
  "stats.err.signIn": "Sign in to see your campaign’s statistics.",
  "stats.err.load": "We couldn’t read this campaign’s records. Try again in a while.",
  "stats.you": "you",
  "stats.left": "left the campaign",
  "stats.hm": "{h} h {m} min",
  "stats.m": "{m} min",
  "stats.none": "Nothing to show here yet.",
  "stats.won": "Won",
  "stats.lost": "Lost",
  "stats.wonN": "{n} won",
  "stats.lostN": "{n} lost",
  "stats.winRate": "{p} won",
  "stats.daysN": "{n} days",
  "stats.overDays": "over {n} days",
  "stats.since": "measured since {d}",
  "stats.perFight": "{n} per fight",
  "stats.perWave": "{n} per wave",
  "stats.perDayAvg": "{m} per day played",
  "stats.best": "best fight: {n}",
  "stats.shareOfGroup": "{p} of the group’s total",
  "stats.togetherTimes": "{a} and {b}: {n} outings together",
  "stats.spentSub": "{n} spent",
  "stats.range.days": "{n} days",
  "stats.range.all": "All",
  "stats.filter.heroes": "Heroes:",
  "stats.filter.all": "All",
  "stats.tab.group": "Group",
  "stats.tab.heroes": "Heroes",
  "stats.tab.compare": "Compare",
  "stats.tab.economy": "Resources",
  "stats.tab.outings": "Outings",
  "stats.tab.waves": "Waves",
  "stats.tab.activity": "Time played",
  "stats.tab.records": "Titles",
  "stats.dps": "Damage per second",
  "stats.aided": "Healing to others",
  "stats.aidedPs": "Healing to others per second",
  "stats.downs": "Downs",
  "stats.fights": "Fights",
  "stats.fightTime": "Time fighting",
  "stats.gathered": "Gathered",
  "stats.gatheredShort": "gathered",
  "stats.given": "Given to works",
  "stats.spent": "Spent from the storehouse",
  "stats.workMin": "Site work",
  "stats.raised": "Works raised",
  "stats.outings": "Outings",
  "stats.wavesLive": "Waves fought live",
  "stats.played": "Time played",
  "stats.worksNote": "Gathering and site work are counted since 30 October 2026.",
  "stats.spentNote": "Storehouse spending is counted since {d}.",
  "stats.spentEmpty": "No spending recorded yet.",
  "stats.recentNote": "What it did lately at the bastion (the campaign’s latest events).",
  "stats.group.title": "The group",
  "stats.group.where": "Where they are",
  "stats.group.whereVal": "Tide {m} · {w}",
  "stats.group.level": "group level {n}",
  "stats.group.waves": "Waves",
  "stats.group.keep": "The keep",
  "stats.group.dmg": "{n} damage",
  "stats.group.bosses": "Bosses felled",
  "stats.group.heroes": "{n} heroes in the campaign",
  "stats.group.share": "What each one brings",
  "stats.group.shareNote": "Pick a figure. Each bar shows its share of the group’s total; tap it to open the hero’s sheet.",
  "stats.group.storage": "The storehouse now",
  "stats.hero.level": "level {n}",
  "stats.hero.joined": "Joined",
  "stats.hero.lastSeen": "last seen {d}",
  "stats.hero.byMode": "By kind of fight",
  "stats.hero.works": "At the bastion",
  "stats.hero.company": "Who it goes out with",
  "stats.hero.when": "When it plays",
  "stats.hero.recent": "What it did lately",
  "stats.col.mode": "Kind",
  "stats.col.outing": "Outing",
  "stats.col.tries": "Tries",
  "stats.col.won": "Won",
  "stats.col.last": "Last",
  "stats.col.figure": "Figure",
  "stats.col.res": "Resource",
  "stats.col.hero": "Hero",
  "stats.col.when": "When",
  "stats.col.wave": "Wave",
  "stats.col.result": "Result",
  "stats.col.leaks": "Got through",
  "stats.col.keep": "Keep damage",
  "stats.col.live": "Live",
  "stats.col.top": "Most damage",
  "stats.col.days": "Days",
  "stats.ghosts": "ghosts",
  "stats.compare.note": "Pick up to four heroes to set side by side.",
  "stats.compare.shape": "How each one plays",
  "stats.compare.shapeNote": "Each axis runs from zero to the campaign’s best in that figure.",
  "stats.compare.side": "Figure by figure",
  "stats.ax.dps": "Strikes",
  "stats.ax.aid": "Heals",
  "stats.ax.tank": "Holds",
  "stats.ax.kills": "Finishes",
  "stats.ax.build": "Builds",
  "stats.ax.out": "Ventures",
  "stats.kind.build": "Works and repairs",
  "stats.kind.forge": "Forge and gear",
  "stats.kind.lab": "Laboratory",
  "stats.kind.keep": "Offerings and defences",
  "stats.kind.hero": "Skills",
  "stats.kind.other": "Other",
  "stats.eco.gathered": "What each one gathered",
  "stats.eco.spent": "What it was spent on",
  "stats.eco.byRes": "Resource by resource",
  "stats.eco.got": "Recovered",
  "stats.eco.now": "In store",
  "stats.eco.builders": "Who raises the bastion",
  "stats.eco.yields": "What the bastion yields each wave",
  "stats.eco.yieldsNote": "Quarry, grove and sanctum, wave by wave.",
  "stats.eco.grove": "Grove",
  "stats.eco.sanctum": "Sanctum",
  "stats.out.side": "The other stories",
  "stats.out.bet": "The wagers",
  "stats.out.group": "The group’s outings",
  "stats.out.byHero": "Each one’s outings",
  "stats.out.byHeroNote": "In each one’s colour, the won; in dark red, the lost. Filter by kind of outing.",
  "stats.out.allKinds": "All",
  "stats.out.pairs": "The pairs that go out most",
  "stats.out.pairsNote": "Times they went together live.",
  "stats.out.recent": "The latest outings",
  "stats.out.recentNote": "{n} outings with these filters.",
  "stats.waves.note": "{n} waves on record.",
  "stats.waves.played": "Waves",
  "stats.waves.live": "With someone live",
  "stats.waves.kills": "Kills",
  "stats.waves.keep": "Keep damage",
  "stats.waves.leaks": "{n} got through",
  "stats.waves.trend": "Wave by wave",
  "stats.waves.list": "Every wave",
  "stats.waves.listNote": "Tap a wave to see its sectors and who did what.",
  "stats.waves.byHero": "Who stood in the waves",
  "stats.waves.sector": "Sector {n}",
  "stats.waves.gateFell": "the gate fell",
  "stats.src.live": "live",
  "stats.src.preview": "played ahead",
  "stats.src.offline": "ghosts",
  "stats.act.empty": "Time played started being measured on {d}. Come back in a few days to see who plays when.",
  "stats.act.note": "Counts the time with the game open and in use since {d}.",
  "stats.act.perDay": "Per day played",
  "stats.act.perDaySub": "average",
  "stats.act.streak": "Best streak",
  "stats.act.current": "current streak: {n}",
  "stats.act.peak": "Favourite hour",
  "stats.act.peakSub": "the one played most",
  "stats.act.daily": "Minutes per day",
  "stats.act.when": "When they play",
  "stats.act.whenNote": "Day of the week and hour, in the campaign’s time zone.",
  "stats.act.byHero": "Each one",
  "stats.act.together": "Who plays at the same time",
  "stats.act.togetherNote": "Time two played in the same hour of the same day.",
  "stats.act.growth": "What each day added",
  "stats.act.growthNote": "How much the chosen figure grew each day, for each hero.",
  "stats.act.growthEmpty": "It takes at least two days played.",
  "stats.snap.xp": "Experience",
  "stats.snap.dmg": "Damage",
  "stats.snap.kills": "Kills",
  "stats.snap.fights": "Fights",
  "stats.snap.gathered": "Gathered",
  "stats.snap.spent": "Spent",
  "stats.snap.given": "Given",
  "stats.snap.work": "Site work",
  "stats.snap.outings": "Outings",
  "stats.snap.wins": "Outings won",
  "stats.rec.note": "Who stands out in each thing. Tap a title to open the sheet.",
  "stats.rec.dps": "The heaviest hand",
  "stats.rec.dps.why": "Most damage per second in a single fight.",
  "stats.rec.hps": "The one who lets no one fall",
  "stats.rec.hps.why": "Most healing to others per second in a fight.",
  "stats.rec.taken": "The wall",
  "stats.rec.taken.why": "Most damage taken in a single fight.",
  "stats.rec.killsOne": "The harvest",
  "stats.rec.killsOne.why": "Most kills in a single fight.",
  "stats.rec.dmg": "The scourge",
  "stats.rec.dmg.why": "Most damage all campaign long.",
  "stats.rec.kills": "The one who felled most",
  "stats.rec.kills.why": "Most kills all campaign long.",
  "stats.rec.aided": "Healer’s hands",
  "stats.rec.aided.why": "Most healing to others all campaign long.",
  "stats.rec.fights": "Always in the breach",
  "stats.rec.fights.why": "Most fights played live.",
  "stats.rec.secs": "The one who never lowers the shield",
  "stats.rec.secs.why": "Most time fighting.",
  "stats.rec.fewDowns": "The one who doesn’t fall",
  "stats.rec.fewDowns.why": "Most fights per down (from ten fights).",
  "stats.rec.fewDownsVal": "{n} fights per down",
  "stats.rec.gathered": "Hauler of {res}",
  "stats.rec.gathered.why": "Brought back the most {res} from outings.",
  "stats.rec.given": "The one who fills the blueprints",
  "stats.rec.given.why": "Most materials given to works.",
  "stats.rec.workMin": "Hands on the site",
  "stats.rec.workMin.why": "Most minutes of site work.",
  "stats.rec.raised": "The architect",
  "stats.rec.raised.why": "Most works planned and finished.",
  "stats.rec.spent": "The open purse",
  "stats.rec.spent.why": "Most resources spent from the storehouse.",
  "stats.rec.outings": "The one who never stays home",
  "stats.rec.outings.why": "Most outings.",
  "stats.rec.outingWins": "Comes back with the spoils",
  "stats.rec.outingWins.why": "Most outings won.",
  "stats.rec.company": "The one who goes out with everyone",
  "stats.rec.company.why": "Most different companions on outings.",
  "stats.rec.waves": "Warden of the wall",
  "stats.rec.waves.why": "Most waves defended live.",
  "stats.rec.level": "The veteran",
  "stats.rec.level.why": "The highest-level hero.",
  "stats.rec.minutes": "The one who plays most",
  "stats.rec.minutes.why": "Most time played.",
  "stats.rec.streak": "Never missing a day",
  "stats.rec.streak.why": "The longest run of days in a row.",
  "stats.rec.night": "The midnight watch",
  "stats.rec.night.why": "Most time played between midnight and five.",
  "stats.rec.dawn": "The early riser",
  "stats.rec.dawn.why": "Most time played between five and nine in the morning.",
  "stats.ev.sima": "The Chasm",
  "stats.ev.simaWeek": "Chasm week",
  "stats.ev.repairOrdered": "Repairs ordered",
  "stats.ev.explore": "Explorations",
  "stats.ev.gift": "Gifts",
  "stats.ev.salvage": "Pieces melted",
  "stats.ev.temper": "Tempers",
  "stats.ev.rebuilt": "Rebuilds",
  "stats.ev.carve": "Glyphs carved",
  "stats.ev.attune": "Attunements",
  "stats.ev.ailment": "Ailments",
  "stats.ev.cure": "Cures",
  "stats.ev.reforge": "Reforges",
  "stats.ev.forged": "Forgings",
  "stats.ev.socket": "Sockets",
  "stats.ev.gem": "Gems",
  "stats.ev.gemCut": "Gems cut",
  "stats.ev.masterwork": "Masterworks",
  "stats.ev.gemFuse": "Gems fused",
  "stats.ev.awaken": "Relics awakened",
  "stats.ev.uniqueAwakened": "Uniques awakened",
  "stats.ev.uniqueKept": "Uniques kept",
  "stats.ev.feat": "Feats",
  "stats.ev.seal": "Seals",
  "stats.ev.offering": "Offerings",
  "stats.ev.dungeon": "Crypts",
  "stats.ev.expedition": "Expeditions",
  "stats.ev.maze": "Furrows",
  "stats.ev.carried": "Carried",
  "stats.ev.tomePage": "Tome pages",
  "stats.ev.glyphFrag": "Glyph fragments",
  "stats.ev.blueprint": "Blueprints",
  "stats.ev.contribute": "Contributions",
  "stats.ev.built": "Works finished",
  "stats.ev.repaired": "Repairs",
  "stats.ev.demolished": "Demolitions",
  "stats.ev.undoDemolish": "Demolitions undone",
  "stats.ev.work": "Work shifts",
  "stats.ev.wave": "Waves",
  "stats.ev.mareaWon": "Tides won",
  "stats.ev.mareaLost": "Tides lost",
  "stats.ev.joined": "Arrivals",
  "stats.ev.district": "Districts",
  "stats.ev.elixir": "Elixirs",
  "stats.ev.left": "Departures",
  "stats.ev.levelUp": "Levels gained",
  "stats.ev.enchant": "Enchantments",
  "stats.ev.fortify": "Fortifications",
  "stats.ev.golems": "Golem orders",
  "stats.ev.ghostPost": "Ghost posts",
  "stats.ev.campaignWon": "Campaign won",
  "stats.ev.campaignLost": "Campaign lost",
  "stats.ev.mareaRepeated": "Tides repeated",
  "stats.ev.titanStirs": "The titan stirs",
  "stats.ev.loot": "Loot",
  "stats.ev.task": "Tasks",
  "stats.ev.incursion": "Incursions",
  "stats.ev.mercenary": "Mercenaries",
  "stats.ev.classChanged": "Class changes",
  "stats.ev.heroNew": "New heroes",
  "stats.ev.heroSwitched": "Hero switches",
  "stats.ev.heroRetired": "Heroes retired",
  "stats.ev.saga": "Saga",
  "stats.ev.unsleeping": "Unsleeping",
  "stats.ev.bet": "Wagers",
  "stats.ev.side": "Other stories",
  "stats.ev.earth": "Earthworks",
  "stats.figure": "Figure",
  "stats.more": "Show more ({n} left)",
  "unique.butcherCleaver": "Butcher's Cleaver",
  "unique.butcherCleaver.short": "The Cleaver",
  "unique.butcherCleaver.wants": "The Cleaver wants",
  "unique.butcherCleaver.desc": "If the nightmare the Low blow exposed dies while it lasts, the mark jumps to the nearest one within 3 hexes with the time it had left. Two jumps at most.",
  "unique.butcherCleaver.lore": "It was the kitchen butcher's. He honed it every morning, singing under his breath.",
  "feat.butcherCleaver.1": "make the mark jump {m} times",
  "feat.butcherCleaver.2": "a mark that jumps twice and all three exposed die, {m} times",
  "uform.noGuard": "No Guard",
  "uform.noGuard.desc": "Each hero's first basic attack on an exposed nightmare is a critical.",
  "unique.barracksMace": "Barracks Mace",
  "unique.barracksMace.short": "The Mace",
  "unique.barracksMace.wants": "The Mace wants",
  "unique.barracksMace.desc": "What the Shield slam pushes knocks into the nightmare behind it: both are stunned 1 s and take half the blow (elites a third of the stun; bosses, nothing). Doesn't stack with Heavy slam.",
  "unique.barracksMace.lore": "The sergeant taught with this one. Said the shield is learned before the sword.",
  "feat.barracksMace.1": "stun {m} by knocking them together",
  "feat.barracksMace.2": "a Shield slam that knocks {k} or more together, {m} times",
  "uform.twoBlows": "Two Blows",
  "uform.twoBlows.desc": "The Shield slam strikes again half a second later, at half strength. Doesn't stack with the Echo glyph.",
  "unique.wellHook": "Well Hook",
  "unique.wellHook.short": "The Hook",
  "unique.wellHook.wants": "The Hook wants",
  "unique.wellHook.desc": "If the Chain catches an elite or a boss, which don't move, you leap to it instead and strike it. An elite is stunned a moment; a boss, not.",
  "unique.wellHook.lore": "He went down the well with this hook to fish out what fell in. Buckets, mostly.",
  "feat.wellHook.1": "leap to {m} elites or bosses",
  "feat.wellHook.2": "kill an elite within {sec} s of leaping to it, {m} times",
  "uform.haul": "Haul",
  "uform.haul.desc": "The Chain drags elites too, halfway: you meet in the middle. Bosses, never.",
  "unique.drillPlate": "Drill-Yard Breastplate",
  "unique.drillPlate.short": "The Breastplate",
  "unique.drillPlate.wants": "The Breastplate wants",
  "unique.drillPlate.desc": "The decoy appears where you stand and you appear at the point you picked: the nightmares around you stay with it.",
  "unique.drillPlate.lore": "From the recruit who stood as the target in the yard. Look at the dents: none on the back.",
  "feat.drillPlate.1": "leave {m} nightmares striking the decoy",
  "feat.drillPlate.2": "a swap that leaves {k} or more at the decoy, {m} times",
  "uform.steady": "Steady",
  "uform.steady.desc": "After the swap you take half the damage for 3 s.",
  "unique.frontRankCuirass": "Front-Rank Cuirass",
  "unique.frontRankCuirass.short": "The Rank",
  "unique.frontRankCuirass.wants": "The Rank wants",
  "unique.frontRankCuirass.desc": "While the Shield wall holds, every second it pushes the nightmares pressed on you back a hex and strikes them with your attack. Elites and bosses aren't moved.",
  "unique.frontRankCuirass.lore": "The front rank's corporal. In the drills he never took a step back.",
  "feat.frontRankCuirass.1": "push {m} with the wall",
  "feat.frontRankCuirass.2": "a push that moves {k} or more at once, {m} times",
  "uform.wallAdvance": "Advancing Wall",
  "uform.wallAdvance.desc": "The push reaches 2 hexes and slows what it pushes by 30 %.",
  "unique.criersCuirass": "Crier's Cuirass",
  "unique.criersCuirass.short": "The Cry",
  "unique.criersCuirass.wants": "The Cry wants",
  "unique.criersCuirass.desc": "While the Shout of defiance lasts, each challenged nightmare that strikes you gives you a shield of 2 % of your life, up to 20 %.",
  "unique.criersCuirass.lore": "The crier who called the hours. You could hear him from the quarry.",
  "feat.criersCuirass.1": "gather {m} shield with the shout",
  "feat.criersCuirass.2": "a shout that challenges {k} or more without falling while it lasts, {m} times",
  "uform.quail": "Let Them Shake",
  "uform.quail.desc": "When the shout ends, the challenged still standing hit for half for 2 s (elites and bosses, three quarters).",
  "unique.menderThimble": "Mender's Thimble",
  "unique.menderThimble.short": "The Thimble",
  "unique.menderThimble.wants": "The Thimble wants",
  "unique.menderThimble.desc": "The Banner throws itself onto the biggest pack of nightmares within 6 hexes. It lands striking them and stunning them 1.5 s (elites a third; bosses, nothing).",
  "unique.menderThimble.lore": "The mender sewed the banners. He wore this thimble on a cord round his neck.",
  "feat.menderThimble.1": "stun {m} with the staff",
  "feat.menderThimble.2": "a staff landing that stuns {k} or more, {m} times",
  "uform.staffBack": "Returning Staff",
  "uform.staffBack.desc": "The staff comes back to your hand: the Banner recharges in half the time.",
  "unique.bellNail": "Bell Nail",
  "unique.bellNail.short": "The Nail",
  "unique.bellNail.wants": "The Nail wants",
  "unique.bellNail.desc": "The Shield echo's ring comes back twice, at 1 and 2 s, with half the reach, the blow and the stun. Doesn't stack with Long echo nor with the Echo glyph.",
  "unique.bellNail.lore": "The watch's bell-ringer. He tuned the bell with this nail, blow by blow.",
  "feat.bellNail.1": "stun {m} with the echoes",
  "feat.bellNail.2": "have all three rings reach the same elite, {m} times",
  "uform.rallyCall": "Rally Call",
  "uform.rallyCall.desc": "Each ring mends every ally it reaches by 3 % of their life.",
  "unique.veteranMedallion": "Veteran's Medallion",
  "unique.veteranMedallion.short": "The Medallion",
  "unique.veteranMedallion.wants": "The Medallion wants",
  "unique.veteranMedallion.desc": "What you take during the Last line is gathered, up to your whole life. When it ends you mend 40 % of it and another 40 % bursts around you.",
  "unique.veteranMedallion.lore": "From the oldest in the barracks. He had seen other Tides and didn't like to tell of them.",
  "feat.veteranMedallion.1": "endure {m} damage during the Last line",
  "feat.veteranMedallion.2": "end a Last line below {sl} % life and mend {sh} % or more, {m} times",
  "uform.lastBlow": "Last Blow",
  "uform.lastBlow.desc": "The burst stuns 1 s (elites a third; bosses, nothing).",
  "unique.hunterBow": "Hunter's Bow",
  "unique.hunterBow.short": "The Hunting Bow",
  "unique.hunterBow.wants": "The Hunting Bow wants",
  "unique.hunterBow.desc": "Each Multishot arrow that kills jumps once to another nightmare within 3 hexes.",
  "unique.hunterBow.lore": "The wanderer's who hunted for the kitchen. He came back with hares and no arrows.",
  "feat.hunterBow.1": "make {m} arrows jump",
  "feat.hunterBow.2": "a Multishot that kills {k} or more, {m} times",
  "uform.secondPass": "Second Pass",
  "uform.secondPass.desc": "Arrows left without a target fall again on the area a moment later.",
  "unique.trackerBow": "Tracker's Bow",
  "unique.trackerBow.short": "The Trail Bow",
  "unique.trackerBow.wants": "The Trail Bow wants",
  "unique.trackerBow.desc": "The third Poison arrow on a nightmare still poisoned bursts it in a cloud that poisons within 1.5 hexes.",
  "unique.trackerBow.lore": "The tracker's who knew poisons. He'd smell a print and tell you what it had eaten.",
  "feat.trackerBow.1": "burst {m} clouds",
  "feat.trackerBow.2": "a cloud that poisons {k} or more, {m} times",
  "uform.fever": "Fever",
  "uform.fever.desc": "What the cloud poisoned hits 20% less while it lasts (elites and bosses, 10%).",
  "unique.pantryBow": "Pantry Bow",
  "unique.pantryBow.short": "The Pantry Bow",
  "unique.pantryBow.wants": "The Pantry Bow wants",
  "unique.pantryBow.desc": "Leaping with Disengage, an arrow at each nightmare within 3 hexes, up to 4, with your attack.",
  "unique.pantryBow.lore": "The one who went out for supplies. He counted the sacks twice on the way back.",
  "feat.pantryBow.1": "loose {m} arrows on the leap",
  "feat.pantryBow.2": "a leap whose arrows kill {k} or more, {m} times",
  "uform.timelyLeap": "Timely Leap",
  "uform.timelyLeap.desc": "Leaping below 30% life, Disengage comes back in half the time.",
  "unique.quarryBow": "Quarry Bow",
  "unique.quarryBow.short": "The Quarry Bow",
  "unique.quarryBow.wants": "The Quarry Bow wants",
  "unique.quarryBow.desc": "At the end of its line, the Piercing shot's arrow turns and flies on along another line at half strength.",
  "unique.quarryBow.lore": "The one who kept the quarry at night. He knew every stone by its echo.",
  "feat.quarryBow.1": "pierce {m} with the turn",
  "feat.quarryBow.2": "a shot that pierces {k} or more across both lines, {m} times",
  "uform.twoTurns": "Two Turns",
  "uform.twoTurns.desc": "The arrow turns twice.",
  "unique.falconerJerkin": "Falconer's Jerkin",
  "unique.falconerJerkin.short": "The Falconer's Jerkin",
  "unique.falconerJerkin.wants": "The Falconer's Jerkin wants",
  "unique.falconerJerkin.desc": "Every 4 s the Familiar's hawk dives on its prey and stuns it half a second (elites, a third; bosses, nothing).",
  "unique.falconerJerkin.lore": "The barracks falconer's. He talked more to the hawk than to people.",
  "feat.falconerJerkin.1": "stun {m} times with the dive",
  "feat.falconerJerkin.2": "have the hawk stun one elite three times and it die within {sec} s, {m} times",
  "uform.hawkReturns": "Hawk Returns",
  "uform.hawkReturns.desc": "When its prey dies, the hawk at once marks the biggest one nearby.",
  "unique.signalerCoat": "Signaler's Coat",
  "unique.signalerCoat.short": "The Signaler's Coat",
  "unique.signalerCoat.wants": "The Signaler's Coat wants",
  "unique.signalerCoat.desc": "What flies under the Signal flare comes down while it burns, elites too; bosses and the dragon, never.",
  "unique.signalerCoat.lore": "The signaler's who lit the warning fires. Not one ever went out on her.",
  "feat.signalerCoat.1": "bring down {m} flyers",
  "feat.signalerCoat.2": "a flare that brings down {k} or more, {m} times",
  "uform.burntAir": "Burnt Air",
  "uform.burntAir.desc": "Your basic attacks crit 1 in 4 against what the flare brought down.",
  "unique.trapperJerkin": "Trapper's Jerkin",
  "unique.trapperJerkin.short": "The Trapper's Jerkin",
  "unique.trapperJerkin.wants": "The Trapper's Jerkin wants",
  "unique.trapperJerkin.desc": "The Snare also catches elites, for a third of the time, and what flies, brought to the ground. Bosses, never.",
  "unique.trapperJerkin.lore": "The trapper's who hunted the low scrub. He knew where every beast would step.",
  "feat.trapperJerkin.1": "catch {m} elites",
  "feat.trapperJerkin.2": "kill a caught elite before it breaks free, {m} times",
  "uform.draggingSnare": "Dragging Snare",
  "uform.draggingSnare.desc": "Shutting, the Snare drags the nightmares within 2 hexes toward the caught one.",
  "unique.ballistaTip": "Great Ballista Tip",
  "unique.ballistaTip.short": "The Ballista Tip",
  "unique.ballistaTip.wants": "The Ballista Tip wants",
  "unique.ballistaTip.desc": "In each elite it pierces, the Titan's arrow sheds three splinters in a fan at the nearest.",
  "unique.ballistaTip.lore": "Hers who aimed the yard's great ballista. She judged the wind with a wet finger.",
  "feat.ballistaTip.1": "deal {m} damage with splinters",
  "feat.ballistaTip.2": "an arrow that pierces {k} elites, {m} times",
  "uform.returningArrow": "Returning Arrow",
  "uform.returningArrow.desc": "The arrow comes back along the same line, at half strength.",
  "unique.archerFeather": "Marksman's Feather",
  "unique.archerFeather.short": "The Feather",
  "unique.archerFeather.wants": "The Feather wants",
  "unique.archerFeather.desc": "Each nightmare you kill while Hidden shot lasts lengthens it half a second, up to double. Doesn't stack with Long cover.",
  "unique.archerFeather.lore": "The marksman's who never missed at practice. Nor at the wagers, either.",
  "feat.archerFeather.1": "kill {m} while hidden",
  "feat.archerFeather.2": "lengthen Hidden shot to double, {m} times",
  "uform.lastShot": "Last Shot",
  "uform.lastShot.desc": "When it ends, your next basic attack hits three times as hard.",
  "unique.tunerLens": "Tuner's Lens",
  "unique.tunerLens.short": "The Lens",
  "unique.tunerLens.wants": "The Lens wants",
  "unique.tunerLens.desc": "During Hawk eye, each basic-attack crit on an elite or boss looses one more arrow at the nearest nightmare. That arrow isn't a basic attack and doesn't crit.",
  "unique.tunerLens.lore": "The one who tuned the crossbows' sights. He said a crooked sight tells lies.",
  "feat.tunerLens.1": "loose {m} extra arrows",
  "feat.tunerLens.2": "kill an elite and {k} in all within one Eye, {m} times",
  "uform.guidingEye": "Guiding Eye",
  "uform.guidingEye.desc": "For 2 s after each of your crits, allies' basic attacks on that target crit 1 in 4.",
  "unique.nurseStaff": "Nurse's Staff",
  "unique.nurseStaff.short": "The Nurse's Staff",
  "unique.nurseStaff.wants": "The Nurse's Staff wants",
  "unique.nurseStaff.desc": "Mend on an ally below 30% life recharges at once, once every 12 s.",
  "unique.nurseStaff.lore": "The head nurse's. She knew every wounded one's name, and their mother's.",
  "feat.nurseStaff.1": "heal {m} on allies below 30%",
  "feat.nurseStaff.2": "save an ally below {sv}% who doesn't fall in the next {sec} s, {m} times",
  "uform.heart": "Heart",
  "uform.heart.desc": "The inspiration also reaches allies within 2 hexes of the healed one. Doesn't stack with Chain mend.",
  "unique.watercarrierStaff": "Water Carrier's Staff",
  "unique.watercarrierStaff.short": "The Water Carrier's Staff",
  "unique.watercarrierStaff.wants": "The Water Carrier's Staff wants",
  "unique.watercarrierStaff.desc": "Ray of faith stays 2 s on the ground: each second it hurts and heals what crosses it again, at half. Doesn't stack with the Trail glyph.",
  "unique.watercarrierStaff.lore": "The brother's who carried water to the rounds. He never spilled a bucket on the stairs.",
  "feat.watercarrierStaff.1": "heal {m} with the lingering ray",
  "feat.watercarrierStaff.2": "a ray that heals {a} allies and hurts {k} nightmares, {m} times",
  "uform.twoRays": "Two Rays",
  "uform.twoRays.desc": "A second ray crosses the first through its middle.",
  "unique.lamplighterStaff": "Lamplighter's Staff",
  "unique.lamplighterStaff.short": "The Lamplighter's Staff",
  "unique.lamplighterStaff.wants": "The Lamplighter's Staff wants",
  "unique.lamplighterStaff.desc": "If the Piercing light's nightmare dies, the light jumps to the nearest one and heals again. Three jumps at most.",
  "unique.lamplighterStaff.lore": "The one who lit the round's lamps. He whistled so they'd hear him coming.",
  "feat.lamplighterStaff.1": "make the light jump {m} times",
  "feat.lamplighterStaff.2": "a light that jumps {k} times in a row, {m} times",
  "uform.cleans": "Cleansing",
  "uform.cleans.desc": "Each jump also takes a bad state off the healed one.",
  "unique.midwifeStaff": "Midwife's Staff",
  "unique.midwifeStaff.short": "The Midwife's Staff",
  "unique.midwifeStaff.wants": "The Midwife's Staff wants",
  "unique.midwifeStaff.desc": "If the renewed ally drops below 30% life, the renewal bursts and heals everything it had left at once.",
  "unique.midwifeStaff.lore": "The barracks midwife's. She brought half the town into the world, mostly at night.",
  "feat.midwifeStaff.1": "heal {m} with bursts",
  "feat.midwifeStaff.2": "a burst that lifts them from below {sv}% and they don't fall in {sec} s, {m} times",
  "uform.passingRenew": "Passing Renewal",
  "uform.passingRenew.desc": "When it ends, Renew passes to the most hurt ally nearby for half the time. Doesn't stack with Shared blessing.",
  "unique.gardenerHabit": "Gardener's Habit",
  "unique.gardenerHabit.short": "The Gardener's Habit",
  "unique.gardenerHabit.wants": "The Gardener's Habit wants",
  "unique.gardenerHabit.desc": "Every 3 s the Guard totem leaps beside the most beset ally.",
  "unique.gardenerHabit.lore": "The brother's who kept the vegetable plot. He spoke softly to the plants, just in case.",
  "feat.gardenerHabit.1": "spare {m} damage",
  "feat.gardenerHabit.2": "have the totem guard {a} different allies in one use, {m} times",
  "uform.twoTotems": "Two Totems",
  "uform.twoTotems.desc": "A second totem comes, going with the next most beset ally. Doesn't stack with the Pack glyph.",
  "unique.cisternStole": "Cistern Stole",
  "unique.cisternStole.short": "The Stole",
  "unique.cisternStole.wants": "The Stole wants",
  "unique.cisternStole.desc": "Each state Cleanse removes falls on the nightmare nearest that ally: stun, fear and sleep as a stun; poison as poison; a curse as hitting less for 3 s.",
  "unique.cisternStole.lore": "Hers who kept the cistern's water. She tasted every bucket before it went up.",
  "feat.cisternStole.1": "return {m} states",
  "feat.cisternStole.2": "a Cleanse that returns {k} or more, {m} times",
  "uform.holyWater": "Holy Water",
  "uform.holyWater.desc": "It also leaves 4 s of holy ground, like a Sanctuary at half. Doesn't stack with the Trail glyph.",
  "unique.pilgrimSmock": "Pilgrim's Smock",
  "unique.pilgrimSmock.short": "The Smock",
  "unique.pilgrimSmock.wants": "The Smock wants",
  "unique.pilgrimSmock.desc": "For each ally Shared prayer heals, a holy light falls on the nightmare nearest them.",
  "unique.pilgrimSmock.lore": "The pilgrim's who stayed to serve. He was passing through and stayed twenty years.",
  "feat.pilgrimSmock.1": "deal {m} damage with lights",
  "feat.pilgrimSmock.2": "a prayer whose lights kill {k} or more, {m} times",
  "uform.amen": "Amen",
  "uform.amen.desc": "The prayer comes back by itself 4 s later, at 30%. Doesn't stack with the Echo glyph.",
  "unique.bronzeSun": "Bronze Sun",
  "unique.bronzeSun.short": "The Sun",
  "unique.bronzeSun.wants": "The Sun wants",
  "unique.bronzeSun.desc": "Dawn's judgment's column walks 3 s toward the biggest nightmare nearby, hurting as it goes.",
  "unique.bronzeSun.lore": "The brother's who rang the hours at dawn. He never missed one, not even with a fever.",
  "feat.bronzeSun.1": "deal {m} damage with the column",
  "feat.bronzeSun.2": "a column that kills {k} or more, {m} times",
  "uform.dawnStays": "Dawn That Stays",
  "uform.dawnStays.desc": "Where it ends, the column leaves 3 s of holy ground. Doesn't stack with the Trail glyph.",
  "unique.infirmaryBell": "Infirmary Bell",
  "unique.infirmaryBell.short": "The Little Bell",
  "unique.infirmaryBell.wants": "The Little Bell wants",
  "unique.infirmaryBell.desc": "Each ally the Choir healed in the last second lengthens it a tenth, up to double. Doesn't stack with Long choir.",
  "unique.infirmaryBell.lore": "Hers who sang so the wounded would sleep. Always the same song, softly.",
  "feat.infirmaryBell.1": "heal {m} with the choir",
  "feat.infirmaryBell.2": "a choir that reaches double, {m} times",
  "uform.lastSong": "Last Song",
  "uform.lastSong.desc": "When it ends, it raises a fallen ally nearby at 30% of their life.",
  "unique.vigilMedal": "Vigil Medal",
  "unique.vigilMedal.short": "The Medal",
  "unique.vigilMedal.wants": "The Medal wants",
  "unique.vigilMedal.desc": "When the Intercession's ally gets up, a light bursts that stuns 1.5 s around (elites, a third; bosses, nothing) and heals allies nearby 10%.",
  "unique.vigilMedal.lore": "The one who sat up with the sick at night. He slept by day, in a chair.",
  "feat.vigilMedal.1": "raise {m} with the Intercession",
  "feat.vigilMedal.2": "the raised one doesn't fall again in {sec} s and its light stuns {k} or more, {m} times",
  "uform.secondMark": "Second Mark",
  "uform.secondMark.desc": "On getting up, the marked one passes the mark to the most hurt ally, once.",
  "unique.minerPick": "Miner's Pick",
  "unique.minerPick.short": "The Pick",
  "unique.minerPick.wants": "The Pick wants",
  "unique.minerPick.desc": "A mine that bursts sets off, in a chain, your other mines within 3 hexes. Doesn't stack with Cluster.",
  "unique.minerPick.lore": "The miner of the lower galleries'. He whistled softly to know where the air was good.",
  "feat.minerPick.1": "set off {m} mines in a chain",
  "feat.minerPick.2": "a chain of three mines or more that fells {k} or more, {m} times",
  "uform.minefield": "Minefield",
  "uform.minefield.desc": "You can have two more mines at once.",
  "unique.stokerPoker": "Stoker's Poker",
  "unique.stokerPoker.short": "The Poker",
  "unique.stokerPoker.wants": "The Poker wants",
  "unique.stokerPoker.desc": "The Flamethrower's jet pushes what it burns one hex away.",
  "unique.stokerPoker.lore": "The bread ovens' stoker's. He came in before dawn to wake the embers.",
  "feat.stokerPoker.1": "push {m} with the jet",
  "feat.stokerPoker.2": "a jet that pushes {k} or more, {m} times",
  "uform.emberBurst": "Bursting Embers",
  "uform.emberBurst.desc": "What dies burning bursts in fire around it, at half the jet, with no chain.",
  "unique.buildersSquare": "Master Builder's Square",
  "unique.buildersSquare.short": "The Square",
  "unique.buildersSquare.wants": "The Square wants",
  "unique.buildersSquare.desc": "What the Wrench mends takes half the damage for 6 s and, a tower, fires 30 % faster. With nothing hurt near, it gives the nearest ally a shield of 10 % of its life.",
  "unique.buildersSquare.lore": "He kept the accounts of the works. He measured twice and cut once.",
  "feat.buildersSquare.1": "mend or shield {m}",
  "feat.buildersSquare.2": "mend a building below {sq} % that still stands {sec} s later, {m} times",
  "uform.rivetHold": "Rivet",
  "uform.rivetHold.desc": "What you mended doesn't drop below 1 life for 3 s.",
  "unique.clockmakerGear": "Clockmaker's Gear",
  "unique.clockmakerGear.short": "The Gear",
  "unique.clockmakerGear.wants": "The Gear wants",
  "unique.clockmakerGear.desc": "With no hurt building near, the Repair drone mends the hurt allies, half of what it repairs.",
  "unique.clockmakerGear.lore": "The barracks clockmaker's. On Sundays he wound every clock, one by one.",
  "feat.clockmakerGear.1": "heal {m} with the drone",
  "feat.clockmakerGear.2": "a drone that mends or heals {k} in a single flight, {m} times",
  "uform.secondDrone": "Second Drone",
  "uform.secondDrone.desc": "Two drones go out. Doesn't stack with the Pack glyph.",
  "unique.locksmithRivet": "Locksmith's Rivet",
  "unique.locksmithRivet.short": "The Rivet",
  "unique.locksmithRivet.wants": "The Rivet wants",
  "unique.locksmithRivet.desc": "The Iron barricade rolls slowly toward the nightmares and pushes what is in front of it.",
  "unique.locksmithRivet.lore": "The locksmith who kept the storehouse doors. He oiled every hinge at closing time.",
  "feat.locksmithRivet.1": "push {m} with the barricade",
  "feat.locksmithRivet.2": "the barricade pushing {k} or more at once, {m} times",
  "uform.plateBurst": "Bursting Plate",
  "uform.plateBurst.desc": "When it ends, the barricade bursts and stuns around it 1 s (elites a third; bosses, nothing).",
  "unique.rodmanCopper": "Rodman's Copper",
  "unique.rodmanCopper.short": "The Copper",
  "unique.rodmanCopper.wants": "The Copper wants",
  "unique.rodmanCopper.desc": "When it ends, the Coil throws a bolt at every nightmare within 4 hexes. It shatters the chilled.",
  "unique.rodmanCopper.lore": "He climbed the roofs to tend the lightning rods. No storm ever frightened him.",
  "feat.rodmanCopper.1": "fell {m} with the last spark",
  "feat.rodmanCopper.2": "a last spark that reaches {k} or more, {m} times",
  "uform.shoulderCoil": "Coil on the Shoulder",
  "uform.shoulderCoil.desc": "The Coil follows you.",
  "unique.gunnerPlate": "Gunner's Breastplate",
  "unique.gunnerPlate.short": "The Breastplate",
  "unique.gunnerPlate.wants": "The Breastplate wants",
  "unique.gunnerPlate.desc": "Each Mortar shell leaves the ground broken for 4 s: what crosses it goes 30 % slower. 12 craters at most. Doesn't stack with Incendiary mortar or the Trail glyph.",
  "unique.gunnerPlate.lore": "The gunner who loaded the catapults. He knew the weight of every stone by heart.",
  "feat.gunnerPlate.1": "slow {m} with craters",
  "feat.gunnerPlate.2": "a mortar that reaches {k} or more, {m} times",
  "uform.secondVolley": "Second Volley",
  "uform.secondVolley.desc": "When it ends, another volley falls at half. Doesn't stack with the Echo glyph.",
  "unique.masonApron": "Mason's Apron",
  "unique.masonApron.short": "The Apron",
  "unique.masonApron.wants": "The Apron wants",
  "unique.masonApron.desc": "The allies inside Fortify take 15 % less damage too.",
  "unique.masonApron.lore": "The mason who patched the cracks in the walls. There was always lime under his nails.",
  "feat.masonApron.1": "spare {m} damage with Fortify",
  "feat.masonApron.2": "a Fortify with {k} or more allies inside for {sec} s, {m} times",
  "uform.limeAndStone": "Lime and Stone",
  "uform.limeAndStone.desc": "When it ends, the allies and buildings that were inside get a shield of 10 % of their life.",
  "unique.kennelCoat": "Kennelman's Jerkin",
  "unique.kennelCoat.short": "The Jerkin",
  "unique.kennelCoat.wants": "The Jerkin wants",
  "unique.kennelCoat.desc": "The nightmare the Clockwork hound bites is held 1 s, each one once every 3 s (elites half; bosses, nothing).",
  "unique.kennelCoat.lore": "The kennelman who kept the barracks dogs. He knew every one of them by name.",
  "feat.kennelCoat.1": "hold {m}",
  "feat.kennelCoat.2": "the hound holding an elite that dies held, {m} times",
  "uform.scent": "Scent",
  "uform.scent.desc": "The hound goes first for the nearest elite and draws it: it goes for the hound.",
  "unique.stormStaff": "Staff of Storms",
  "unique.stormStaff.short": "The Storm Staff",
  "unique.stormStaff.wants": "The Storm Staff wants",
  "unique.stormStaff.desc": "At the last one, the Chain lightning comes back along its way, at half. Doesn't stack with Long arc.",
  "unique.stormStaff.lore": "The mage who measured the storms. She wrote down every thunderclap in a damp notebook.",
  "feat.stormStaff.1": "strike {m} targets with the way back",
  "feat.stormStaff.2": "a chain that fells {k} or more, {m} times",
  "uform.splitBolt": "Split Bolt",
  "uform.splitBolt.desc": "At the first target, the chain splits in two.",
  "unique.distillerStaff": "Distiller's Staff",
  "unique.distillerStaff.short": "The Distiller's",
  "unique.distillerStaff.wants": "The Distiller's wants",
  "unique.distillerStaff.desc": "For 3 s the nightmare eaten by the Acid dart drips: each second it leaves a drop that eats the first one to step on it. 9 drops at most.",
  "unique.distillerStaff.lore": "He distilled the infirmary's remedies. He always smelled of mint and spirits.",
  "feat.distillerStaff.1": "eat {m} with the drip",
  "feat.distillerStaff.2": "a dart whose drip eats {k} or more, {m} times",
  "uform.seekingDart": "Seeking Dart",
  "uform.seekingDart.desc": "If the eaten one dies while the acid lasts, the dart flies again to the nearest.",
  "unique.pantryStaff": "Pantry Staff",
  "unique.pantryStaff.short": "The Pantry Staff",
  "unique.pantryStaff.wants": "The Pantry Staff wants",
  "unique.pantryStaff.desc": "The Frost lance leaves its line frozen for 3 s: what steps on it is chilled. Doesn't stack with the Trail glyph.",
  "unique.pantryStaff.lore": "The mage who kept the pantry's ice. With her, the milk lasted all summer.",
  "feat.pantryStaff.1": "chill {m} with the frozen line",
  "feat.pantryStaff.2": "a lance that pierces {k} or more, {m} times",
  "uform.icicle": "Ice Floe",
  "uform.icicle.desc": "A shatter on the frozen line reaches everything on it.",
  "unique.whiteWallRobe": "White Wall Robe",
  "unique.whiteWallRobe.short": "The White Robe",
  "unique.whiteWallRobe.wants": "The White Robe wants",
  "unique.whiteWallRobe.desc": "When it ends, the Frost wall bursts into shards that chill what is within 1 hex.",
  "unique.whiteWallRobe.lore": "The apprentice who practised ice in the yard. His walls came out crooked, and he laughed.",
  "feat.whiteWallRobe.1": "chill {m} with the burst",
  "feat.whiteWallRobe.2": "a burst that chills {k} or more, {m} times",
  "uform.wallAgain": "Returning Wall",
  "uform.wallAgain.desc": "The burst leaves another wall, half as long, for 2 s.",
  "unique.teacherRobe": "Teacher's Robe",
  "unique.teacherRobe.short": "The Teacher's Robe",
  "unique.teacherRobe.wants": "The Teacher's Robe wants",
  "unique.teacherRobe.desc": "Where it arrives, the Frost orb comes back toward you the same way. Doesn't stack with Deep orb.",
  "unique.teacherRobe.lore": "The mage who taught the apprentices. She repeated every lesson for the back row.",
  "feat.teacherRobe.1": "deal {m} damage on the way back",
  "feat.teacherRobe.2": "the orb biting {k} or more there and back, {m} times",
  "uform.growingOrb": "Growing Orb",
  "uform.growingOrb.desc": "It grows with every nightmare it touches, up to twice its size.",
  "unique.jailerSurcoat": "Jailer's Surcoat",
  "unique.jailerSurcoat.short": "The Surcoat",
  "unique.jailerSurcoat.wants": "The Surcoat wants",
  "unique.jailerSurcoat.desc": "When a nightmare bound by the Shadow chains dies, the others take 20 % of its maximum life.",
  "unique.jailerSurcoat.lore": "The dungeons' jailer. He read the letters to the prisoners who couldn't read.",
  "feat.jailerSurcoat.1": "deal {m} damage with shared deaths",
  "feat.jailerSurcoat.2": "a binding of {k} or more where all of them die, {m} times",
  "uform.seekingChains": "Seeking Chains",
  "uform.seekingChains.desc": "The chain of a bound one that dies passes to the nearest nightmare.",
  "unique.messengerCape": "Messenger's Cape",
  "unique.messengerCape.short": "The Cape",
  "unique.messengerCape.wants": "The Cape wants",
  "unique.messengerCape.desc": "The Blink bursts another flare where you appear.",
  "unique.messengerCape.lore": "The messenger who carried the Order's letters. He knew every shortcut on the road.",
  "feat.messengerCape.1": "land {m} arrival flares that reach two or more",
  "feat.messengerCape.2": "two flares that reach {k} or more each, {m} times",
  "uform.mirrorImage": "Afterimage",
  "uform.mirrorImage.desc": "Where you were, an image of you stays 3 s and draws the nightmares near: they go for the image.",
  "unique.iceTear": "Ice Tear",
  "unique.iceTear.short": "The Tear",
  "unique.iceTear.wants": "The Tear wants",
  "unique.iceTear.desc": "Each second a hailstone falls on a chilled nightmare inside the Blizzard and shatters it, as lightning does. Never on the dragon.",
  "unique.iceTear.lore": "The mage who made it snow at the feasts. The children followed her, asking for more.",
  "feat.iceTear.1": "shatter {m} with the hail",
  "feat.iceTear.2": "a blizzard where the hail shatters {k} or more, {m} times",
  "uform.feedingStorm": "Feeding Blizzard",
  "uform.feedingStorm.desc": "Each nightmare that dies inside makes it last 0.5 s longer, up to twice as long.",
  "unique.dreamStone": "Stone of Deep Sleep",
  "unique.dreamStone.short": "The Stone",
  "unique.dreamStone.wants": "The Stone wants",
  "unique.dreamStone.desc": "After it bursts, the Dream rift stays open 4 s: what comes in is stunned 1 s, each one once (elites a third; bosses, nothing).",
  "unique.dreamStone.lore": "She wrote down the guards' dreams. She said you could read the weather in them.",
  "feat.dreamStone.1": "stun {m} with the open rift",
  "feat.dreamStone.2": "a rift that drags {k} or more, {m} times",
  "uform.dreamBlow": "Blow in the Dream",
  "uform.dreamBlow.desc": "The first blow on a nightmare the open rift stunned hits twice as hard.",
  "unique.cometEmber": "Comet Ember",
  "unique.cometEmber.short": "The Ember",
  "unique.cometEmber.wants": "The Ember wants",
  "unique.cometEmber.desc": "The Rain of fire's meteors fall on nightmares, the biggest first, instead of at random. They never pick the dragon.",
  "unique.cometEmber.lore": "He watched the stars from the yard. He had given names to many of them.",
  "feat.cometEmber.1": "deal {m} damage with the rain",
  "feat.cometEmber.2": "a rain that fells {k} or more, {m} times",
  "uform.cometTail": "Comet's Tail",
  "uform.cometTail.desc": "The last meteor is huge: it strikes 5 times over a wide area. Doesn't stack with Great meteors.",
  "reason.notEnoughScraps": "Not enough scraps: it takes 6 of this slot.",
  "reason.unknownSkill": "Learn that piece's skill first.",
  "reason.noSlot": "That slot doesn't have its saga unique yet.",
  "reason.have": "That piece is already yours.",
  "reason.notPanoply": "That piece isn't rearmed: it comes from the saga.",
  "reason.badSlot": "The rare has to be of the same slot as the unique.",
  "reason.badEffect": "That slot doesn't take that effect.",
  "reason.notInfused": "That slot already has each piece's own effect.",
  "reason.noScrap": "There's no cellars' scrap to move.",
  "reason.scrapsFull": "That slot takes no more scraps.",
  "reason.infuseNotUnique": "Only a unique of your class takes an infusion.",
  "reason.infuseNotRare": "Only a rare or very rare piece with an effect can be burnt.",
  "log.rearmed": "Hilde rearmed {u} for {who}",
  "log.rearmed.you": "Hilde rearmed {u} for you",
  "log.infused": "{who} infused {fx} into their unique slot (rank {n})",
  "log.infused.you": "You infused {fx} into your unique slot (rank {n})",
  "log.uninfused": "{who} set their unique slot back to each piece's own effect",
  "log.uninfused.you": "You set your unique slot back to each piece's own effect",
  "panoply.yours": "Your uniques",
  "panoply.scraps.weapon": "weapon scraps",
  "panoply.scraps.armor": "armor scraps",
  "panoply.scraps.amulet": "amulet scraps",
  "panoply.scrapsCount": "{n} / {m} {what}",
  "panoply.scrapsHint": "Scraps of the old garrison. With 6, Hilde rearms at the forge a piece of a skill you know.",
  "panoply.later.weapon": "The old barracks' weapons come after the saga's weapon.",
  "panoply.later.armor": "The old barracks' armors come after the dragon's armor.",
  "panoply.later.amulet": "The old barracks' amulets come after the Drowned Dragon's amulet.",
  "panoply.studying": "Hilde is studying them: your scraps wait for you.",
  "panoply.noSkill": "No skill",
  "panoply.carried": "You carry that skill",
  "panoply.canRearm": "Ready to rearm",
  "panoply.fromSaga": "The Turtle, chapter {n}",
  "panoply.needTome": "{skill} tome: {n} / {m} pages",
  "panoply.needSkill": "Learn {skill} in the tree",
  "panoply.needScraps": "{n} / {m} {what}",
  "panoply.rearmCap": "Hilde can rearm a piece with 6 {what}",
  "panoply.ofSkill": "A piece of {skill}",
  "panoply.legend": "Its Legend: {n} of {m} bosses",
  "panoply.finalWon": "won",
  "panoply.wear": "Put it on",
  "panoply.wearWith": "Put it on with {skill}",
  "panoply.again": "See its arrival again",
  "panoply.keep": "Keep",
  "panoply.cellarsWent": "The cellars' scrap went to {what}.",
  "panoply.moveScrap": "Move it to {what}",
  "panoply.swapped": "{where}: you put on {to} (was: {from})",
  "panoply.swappedNew": "{where}: you put on {to}",
  "panoply.undo": "Undo",
  "panoply.told": "What's worked on the slot isn't lost: the final form is won with each piece.",
  "panoply.carry": "Carry {what}",
  "panoply.scrapsTitle": "Scraps",
  "panoply.gained": "+{n} {what} ({have} / {m})",
  "panoply.full": "at the most: rearm a piece",
  "panoply.hildeCan": "Hilde can rearm a piece at the forge.",
  "infuse.title": "Infuse",
  "infuse.hint": "Burn a rare of this slot: its effect goes to all your uniques of the slot. Each more rare of the same effect raises a rank, up to {n}.",
  "infuse.none": "You have no rares of this slot with an effect it takes.",
  "infuse.full": "already at the top rank",
  "infuse.rankUp": "rises to rank {n}",
  "infuse.replace": "replaces {was}",
  "infuse.go": "Infuse",
  "infuse.confirm": "The rare is lost: confirm",
  "infuse.back": "Back to each piece's own effect",
  "infuse.badge": "infused, rank {n} of {m}",
  "infuse.ownHint": "The piece's own effect, covered by the infused one",
  "news.2026-11-04-zzzzzzzzzzzpanoply.title": "A unique for every skill",
  "news.2026-11-04-zzzzzzzzzzzpanoply.intro": "Uniques no longer tie you to your level 1 skills. The warrior comes first.",
  "news.2026-11-04-zzzzzzzzzzzpanoply.panoply": "Nine new uniques for the warrior",
  "news.2026-11-04-zzzzzzzzzzzpanoply.panoply.desc": "Each of the warrior's skills now has its own unique that changes how it works: the Low blow's mark that jumps, the Shield slam that knocks foes together, the Banner that throws itself, the Shield echo that rings again. The other classes come later, one at a time.",
  "news.2026-11-04-zzzzzzzzzzzpanoply.scraps": "Scraps of the old garrison",
  "news.2026-11-04-zzzzzzzzzzzpanoply.scraps.desc": "Crypts give weapon scraps, incursions armor scraps, and the Furrows, the Chasm and the deep Tides amulet scraps, once you hold that slot's saga unique. With 6, Hilde rearms at the forge the piece you pick of a skill you know.",
  "news.2026-11-04-zzzzzzzzzzzpanoply.infuse": "Infusing: rares matter again",
  "news.2026-11-04-zzzzzzzzzzzpanoply.infuse.desc": "At the forge you can burn a rare so its effect goes to your unique. Each more rare of the same effect raises its rank, up to the unique's own effect.",
  "news.2026-11-04-zzzzzzzzzzzpanoply.collection": "What you work belongs to the slot",
  "news.2026-11-04-zzzzzzzzzzzpanoply.collection.desc": "The awakening, the forge's pluses, the reforges and the gems stay on the slot: changing pieces never leaves you weaker. Your uniques no longer take bag room. Pick a skill in a preparation and its piece goes on by itself, with an undo.",
  "news.2026-11-04-zzzzzzzzzzzzglyphs.title": "The deep crypt's fragments",
  "news.2026-11-04-zzzzzzzzzzzzglyphs.intro": "A fix to what the deep crypt gives.",
  "news.2026-11-04-zzzzzzzzzzzzglyphs.deepGlyphs": "The deep crypt gives the fragments it says",
  "news.2026-11-04-zzzzzzzzzzzzglyphs.deepGlyphs.desc": "Winning it without falling gave twice the glyph fragments by mistake: now it gives the two it should. Fragments already gathered stay.",
  "unique.hiveStaff": "Hive Staff",
  "unique.hiveStaff.short": "The Hive",
  "unique.hiveStaff.wants": "The Hive wants",
  "unique.hiveStaff.desc": "The Swarm leaves a hive for 6 s where it stings: every second it sends wasps at the two nearest unpoisoned nightmares within 2 hexes.",
  "unique.hiveStaff.lore": "The orchard beekeeper's. She could tell when the bees were in a bad mood.",
  "feat.hiveStaff.1": "poison {m} with the hive",
  "feat.hiveStaff.2": "a hive that poisons {k} or more, {m} times",
  "uform.queen": "Queen",
  "uform.queen.desc": "The hive lasts twice as long and its wasps slow 20 %.",
  "unique.herbalistStaff": "Herbalist's Staff",
  "unique.herbalistStaff.short": "The Herbal",
  "unique.herbalistStaff.wants": "The Herbal wants",
  "unique.herbalistStaff.desc": "The Spore cloud drifts slowly toward the biggest nightmare nearby.",
  "unique.herbalistStaff.lore": "The infirmary herbalist's. He dried the leaves hung by the window.",
  "feat.herbalistStaff.1": "poison {m} with the drifting cloud",
  "feat.herbalistStaff.2": "a cloud that poisons {k} or more, {m} times",
  "uform.mushrooms": "Mushrooms",
  "uform.mushrooms.desc": "Where the cloud ends, mushrooms spring up and let it out again, at half.",
  "unique.briarStaff": "Briar Staff",
  "unique.briarStaff.short": "The Briar",
  "unique.briarStaff.wants": "The Briar wants",
  "unique.briarStaff.desc": "What the Briar lash drags stays thorned for 4 s: each blow it lands on you takes back 30 % of your attack.",
  "unique.briarStaff.lore": "From the woman who cut the briars off the paths. She never wore gloves.",
  "feat.briarStaff.1": "give back {m} damage",
  "feat.briarStaff.2": "a lash that drags {k} or more, {m} times",
  "uform.hedge": "Hedge",
  "uform.hedge.desc": "Leaves a row of briars ahead for 3 s that slows 40 % (does not stack with the Trail glyph).",
  "unique.poulticeTunic": "Poultice Tunic",
  "unique.poulticeTunic.short": "The Tunic",
  "unique.poulticeTunic.wants": "The Tunic wants",
  "unique.poulticeTunic.desc": "While Deep root lasts, the rooted one gives back 20 % of what it takes to whoever strikes it.",
  "unique.poulticeTunic.lore": "From the woman who made the poultices. It smelled of mustard and wet linen.",
  "feat.poulticeTunic.1": "give back {m} damage with the root",
  "feat.poulticeTunic.2": "a root on an ally with {k} or more striking it who does not fall, {m} times",
  "uform.sprout": "Sprout",
  "uform.sprout.desc": "When the root ends, it leaves a sprout that mends around it for 4 s.",
  "unique.goatherdPelt": "Goatherd's Pelt",
  "unique.goatherdPelt.short": "The Pelt",
  "unique.goatherdPelt.wants": "The Pelt wants",
  "unique.goatherdPelt.desc": "In Wolf form two shadow wolves run by your side, striking half as hard as you.",
  "unique.goatherdPelt.lore": "The barracks goatherd's. In winter he slept among the goats.",
  "feat.goatherdPelt.1": "deal {m} damage with the wolves",
  "feat.goatherdPelt.2": "have the wolves kill {k} in a single form, {m} times",
  "uform.howl": "Howl",
  "uform.howl.desc": "Taking the form stuns around you for 2 s (elites a third; bosses, nothing).",
  "unique.gardenerPlate": "Gardener's Plate",
  "unique.gardenerPlate.short": "The Plate",
  "unique.gardenerPlate.wants": "The Plate wants",
  "unique.gardenerPlate.desc": "What crosses the Thorn wall is held for 1 s, once.",
  "unique.gardenerPlate.lore": "The infirmary gardener's. He talked to the rosebushes when he thought nobody heard.",
  "feat.gardenerPlate.1": "hold {m}",
  "feat.gardenerPlate.2": "a wall that holds {k} or more, {m} times",
  "uform.venomThorns": "Venom thorns",
  "uform.venomThorns.desc": "What the thorns prick is poisoned (ready for combustion).",
  "unique.undertakerPendant": "Undertaker's Pendant",
  "unique.undertakerPendant.short": "The Pendant",
  "unique.undertakerPendant.wants": "The Pendant wants",
  "unique.undertakerPendant.desc": "Those poisoned by the Plague pass it on to those within 1 hex.",
  "unique.undertakerPendant.lore": "The barracks undertaker's. He dug slowly and always left flowers.",
  "feat.undertakerPendant.1": "spread it to {m}",
  "feat.undertakerPendant.2": "a plague that poisons {k} or more, {m} times",
  "uform.blackCloud": "Black cloud",
  "uform.blackCloud.desc": "Those poisoned by the plague strike 20 % softer (elites and bosses, half of it).",
  "unique.groundStone": "Ground Stone",
  "unique.groundStone.short": "The Stone",
  "unique.groundStone.wants": "The Stone wants",
  "unique.groundStone.desc": "Root quake opens three cracks that run 3 hexes outward and stun what they cross for 1 s.",
  "unique.groundStone.lore": "From the druid who read the ground of the shell. He always kept it in his pocket.",
  "feat.groundStone.1": "stun {m} with cracks",
  "feat.groundStone.2": "a quake whose cracks stun {k} or more, {m} times",
  "uform.unforgiving": "Unforgiving ground",
  "uform.unforgiving.desc": "What stands on the broken ground takes 15 % more.",
  "unique.orchardAcorn": "Orchard Acorn",
  "unique.orchardAcorn.short": "The Acorn",
  "unique.orchardAcorn.wants": "The Acorn wants",
  "unique.orchardAcorn.desc": "The trees of Forest awakening hold what they strike for 1 s, once every 3 s for each nightmare.",
  "unique.orchardAcorn.lore": "From the woman who planted the orchard trees. She counted the years by the rings.",
  "feat.orchardAcorn.1": "hold {m}",
  "feat.orchardAcorn.2": "trees that hold {k} in a single awakening, {m} times",
  "uform.walkingTrees": "Trees that follow",
  "uform.walkingTrees.desc": "The trees walk with you.",
  "news.2026-11-04-zzzzzzzzzzzzzdruid.title": "The druid's uniques",
  "news.2026-11-04-zzzzzzzzzzzzzdruid.intro": "The druid now has a unique for every skill.",
  "news.2026-11-04-zzzzzzzzzzzzzdruid.druid": "Nine new uniques for the druid",
  "news.2026-11-04-zzzzzzzzzzzzzdruid.druid.desc": "Each of the druid's skills has its own unique: the Wasps that leave a hive, the Spores that drift, the shadow wolves of the Wolf form, the Plague that spreads. They're rearmed from scraps at the forge, like the warrior's.",
  "unique.shepherdAxe": "Shepherd's Greataxe",
  "unique.shepherdAxe.short": "The Shepherd",
  "unique.shepherdAxe.wants": "The Shepherd wants",
  "unique.shepherdAxe.desc": "On its way out the Throwing axe also leaps to the nightmare nearest its target within 2.5 hex and hits it just as hard before coming back. Doesn't stack with Bouncing axe.",
  "unique.shepherdAxe.lore": "The shepherd took it up the hill for the wolves. It always came back clean.",
  "feat.shepherdAxe.1": "make the axe leap {m} times",
  "feat.shepherdAxe.2": "an axe that kills {k} between going out, the leap and coming back, {m} times",
  "uform.axePair": "Axe Pair",
  "uform.axePair.desc": "You throw two axes at two different nightmares, and each one leaps.",
  "unique.brawlerAxe": "Brawler's Greataxe",
  "unique.brawlerAxe.short": "The Brawler",
  "unique.brawlerAxe.wants": "The Brawler wants",
  "unique.brawlerAxe.desc": "If the nightmare the Kick knocked down dies before it gets up, the Kick recharges at once (once every 6 s).",
  "unique.brawlerAxe.lore": "From the one who fought at the fair for a coin. Said a kick wins more than an edge.",
  "feat.brawlerAxe.1": "kill {m} before they get up from the Kick",
  "feat.brawlerAxe.2": "{k} Kicks in a row that kill, {m} times",
  "uform.bigKick": "Kick the Big Ones",
  "uform.bigKick.desc": "The Kick throws elites too, at half the distance. Bosses, never.",
  "unique.carterAxe": "Carter's Greataxe",
  "unique.carterAxe.short": "The Carter",
  "unique.carterAxe.wants": "The Carter wants",
  "unique.carterAxe.desc": "The Brutal blow heals you all that your wounds added to it.",
  "unique.carterAxe.lore": "He split firewood at every stop on the road. The cart never arrived without a fire.",
  "feat.carterAxe.1": "heal {m} with the Brutal blow",
  "feat.carterAxe.2": "go from below {bl} % to above {bh} % health within {sec} s, {m} times",
  "uform.carterEdge": "Carter's Edge",
  "uform.carterEdge.desc": "Below 20 % health, the Brutal blow also hits everything within 1 hex of its target.",
  "unique.bullTusk": "Bull Tusk",
  "unique.bullTusk.short": "The Tusk",
  "unique.bullTusk.wants": "The Tusk wants",
  "unique.bullTusk.desc": "When the Charge ends you run back to where you left, striking again what you cross at half the blow and the stun.",
  "unique.bullTusk.lore": "From the mill bull that got loose one winter. It took six of them to bring it back.",
  "feat.bullTusk.1": "stun {m} between going and coming back",
  "feat.bullTusk.2": "a Charge that stuns {k} or more, {m} times",
  "uform.dustTrail": "Dust Trail",
  "uform.dustTrail.desc": "The path there and back stays broken 3 s: whatever crosses it goes 40 % slower. Doesn't stack with the Trail glyph.",
  "unique.wolfSkull": "Wolf Skull",
  "unique.wolfSkull.short": "The Skull",
  "unique.wolfSkull.wants": "The Skull wants",
  "unique.wolfSkull.desc": "Each nightmare stunned by the roar that dies stuns those within 1 hex for 1 s (elites a third; bosses, nothing). The fear spreads up to three times.",
  "unique.wolfSkull.lore": "It hung on the pen gate. The sheep never went near it.",
  "feat.wolfSkull.1": "spread the fear to {m}",
  "feat.wolfSkull.2": "a roar whose fear spreads to {k} or more, {m} times",
  "uform.panic": "Panic",
  "uform.panic.desc": "Those the fear stuns hit 30 % softer for 3 s after they get up (elites and bosses, half of it).",
  "unique.tannerFang": "Tanner's Fang",
  "unique.tannerFang.short": "The Tanner",
  "unique.tannerFang.wants": "The Tanner wants",
  "unique.tannerFang.desc": "Each nightmare that dies bleeding from you leaves a 3 s stain that bleeds whatever steps on it. Up to 6 stains at a time.",
  "unique.tannerFang.lore": "The tanner scraped hides with this fang. Her hands were always red.",
  "feat.tannerFang.1": "bleed {m} with the stains",
  "feat.tannerFang.2": "a stain that bleeds {k} or more, {m} times",
  "uform.heavyBlood": "Heavy Blood",
  "uform.heavyBlood.desc": "The nightmares bleeding from you go 20 % slower.",
  "unique.foremanPelt": "Foreman's Pelt",
  "unique.foremanPelt.short": "The Pelt",
  "unique.foremanPelt.wants": "The Pelt wants",
  "unique.foremanPelt.desc": "When the Clan roar ends, it roars again for half as long from the ally with the most nightmares around. Doesn't stack with Long roar or the Echo glyph.",
  "unique.foremanPelt.lore": "The quarry foreman shouted louder than the hammers. Nobody came in late.",
  "feat.foremanPelt.1": "spare {m} damage with the roar",
  "feat.foremanPelt.2": "an echo that reaches {a} or more allies, {m} times",
  "uform.warDrum": "War Drum",
  "uform.warDrum.desc": "The allies the roar reaches attack 15 % faster while it lasts (with another haste, the stronger counts).",
  "unique.challengerHide": "Challenger's Hide",
  "unique.challengerHide.short": "The Hide",
  "unique.challengerHide.wants": "The Hide wants",
  "unique.challengerHide.desc": "If the challenged one dies during the Duel, the duel goes to the biggest nightmare near, with the time it had left and 2 s more. It passes twice at most. Doesn't stack with Long duel.",
  "unique.challengerHide.lore": "From the one who challenged everyone at the tavern. Lost nearly always, and came back the next day.",
  "feat.challengerHide.1": "win {m} duels",
  "feat.challengerHide.2": "win {k} in a single Duel, {m} times",
  "uform.arena": "Arena",
  "uform.arena.desc": "While the Duel lasts, the other nightmares hit you for half.",
  "unique.ancestorPelts": "Pelts of the Ancestors",
  "unique.ancestorPelts.short": "The Pelts",
  "unique.ancestorPelts.wants": "The Pelts wants",
  "unique.ancestorPelts.desc": "During the Ancestral fury, every third blow lets loose a spirit that leaps to another nightmare within 2 hex and hits it with your attack.",
  "unique.ancestorPelts.lore": "Old pelts handed down from parents to children. They smelled of the smoke of many winters.",
  "feat.ancestorPelts.1": "let loose {m} spirits",
  "feat.ancestorPelts.2": "{k} spirits in a single Fury, {m} times",
  "uform.healingSpirits": "Healing Spirits",
  "uform.healingSpirits.desc": "Each spirit that kills heals you 2 % of your health.",
  "unique.firstRoundHammer": "Hammer of the First Round",
  "unique.firstRoundHammer.short": "The Round",
  "unique.firstRoundHammer.wants": "The Round wants",
  "unique.firstRoundHammer.desc": "The Blinding light goes out behind you too, with the same reach, blinding and damage. Doesn't stack with Wide light.",
  "unique.firstRoundHammer.lore": "From whoever walked the night's first round. They knocked on every door with the handle.",
  "feat.firstRoundHammer.1": "blind {m} behind you",
  "feat.firstRoundHammer.2": "a Light that blinds {k} or more, {m} times",
  "uform.hush": "Blindness",
  "uform.hush.desc": "The blinded can't strike from afar while it lasts (elites, half the time; bosses hit for half from afar).",
  "unique.penitenceHammer": "Penitence Hammer",
  "unique.penitenceHammer.short": "The Penitence",
  "unique.penitenceHammer.wants": "The Penitence wants",
  "unique.penitenceHammer.desc": "If the atoning blow kills, the next blow atones too (once per Atone).",
  "unique.penitenceHammer.lore": "They used it to nail the boards over the old well. Not one ever came loose.",
  "feat.penitenceHammer.1": "heal {m} with chained blows",
  "feat.penitenceHammer.2": "{k} atoning blows in a row that kill, {m} times",
  "uform.absolution": "Absolution",
  "uform.absolution.desc": "The atoning blow also hits everything within 0.9 hex of its target.",
  "unique.keeperHammer": "Keykeeper's Hammer",
  "unique.keeperHammer.short": "The Keykeeper",
  "unique.keeperHammer.wants": "The Keykeeper wants",
  "unique.keeperHammer.desc": "When the sealed nightmare dies, each ally that struck it heals 5 % of its health.",
  "unique.keeperHammer.lore": "The keykeeper beat frozen locks until they gave. None ever beat him.",
  "feat.keeperHammer.1": "heal {m} with seals",
  "feat.keeperHammer.2": "a seal that heals {a} different allies, {m} times",
  "uform.twoSeals": "Two Seals",
  "uform.twoSeals.desc": "The Seal also marks the nightmare nearest the sealed one.",
  "unique.armsMasterCuirass": "Arms Master's Cuirass",
  "unique.armsMasterCuirass.short": "The Master",
  "unique.armsMasterCuirass.wants": "The Master wants",
  "unique.armsMasterCuirass.desc": "When the Spinning hammer ends, the hammer flies 4 hex in a straight line where you face and hits everything it crosses.",
  "unique.armsMasterCuirass.lore": "The arms master wore it in the yard. Said a blow begins in the feet.",
  "feat.armsMasterCuirass.1": "deal {m} with the loose hammer",
  "feat.armsMasterCuirass.2": "a loose hammer that hits {k} or more, {m} times",
  "uform.twinHammers": "Two Hammers",
  "uform.twinHammers.desc": "Two hammers fly out, one ahead and one behind.",
  "unique.armourerCoat": "Armourer's Coat",
  "unique.armourerCoat.short": "The Coat",
  "unique.armourerCoat.wants": "The Coat wants",
  "unique.armourerCoat.desc": "Bless weapon also blesses, at half, the ally nearest the blessed one. Doesn't stack with the Bond glyph.",
  "unique.armourerCoat.lore": "The armourer tried every new sword on it. It was full of nicks.",
  "feat.armourerCoat.1": "deal {m} with blessed weapons",
  "feat.armourerCoat.2": "blessed allies kill {k} in a single blessing, {m} times",
  "uform.holyArm": "Holy Arm",
  "uform.holyArm.desc": "Each blessed blow heals whoever strikes 2 % of their health.",
  "unique.stairPlates": "Stair Plates",
  "unique.stairPlates.short": "The Plates",
  "unique.stairPlates.wants": "The Plates wants",
  "unique.stairPlates.desc": "On landing by the ally, Intervene stuns everything within 1.5 hex of it for 1 s (elites a third; bosses, nothing).",
  "unique.stairPlates.lore": "From whoever went down the wall stair first. Always came down loud.",
  "feat.stairPlates.1": "stun {m} on landing",
  "feat.stairPlates.2": "an ally below {il} % who doesn't fall, with {k} or more stunned, {m} times",
  "uform.alwaysThere": "Always There",
  "uform.alwaysThere.desc": "If the ally was below 20 % health, Intervene is ready again (once every 15 s).",
  "unique.blessedStone": "Blessed Stone",
  "unique.blessedStone.short": "The Stone",
  "unique.blessedStone.wants": "The Stone wants",
  "unique.blessedStone.desc": "Whatever strikes a building the Holy rampart protects burns (holy) for 30 % of the blow. With no buildings near, it protects you as one. Doesn't stack with Blessed rampart.",
  "unique.blessedStone.lore": "The chapel's first stone. The children touched it as they passed.",
  "feat.blessedStone.1": "burn {m} with the rampart",
  "feat.blessedStone.2": "a rampart that burns {k} or more, {m} times",
  "uform.unyielding": "Unyielding Stone",
  "uform.unyielding.desc": "What the rampart protects doesn't go below 1 health while it lasts.",
  "unique.elderCharm": "Elder Brother's Charm",
  "unique.elderCharm.short": "The Charm",
  "unique.elderCharm.wants": "The Charm wants",
  "unique.elderCharm.desc": "While the Sacrifice lasts, whatever strikes a protected ally burns (holy) for 20 % of the damage you carry.",
  "unique.elderCharm.lore": "Worn by the eldest of many brothers. He always ate last.",
  "feat.elderCharm.1": "carry {m} damage",
  "feat.elderCharm.2": "a Sacrifice with {a} allies where nobody falls, {m} times",
  "uform.staying": "The One Who Stays",
  "uform.staying.desc": "If you would fall during the Sacrifice, you stay at 1 health and the Sacrifice ends.",
  "unique.prayerBead": "Prayer Bead",
  "unique.prayerBead.short": "The Bead",
  "unique.prayerBead.wants": "The Bead wants",
  "unique.prayerBead.desc": "While the Avatar of light lasts, every 2 s a hammer of light falls on the nearest inked nightmare within 6 hex (else the nearest) and hits it for 150 % of your attack.",
  "unique.prayerBead.lore": "From a rosary that broke in the fire. Only this bead was found.",
  "feat.prayerBead.1": "deal {m} with hammers of light",
  "feat.prayerBead.2": "the hammers kill {k} in a single avatar, {m} times",
  "uform.unfading": "Unfading Light",
  "uform.unfading.desc": "Each inked nightmare you kill lengthens the avatar 1 s, up to twice as long.",
  "news.2026-11-04-zzzzzzzzzzzzzzbarbpal.title": "The barbarian's and the paladin's uniques",
  "news.2026-11-04-zzzzzzzzzzzzzzbarbpal.intro": "The barbarian and the paladin now have a unique for every skill.",
  "news.2026-11-04-zzzzzzzzzzzzzzbarbpal.barbarian": "Nine new uniques for the barbarian",
  "news.2026-11-04-zzzzzzzzzzzzzzbarbpal.barbarian.desc": "Each of the barbarian's skills has its own unique: the Throwing axe that leaps to another nightmare, the Charge that runs back, fear that spreads, the spirits of the Ancestral fury. They're rearmed from scraps at the forge, like the warrior's.",
  "news.2026-11-04-zzzzzzzzzzzzzzbarbpal.paladin": "Nine new uniques for the paladin",
  "news.2026-11-04-zzzzzzzzzzzzzzbarbpal.paladin.desc": "Each of the paladin's skills has its own unique: the Blinding light that flashes back, the hammer that flies loose, the Intervene that stuns on arrival, the Avatar of light with its hammers. They're rearmed from scraps at the forge.",
  "allies.in.saga": "in the saga",
  "allies.in.maze": "in the Furrows",
  "news.2026-11-04-zzzzzzzzzzzzzzzallies.title": "Where everyone is",
  "news.2026-11-04-zzzzzzzzzzzzzzzallies.intro": "The group's list by the bastion now says properly where each one is.",
  "news.2026-11-04-zzzzzzzzzzzzzzzallies.allyRoom": "\"In the saga\" and \"in the Furrows\"",
  "news.2026-11-04-zzzzzzzzzzzzzzzallies.allyRoom.desc": "Whoever was in the saga or the Furrows showed a broken text under their name. It now reads properly.",
  "news.2026-11-04-zzzzzzzzzzzzzzzzrangcler.title": "The ranger's and the cleric's uniques",
  "news.2026-11-04-zzzzzzzzzzzzzzzzrangcler.intro": "The ranger and the cleric now have a unique for every skill.",
  "news.2026-11-04-zzzzzzzzzzzzzzzzrangcler.ranger": "Ten new uniques for the ranger",
  "news.2026-11-04-zzzzzzzzzzzzzzzzrangcler.ranger.desc": "Each of the ranger's skills has its own unique: Multishot arrows that leap to another nightmare, the hawk that dives and stuns, the Signal flare that brings down what flies, the Titan's arrow that throws splinters. They're rearmed from scraps at the forge.",
  "news.2026-11-04-zzzzzzzzzzzzzzzzrangcler.cleric": "Ten new uniques for the cleric",
  "news.2026-11-04-zzzzzzzzzzzzzzzzrangcler.cleric.desc": "Each of the cleric's skills has its own unique: the ray that stays, the light that leaps from one nightmare to the next, the Shared prayer that brings down holy light, the Dawn's judgment that walks. They're rearmed from scraps at the forge.",
  "news.2026-11-04-zzzzzzzzzzzzzzzzzartmage.title": "The artificer's and the mage's uniques",
  "news.2026-11-04-zzzzzzzzzzzzzzzzzartmage.intro": "With the artificer and the mage, every class now has a unique for every skill.",
  "news.2026-11-04-zzzzzzzzzzzzzzzzzartmage.artificer": "Nine new uniques for the artificer",
  "news.2026-11-04-zzzzzzzzzzzzzzzzzartmage.artificer.desc": "Each of the artificer's skills has its own unique: the Spike mine that sets off a chain, the Flamethrower that pushes, the Repair drone that heals too, the hound that holds what it bites. They're rearmed from scraps at the forge.",
  "news.2026-11-04-zzzzzzzzzzzzzzzzzartmage.mage": "Ten new uniques for the mage",
  "news.2026-11-04-zzzzzzzzzzzzzzzzzartmage.mage.desc": "Each of the mage's skills has its own unique: the frost wall that bursts into shards when it ends, the Blizzard that drops hail, the Shadow chains that hurt all the bound when one falls, the Blink that bursts again where you appear. They're rearmed from scraps at the forge."
}
